// // AllGroup.js - Complete working component with all features

// import React, { useEffect, useState, useCallback } from "react";
// import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
// import { connect } from "react-redux";
// import { setBreadcrumbItems } from "../../store/actions";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import moment from "moment";

// import { Paper, TextField, LinearProgress, Tooltip, CircularProgress, Box, Typography, Menu, MenuItem } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { Modal } from "react-bootstrap";
// import Select from "react-select";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import FilterListIcon from '@mui/icons-material/FilterList';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import MergeTypeIcon from '@mui/icons-material/MergeType';
// import DownloadIcon from '@mui/icons-material/Download';
// import ArchiveIcon from '@mui/icons-material/Archive';
// import ScienceIcon from '@mui/icons-material/Science';
// import FirstPageIcon from '@mui/icons-material/FirstPage';
// import LastPageIcon from '@mui/icons-material/LastPage';
// import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';

// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import axios from "axios";
// import JSZip from "jszip";

// import Loader from "components/Loader/Loader";
// import {
//   fetchAllBatchesWithPagination,
//   fetchAllBatch,
//   fetchAllBatchOfTrainer,
//   getAllTrainerOfBatch,
//   getAllStudentOfBatch,
//   updateBatch,
//   deleteBatch,
//   batchDetailFile,
//   batchDetailFileWithFullFilters,
//   getDistinctStates,
//   getDistinctDepots,
// } from "helpers/batch_helper";
// import { downloadBatchReport, url } from "helpers/url_helper";
// import { getResult } from "helpers/exam_helper";
// import { fetchAllFeedbackOfBatch, getAllResponsesOfFeedback } from "helpers/feedback_helper";

// // ============================
// // SIMULATOR API HELPER FUNCTIONS
// // ============================
// const SIMULATOR_EXCEL_URL = url + "api/simulator/excel/";

// const downloadBatchSimulatorReport = (batchId) => {
//   return `${SIMULATOR_EXCEL_URL}${batchId}`;
// };

// // ============================
// // PROGRESS TOAST FUNCTIONS
// // ============================
// let progressToastId = null;

// const showProgressToast = (message, isProcessing = true) => {
//   if (progressToastId) {
//     toast.update(progressToastId, {
//       render: message,
//       type: isProcessing ? "info" : "success",
//       isLoading: isProcessing,
//       autoClose: isProcessing ? false : 5000,
//     });
//   } else {
//     progressToastId = toast.info(message, {
//       autoClose: false,
//       isLoading: true,
//     });
//   }
// };

// const hideProgressToast = (message, isSuccess = true) => {
//   if (progressToastId) {
//     toast.update(progressToastId, {
//       render: message,
//       type: isSuccess ? "success" : "error",
//       isLoading: false,
//       autoClose: 5000,
//     });
//     progressToastId = null;
//   }
// };

// const AllGroup = (props) => {
//   document.title = "Content Management | All Batches";
//   const navigate = useNavigate();

//   // ============================
//   // STATE DECLARATIONS
//   // ============================
//   const [loader, setLoader] = useState(false);
//   const [allBatch, setAllBatch] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [searchText, setSearchText] = useState("");
//   const [modalShow, setModalShow] = useState(false);
//   const [deleteModalShow, setDeleteModalShow] = useState(false);
//   const [name, setName] = useState("");
//   const [id, setId] = useState({});
//   const [spanDisplay, setSpanDisplay] = useState("none");

//   // Pagination states
//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalItems, setTotalItems] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);

//   // Filter states
//   const [filterState, setFilterState] = useState("");
//   const [filterDepot, setFilterDepot] = useState("");
//   const [filterPeriod, setFilterPeriod] = useState("ALL");
//   const [availableStates, setAvailableStates] = useState([]);
//   const [availableDepots, setAvailableDepots] = useState([]);
//   const [filterAnchorEl, setFilterAnchorEl] = useState(null);

//   // Additional filter states
//   const [departmentFilter, setDepartmentFilter] = useState("");
//   const [trainerNameFilter, setTrainerNameFilter] = useState("");
//   const [batchTypeFilter, setBatchTypeFilter] = useState("");
//   const [availableDepartments, setAvailableDepartments] = useState([]);
//   const [availableTrainers, setAvailableTrainers] = useState([]);
//   const [availableBatchTypes, setAvailableBatchTypes] = useState([]);

//   // Report generation states
//   const [consolidatedModalShow, setConsolidatedModalShow] = useState(false);
//   const [selectedConsolidatedType, setSelectedConsolidatedType] = useState("Other");
//   const [dateRangeModalShow, setDateRangeModalShow] = useState(false);
//   const [serialRangeModalShow, setSerialRangeModalShow] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState(null);
//   const [customEndDate, setCustomEndDate] = useState(null);
//   const [isCustomDateRangeActive, setIsCustomDateRangeActive] = useState(false);
//   const [fromSerial, setFromSerial] = useState("");
//   const [toSerial, setToSerial] = useState("");

//   // Individual Batch Report Download States
//   const [batchReportModalShow, setBatchReportModalShow] = useState(false);
//   const [selectedBatchForReport, setSelectedBatchForReport] = useState(null);
//   const [selectedReportType, setSelectedReportType] = useState("Other");

//   // Individual Batch Simulator Report Download States
//   const [batchSimulatorReportModalShow, setBatchSimulatorReportModalShow] = useState(false);
//   const [selectedBatchForSimulatorReport, setSelectedBatchForSimulatorReport] = useState(null);

//   // ZIP Download States
//   const [zipDownloadModalShow, setZipDownloadModalShow] = useState(false);
//   const [selectedZipType, setSelectedZipType] = useState("Other");

//   // ZIP Simulator Download States
//   const [zipSimulatorDownloadModalShow, setZipSimulatorDownloadModalShow] = useState(false);

//   // Consolidated Simulator Report States
//   const [consolidatedSimulatorModalShow, setConsolidatedSimulatorModalShow] = useState(false);

//   // Store data maps
//   const [batchTrainersMap, setBatchTrainersMap] = useState({});
//   const [batchFeedbackRatings, setBatchFeedbackRatings] = useState({});
//   const [batchFeedbackCounts, setBatchFeedbackCounts] = useState({});
//   const [batchFeedbackGivenCounts, setBatchFeedbackGivenCounts] = useState({});
//   const [batchNotFeedbackGivenCounts, setBatchNotFeedbackGivenCounts] = useState({});
//   const [loadingRatings, setLoadingRatings] = useState({});
//   const [ratingsFetched, setRatingsFetched] = useState(false);

//   // Progress tracking
//   const [consolidatedProgress, setConsolidatedProgress] = useState({ 
//     active: false, 
//     current: 0, 
//     total: 0, 
//     message: "" 
//   });

//   // All filtered batches state (for consolidated report)
//   const [allFilteredBatchCount, setAllFilteredBatchCount] = useState(0);
//   const [allFilteredBatchData, setAllFilteredBatchData] = useState([]);

//   // ============================
//   // HELPER FUNCTIONS
//   // ============================
//   const formatTrainerNames = (trainers) => {
//     if (!trainers || trainers.length === 0) return "No Trainer Assigned";
//     const trainerNames = trainers.map((t) => {
//       if (t.name) return t.name;
//       if (t.firstName && t.lastName) return `${t.firstName} ${t.lastName}`;
//       if (t.firstName) return t.firstName;
//       if (t.fullName) return t.fullName;
//       if (t.email) return t.email.split("@")[0];
//       return `Trainer ${t.id}`;
//     });
//     if (trainers.length === 1) return trainerNames[0];
//     return `${trainerNames[0]} +${trainers.length - 1}`;
//   };

//   const formatRatingWithStars = (rating) => {
//     if (!rating) return "Not Rated";
//     const fullStars = Math.floor(rating);
//     const emptyStars = 5 - fullStars;
//     return `${"★".repeat(fullStars)}${"☆".repeat(emptyStars)} ${rating.toFixed(1)}/5.0`;
//   };

//   // ============================
//   // OPTIONS
//   // ============================
//   const consolidatedOptions = [
//     { value: "DDT", label: "DDT Report (Single Sheet)" },
//     { value: "DASP", label: "DASP Report (Single Sheet)" },
//     { value: "Other", label: "Other Report (Single Sheet)" },
//   ];

//   const reportTypeOptions = [
//     { value: "DDT", label: "DDT Report" },
//     { value: "DASP", label: "DASP Report" },
//     { value: "Other", label: "Other Report" },
//   ];

//   const zipDownloadOptions = [
//     { value: "DDT", label: "DDT Reports (Batch-wise ZIP)" },
//     { value: "DASP", label: "DASP Reports (Batch-wise ZIP)" },
//     { value: "Other", label: "Other Reports (Batch-wise ZIP)" },
//   ];

//   const periodOptions = [
//     { value: "ALL", label: "All Time" },
//     { value: "TODAY", label: "Today" },
//     { value: "WEEKLY", label: "This Week" },
//     { value: "MONTHLY", label: "This Month" },
//     { value: "YEARLY", label: "This Year" },
//   ];

//   const pageSizeOptions = [
//     { value: 5, label: "5" },
//     { value: 10, label: "10" },
//     { value: 25, label: "25" },
//     { value: 50, label: "50" },
//     { value: 100, label: "100" },
//   ];

//   const breadcrumbItems = [
//     { title: "Batch", link: "#" },
//     { title: "All Batches", link: "#" },
//   ];

//   // ============================
//   // FETCH ALL BATCHES FOR CONSOLIDATED REPORT
//   // ============================
//   const fetchAllBatchesForConsolidated = useCallback(async () => {
//     try {
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) return;

//       let startDate = null;
//       let endDate = null;
      
//       if (isCustomDateRangeActive && customStartDate && customEndDate) {
//         startDate = moment(customStartDate).format("YYYY-MM-DD");
//         endDate = moment(customEndDate).format("YYYY-MM-DD");
//       } else if (filterPeriod !== "ALL") {
//         const today = moment().startOf('day');
//         switch (filterPeriod) {
//           case "TODAY":
//             startDate = today.format("YYYY-MM-DD");
//             endDate = today.format("YYYY-MM-DD");
//             break;
//           case "WEEKLY":
//             startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//             break;
//           case "MONTHLY":
//             startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//             break;
//           case "YEARLY":
//             startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//             break;
//           default:
//             break;
//         }
//       }

//       const response = await fetchAllBatchesWithPagination(
//         0, 
//         10000,
//         startDate,
//         endDate,
//         filterState,
//         filterDepot,
//         searchText
//       );

//       if (response.data?.success) {
//         const batches = response.data.result || [];
//         setAllFilteredBatchData(batches);
//         setAllFilteredBatchCount(batches.length);
//       }
//     } catch (error) {
//       console.error("Error fetching all batches for consolidated:", error);
//     }
//   }, [isCustomDateRangeActive, customStartDate, customEndDate, filterPeriod, filterState, filterDepot, searchText]);

//   // ============================
//   // FETCH DISTINCT FILTERS
//   // ============================
//   const fetchDistinctFilters = useCallback(async () => {
//     try {
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser?.organizationId) return;

//       const [statesRes, depotsRes] = await Promise.all([
//         getDistinctStates(),
//         getDistinctDepots()
//       ]);

//       if (statesRes?.data) {
//         setAvailableStates(statesRes.data);
//       }
//       if (depotsRes?.data) {
//         setAvailableDepots(depotsRes.data);
//       }

//       const depts = new Set();
//       const trainers = new Set();
//       const types = new Set();

//       allBatch.forEach(batch => {
//         if (batch.department) depts.add(batch.department);
//         if (batch.batchType) types.add(batch.batchType);
//         if (batch.trainerNames && batch.trainerNames !== "No Trainer Assigned") {
//           trainers.add(batch.trainerNames);
//         }
//       });

//       setAvailableDepartments([...depts]);
//       setAvailableTrainers([...trainers]);
//       setAvailableBatchTypes([...types]);

//     } catch (error) {
//       console.error("Error fetching distinct filters:", error);
//     }
//   }, [allBatch]);

//   // ============================
//   // FETCH FEEDBACK RATINGS
//   // ============================
//   const fetchFeedbackRatingsOnly = async (batches) => {
//     if (ratingsFetched) return;
    
//     const feedbackRatingsMap = {};
//     const feedbackCountsMap = {};
//     const feedbackGivenCountsMap = {};
//     const notFeedbackGivenCountsMap = {};
    
//     const asyncPool = async (concurrency, items, iteratorFn) => {
//       const results = [];
//       const executing = new Set();
//       for (const [index, item] of items.entries()) {
//         const promise = Promise.resolve().then(() => iteratorFn(item, index));
//         results.push(promise);
//         executing.add(promise);
//         const clean = () => executing.delete(promise);
//         promise.then(clean, clean);
//         if (executing.size >= concurrency) {
//           await Promise.race(executing);
//         }
//       }
//       return Promise.all(results);
//     };
    
//     await asyncPool(5, batches, async (batch) => {
//       const batchId = batch.id || batch._id;
//       if (!batchId) return;
      
//       try {
//         setLoadingRatings(prev => ({ ...prev, [batchId]: true }));
        
//         const feedbacksResponse = await fetchAllFeedbackOfBatch(batchId);
        
//         if (!feedbacksResponse?.success || !feedbacksResponse?.result?.length) {
//           feedbackRatingsMap[batchId] = null;
//           feedbackCountsMap[batchId] = 0;
//           feedbackGivenCountsMap[batchId] = 0;
//           notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
//           return;
//         }

//         let totalRatingSum = 0;
//         let totalResponseCount = 0;
//         let totalFeedbackGiven = 0;

//         for (const feedback of feedbacksResponse.result) {
//           const responsesResponse = await getAllResponsesOfFeedback(feedback.id);
          
//           if (responsesResponse?.success && responsesResponse?.responseResult?.length) {
//             const feedbackRatingSum = responsesResponse.responseResult.reduce(
//               (sum, response) => sum + (response.rating || 0), 
//               0
//             );
//             totalRatingSum += feedbackRatingSum;
//             totalResponseCount += responsesResponse.responseResult.length;
//             totalFeedbackGiven += responsesResponse.responseResult.length;
//           }
//         }

//         const averageRating = totalResponseCount > 0 ? totalRatingSum / totalResponseCount : null;
//         const totalStudents = batch.totalStudents || 0;
//         const notFeedbackGiven = totalStudents - totalFeedbackGiven;
        
//         feedbackRatingsMap[batchId] = averageRating;
//         feedbackCountsMap[batchId] = totalResponseCount;
//         feedbackGivenCountsMap[batchId] = totalFeedbackGiven;
//         notFeedbackGivenCountsMap[batchId] = notFeedbackGiven > 0 ? notFeedbackGiven : 0;
        
//         setBatchFeedbackRatings(prev => ({ ...prev, [batchId]: averageRating }));
//         setBatchFeedbackCounts(prev => ({ ...prev, [batchId]: totalResponseCount }));
//         setBatchFeedbackGivenCounts(prev => ({ ...prev, [batchId]: totalFeedbackGiven }));
//         setBatchNotFeedbackGivenCounts(prev => ({ ...prev, [batchId]: notFeedbackGiven > 0 ? notFeedbackGiven : 0 }));
//       } catch (error) {
//         console.error(`Error fetching feedback rating for batch ${batchId}:`, error);
//         feedbackRatingsMap[batchId] = null;
//         feedbackCountsMap[batchId] = 0;
//         feedbackGivenCountsMap[batchId] = 0;
//         notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
//       } finally {
//         setLoadingRatings(prev => ({ ...prev, [batchId]: false }));
//       }
//     });
    
//     setRatingsFetched(true);
//   };

//   // ============================
//   // FETCH TRAINERS FOR BATCHES
//   // ============================
//   const fetchTrainersForBatches = async (batches) => {
//     const trainersMap = {};
    
//     const asyncPool = async (concurrency, items, iteratorFn) => {
//       const results = [];
//       const executing = new Set();
//       for (const [index, item] of items.entries()) {
//         const promise = Promise.resolve().then(() => iteratorFn(item, index));
//         results.push(promise);
//         executing.add(promise);
//         const clean = () => executing.delete(promise);
//         promise.then(clean, clean);
//         if (executing.size >= concurrency) {
//           await Promise.race(executing);
//         }
//       }
//       return Promise.all(results);
//     };
    
//     await asyncPool(5, batches, async (batch) => {
//       const batchId = batch.id || batch._id;
//       if (!batchId) return;
//       try {
//         const trainers = await getAllTrainerOfBatch(batchId).catch(() => []);
//         trainersMap[batchId] = trainers?.success ? trainers.result || [] : [];
//       } catch (error) {
//         trainersMap[batchId] = [];
//       }
//     });
    
//     setBatchTrainersMap(trainersMap);
//   };

//   // ============================
//   // GET ALL BATCHES WITH PAGINATION
//   // ============================
//   const getAllBatches = useCallback(async () => {
//     try {
//       setLoader(true);
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       const type = authUser?.userType;
      
//       if (type === "Tata Trainer") {
//         const res = await fetchAllBatchOfTrainer();
//         if (res?.success) {
//           const batches = (res.result || []).map(batch => ({
//             id: batch.id || batch._id,
//             batchName: batch.batchName,
//             department: batch.department,
//             state: batch.state,
//             depot: batch.depot,
//             trainingStartDate: batch.trainingStartDate,
//             trainingEndDate: batch.trainingEndDate,
//             totalStudents: batch.totalStudents || batch.students?.length || 0,
//             passedStudents: batch.passedStudents || 0,
//             failedStudents: batch.failedStudents || 0,
//             notAttemptedStudents: batch.notAttemptedStudents || 0,
//             passPercentage: batch.passPercentage || 0,
//             trainerNames: batch.trainerNames || "No Trainer Assigned",
//             totalTrainers: batch.totalTrainers || 0,
//             entryBy: batch.entryBy,
//             entryAt: batch.entryAt,
//             updatedBy: batch.updatedBy,
//             updatedAt: batch.updatedAt,
//             feedbackGivenCount: batch.feedbackGivenCount || 0,
//             notFeedbackGivenCount: batch.notFeedbackGivenCount || 0,
//             batchType: batch.batchType || "Offline"
//           }));
//           setAllBatch(batches);
//           setFilteredBatches(batches);
//           setTotalItems(batches.length);
//           setTotalPages(1);
//           toast.success(`${batches.length} batches loaded successfully`);
          
//           if (batches.length > 0) {
//             await Promise.all([
//               fetchTrainersForBatches(batches),
//               fetchFeedbackRatingsOnly(batches)
//             ]);
//           }
//         }
//       } else {
//         let startDate = null;
//         let endDate = null;
        
//         if (isCustomDateRangeActive && customStartDate && customEndDate) {
//           startDate = moment(customStartDate).format("YYYY-MM-DD");
//           endDate = moment(customEndDate).format("YYYY-MM-DD");
//         } else if (filterPeriod !== "ALL") {
//           const today = moment().startOf('day');
//           switch (filterPeriod) {
//             case "TODAY":
//               startDate = today.format("YYYY-MM-DD");
//               endDate = today.format("YYYY-MM-DD");
//               break;
//             case "WEEKLY":
//               startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//               break;
//             case "MONTHLY":
//               startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//               break;
//             case "YEARLY":
//               startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//               break;
//             default:
//               break;
//           }
//         }
        
//         const searchValue = searchText || null;
        
//         const response = await fetchAllBatchesWithPagination(
//           page, 
//           pageSize, 
//           startDate, 
//           endDate, 
//           filterState || null, 
//           filterDepot || null, 
//           searchValue
//         );
        
//         if (response.data?.success) {
//           const batches = (response.data.result || []).map(batch => ({
//             id: batch.id || batch._id,
//             batchName: batch.batchName,
//             department: batch.department,
//             state: batch.state,
//             depot: batch.depot,
//             trainingStartDate: batch.trainingStartDate,
//             trainingEndDate: batch.trainingEndDate,
//             totalStudents: batch.totalStudents || 0,
//             passedStudents: batch.passedStudents || 0,
//             failedStudents: batch.failedStudents || 0,
//             notAttemptedStudents: batch.notAttemptedStudents || 0,
//             passPercentage: batch.passPercentage || 0,
//             trainerNames: batch.trainerNames || "No Trainer Assigned",
//             totalTrainers: batch.totalTrainers || 0,
//             entryBy: batch.entryBy,
//             entryAt: batch.entryAt,
//             updatedBy: batch.updatedBy,
//             updatedAt: batch.updatedAt,
//             feedbackGivenCount: batch.feedbackGivenCount || 0,
//             notFeedbackGivenCount: batch.notFeedbackGivenCount || 0,
//             batchType: batch.batchType || "Offline"
//           }));
          
//           setAllBatch(batches);
//           setFilteredBatches(batches);
//           setTotalItems(response.data.totalItems || 0);
//           setTotalPages(response.data.totalPages || 0);
          
//           if (batches.length > 0) {
//             await Promise.all([
//               fetchTrainersForBatches(batches),
//               fetchFeedbackRatingsOnly(batches)
//             ]);
//           }
          
//           if (batches.length === 0) {
//             toast.info("No batches found for the selected filters");
//           }
//         } else {
//           toast.error(response.data?.message || "Failed to load batches");
//         }
//       }
//     } catch (error) {
//       console.error("Error in getAllBatches:", error);
//       toast.error(error?.response?.data?.message || "Failed to load batches");
//     } finally {
//       setLoader(false);
//     }
//   }, [page, pageSize, filterState, filterDepot, filterPeriod, searchText, customStartDate, customEndDate, isCustomDateRangeActive]);

//   // ============================
//   // DOWNLOAD CONSOLIDATED SIMULATOR REPORT
//   // ============================
//   const downloadConsolidatedSimulator = async () => {
//     try {
//       setLoader(true);
//       setConsolidatedSimulatorModalShow(false);
      
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) {
//         toast.error("Organization ID not found. Please log in again.");
//         setLoader(false);
//         return;
//       }
      
//       let startDate = null;
//       let endDate = null;
      
//       if (isCustomDateRangeActive && customStartDate && customEndDate) {
//         startDate = moment(customStartDate).format("YYYY-MM-DD");
//         endDate = moment(customEndDate).format("YYYY-MM-DD");
//       } else if (filterPeriod !== "ALL") {
//         const today = moment().startOf('day');
//         switch (filterPeriod) {
//           case "TODAY":
//             startDate = today.format("YYYY-MM-DD");
//             endDate = today.format("YYYY-MM-DD");
//             break;
//           case "WEEKLY":
//             startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//             break;
//           case "MONTHLY":
//             startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//             break;
//           case "YEARLY":
//             startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//             break;
//           default:
//             break;
//         }
//       }
      
//       // Build filter message
//       const filters = [];
//       if (startDate && endDate) {
//         filters.push(`Training End Date: ${moment(startDate).format('DD/MM/YYYY')} to ${moment(endDate).format('DD/MM/YYYY')}`);
//       } else if (startDate) {
//         filters.push(`From: ${moment(startDate).format('DD/MM/YYYY')}`);
//       } else if (endDate) {
//         filters.push(`Until: ${moment(endDate).format('DD/MM/YYYY')}`);
//       }
//       if (filterState) filters.push(`State: ${filterState}`);
//       if (filterDepot) filters.push(`Depot: ${filterDepot}`);
//       if (searchText) filters.push(`Search: "${searchText}"`);
//       if (departmentFilter) filters.push(`Department: ${departmentFilter}`);
//       if (trainerNameFilter) filters.push(`Trainer: ${trainerNameFilter}`);
//       if (batchTypeFilter) filters.push(`Batch Type: ${batchTypeFilter}`);
      
//       // Build the URL correctly with /api prefix
//       const baseUrl = "https://backend.skillserve.in/api/";
//       let apiUrl = `${baseUrl}simulator/consolidated-report`;
      
//       const params = new URLSearchParams();
//       if (startDate) params.append("startDate", startDate);
//       if (endDate) params.append("endDate", endDate);
//       if (filterState && filterState !== "") params.append("state", filterState);
//       if (filterDepot && filterDepot !== "") params.append("depot", filterDepot);
//       if (searchText && searchText !== "") params.append("search", searchText);
//       if (departmentFilter && departmentFilter !== "") params.append("department", departmentFilter);
//       if (trainerNameFilter && trainerNameFilter !== "") params.append("trainerName", trainerNameFilter);
//       if (batchTypeFilter && batchTypeFilter !== "") params.append("batchType", batchTypeFilter);
      
//       if (params.toString()) {
//         apiUrl += "?" + params.toString();
//       }
      
//       console.log("Calling consolidated report URL:", apiUrl);
      
//       showProgressToast(`⏳ Generating Consolidated Simulator Report for ${allFilteredBatchCount} batches... This may take several minutes.`, true);
      
//       // Make request with extended timeout
//       const response = await axios({
//         method: 'get',
//         url: apiUrl,
//         responseType: 'blob',
//         timeout: 600000,
//         headers: {
//           'X-Organization-ID': authUser.organizationId || ''
//         }
//       });
      
//       hideProgressToast("✅ Report generated successfully! Downloading...", true);
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         setLoader(false);
//         return;
//       }
      
//       // Check if response is JSON error
//       const firstBytes = await response.data.slice(0, 100).text();
//       const trimmedFirstBytes = firstBytes.trim();
//       if (trimmedFirstBytes.startsWith('{') || trimmedFirstBytes.startsWith('[')) {
//         try {
//           const fullText = await response.data.text();
//           const errorData = JSON.parse(fullText);
//           toast.error(errorData.message || "Failed to download file");
//           setLoader(false);
//           return;
//         } catch (e) {
//           toast.error("Failed to download file");
//           setLoader(false);
//           return;
//         }
//       }
      
//       const blob = new Blob([response.data], {
//         type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       });
      
//       const downloadUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
      
//       let filename = `Consolidated_Simulator_Report`;
//       if (startDate && endDate) {
//         filename += `_${moment(startDate).format("YYYYMMDD")}_to_${moment(endDate).format("YYYYMMDD")}`;
//       } else if (startDate) {
//         filename += `_from_${moment(startDate).format("YYYYMMDD")}`;
//       } else if (endDate) {
//         filename += `_upto_${moment(endDate).format("YYYYMMDD")}`;
//       }
//       if (filterState) {
//         filename += `_state_${filterState}`;
//       }
//       if (filterDepot) {
//         filename += `_depot_${filterDepot}`;
//       }
//       if (departmentFilter) {
//         filename += `_dept_${departmentFilter.replace(/\s+/g, '_')}`;
//       }
//       if (trainerNameFilter) {
//         filename += `_trainer_${trainerNameFilter.replace(/\s+/g, '_')}`;
//       }
//       if (batchTypeFilter) {
//         filename += `_type_${batchTypeFilter}`;
//       }
//       filename += `.xlsx`;
      
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`✅ Consolidated Simulator Report downloaded successfully! (${allFilteredBatchCount} batches)`);
//     } catch (error) {
//       console.error("Error downloading consolidated simulator report:", error);
//       hideProgressToast("❌ Failed to generate report. Please try again.", false);
      
//       if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
//         toast.error("⏱️ Report generation is taking longer than expected. Please try again with fewer filters or try again later.");
//       } else if (error.response?.data) {
//         try {
//           const errorText = await error.response.data.text();
//           const errorJson = JSON.parse(errorText);
//           toast.error(errorJson.message || "Failed to generate report");
//         } catch (e) {
//           toast.error("Failed to generate report. Server error occurred.");
//         }
//       } else if (error.message) {
//         toast.error(`Failed to generate report: ${error.message}`);
//       } else {
//         toast.error("Failed to generate report. Please try again.");
//       }
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // OPEN CONSOLIDATED MODALS
//   // ============================
//   const openConsolidatedModal = async () => {
//     await fetchAllBatchesForConsolidated();
//     setConsolidatedModalShow(true);
//   };

//   const openConsolidatedSimulatorModal = async () => {
//     await fetchAllBatchesForConsolidated();
//     setConsolidatedSimulatorModalShow(true);
//   };

//   // ============================
//   // DOWNLOAD EXCEL WITH FULL FILTERS
//   // ============================
//   const downloadExcel = async () => {
//     try {
//       setLoader(true);
      
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) {
//         toast.error("Organization ID not found. Please log in again.");
//         return;
//       }
      
//       let startDate = null;
//       let endDate = null;
      
//       if (isCustomDateRangeActive && customStartDate && customEndDate) {
//         startDate = moment(customStartDate).format("YYYY-MM-DD");
//         endDate = moment(customEndDate).format("YYYY-MM-DD");
//       } else if (filterPeriod !== "ALL") {
//         const today = moment().startOf('day');
//         switch (filterPeriod) {
//           case "TODAY":
//             startDate = today.format("YYYY-MM-DD");
//             endDate = today.format("YYYY-MM-DD");
//             break;
//           case "WEEKLY":
//             startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//             break;
//           case "MONTHLY":
//             startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//             break;
//           case "YEARLY":
//             startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//             break;
//           default:
//             break;
//         }
//       }
      
//       const filters = [];
//       if (startDate && endDate) {
//         filters.push(`Training End Date: ${moment(startDate).format('DD/MM/YYYY')} to ${moment(endDate).format('DD/MM/YYYY')}`);
//       } else if (startDate) {
//         filters.push(`From: ${moment(startDate).format('DD/MM/YYYY')}`);
//       } else if (endDate) {
//         filters.push(`Until: ${moment(endDate).format('DD/MM/YYYY')}`);
//       }
//       if (filterState) filters.push(`State: ${filterState}`);
//       if (filterDepot) filters.push(`Depot: ${filterDepot}`);
//       if (searchText) filters.push(`Search: "${searchText}"`);
//       if (departmentFilter) filters.push(`Department: ${departmentFilter}`);
      
//       toast.info(filters.length > 0 ? 
//         `Downloading report with filters: ${filters.join(', ')}...` : 
//         "Downloading all batch report...");
      
//       const response = await batchDetailFileWithFullFilters(
//         startDate, 
//         endDate, 
//         filterState, 
//         filterDepot, 
//         searchText
//       );
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const firstBytes = await response.data.slice(0, 100).text();
//       const trimmedFirstBytes = firstBytes.trim();
//       if (trimmedFirstBytes.startsWith('{') || trimmedFirstBytes.startsWith('[')) {
//         try {
//           const fullText = await response.data.text();
//           const errorData = JSON.parse(fullText);
//           toast.error(errorData.message || "Failed to download file");
//           return;
//         } catch (e) {
//           toast.error("Failed to download file");
//           return;
//         }
//       }
      
//       const blob = new Blob([response.data], {
//         type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       });
      
//       const downloadUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
      
//       let filename = `Batch_Details`;
//       if (startDate && endDate) {
//         filename += `_${moment(startDate).format("YYYYMMDD")}_to_${moment(endDate).format("YYYYMMDD")}`;
//       } else if (startDate) {
//         filename += `_from_${moment(startDate).format("YYYYMMDD")}`;
//       } else if (endDate) {
//         filename += `_upto_${moment(endDate).format("YYYYMMDD")}`;
//       }
//       if (filterState) {
//         filename += `_state_${filterState}`;
//       }
//       if (filterDepot) {
//         filename += `_depot_${filterDepot}`;
//       }
//       if (searchText) {
//         filename += `_search_${searchText.replace(/\s+/g, '_')}`;
//       }
//       if (departmentFilter) {
//         filename += `_dept_${departmentFilter.replace(/\s+/g, '_')}`;
//       }
//       filename += `.xlsx`;
      
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success("File downloaded successfully!");
//     } catch (error) {
//       console.error("Error downloading file:", error);
//       toast.error(error.response?.data?.message || "Failed to download file");
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // PAGE CHANGE HANDLERS
//   // ============================
//   const handlePageChange = (newPage) => {
//     if (newPage >= 0 && newPage < totalPages) {
//       setPage(newPage);
//     }
//   };

//   const handlePageSizeChange = (newSize) => {
//     setPageSize(newSize);
//     setPage(0);
//   };

//   // ============================
//   // PAGINATION RENDER
//   // ============================
//   const renderPagination = () => {
//     if (totalPages <= 1) return null;

//     const pageNumbers = [];
//     const maxVisible = 5;
//     let startPage = Math.max(0, page - Math.floor(maxVisible / 2));
//     let endPage = Math.min(totalPages - 1, startPage + maxVisible - 1);
    
//     if (endPage - startPage < maxVisible - 1) {
//       startPage = Math.max(0, endPage - maxVisible + 1);
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pageNumbers.push(i);
//     }

//     return (
//       <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
//         <div className="d-flex align-items-center gap-2">
//           <span className="text-muted" style={{ fontSize: "14px" }}>
//             Showing {page * pageSize + 1} to {Math.min((page + 1) * pageSize, totalItems)} of {totalItems} entries
//           </span>
//         </div>
//         <div className="d-flex align-items-center gap-2 flex-wrap">
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(0)}
//             disabled={page === 0}
//           >
//             <FirstPageIcon style={{ fontSize: "18px" }} />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(page - 1)}
//             disabled={page === 0}
//           >
//             <NavigateBeforeIcon style={{ fontSize: "18px" }} />
//           </Button>
//           {pageNumbers.map((num) => (
//             <Button
//               key={num}
//               color={num === page ? "primary" : "secondary"}
//               size="sm"
//               onClick={() => handlePageChange(num)}
//               style={{ minWidth: "35px" }}
//             >
//               {num + 1}
//             </Button>
//           ))}
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(page + 1)}
//             disabled={page >= totalPages - 1}
//           >
//             <NavigateNextIcon style={{ fontSize: "18px" }} />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(totalPages - 1)}
//             disabled={page >= totalPages - 1}
//           >
//             <LastPageIcon style={{ fontSize: "18px" }} />
//           </Button>
          
//           <div className="d-flex align-items-center ms-2 gap-2">
//             <span className="text-muted" style={{ fontSize: "13px" }}>Rows:</span>
//             <Select
//               options={pageSizeOptions}
//               value={pageSizeOptions.find(opt => opt.value === pageSize)}
//               onChange={(option) => handlePageSizeChange(option.value)}
//               className="page-size-select"
//               styles={{
//                 control: (base) => ({
//                   ...base,
//                   minHeight: "32px",
//                   width: "70px",
//                   borderColor: "#ced4da",
//                   boxShadow: "none",
//                   "&:hover": {
//                     borderColor: "#80bdff",
//                   },
//                 }),
//                 menu: (base) => ({
//                   ...base,
//                   zIndex: 9999,
//                 }),
//                 option: (base, state) => ({
//                   ...base,
//                   backgroundColor: state.isSelected ? "#0d6efd" : state.isFocused ? "#e9ecef" : "white",
//                   color: state.isSelected ? "white" : "#212529",
//                   "&:active": {
//                     backgroundColor: "#0d6efd",
//                     color: "white",
//                   },
//                 }),
//               }}
//               isSearchable={false}
//               menuPortalTarget={document.body}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // ============================
//   // EFFECTS
//   // ============================
//   useEffect(() => {
//     props.setBreadcrumbItems("All Batches", breadcrumbItems);
//   }, []);

//   useEffect(() => {
//     getAllBatches();
//   }, [getAllBatches]);

//   useEffect(() => {
//     if (allBatch.length > 0) {
//       fetchTrainersForBatches(allBatch);
//       fetchFeedbackRatingsOnly(allBatch);
//       fetchDistinctFilters();
//     }
//   }, [allBatch]);

//   // ============================
//   // COLUMNS DEFINITION
//   // ============================
//   const columns = [
//     { field: "serialNo", headerName: "S.No", width: 70 },
//     {
//       field: "batchName",
//       headerName: "Batch Name",
//       width: 200,
//       renderCell: (params) => {
//         return (
//           <span
//             style={{ cursor: "pointer", color: "#0d6efd", fontWeight: 500, textDecoration: "underline" }}
//             onClick={() => handleViewDetails(params.row)}
//             title={`${params.row.totalStudents || 0} student(s)`}
//           >
//             {params.value}
//           </span>
//         );
//       },
//     },
//     { field: "department", headerName: "Department", width: 150 },
//     {
//       field: "trainerNames",
//       headerName: "Trainer(s)",
//       width: 250,
//       renderCell: (params) => {
//         return <span>{params.value || "No Trainer Assigned"}</span>;
//       },
//     },
//     {
//       field: "state",
//       headerName: "State",
//       width: 130,
//       renderCell: (params) => params.value || "N/A",
//     },
//     {
//       field: "depot",
//       headerName: "Depot",
//       width: 130,
//       renderCell: (params) => params.value || "N/A",
//     },
//     {
//       field: "trainingStartDate",
//       headerName: "Start Date",
//       width: 130,
//       renderCell: (params) => formatDateToDDMMYYYY(params.value),
//     },
//     {
//       field: "trainingEndDate",
//       headerName: "End Date",
//       width: 130,
//       renderCell: (params) => formatDateToDDMMYYYY(params.value),
//     },
//     {
//       field: "totalStudents",
//       headerName: "Students",
//       width: 90,
//       renderCell: (params) => (
//         <span style={{ fontWeight: params.value > 0 ? "bold" : "normal", color: params.value > 0 ? "#198754" : "#6c757d" }}>
//           {params.value || 0}
//         </span>
//       ),
//     },
//     {
//       field: "passedStudents",
//       headerName: "Passed",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ color: "#198754", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "failedStudents",
//       headerName: "Failed",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ color: "#dc3545", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "notAttemptedStudents",
//       headerName: "Not Attempted",
//       width: 100,
//       renderCell: (params) => (
//         <span style={{ color: "#ffc107", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "passPercentage",
//       headerName: "Pass %",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ fontWeight: "bold" }}>{params.value || 0}%</span>
//       ),
//     },
//     {
//       field: "feedbackRating",
//       headerName: "Rating",
//       width: 220,
//       renderCell: (params) => {
//         const rating = batchFeedbackRatings[params.row.id];
//         const count = batchFeedbackCounts[params.row.id] || 0;
//         const loading = loadingRatings[params.row.id];

//         if (loading) {
//           return <CircularProgress size={25} />;
//         }

//         return renderStarRating(rating, count);
//       },
//     },
//     {
//       field: "feedbackGiven",
//       headerName: "Feedback Given",
//       width: 130,
//       renderCell: (params) => {
//         const given = batchFeedbackGivenCounts[params.row.id] || 0;
//         const notGiven = batchNotFeedbackGivenCounts[params.row.id] || 0;
//         return (
//           <Tooltip title={`${given} students gave feedback, ${notGiven} students did not`}>
//             <span style={{ color: given > 0 ? "#198754" : "#6c757d" }}>
//               {given} / {given + notGiven}
//             </span>
//           </Tooltip>
//         );
//       },
//     },
//     {
//       field: "edit",
//       headerName: "Edit",
//       width: 80,
//       renderCell: (p) => (
//         <Button size="sm" color="warning" onClick={() => handleRowClick(p.row)} style={{ padding: "4px 12px" }}>
//           Edit
//         </Button>
//       ),
//     },
//     {
//       field: "download",
//       headerName: "Download Report",
//       width: 130,
//       renderCell: (p) => (
//         <Button 
//           size="sm" 
//           color="success" 
//           onClick={() => openBatchReportModal(p.row)}
//           style={{ padding: "4px 8px", marginRight: "4px" }}
//         >
//           <DownloadIcon style={{ fontSize: "14px" }} />
//         </Button>
//       ),
//     },
//     {
//       field: "downloadSimulator",
//       headerName: "Simulator",
//       width: 100,
//       renderCell: (p) => (
//         <Button 
//           size="sm" 
//           color="primary" 
//           onClick={() => openBatchSimulatorReportModal(p.row)}
//           style={{ padding: "4px 8px" }}
//         >
//           <ScienceIcon style={{ fontSize: "14px" }} />
//         </Button>
//       ),
//     },
//   ];

//   // ============================
//   // HELPER FUNCTIONS FOR DISPLAY
//   // ============================
//   const formatDateToDDMMYYYY = useCallback((dateStr) => {
//     if (!dateStr) return "N/A";
//     try {
//       const date = moment(dateStr);
//       if (date.isValid()) {
//         return date.format("DD/MM/YYYY");
//       }
//       return String(dateStr);
//     } catch (error) {
//       return String(dateStr);
//     }
//   }, []);

//   const renderStarRating = (rating, count = 0) => {
//     if (!rating || count === 0) {
//       return (
//         <Tooltip title="No feedback responses yet">
//           <span style={{ color: "#6c757d", fontStyle: "italic" }}>No Rating</span>
//         </Tooltip>
//       );
//     }

//     const fullStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 >= 0.5;
//     const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

//     return (
//       <Tooltip title={`Based on ${count} response(s) - Average Rating: ${rating.toFixed(1)}/5.0`}>
//         <Box display="flex" alignItems="center" gap={1} sx={{ cursor: "pointer" }}>
//           <Box display="flex" alignItems="center" gap={0.2}>
//             {[...Array(fullStars)].map((_, i) => (
//               <span key={`full-${i}`} style={{ color: "#ffb400", fontSize: "16px" }}>★</span>
//             ))}
//             {hasHalfStar && (
//               <span style={{ color: "#ffb400", fontSize: "16px", position: "relative", display: "inline-block" }}>
//                 <span style={{ position: "absolute", overflow: "hidden", width: "50%", color: "#ffb400" }}>★</span>
//                 <span style={{ color: "#e4e5e9" }}>★</span>
//               </span>
//             )}
//             {[...Array(emptyStars)].map((_, i) => (
//               <span key={`empty-${i}`} style={{ color: "#e4e5e9", fontSize: "16px" }}>★</span>
//             ))}
//           </Box>
//           <Typography 
//             variant="body2" 
//             sx={{ 
//               fontWeight: "bold", 
//               color: "#ffb400",
//               backgroundColor: "#fff3e0",
//               padding: "2px 6px",
//               borderRadius: "12px",
//               fontSize: "12px"
//             }}
//           >
//             {rating.toFixed(1)}
//           </Typography>
//         </Box>
//       </Tooltip>
//     );
//   };

//   const getFilteredStats = useCallback(() => {
//     let totalStudents = 0;
//     let totalPassed = 0;
//     let totalFailed = 0;
//     let totalNotAttempted = 0;
//     let totalRatingSum = 0;
//     let totalRatingCount = 0;
//     let totalFeedbackGiven = 0;
//     let totalNotFeedbackGiven = 0;

//     filteredBatches.forEach((batch) => {
//       totalStudents += batch.totalStudents || 0;
//       totalPassed += batch.passedStudents || 0;
//       totalFailed += batch.failedStudents || 0;
//       totalNotAttempted += batch.notAttemptedStudents || 0;
      
//       const rating = batchFeedbackRatings[batch.id];
//       if (rating) {
//         totalRatingSum += rating;
//         totalRatingCount++;
//       }
      
//       totalFeedbackGiven += batchFeedbackGivenCounts[batch.id] || 0;
//       totalNotFeedbackGiven += batchNotFeedbackGivenCounts[batch.id] || 0;
//     });

//     const passRate = totalStudents > 0 ? ((totalPassed / totalStudents) * 100).toFixed(1) : 0;
//     const avgRating = totalRatingCount > 0 ? (totalRatingSum / totalRatingCount).toFixed(1) : 0;

//     return {
//       totalStudents,
//       totalPassed,
//       totalFailed,
//       totalNotAttempted,
//       passRate,
//       avgRating,
//       totalRatingCount,
//       totalFeedbackGiven,
//       totalNotFeedbackGiven
//     };
//   }, [filteredBatches, batchFeedbackRatings, batchFeedbackGivenCounts, batchNotFeedbackGivenCounts]);

//   const filteredStats = getFilteredStats();

//   // ============================
//   // EDIT/DELETE FUNCTIONS
//   // ============================
//   const handleRowClick = (row) => {
//     setModalShow(true);
//     navigate(`/batch/${row.id}`);
//     setId(row.id);
//     setName(row.batchName || "");
//   };

//   const handleUpdate = async () => {
//     if (!name) {
//       setSpanDisplay("inline");
//       return;
//     }

//     try {
//       setLoader(true);
//       const result = await updateBatch({ id, batchName: name });
//       if (result?.success) {
//         toast.success(result?.message);
//         getAllBatches();
//         setModalShow(false);
//         setName("");
//         setId("");
//         setSpanDisplay("none");
//       } else {
//         toast.error(result?.message);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to update batch");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       setLoader(true);
//       const result = await deleteBatch(id);
//       if (result?.success) {
//         toast.success(result?.message);
//         getAllBatches();
//         setDeleteModalShow(false);
//         setModalShow(false);
//         setName("");
//         setId("");
//       } else {
//         toast.error(result?.message);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to delete batch");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleViewDetails = (row) => {
//     navigate(`/batch/${row.id}`);
//   };

//   const resetFilters = () => {
//     setFilterState("");
//     setFilterDepot("");
//     setFilterPeriod("ALL");
//     setSearchText("");
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setFilterAnchorEl(null);
//     setDepartmentFilter("");
//     setTrainerNameFilter("");
//     setBatchTypeFilter("");
//     setPage(0);
//   };

//   const handleFilterClick = (event) => {
//     setFilterAnchorEl(event.currentTarget);
//   };

//   const handleFilterClose = () => {
//     setFilterAnchorEl(null);
//   };

//   const openCustomDateRangeModal = () => {
//     setDateRangeModalShow(true);
//     handleFilterClose();
//   };

//   const applyCustomDateRange = () => {
//     if (!customStartDate || !customEndDate) {
//       toast.error("Please select both start and end dates");
//       return;
//     }

//     if (moment(customStartDate).isAfter(moment(customEndDate))) {
//       toast.error("Start date cannot be after end date");
//       return;
//     }

//     setIsCustomDateRangeActive(true);
//     setFilterPeriod("ALL");
//     setDateRangeModalShow(false);
//     setPage(0);
//     toast.success(`Custom date range applied: ${formatDateToDDMMYYYY(customStartDate)} to ${formatDateToDDMMYYYY(customEndDate)}`);
//   };

//   const clearCustomDateRange = () => {
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setPage(0);
//     toast.success("Custom date range cleared");
//   };

//   const applySerialRangeFilter = () => {
//     if (!fromSerial || !toSerial) {
//       toast.error("Please enter both from and to serial numbers");
//       return;
//     }

//     const from = parseInt(fromSerial);
//     const to = parseInt(toSerial);

//     if (isNaN(from) || isNaN(to)) {
//       toast.error("Please enter valid numbers");
//       return;
//     }

//     if (from < 1 || to > allBatch.length) {
//       toast.error(`Please enter serial numbers between 1 and ${allBatch.length}`);
//       return;
//     }

//     if (from > to) {
//       toast.error("'From' serial number must be less than or equal to 'To' serial number");
//       return;
//     }

//     const filtered = allBatch.filter((_, index) => {
//       const serialNo = index + 1;
//       return serialNo >= from && serialNo <= to;
//     });

//     setFilteredBatches(filtered);
//     setSerialRangeModalShow(false);
//     toast.success(`Showing ${filtered.length} batches`);
//   };

//   const clearAllFilters = () => {
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setFromSerial("");
//     setToSerial("");
//     setSearchText("");
//     setFilterState("");
//     setFilterDepot("");
//     setFilterPeriod("ALL");
//     setDepartmentFilter("");
//     setTrainerNameFilter("");
//     setBatchTypeFilter("");
//     setPage(0);
//     toast.success("All filters cleared");
//   };

//   const refreshData = () => {
//     setPage(0);
//     getAllBatches();
//     toast.info("Refreshing data from server...");
//   };

//   // ============================
//   // MODAL FUNCTIONS
//   // ============================
//   const openBatchReportModal = (batch) => {
//     setSelectedBatchForReport(batch);
//     setSelectedReportType("Other");
//     setBatchReportModalShow(true);
//   };

//   const openBatchSimulatorReportModal = (batch) => {
//     setSelectedBatchForSimulatorReport(batch);
//     setBatchSimulatorReportModalShow(true);
//   };

//   // ============================
//   // DOWNLOAD SINGLE BATCH REPORT
//   // ============================
//   const downloadSingleBatchReport = async () => {
//     if (!selectedBatchForReport) {
//       toast.error("No batch selected");
//       return;
//     }

//     try {
//       setLoader(true);
//       setBatchReportModalShow(false);
      
//       const batchId = selectedBatchForReport.id;
//       const batchName = selectedBatchForReport.batchName || "Batch";
      
//       toast.info(`Downloading ${selectedReportType} report for ${batchName}...`);
      
//       const apiUrl = `${downloadBatchReport}${batchId}?type=${selectedReportType}`;
//       const response = await axios.get(apiUrl, { 
//         responseType: "blob", 
//         timeout: 120000
//       });
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `${batchName}_${selectedReportType}_Report.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`${selectedReportType} report downloaded for ${batchName}`);
      
//     } catch (error) {
//       console.error(`Error downloading report:`, error);
//       toast.error(`Failed to download report: ${error.message}`);
//     } finally {
//       setLoader(false);
//       setSelectedBatchForReport(null);
//     }
//   };

//   // ============================
//   // DOWNLOAD SINGLE BATCH SIMULATOR REPORT
//   // ============================
//   const downloadSingleBatchSimulatorReport = async () => {
//     if (!selectedBatchForSimulatorReport) {
//       toast.error("No batch selected");
//       return;
//     }

//     try {
//       setLoader(true);
//       setBatchSimulatorReportModalShow(false);
      
//       const batchId = selectedBatchForSimulatorReport.id;
//       const batchName = selectedBatchForSimulatorReport.batchName || "Batch";
      
//       toast.info(`Downloading Simulator report for ${batchName}...`);
      
//       const apiUrl = downloadBatchSimulatorReport(batchId);
//       const response = await axios.get(apiUrl, { 
//         responseType: "blob", 
//         timeout: 120000
//       });
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `${batchName}_Simulator_Report.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`Simulator report downloaded for ${batchName}`);
      
//     } catch (error) {
//       console.error(`Error downloading simulator report:`, error);
//       toast.error(`Failed to download simulator report: ${error.message}`);
//     } finally {
//       setLoader(false);
//       setSelectedBatchForSimulatorReport(null);
//     }
//   };

//   // ============================
//   // DOWNLOAD ALL BATCHES AS ZIP
//   // ============================
//   const downloadAllBatchesAsZip = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to download");
//       return;
//     }

//     try {
//       setLoader(true);
//       setZipDownloadModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Downloading ${selectedZipType} reports for ${filteredBatches.length} batches...`
//       });

//       const mainZip = new JSZip();
//       const timestamp = moment().format("YYYYMMDD_HHmmss");
//       const reportsFolder = mainZip.folder(`All_Reports_${selectedZipType}_${timestamp}`);

//       let successCount = 0;
//       let failCount = 0;
//       const failedBatches = [];

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Downloading ${i + 1}/${filteredBatches.length}: ${batch.batchName}`
//         });
        
//         try {
//           const apiUrl = `${downloadBatchReport}${batch.id}?type=${selectedZipType}`;
//           const response = await axios.get(apiUrl, { 
//             responseType: "blob", 
//             timeout: 120000
//           });
          
//           if (response.data && response.data.size > 0) {
//             const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
//             const batchFolder = reportsFolder.folder(batchFolderName);
            
//             batchFolder.file(`${selectedZipType}_Report.zip`, response.data);
            
//             const trainers = batchTrainersMap[batch.id] || [];
//             const trainerName = formatTrainerNames(trainers);
//             const feedbackRating = batchFeedbackRatings[batch.id];
//             const feedbackCount = batchFeedbackCounts[batch.id] || 0;
//             const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
//             const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
//             const batchInfo = {
//               batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
//               batchName: batch.batchName,
//               batchId: batch.id,
//               department: batch.department,
//               depot: batch.depot,
//               state: batch.state,
//               startDate: formatDateToDDMMYYYY(batch.trainingStartDate),
//               endDate: formatDateToDDMMYYYY(batch.trainingEndDate),
//               trainers: trainers.map(t => ({
//                 id: t.id,
//                 name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
//               })),
//               trainerName: trainerName,
//               totalStudents: batch.totalStudents || 0,
//               passedStudents: batch.passedStudents || 0,
//               failedStudents: batch.failedStudents || 0,
//               notAttemptedStudents: batch.notAttemptedStudents || 0,
//               passPercentage: batch.passPercentage || 0,
//               feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
//               feedbackCount: feedbackCount,
//               feedbackGivenCount: feedbackGivenCount,
//               notFeedbackGivenCount: notFeedbackGivenCount,
//               reportType: selectedZipType,
//               downloadedAt: new Date().toISOString()
//             };
            
//             batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
//             try {
//               const downloadedZip = await JSZip.loadAsync(response.data);
//               const imageFiles = Object.keys(downloadedZip.files).filter(
//                 filename => filename.startsWith('images/') && 
//                 (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png') || filename.endsWith('.gif'))
//               );
              
//               if (imageFiles.length > 0) {
//                 const imagesFolder = batchFolder.folder("Images");
//                 for (const imageFile of imageFiles) {
//                   const imageData = await downloadedZip.files[imageFile].async("blob");
//                   const imageName = imageFile.split('/').pop();
//                   imagesFolder.file(imageName, imageData);
//                 }
//               }
//             } catch (imageError) {
//               console.log(`No images found for batch ${batch.batchName}`);
//             }
            
//             successCount++;
//           } else {
//             failCount++;
//             failedBatches.push({ name: batch.batchName, error: "Empty response" });
//           }
//         } catch (error) {
//           console.error(`Error downloading batch ${batch.batchName}:`, error);
//           failCount++;
//           failedBatches.push({ name: batch.batchName, error: error.message });
//         }
//       }

//       const summaryReport = [
//         "DOWNLOAD SUMMARY",
//         "================",
//         `Report Type: ${selectedZipType}`,
//         `Date: ${new Date().toLocaleString()}`,
//         `Total Batches: ${filteredBatches.length}`,
//         `Successfully Downloaded: ${successCount}`,
//         `Failed: ${failCount}`,
//         "",
//         failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
//         ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
//         "",
//         "BATCH SUMMARY",
//         "==============",
//         ...filteredBatches.map((batch, idx) => {
//           const rating = batchFeedbackRatings[batch.id];
//           const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
//           const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
//           return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
//         })
//       ].join("\n");

//       reportsFolder.file("Download_Summary.txt", summaryReport);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

//       const finalZipBlob = await mainZip.generateAsync({
//         type: "blob",
//         compression: "DEFLATE",
//         compressionOptions: { level: 6 },
//       });

//       const downloadUrl = window.URL.createObjectURL(finalZipBlob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `All_Batches_${selectedZipType}_${timestamp}.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       if (failCount === 0) {
//         toast.success(`All ${successCount} batches downloaded successfully with images!`);
//       } else {
//         toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
//       }
//     } catch (error) {
//       console.error("Error downloading all reports:", error);
//       toast.error("Error downloading reports: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // DOWNLOAD ALL BATCHES SIMULATOR AS ZIP
//   // ============================
//   const downloadAllBatchesSimulatorAsZip = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to download");
//       return;
//     }

//     try {
//       setLoader(true);
//       setZipSimulatorDownloadModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Downloading Simulator reports for ${filteredBatches.length} batches...`
//       });

//       const mainZip = new JSZip();
//       const timestamp = moment().format("YYYYMMDD_HHmmss");
//       const reportsFolder = mainZip.folder(`All_Simulator_Reports_${timestamp}`);

//       let successCount = 0;
//       let failCount = 0;
//       const failedBatches = [];

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Downloading ${i + 1}/${filteredBatches.length}: ${batch.batchName} Simulator Report`
//         });
        
//         try {
//           const apiUrl = downloadBatchSimulatorReport(batch.id);
//           const response = await axios.get(apiUrl, { 
//             responseType: "blob", 
//             timeout: 120000
//           });
          
//           if (response.data && response.data.size > 0) {
//             const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
//             const batchFolder = reportsFolder.folder(batchFolderName);
            
//             batchFolder.file(`Simulator_Report.xlsx`, response.data);
            
//             const trainers = batchTrainersMap[batch.id] || [];
//             const trainerName = formatTrainerNames(trainers);
//             const feedbackRating = batchFeedbackRatings[batch.id];
//             const feedbackCount = batchFeedbackCounts[batch.id] || 0;
//             const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
//             const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
//             const batchInfo = {
//               batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
//               batchName: batch.batchName,
//               batchId: batch.id,
//               department: batch.department,
//               depot: batch.depot,
//               state: batch.state,
//               startDate: formatDateToDDMMYYYY(batch.trainingStartDate),
//               endDate: formatDateToDDMMYYYY(batch.trainingEndDate),
//               trainers: trainers.map(t => ({
//                 id: t.id,
//                 name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
//               })),
//               trainerName: trainerName,
//               totalStudents: batch.totalStudents || 0,
//               passedStudents: batch.passedStudents || 0,
//               failedStudents: batch.failedStudents || 0,
//               notAttemptedStudents: batch.notAttemptedStudents || 0,
//               passPercentage: batch.passPercentage || 0,
//               feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
//               feedbackCount: feedbackCount,
//               feedbackGivenCount: feedbackGivenCount,
//               notFeedbackGivenCount: notFeedbackGivenCount,
//               reportType: "Simulator",
//               downloadedAt: new Date().toISOString()
//             };
            
//             batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
//             successCount++;
//           } else {
//             failCount++;
//             failedBatches.push({ name: batch.batchName, error: "Empty response" });
//           }
//         } catch (error) {
//           console.error(`Error downloading simulator report for batch ${batch.batchName}:`, error);
//           failCount++;
//           failedBatches.push({ name: batch.batchName, error: error.message });
//         }
//       }

//       const summaryReport = [
//         "SIMULATOR DOWNLOAD SUMMARY",
//         "========================",
//         `Report Type: Simulator`,
//         `Date: ${new Date().toLocaleString()}`,
//         `Total Batches: ${filteredBatches.length}`,
//         `Successfully Downloaded: ${successCount}`,
//         `Failed: ${failCount}`,
//         "",
//         failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
//         ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
//         "",
//         "BATCH SUMMARY",
//         "==============",
//         ...filteredBatches.map((batch, idx) => {
//           const rating = batchFeedbackRatings[batch.id];
//           const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
//           const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
//           return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
//         })
//       ].join("\n");

//       reportsFolder.file("Download_Summary.txt", summaryReport);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

//       const finalZipBlob = await mainZip.generateAsync({
//         type: "blob",
//         compression: "DEFLATE",
//         compressionOptions: { level: 6 },
//       });

//       const downloadUrl = window.URL.createObjectURL(finalZipBlob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `All_Batches_Simulator_Reports_${timestamp}.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       if (failCount === 0) {
//         toast.success(`All ${successCount} simulator reports downloaded successfully!`);
//       } else {
//         toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
//       }
//     } catch (error) {
//       console.error("Error downloading simulator reports:", error);
//       toast.error("Error downloading simulator reports: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // RENDER
//   // ============================
//   return (
//     <>
//       {loader && <Loader />}

//       {consolidatedProgress.active && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             zIndex: 9999,
//             backgroundColor: "rgba(255,255,255,0.95)",
//             padding: "15px 20px",
//             boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//           }}
//         >
//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <span className="fw-bold text-primary">
//               <i className="fas fa-spinner fa-spin me-2"></i>
//               {consolidatedProgress.message}
//             </span>
//             <span className="text-muted">
//               {consolidatedProgress.current}/{consolidatedProgress.total}
//             </span>
//           </div>
//           <LinearProgress
//             variant="determinate"
//             value={consolidatedProgress.total > 0 ? (consolidatedProgress.current / consolidatedProgress.total) * 100 : 0}
//           />
//         </div>
//       )}

//       <Row>
//         <Col>
//           <Card>
//             <CardBody>
//               {/* Header Section */}
//               <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
//                 <CardTitle className="h4 mb-0">
//                   All Batches
//                   {filterState && <span className="ms-2 fs-6 text-muted">(State: {filterState})</span>}
//                   {filterDepot && <span className="ms-2 fs-6 text-muted">(Depot: {filterDepot})</span>}
//                   {filterPeriod !== "ALL" && (
//                     <span className="ms-2 fs-6 text-muted">(Period: {filterPeriod})</span>
//                   )}
//                   {isCustomDateRangeActive && customStartDate && customEndDate && (
//                     <span className="ms-2 fs-6 text-muted">
//                       (Custom Range: {formatDateToDDMMYYYY(customStartDate)} - {formatDateToDDMMYYYY(customEndDate)})
//                     </span>
//                   )}
//                   {departmentFilter && (
//                     <span className="ms-2 fs-6 text-muted">(Dept: {departmentFilter})</span>
//                   )}
//                 </CardTitle>
//                 <div className="d-flex flex-wrap gap-2">
//                   <Button color="secondary" size="sm" onClick={handleFilterClick}>
//                     <FilterListIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Filters
//                   </Button>
//                   <Menu
//                     anchorEl={filterAnchorEl}
//                     open={Boolean(filterAnchorEl)}
//                     onClose={handleFilterClose}
//                   >
//                     <div style={{ padding: "16px", minWidth: "280px" }}>
//                       <Typography variant="subtitle2" className="mb-2">State</Typography>
//                       <Select
//                         options={availableStates.map(s => ({ value: s, label: s }))}
//                         value={filterState ? { value: filterState, label: filterState } : null}
//                         onChange={(option) => {
//                           setFilterState(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All States"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Depot</Typography>
//                       <Select
//                         options={availableDepots.map(d => ({ value: d, label: d }))}
//                         value={filterDepot ? { value: filterDepot, label: filterDepot } : null}
//                         onChange={(option) => {
//                           setFilterDepot(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All Depots"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Department</Typography>
//                       <Select
//                         options={availableDepartments.map(d => ({ value: d, label: d }))}
//                         value={departmentFilter ? { value: departmentFilter, label: departmentFilter } : null}
//                         onChange={(option) => {
//                           setDepartmentFilter(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All Departments"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Period</Typography>
//                       <Select
//                         options={periodOptions}
//                         value={periodOptions.find(p => p.value === filterPeriod)}
//                         onChange={(option) => {
//                           setFilterPeriod(option?.value || "ALL");
//                           setPage(0);
//                           if (option?.value !== "CUSTOM") {
//                             setIsCustomDateRangeActive(false);
//                           }
//                         }}
//                         className="mb-3"
//                       />
                      
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={openCustomDateRangeModal}
//                         fullWidth
//                         style={{ marginBottom: "8px" }}
//                       >
//                         Custom Date Range
//                       </Button>
//                       {isCustomDateRangeActive && (
//                         <Button 
//                           size="small" 
//                           variant="outlined" 
//                           onClick={clearCustomDateRange}
//                           fullWidth
//                           style={{ marginBottom: "8px", backgroundColor: "#ffebee" }}
//                         >
//                           Clear Date Range
//                         </Button>
//                       )}
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={() => setSerialRangeModalShow(true)}
//                         fullWidth
//                         style={{ marginBottom: "8px" }}
//                       >
//                         Serial Range
//                       </Button>
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={resetFilters}
//                         fullWidth
//                       >
//                         Reset All Filters
//                       </Button>
//                     </div>
//                   </Menu>
                  
//                   <Button color="secondary" size="sm" onClick={() => setSerialRangeModalShow(true)}>
//                     <i className="fas fa-sort-numeric-up-alt me-1"></i>Serial Range
//                   </Button>
                  
//                   {(filterState || filterDepot || filterPeriod !== "ALL" || isCustomDateRangeActive || fromSerial || toSerial || searchText || departmentFilter) && (
//                     <Button color="danger" size="sm" onClick={clearAllFilters}>
//                       <i className="fas fa-times me-1"></i>Clear All
//                     </Button>
//                   )}
                  
//                   <Button color="info" size="sm" onClick={downloadExcel}>
//                     <i className="fas fa-download me-1"></i>Excel
//                   </Button>
                  
//                   <Button color="success" size="sm" onClick={() => setZipDownloadModalShow(true)}>
//                     <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Download ZIP
//                   </Button>
                  
//                   <Button color="success" size="sm" onClick={() => setZipSimulatorDownloadModalShow(true)}>
//                     <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Simulator ZIP
//                   </Button>
                  
//                   <Button color="warning" size="sm" onClick={openConsolidatedModal}>
//                     <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Consolidated Report
//                   </Button>
                  
//                   <Button color="warning" size="sm" onClick={openConsolidatedSimulatorModal}>
//                     <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Combined Consolidated
//                   </Button>
                  
//                   <Button color="primary" size="sm" onClick={refreshData}>
//                     <RefreshIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Refresh
//                   </Button>
//                 </div>
//               </div>

//               {/* Search and Stats */}
//               <Row className="mb-3">
//                 <Col md={6}>
//                   <TextField
//                     fullWidth
//                     label="Search..."
//                     placeholder="Batch name, department, depot, state, trainer, date"
//                     value={searchText}
//                     onChange={(e) => {
//                       setSearchText(e.target.value);
//                       setPage(0);
//                     }}
//                     variant="outlined"
//                     size="small"
//                     InputProps={{
//                       startAdornment: <i className="fas fa-search" style={{ marginRight: 8, color: "#6c757d" }}></i>,
//                     }}
//                   />
//                 </Col>
//                 <Col md={6} className="d-flex align-items-center">
//                   <small className="text-muted">
//                     <span className="me-2">Batches: <strong>{totalItems}</strong></span>
//                     <span className="me-2">| Students: <strong>{filteredStats.totalStudents}</strong></span>
//                     <span className="me-2 text-success">| Passed: <strong>{filteredStats.totalPassed}</strong></span>
//                     <span className="me-2 text-danger">| Failed: <strong>{filteredStats.totalFailed}</strong></span>
//                     <span className="me-2 text-warning">| Not Attempted: <strong>{filteredStats.totalNotAttempted}</strong></span>
//                     <span>| Pass Rate: <strong>{filteredStats.passRate}%</strong></span>
//                     <span className="ms-2" style={{ color: "#ffb400" }}>
//                       | Avg Rating: <strong>{filteredStats.avgRating > 0 ? filteredStats.avgRating + " ★" : "No Ratings"}</strong>
//                     </span>
//                     <span className="ms-2 text-success">
//                       | Feedback Given: <strong>{filteredStats.totalFeedbackGiven}</strong>
//                     </span>
//                     <span className="ms-2 text-danger">
//                       | Not Given: <strong>{filteredStats.totalNotFeedbackGiven}</strong>
//                     </span>
//                   </small>
//                 </Col>
//               </Row>

//               {/* Data Grid */}
//               <Paper elevation={0} style={{ border: "1px solid #e0e0e0" }}>
//                 <DataGrid
//                   autoHeight
//                   rows={filteredBatches.map((r, i) => ({
//                     ...r,
//                     serialNo: page * pageSize + i + 1,
//                     id: r.id,
//                   }))}
//                   columns={columns}
//                   pageSizeOptions={[5, 10, 25, 50, 100]}
//                   initialState={{
//                     pagination: { paginationModel: { pageSize: pageSize, page: 0 } },
//                   }}
//                   onPaginationModelChange={(model) => {
//                     if (model.pageSize !== pageSize) {
//                       handlePageSizeChange(model.pageSize);
//                     }
//                   }}
//                   disableRowSelectionOnClick
//                   sx={{
//                     "& .MuiDataGrid-cell:focus": { outline: "none" },
//                     "& .MuiDataGrid-columnHeaders": { backgroundColor: "#f8f9fa", fontWeight: "bold" },
//                   }}
//                 />
//               </Paper>

//               {renderPagination()}
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>

//       {/* ============================ */}
//       {/* MODALS */}
//       {/* ============================ */}

//       {/* Custom Date Range Modal */}
//       <Modal show={dateRangeModalShow} centered onHide={() => setDateRangeModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Select Custom Date Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="row">
//             <div className="col-md-6 mb-3">
//               <label className="form-label fw-bold">Start Date</label>
//               <DatePicker
//                 selected={customStartDate}
//                 onChange={(date) => setCustomStartDate(date)}
//                 selectsStart
//                 startDate={customStartDate}
//                 endDate={customEndDate}
//                 className="form-control"
//                 dateFormat="dd/MM/yyyy"
//                 placeholderText="Select start date"
//                 maxDate={customEndDate || undefined}
//                 showYearDropdown
//                 showMonthDropdown
//                 dropdownMode="select"
//               />
//             </div>
//             <div className="col-md-6 mb-3">
//               <label className="form-label fw-bold">End Date</label>
//               <DatePicker
//                 selected={customEndDate}
//                 onChange={(date) => setCustomEndDate(date)}
//                 selectsEnd
//                 startDate={customStartDate}
//                 endDate={customEndDate}
//                 minDate={customStartDate}
//                 className="form-control"
//                 dateFormat="dd/MM/yyyy"
//                 placeholderText="Select end date"
//                 showYearDropdown
//                 showMonthDropdown
//                 dropdownMode="select"
//               />
//             </div>
//           </div>
//           <div className="mt-2 p-2 bg-light rounded">
//             <small className="text-muted">
//               <i className="fas fa-info-circle me-1"></i>
//               Select a date range to show batches that started within this period.
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDateRangeModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={applyCustomDateRange}>
//             Apply Filter
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Serial Range Modal */}
//       <Modal show={serialRangeModalShow} centered onHide={() => setSerialRangeModalShow(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Serial Number Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="mb-3">
//             <label className="form-label fw-bold">From</label>
//             <input
//               type="number"
//               className="form-control"
//               min="1"
//               max={allBatch.length}
//               value={fromSerial}
//               onChange={(e) => setFromSerial(e.target.value)}
//               placeholder={`1 to ${allBatch.length}`}
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label fw-bold">To</label>
//             <input
//               type="number"
//               className="form-control"
//               min="1"
//               max={allBatch.length}
//               value={toSerial}
//               onChange={(e) => setToSerial(e.target.value)}
//               placeholder={`1 to ${allBatch.length}`}
//             />
//           </div>
//           <div className="mt-2 p-2 bg-light rounded">
//             <small className="text-muted">
//               <i className="fas fa-info-circle me-1"></i>
//               Enter serial number range to filter batches by their position in the list.
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setSerialRangeModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={applySerialRangeFilter}>
//             Apply
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Batch Modal */}
//       <Modal show={modalShow} size="lg" centered onHide={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Batch</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Row className="mb-3">
//             <label htmlFor="batch-name-input" className="col-md-2 col-form-label">
//               Batch Name
//             </label>
//             <div className="col-md-10">
//               <input
//                 id="batch-name-input"
//                 type="text"
//                 className="form-control"
//                 placeholder="Enter new batch name"
//                 maxLength="50"
//                 value={name}
//                 onChange={(e) => { setName(e.target.value); setSpanDisplay("none"); }}
//               />
//               <span style={{ color: "red", display: spanDisplay, fontSize: "12px", marginTop: "5px" }}>
//                 Batch name is required
//               </span>
//             </div>
//           </Row>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button color="secondary" onClick={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
//             Close
//           </Button>
//           <Button color="success" onClick={handleUpdate}>
//             Update
//           </Button>
//           <Button color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false); }}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Modal */}
//       <Modal show={deleteModalShow} centered onHide={() => setDeleteModalShow(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Delete</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="text-center py-3">
//             <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: "48px" }}></i>
//             <h5 className="mt-3">Delete this batch?</h5>
//             <p className="text-muted">This action cannot be undone.</p>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button color="secondary" onClick={() => { setDeleteModalShow(false); setModalShow(true); }}>
//             Cancel
//           </Button>
//           <Button color="danger" onClick={handleDelete}>
//             Yes, Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Individual Batch Report Modal */}
//       <Modal show={batchReportModalShow} centered onHide={() => setBatchReportModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download Batch Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
//             <DownloadIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
//             <div>
//               <strong>Download Report for {selectedBatchForReport?.batchName || "Batch"}</strong>
//               <small className="d-block text-muted">
//                 Select report type to download with images
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batch</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.batchName || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Department</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.department || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.totalStudents || 0}</div>
//             </div>
//             <div>
//               <small className="text-muted">Depot</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.depot || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">State</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.state || "N/A"}</div>
//             </div>
//           </div>

//           <label className="mb-2 fw-bold">Select Report Type:</label>
//           <Select
//             options={reportTypeOptions}
//             value={reportTypeOptions.find((opt) => opt.value === selectedReportType)}
//             onChange={(option) => setSelectedReportType(option?.value || "Other")}
//             placeholder="Choose report type..."
//             isSearchable={false}
//           />

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The downloaded file will be a ZIP containing:
//               <ul className="mt-2 mb-0">
//                 <li>Excel report with all student data</li>
//                 <li>Images folder with all uploaded images</li>
//                 <li>Complete with all fields including Pre Test, Post Test, Practical Grade, etc.</li>
//               </ul>
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBatchReportModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="success" onClick={downloadSingleBatchReport}>
//             <DownloadIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download {selectedReportType} Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Individual Batch Simulator Report Modal */}
//       <Modal show={batchSimulatorReportModalShow} centered onHide={() => setBatchSimulatorReportModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download Simulator Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Download Simulator Report for {selectedBatchForSimulatorReport?.batchName || "Batch"}</strong>
//               <small className="d-block text-muted">
//                 Download complete simulator report with all scenarios (PASS/FAIL/NOT_ATTEMPTED)
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batch</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.batchName || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Department</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.department || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.totalStudents || 0}</div>
//             </div>
//             <div>
//               <small className="text-muted">Depot</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.depot || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">State</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.state || "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The simulator report includes:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
//                 <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//               </ul>
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBatchSimulatorReportModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadSingleBatchSimulatorReport}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download Simulator Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Consolidated Report Modal */}
//       <Modal show={consolidatedModalShow} centered onHide={() => setConsolidatedModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Generate Consolidated Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
//             <MergeTypeIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
//             <div>
//               <strong>Single Sheet Consolidated Report</strong>
//               <small className="d-block text-muted">
//                 Combines all data from <strong>{allFilteredBatchCount}</strong> filtered batches into a single Excel sheet
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Process</small>
//               <div className="fw-bold fs-5">{allFilteredBatchCount}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//             <div>
//               <small className="text-muted">Avg Rating</small>
//               <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               This will generate a single Excel file containing all data with:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
//               </ul>
//             </small>
//           </div>

//           {allFilteredBatchCount > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Processing <strong>{allFilteredBatchCount}</strong> batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConsolidatedModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="success" onClick={downloadConsolidatedSimulator}>
//             <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Generate Report ({allFilteredBatchCount} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Consolidated Simulator Report Modal */}
//       <Modal show={consolidatedSimulatorModalShow} centered onHide={() => setConsolidatedSimulatorModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Generate Consolidated Simulator Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Single Sheet Consolidated Simulator Report</strong>
//               <small className="d-block text-muted">
//                 Combines all simulator data from <strong>{allFilteredBatchCount}</strong> filtered batches into a single Excel sheet
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Process</small>
//               <div className="fw-bold fs-5">{allFilteredBatchCount}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//             <div>
//               <small className="text-muted">Avg Rating</small>
//               <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               This will generate a single Excel file containing simulator data:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
//                 <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//                 <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
//               </ul>
//             </small>
//           </div>

//           {allFilteredBatchCount > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Processing <strong>{allFilteredBatchCount}</strong> batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConsolidatedSimulatorModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadConsolidatedSimulator}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Generate Simulator Report ({allFilteredBatchCount} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ZIP Download Modal */}
//       <Modal show={zipDownloadModalShow} centered onHide={() => setZipDownloadModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download All Batches as ZIP</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ArchiveIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Batch-wise ZIP Download with Images</strong>
//               <small className="d-block text-muted">
//                 Downloads each batch's report as a separate folder in a single ZIP file
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Download</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//           </div>

//           <label className="mb-2 fw-bold">Report Type:</label>
//           <Select
//             options={zipDownloadOptions}
//             value={zipDownloadOptions.find((opt) => opt.value === selectedZipType)}
//             onChange={(option) => setSelectedZipType(option?.value || "Other")}
//             placeholder="Choose report type..."
//             isSearchable={false}
//           />

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The ZIP file will contain:
//               <ul className="mt-2 mb-0">
//                 <li>Each batch in a separate folder with original report ZIP</li>
//                 <li>Batch_Info.json with complete batch details</li>
//                 <li>Images folder with all uploaded images</li>
//                 <li>Download_Summary.txt with overall statistics</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Downloading {filteredBatches.length} batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setZipDownloadModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadAllBatchesAsZip}>
//             <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download All as ZIP ({filteredBatches.length} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ZIP Simulator Download Modal */}
//       <Modal show={zipSimulatorDownloadModalShow} centered onHide={() => setZipSimulatorDownloadModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download All Simulator Reports as ZIP</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Batch-wise Simulator Reports ZIP Download</strong>
//               <small className="d-block text-muted">
//                 Downloads each batch's simulator report as a separate folder in a single ZIP file
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Download</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The ZIP file will contain:
//               <ul className="mt-2 mb-0">
//                 <li>Each batch in a separate folder with Simulator_Report.xlsx</li>
//                 <li>Batch_Info.json with complete batch details</li>
//                 <li>Download_Summary.txt with overall statistics</li>
//                 <li>Complete simulator data with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>All scenarios (PASS/FAIL/NOT_ATTEMPTED)</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Downloading {filteredBatches.length} batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setZipSimulatorDownloadModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadAllBatchesSimulatorAsZip}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download All Simulator Reports ({filteredBatches.length} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default connect(null, { setBreadcrumbItems })(AllGroup);







// import React, { useEffect, useState, useCallback } from "react";
// import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
// import { connect } from "react-redux";
// import { setBreadcrumbItems } from "../../store/actions";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import moment from "moment";

// import { Paper, TextField, LinearProgress, Tooltip, CircularProgress, Box, Typography, Menu, MenuItem } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { Modal } from "react-bootstrap";
// import Select from "react-select";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import FilterListIcon from '@mui/icons-material/FilterList';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import MergeTypeIcon from '@mui/icons-material/MergeType';
// import DownloadIcon from '@mui/icons-material/Download';
// import ArchiveIcon from '@mui/icons-material/Archive';
// import ScienceIcon from '@mui/icons-material/Science';
// import FirstPageIcon from '@mui/icons-material/FirstPage';
// import LastPageIcon from '@mui/icons-material/LastPage';
// import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';

// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import axios from "axios";
// import JSZip from "jszip";

// import Loader from "components/Loader/Loader";
// import {
//   fetchAllBatchesWithPagination,
//   fetchAllBatch,
//   fetchAllBatchOfTrainer,
//   getAllTrainerOfBatch,
//   getAllStudentOfBatch,
//   updateBatch,
//   deleteBatch,
//   batchDetailFile,
// } from "helpers/batch_helper";
// import { downloadBatchReport, url } from "helpers/url_helper";
// import { getResult } from "helpers/exam_helper";
// import { fetchAllFeedbackOfBatch, getAllResponsesOfFeedback } from "helpers/feedback_helper";

// // ============================
// // SIMULATOR API HELPER FUNCTIONS
// // ============================
// const SIMULATOR_EXCEL_URL = url + "api/simulator/excel/";

// const downloadBatchSimulatorReport = (batchId) => {
//   return `${SIMULATOR_EXCEL_URL}${batchId}`;
// };

// const AllGroup = (props) => {
//   document.title = "Content Management | All Batches";
//   const navigate = useNavigate();

//   const [loader, setLoader] = useState(false);
//   const [allBatch, setAllBatch] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [searchText, setSearchText] = useState("");
//   const [modalShow, setModalShow] = useState(false);
//   const [deleteModalShow, setDeleteModalShow] = useState(false);
//   const [name, setName] = useState("");
//   const [id, setId] = useState({});
//   const [spanDisplay, setSpanDisplay] = useState("none");

//   // ============================
//   // PAGINATION STATES
//   // ============================
//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalItems, setTotalItems] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);

//   // Filter states
//   const [filterState, setFilterState] = useState("");
//   const [filterDepot, setFilterDepot] = useState("");
//   const [filterPeriod, setFilterPeriod] = useState("ALL");
//   const [availableStates, setAvailableStates] = useState([]);
//   const [availableDepots, setAvailableDepots] = useState([]);
//   const [filterAnchorEl, setFilterAnchorEl] = useState(null);

//   // Report generation states
//   const [consolidatedModalShow, setConsolidatedModalShow] = useState(false);
//   const [selectedConsolidatedType, setSelectedConsolidatedType] = useState("Other");
//   const [dateRangeModalShow, setDateRangeModalShow] = useState(false);
//   const [serialRangeModalShow, setSerialRangeModalShow] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState(null);
//   const [customEndDate, setCustomEndDate] = useState(null);
//   const [isCustomDateRangeActive, setIsCustomDateRangeActive] = useState(false);
//   const [fromSerial, setFromSerial] = useState("");
//   const [toSerial, setToSerial] = useState("");

//   // Individual Batch Report Download States
//   const [batchReportModalShow, setBatchReportModalShow] = useState(false);
//   const [selectedBatchForReport, setSelectedBatchForReport] = useState(null);
//   const [selectedReportType, setSelectedReportType] = useState("Other");

//   // Individual Batch Simulator Report Download States
//   const [batchSimulatorReportModalShow, setBatchSimulatorReportModalShow] = useState(false);
//   const [selectedBatchForSimulatorReport, setSelectedBatchForSimulatorReport] = useState(null);

//   // ZIP Download States
//   const [zipDownloadModalShow, setZipDownloadModalShow] = useState(false);
//   const [selectedZipType, setSelectedZipType] = useState("Other");

//   // ZIP Simulator Download States
//   const [zipSimulatorDownloadModalShow, setZipSimulatorDownloadModalShow] = useState(false);

//   // Consolidated Simulator Report States
//   const [consolidatedSimulatorModalShow, setConsolidatedSimulatorModalShow] = useState(false);

//   // Store data maps
//   const [batchTrainersMap, setBatchTrainersMap] = useState({});
//   const [batchFeedbackRatings, setBatchFeedbackRatings] = useState({});
//   const [batchFeedbackCounts, setBatchFeedbackCounts] = useState({});
//   const [batchFeedbackGivenCounts, setBatchFeedbackGivenCounts] = useState({});
//   const [batchNotFeedbackGivenCounts, setBatchNotFeedbackGivenCounts] = useState({});
//   const [loadingRatings, setLoadingRatings] = useState({});
//   const [ratingsFetched, setRatingsFetched] = useState(false);

//   // Progress tracking
//   const [consolidatedProgress, setConsolidatedProgress] = useState({ 
//     active: false, 
//     current: 0, 
//     total: 0, 
//     message: "" 
//   });

//   const consolidatedOptions = [
//     { value: "DDT", label: "DDT Report (Single Sheet)" },
//     { value: "DASP", label: "DASP Report (Single Sheet)" },
//     { value: "Other", label: "Other Report (Single Sheet)" },
//   ];

//   const reportTypeOptions = [
//     { value: "DDT", label: "DDT Report" },
//     { value: "DASP", label: "DASP Report" },
//     { value: "Other", label: "Other Report" },
//   ];

//   const zipDownloadOptions = [
//     { value: "DDT", label: "DDT Reports (Batch-wise ZIP)" },
//     { value: "DASP", label: "DASP Reports (Batch-wise ZIP)" },
//     { value: "Other", label: "Other Reports (Batch-wise ZIP)" },
//   ];

//   const periodOptions = [
//     { value: "ALL", label: "All Time" },
//     { value: "TODAY", label: "Today" },
//     { value: "WEEKLY", label: "This Week" },
//     { value: "MONTHLY", label: "This Month" },
//     { value: "YEARLY", label: "This Year" },
//   ];

//   const pageSizeOptions = [
//     { value: 5, label: "5" },
//     { value: 10, label: "10" },
//     { value: 25, label: "25" },
//     { value: 50, label: "50" },
//   ];

//   const breadcrumbItems = [
//     { title: "Batch", link: "#" },
//     { title: "All Batches", link: "#" },
//   ];

//   // ============================
//   // FETCH FEEDBACK RATINGS
//   // ============================
//   const fetchFeedbackRatingsOnly = async (batches) => {
//     if (ratingsFetched) return;
    
//     const feedbackRatingsMap = {};
//     const feedbackCountsMap = {};
//     const feedbackGivenCountsMap = {};
//     const notFeedbackGivenCountsMap = {};
    
//     const asyncPool = async (concurrency, items, iteratorFn) => {
//       const results = [];
//       const executing = new Set();
//       for (const [index, item] of items.entries()) {
//         const promise = Promise.resolve().then(() => iteratorFn(item, index));
//         results.push(promise);
//         executing.add(promise);
//         const clean = () => executing.delete(promise);
//         promise.then(clean, clean);
//         if (executing.size >= concurrency) {
//           await Promise.race(executing);
//         }
//       }
//       return Promise.all(results);
//     };
    
//     await asyncPool(5, batches, async (batch) => {
//       const batchId = batch.id || batch._id;
//       if (!batchId) return;
      
//       try {
//         setLoadingRatings(prev => ({ ...prev, [batchId]: true }));
        
//         const feedbacksResponse = await fetchAllFeedbackOfBatch(batchId);
        
//         if (!feedbacksResponse?.success || !feedbacksResponse?.result?.length) {
//           feedbackRatingsMap[batchId] = null;
//           feedbackCountsMap[batchId] = 0;
//           feedbackGivenCountsMap[batchId] = 0;
//           notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
//           return;
//         }

//         let totalRatingSum = 0;
//         let totalResponseCount = 0;
//         let totalFeedbackGiven = 0;

//         for (const feedback of feedbacksResponse.result) {
//           const responsesResponse = await getAllResponsesOfFeedback(feedback.id);
          
//           if (responsesResponse?.success && responsesResponse?.responseResult?.length) {
//             const feedbackRatingSum = responsesResponse.responseResult.reduce(
//               (sum, response) => sum + (response.rating || 0), 
//               0
//             );
//             totalRatingSum += feedbackRatingSum;
//             totalResponseCount += responsesResponse.responseResult.length;
//             totalFeedbackGiven += responsesResponse.responseResult.length;
//           }
//         }

//         const averageRating = totalResponseCount > 0 ? totalRatingSum / totalResponseCount : null;
//         const totalStudents = batch.totalStudents || 0;
//         const notFeedbackGiven = totalStudents - totalFeedbackGiven;
        
//         feedbackRatingsMap[batchId] = averageRating;
//         feedbackCountsMap[batchId] = totalResponseCount;
//         feedbackGivenCountsMap[batchId] = totalFeedbackGiven;
//         notFeedbackGivenCountsMap[batchId] = notFeedbackGiven > 0 ? notFeedbackGiven : 0;
        
//         setBatchFeedbackRatings(prev => ({ ...prev, [batchId]: averageRating }));
//         setBatchFeedbackCounts(prev => ({ ...prev, [batchId]: totalResponseCount }));
//         setBatchFeedbackGivenCounts(prev => ({ ...prev, [batchId]: totalFeedbackGiven }));
//         setBatchNotFeedbackGivenCounts(prev => ({ ...prev, [batchId]: notFeedbackGiven > 0 ? notFeedbackGiven : 0 }));
//       } catch (error) {
//         console.error(`Error fetching feedback rating for batch ${batchId}:`, error);
//         feedbackRatingsMap[batchId] = null;
//         feedbackCountsMap[batchId] = 0;
//         feedbackGivenCountsMap[batchId] = 0;
//         notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
//       } finally {
//         setLoadingRatings(prev => ({ ...prev, [batchId]: false }));
//       }
//     });
    
//     setRatingsFetched(true);
//   };

//   // ============================
//   // FETCH TRAINERS FOR BATCHES
//   // ============================
//   const fetchTrainersForBatches = async (batches) => {
//     const trainersMap = {};
    
//     const asyncPool = async (concurrency, items, iteratorFn) => {
//       const results = [];
//       const executing = new Set();
//       for (const [index, item] of items.entries()) {
//         const promise = Promise.resolve().then(() => iteratorFn(item, index));
//         results.push(promise);
//         executing.add(promise);
//         const clean = () => executing.delete(promise);
//         promise.then(clean, clean);
//         if (executing.size >= concurrency) {
//           await Promise.race(executing);
//         }
//       }
//       return Promise.all(results);
//     };
    
//     await asyncPool(5, batches, async (batch) => {
//       const batchId = batch.id || batch._id;
//       if (!batchId) return;
//       try {
//         const trainers = await getAllTrainerOfBatch(batchId).catch(() => []);
//         trainersMap[batchId] = trainers?.success ? trainers.result || [] : [];
//       } catch (error) {
//         trainersMap[batchId] = [];
//       }
//     });
    
//     setBatchTrainersMap(trainersMap);
//   };

//   // ============================
//   // GET ALL BATCHES WITH PAGINATION
//   // ============================
//   const getAllBatches = useCallback(async () => {
//     try {
//       setLoader(true);
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       const type = authUser?.userType;
      
//       if (type === "Tata Trainer") {
//         const res = await fetchAllBatchOfTrainer();
//         if (res?.success) {
//           const batches = (res.result || []).map(batch => ({
//             id: batch.id || batch._id,
//             batchName: batch.batchName,
//             department: batch.department,
//             state: batch.state,
//             depot: batch.depot,
//             trainingStartDate: batch.trainingStartDate,
//             trainingEndDate: batch.trainingEndDate,
//             totalStudents: batch.totalStudents || batch.students?.length || 0,
//             passedStudents: batch.passedStudents || 0,
//             failedStudents: batch.failedStudents || 0,
//             notAttemptedStudents: batch.notAttemptedStudents || 0,
//             passPercentage: batch.passPercentage || 0,
//             trainerNames: batch.trainerNames || "No Trainer Assigned",
//             totalTrainers: batch.totalTrainers || 0,
//             entryBy: batch.entryBy,
//             entryAt: batch.entryAt,
//             updatedBy: batch.updatedBy,
//             updatedAt: batch.updatedAt,
//             feedbackGivenCount: batch.feedbackGivenCount || 0,
//             notFeedbackGivenCount: batch.notFeedbackGivenCount || 0
//           }));
//           setAllBatch(batches);
//           setFilteredBatches(batches);
//           setTotalItems(batches.length);
//           setTotalPages(1);
//           updateAvailableFilters(batches);
//           toast.success(`${batches.length} batches loaded successfully`);
          
//           // Fetch additional data for trainer view
//           if (batches.length > 0) {
//             await Promise.all([
//               fetchTrainersForBatches(batches),
//               fetchFeedbackRatingsOnly(batches)
//             ]);
//           }
//         }
//       } else {
//         let startDate = null;
//         let endDate = null;
        
//         if (isCustomDateRangeActive && customStartDate && customEndDate) {
//           startDate = moment(customStartDate).format("YYYY-MM-DD");
//           endDate = moment(customEndDate).format("YYYY-MM-DD");
//         } else if (filterPeriod !== "ALL") {
//           const today = moment().startOf('day');
//           switch (filterPeriod) {
//             case "TODAY":
//               startDate = today.format("YYYY-MM-DD");
//               endDate = today.format("YYYY-MM-DD");
//               break;
//             case "WEEKLY":
//               startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//               break;
//             case "MONTHLY":
//               startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//               break;
//             case "YEARLY":
//               startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//               break;
//             default:
//               break;
//           }
//         }
        
//         const response = await fetchAllBatchesWithPagination(
//           page, 
//           pageSize, 
//           startDate, 
//           endDate, 
//           filterState || null, 
//           filterDepot || null, 
//           searchText || null
//         );
        
//         if (response.data?.success) {
//           const batches = (response.data.result || []).map(batch => ({
//             id: batch.id || batch._id,
//             batchName: batch.batchName,
//             department: batch.department,
//             state: batch.state,
//             depot: batch.depot,
//             trainingStartDate: batch.trainingStartDate,
//             trainingEndDate: batch.trainingEndDate,
//             totalStudents: batch.totalStudents || 0,
//             passedStudents: batch.passedStudents || 0,
//             failedStudents: batch.failedStudents || 0,
//             notAttemptedStudents: batch.notAttemptedStudents || 0,
//             passPercentage: batch.passPercentage || 0,
//             trainerNames: batch.trainerNames || "No Trainer Assigned",
//             totalTrainers: batch.totalTrainers || 0,
//             entryBy: batch.entryBy,
//             entryAt: batch.entryAt,
//             updatedBy: batch.updatedBy,
//             updatedAt: batch.updatedAt,
//             feedbackGivenCount: batch.feedbackGivenCount || 0,
//             notFeedbackGivenCount: batch.notFeedbackGivenCount || 0
//           }));
          
//           setAllBatch(batches);
//           setFilteredBatches(batches);
//           setTotalItems(response.data.totalItems || 0);
//           setTotalPages(response.data.totalPages || 0);
          
//           updateAvailableFilters(batches);
          
//           // Fetch additional data for admin view
//           if (batches.length > 0) {
//             await Promise.all([
//               fetchTrainersForBatches(batches),
//               fetchFeedbackRatingsOnly(batches)
//             ]);
//           }
          
//           if (batches.length === 0) {
//             toast.info("No batches found for the selected filters");
//           }
//         } else {
//           toast.error(response.data?.message || "Failed to load batches");
//         }
//       }
//     } catch (error) {
//       console.error("Error in getAllBatches:", error);
//       toast.error(error?.response?.data?.message || "Failed to load batches");
//     } finally {
//       setLoader(false);
//     }
//   }, [page, pageSize, filterState, filterDepot, filterPeriod, searchText, customStartDate, customEndDate, isCustomDateRangeActive]);

//   // ============================
//   // UPDATE AVAILABLE FILTERS
//   // ============================
//   const updateAvailableFilters = (batches) => {
//     const uniqueStates = new Set();
//     const uniqueDepots = new Set();
//     batches.forEach(batch => {
//       if (batch.state) uniqueStates.add(batch.state);
//       if (batch.depot) uniqueDepots.add(batch.depot);
//     });
//     setAvailableStates([...uniqueStates]);
//     setAvailableDepots([...uniqueDepots]);
//   };

//   // ============================
//   // DOWNLOAD SINGLE BATCH REPORT
//   // ============================
//   const downloadSingleBatchReport = async () => {
//     if (!selectedBatchForReport) {
//       toast.error("No batch selected");
//       return;
//     }

//     try {
//       setLoader(true);
//       setBatchReportModalShow(false);
      
//       const batchId = selectedBatchForReport.id;
//       const batchName = selectedBatchForReport.batchName || "Batch";
      
//       toast.info(`Downloading ${selectedReportType} report for ${batchName}...`);
      
//       const apiUrl = `${downloadBatchReport}${batchId}?type=${selectedReportType}`;
//       const response = await axios.get(apiUrl, { 
//         responseType: "blob", 
//         timeout: 120000
//       });
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `${batchName}_${selectedReportType}_Report.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`${selectedReportType} report downloaded for ${batchName}`);
      
//     } catch (error) {
//       console.error(`Error downloading report:`, error);
//       toast.error(`Failed to download report: ${error.message}`);
//     } finally {
//       setLoader(false);
//       setSelectedBatchForReport(null);
//     }
//   };

//   // ============================
//   // DOWNLOAD SINGLE BATCH SIMULATOR REPORT
//   // ============================
//   const downloadSingleBatchSimulatorReport = async () => {
//     if (!selectedBatchForSimulatorReport) {
//       toast.error("No batch selected");
//       return;
//     }

//     try {
//       setLoader(true);
//       setBatchSimulatorReportModalShow(false);
      
//       const batchId = selectedBatchForSimulatorReport.id;
//       const batchName = selectedBatchForSimulatorReport.batchName || "Batch";
      
//       toast.info(`Downloading Simulator report for ${batchName}...`);
      
//       const apiUrl = downloadBatchSimulatorReport(batchId);
//       const response = await axios.get(apiUrl, { 
//         responseType: "blob", 
//         timeout: 120000
//       });
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `${batchName}_Simulator_Report.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`Simulator report downloaded for ${batchName}`);
      
//     } catch (error) {
//       console.error(`Error downloading simulator report:`, error);
//       toast.error(`Failed to download simulator report: ${error.message}`);
//     } finally {
//       setLoader(false);
//       setSelectedBatchForSimulatorReport(null);
//     }
//   };

//   // ============================
//   // OPEN BATCH REPORT MODAL
//   // ============================
//   const openBatchReportModal = (batch) => {
//     setSelectedBatchForReport(batch);
//     setSelectedReportType("Other");
//     setBatchReportModalShow(true);
//   };

//   // ============================
//   // OPEN BATCH SIMULATOR REPORT MODAL
//   // ============================
//   const openBatchSimulatorReportModal = (batch) => {
//     setSelectedBatchForSimulatorReport(batch);
//     setBatchSimulatorReportModalShow(true);
//   };

//   // ============================
//   // EXTRACT STUDENTS FROM SIMULATOR EXCEL
//   // ============================
//   const extractStudentsFromSimulatorExcel = async (excelBlob, batchInfo) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = async (e) => {
//         try {
//           const data = new Uint8Array(e.target.result);
//           const workbook = XLSX.read(data, { type: 'array' });
          
//           const firstSheetName = workbook.SheetNames[0];
//           const worksheet = workbook.Sheets[firstSheetName];
          
//           const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
//           if (!rows || rows.length === 0) {
//             resolve([]);
//             return;
//           }
          
//           let headers = [];
//           let dataStartRow = 0;
//           let scenarioColumnMap = {};
          
//           const scenarioNames = [
//             'Simulator(City_Driving)', 
//             'Simulator(Highway_Driving)', 
//             'Simulator(Practice_Area)', 
//             'Simulator(Country_Driving)', 
//             'Simulator(Hill_Driving)'
//           ];
          
//           const scenarioShortNames = [
//             'City_Driving', 'Highway_Driving', 'Practice_Area', 
//             'Country_Driving', 'Hill_Driving'
//           ];
          
//           for (let i = 0; i < Math.min(rows.length, 50); i++) {
//             const row = rows[i];
//             if (row && Array.isArray(row)) {
//               const rowStr = JSON.stringify(row).toLowerCase();
              
//               const hasScenarioHeaders = scenarioShortNames.some(scenario => 
//                 rowStr.includes(scenario.toLowerCase())
//               );
              
//               if (hasScenarioHeaders || 
//                   (rowStr.includes('s.no') || rowStr.includes('serial')) && 
//                   (rowStr.includes('name') || rowStr.includes('participant') || rowStr.includes('employee'))) {
//                 headers = row;
//                 dataStartRow = i + 1;
                
//                 headers.forEach((header, index) => {
//                   const headerStr = String(header).trim();
                  
//                   scenarioNames.forEach(scenario => {
//                     if (headerStr === scenario) {
//                       scenarioColumnMap[scenario] = index;
//                     }
//                   });
                  
//                   scenarioShortNames.forEach((scenario, idx) => {
//                     if (headerStr.includes(scenario)) {
//                       const fullName = scenarioNames[idx];
//                       if (!scenarioColumnMap[fullName]) {
//                         scenarioColumnMap[fullName] = index;
//                       }
//                     }
//                   });
//                 });
//                 break;
//               }
//             }
//           }
          
//           if (headers.length === 0 && rows.length > 0) {
//             headers = rows[0];
//             dataStartRow = 1;
            
//             headers.forEach((header, index) => {
//               const headerStr = String(header).trim();
//               scenarioShortNames.forEach((scenario, idx) => {
//                 if (headerStr.includes(scenario)) {
//                   const fullName = scenarioNames[idx];
//                   scenarioColumnMap[fullName] = index;
//                 }
//               });
//             });
//           }
          
//           const students = [];
          
//           for (let i = dataStartRow; i < rows.length; i++) {
//             const row = rows[i];
//             if (!row || !Array.isArray(row)) continue;
            
//             const hasData = row.some(cell => cell && String(cell).trim() !== '');
//             if (!hasData) continue;
            
//             const student = {};
//             headers.forEach((header, idx) => {
//               if (header && idx < row.length) {
//                 const headerKey = String(header).trim();
//                 const value = row[idx] !== undefined && row[idx] !== null ? row[idx] : "";
//                 student[headerKey] = value;
//               }
//             });
            
//             if (!student["Training Name"] && batchInfo.batchName) {
//               student["Training Name"] = batchInfo.batchName;
//             }
//             if (!student["Trainer Name"] && batchInfo.trainerName) {
//               student["Trainer Name"] = batchInfo.trainerName;
//             }
//             if (!student["Depot Manager Name"] && batchInfo.depotManagerName) {
//               student["Depot Manager Name"] = batchInfo.depotManagerName;
//             }
//             if (!student["Depot (Training)"] && batchInfo.depot) {
//               student["Depot (Training)"] = batchInfo.depot;
//             }
//             if (!student["State (Training)"] && batchInfo.state) {
//               student["State (Training)"] = batchInfo.state;
//             }
//             if (!student["Training Start Date"] && batchInfo.startDate) {
//               student["Training Start Date"] = batchInfo.startDate;
//             }
//             if (!student["Training End Date"] && batchInfo.endDate) {
//               student["Training End Date"] = batchInfo.endDate;
//             }
//             if (!student["Type"] && batchInfo.type) {
//               student["Type"] = batchInfo.type;
//             }
            
//             scenarioNames.forEach(scenario => {
//               const columnIndex = scenarioColumnMap[scenario];
//               let value = "NOT_ATTEMPTED";
              
//               if (columnIndex !== undefined && row[columnIndex] !== undefined && row[columnIndex] !== null) {
//                 value = String(row[columnIndex]).trim();
//                 if (value === "" || value === "undefined" || value === "null") {
//                   value = "NOT_ATTEMPTED";
//                 }
//               } else {
//                 const scenarioKey = Object.keys(student).find(key => 
//                   key.includes(scenario) || key.includes(scenarioShortNames[scenarioNames.indexOf(scenario)])
//                 );
//                 if (scenarioKey && student[scenarioKey] !== undefined) {
//                   value = String(student[scenarioKey]).trim();
//                   if (value === "" || value === "undefined" || value === "null") {
//                     value = "NOT_ATTEMPTED";
//                   }
//                 }
//               }
              
//               const upperValue = value.toUpperCase();
//               if (upperValue.includes('PASS')) {
//                 student[scenario] = "PASS";
//               } else if (upperValue.includes('FAIL')) {
//                 student[scenario] = "FAIL";
//               } else {
//                 student[scenario] = "NOT_ATTEMPTED";
//               }
//             });
            
//             if (student["Participant Name"] || student["Employee Id"] || student["Name"]) {
//               if (!student["Participant Name"] && student["Name"]) {
//                 student["Participant Name"] = student["Name"];
//               }
              
//               let totalSimDuration = 0;
//               let durationFound = false;
              
//               Object.keys(student).forEach(key => {
//                 if (key.toLowerCase().includes('total sim duration') || 
//                     key.toLowerCase().includes('total duration') || 
//                     key.toLowerCase().includes('sim duration')) {
//                   const durationValue = parseFloat(student[key]);
//                   if (!isNaN(durationValue) && durationValue > 0) {
//                     totalSimDuration = durationValue;
//                     durationFound = true;
//                   }
//                 }
//               });
              
//               if (!durationFound) {
//                 Object.keys(student).forEach(key => {
//                   if (key.toLowerCase().includes('duration') && 
//                       !key.toLowerCase().includes('total')) {
//                     const durationValue = parseFloat(student[key]);
//                     if (!isNaN(durationValue) && durationValue > 0) {
//                       totalSimDuration += durationValue;
//                       durationFound = true;
//                     }
//                   }
//                 });
//               }
              
//               if (!durationFound) {
//                 const durationKey = Object.keys(student).find(key => 
//                   key.includes('Total Sim Duration') || key.includes('Total Duration')
//                 );
//                 if (durationKey) {
//                   const durationValue = parseFloat(student[durationKey]);
//                   if (!isNaN(durationValue) && durationValue > 0) {
//                     totalSimDuration = durationValue;
//                   }
//                 }
//               }
              
//               student["Total Sim Duration (min)"] = totalSimDuration.toFixed(1);
              
//               let passCount = 0;
//               let failCount = 0;
//               let notAttemptedCount = 0;
              
//               scenarioNames.forEach(scenario => {
//                 const value = String(student[scenario] || "NOT_ATTEMPTED").toUpperCase();
//                 if (value === 'PASS') {
//                   passCount++;
//                 } else if (value === 'FAIL') {
//                   failCount++;
//                 } else {
//                   notAttemptedCount++;
//                 }
//               });
              
//               if (passCount > 0 && failCount === 0 && notAttemptedCount === 0) {
//                 student["Fail/Pass"] = "Pass";
//               } else if (failCount > 0) {
//                 student["Fail/Pass"] = "Fail";
//               } else if (passCount === 0 && failCount === 0 && notAttemptedCount > 0) {
//                 student["Fail/Pass"] = "Not Attempted";
//               } else if (passCount > 0 && notAttemptedCount > 0) {
//                 student["Fail/Pass"] = "Pass";
//               } else {
//                 student["Fail/Pass"] = "Not Attempted";
//               }
              
//               const requiredColumns = [
//                 "S.No.", "Training Name", "Trainer Name", "Depot Manager Name",
//                 "Depot (Training)", "Type", "State (Training)",
//                 "Training Start Date", "Training End Date",
//                 "Depot (Student)", "State (Student)", "Candidate Assigned by", 
//                 "Company", "Employee Id", "Aadhaar Number", "Phone Number", 
//                 "Email Id", "Participant Name", "Father Name", "Designation", 
//                 "Date of Service", "Last Attend Date", "Attendance Days",
//                 "Post Test Start Date", "Post Test End Date", "Pre Test", 
//                 "Post Test", "Practical Grade", "Student Rating", "Remarks"
//               ];
              
//               requiredColumns.forEach(col => {
//                 if (!student[col] || student[col] === "" || student[col] === "undefined") {
//                   if (col === "Attendance Days") {
//                     student[col] = 0;
//                   } else if (col === "Pre Test" || col === "Post Test") {
//                     student[col] = "0%";
//                   } else if (col === "Practical Grade") {
//                     student[col] = "Not Attempted";
//                   } else if (col === "Student Rating") {
//                     student[col] = "";
//                   } else {
//                     student[col] = "";
//                   }
//                 }
//               });
              
//               students.push(student);
//             }
//           }
          
//           resolve(students);
//         } catch (error) {
//           reject(error);
//         }
//       };
//       reader.onerror = reject;
//       reader.readAsArrayBuffer(excelBlob);
//     });
//   };

//   // ============================
//   // DOWNLOAD ALL BATCHES SIMULATOR AS ZIP
//   // ============================
//   const downloadAllBatchesSimulatorAsZip = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to download");
//       return;
//     }

//     try {
//       setLoader(true);
//       setZipSimulatorDownloadModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Downloading Simulator reports for ${filteredBatches.length} batches...`
//       });

//       const mainZip = new JSZip();
//       const timestamp = moment().format("YYYYMMDD_HHmmss");
//       const reportsFolder = mainZip.folder(`All_Simulator_Reports_${timestamp}`);

//       let successCount = 0;
//       let failCount = 0;
//       const failedBatches = [];

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Downloading ${i + 1}/${filteredBatches.length}: ${batch.batchName} Simulator Report`
//         });
        
//         try {
//           const apiUrl = downloadBatchSimulatorReport(batch.id);
//           const response = await axios.get(apiUrl, { 
//             responseType: "blob", 
//             timeout: 120000
//           });
          
//           if (response.data && response.data.size > 0) {
//             const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
//             const batchFolder = reportsFolder.folder(batchFolderName);
            
//             batchFolder.file(`Simulator_Report.xlsx`, response.data);
            
//             const trainers = batchTrainersMap[batch.id] || [];
//             const trainerName = formatTrainerNames(trainers);
//             const feedbackRating = batchFeedbackRatings[batch.id];
//             const feedbackCount = batchFeedbackCounts[batch.id] || 0;
//             const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
//             const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
//             const batchInfo = {
//               batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
//               batchName: batch.batchName,
//               batchId: batch.id,
//               department: batch.department,
//               depot: batch.depot,
//               state: batch.state,
//               startDate: formatDateToDDMMYYYY(batch.trainingStartDate),
//               endDate: formatDateToDDMMYYYY(batch.trainingEndDate),
//               trainers: trainers.map(t => ({
//                 id: t.id,
//                 name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
//               })),
//               trainerName: trainerName,
//               totalStudents: batch.totalStudents || 0,
//               passedStudents: batch.passedStudents || 0,
//               failedStudents: batch.failedStudents || 0,
//               notAttemptedStudents: batch.notAttemptedStudents || 0,
//               passPercentage: batch.passPercentage || 0,
//               feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
//               feedbackCount: feedbackCount,
//               feedbackGivenCount: feedbackGivenCount,
//               notFeedbackGivenCount: notFeedbackGivenCount,
//               reportType: "Simulator",
//               downloadedAt: new Date().toISOString()
//             };
            
//             batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
//             successCount++;
//           } else {
//             failCount++;
//             failedBatches.push({ name: batch.batchName, error: "Empty response" });
//           }
//         } catch (error) {
//           console.error(`Error downloading simulator report for batch ${batch.batchName}:`, error);
//           failCount++;
//           failedBatches.push({ name: batch.batchName, error: error.message });
//         }
//       }

//       const summaryReport = [
//         "SIMULATOR DOWNLOAD SUMMARY",
//         "========================",
//         `Report Type: Simulator`,
//         `Date: ${new Date().toLocaleString()}`,
//         `Total Batches: ${filteredBatches.length}`,
//         `Successfully Downloaded: ${successCount}`,
//         `Failed: ${failCount}`,
//         "",
//         failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
//         ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
//         "",
//         "BATCH SUMMARY",
//         "==============",
//         ...filteredBatches.map((batch, idx) => {
//           const rating = batchFeedbackRatings[batch.id];
//           const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
//           const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
//           return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
//         })
//       ].join("\n");

//       reportsFolder.file("Download_Summary.txt", summaryReport);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

//       const finalZipBlob = await mainZip.generateAsync({
//         type: "blob",
//         compression: "DEFLATE",
//         compressionOptions: { level: 6 },
//       });

//       const downloadUrl = window.URL.createObjectURL(finalZipBlob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `All_Batches_Simulator_Reports_${timestamp}.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       if (failCount === 0) {
//         toast.success(`All ${successCount} simulator reports downloaded successfully!`);
//       } else {
//         toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
//       }
//     } catch (error) {
//       console.error("Error downloading simulator reports:", error);
//       toast.error("Error downloading simulator reports: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // DOWNLOAD ALL BATCHES AS ZIP WITH IMAGES
//   // ============================
//   const downloadAllBatchesAsZip = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to download");
//       return;
//     }

//     try {
//       setLoader(true);
//       setZipDownloadModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Downloading ${selectedZipType} reports for ${filteredBatches.length} batches...`
//       });

//       const mainZip = new JSZip();
//       const timestamp = moment().format("YYYYMMDD_HHmmss");
//       const reportsFolder = mainZip.folder(`All_Reports_${selectedZipType}_${timestamp}`);

//       let successCount = 0;
//       let failCount = 0;
//       const failedBatches = [];

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Downloading ${i + 1}/${filteredBatches.length}: ${batch.batchName}`
//         });
        
//         try {
//           const apiUrl = `${downloadBatchReport}${batch.id}?type=${selectedZipType}`;
//           const response = await axios.get(apiUrl, { 
//             responseType: "blob", 
//             timeout: 120000
//           });
          
//           if (response.data && response.data.size > 0) {
//             const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
//             const batchFolder = reportsFolder.folder(batchFolderName);
            
//             batchFolder.file(`${selectedZipType}_Report.zip`, response.data);
            
//             const trainers = batchTrainersMap[batch.id] || [];
//             const trainerName = formatTrainerNames(trainers);
//             const feedbackRating = batchFeedbackRatings[batch.id];
//             const feedbackCount = batchFeedbackCounts[batch.id] || 0;
//             const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
//             const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
//             const batchInfo = {
//               batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
//               batchName: batch.batchName,
//               batchId: batch.id,
//               department: batch.department,
//               depot: batch.depot,
//               state: batch.state,
//               startDate: formatDateToDDMMYYYY(batch.trainingStartDate),
//               endDate: formatDateToDDMMYYYY(batch.trainingEndDate),
//               trainers: trainers.map(t => ({
//                 id: t.id,
//                 name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
//               })),
//               trainerName: trainerName,
//               totalStudents: batch.totalStudents || 0,
//               passedStudents: batch.passedStudents || 0,
//               failedStudents: batch.failedStudents || 0,
//               notAttemptedStudents: batch.notAttemptedStudents || 0,
//               passPercentage: batch.passPercentage || 0,
//               feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
//               feedbackCount: feedbackCount,
//               feedbackGivenCount: feedbackGivenCount,
//               notFeedbackGivenCount: notFeedbackGivenCount,
//               reportType: selectedZipType,
//               downloadedAt: new Date().toISOString()
//             };
            
//             batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
//             try {
//               const downloadedZip = await JSZip.loadAsync(response.data);
//               const imageFiles = Object.keys(downloadedZip.files).filter(
//                 filename => filename.startsWith('images/') && 
//                 (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png') || filename.endsWith('.gif'))
//               );
              
//               if (imageFiles.length > 0) {
//                 const imagesFolder = batchFolder.folder("Images");
//                 for (const imageFile of imageFiles) {
//                   const imageData = await downloadedZip.files[imageFile].async("blob");
//                   const imageName = imageFile.split('/').pop();
//                   imagesFolder.file(imageName, imageData);
//                 }
//               }
//             } catch (imageError) {
//               console.log(`No images found for batch ${batch.batchName}`);
//             }
            
//             successCount++;
//           } else {
//             failCount++;
//             failedBatches.push({ name: batch.batchName, error: "Empty response" });
//           }
//         } catch (error) {
//           console.error(`Error downloading batch ${batch.batchName}:`, error);
//           failCount++;
//           failedBatches.push({ name: batch.batchName, error: error.message });
//         }
//       }

//       const summaryReport = [
//         "DOWNLOAD SUMMARY",
//         "================",
//         `Report Type: ${selectedZipType}`,
//         `Date: ${new Date().toLocaleString()}`,
//         `Total Batches: ${filteredBatches.length}`,
//         `Successfully Downloaded: ${successCount}`,
//         `Failed: ${failCount}`,
//         "",
//         failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
//         ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
//         "",
//         "BATCH SUMMARY",
//         "==============",
//         ...filteredBatches.map((batch, idx) => {
//           const rating = batchFeedbackRatings[batch.id];
//           const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
//           const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
//           return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
//         })
//       ].join("\n");

//       reportsFolder.file("Download_Summary.txt", summaryReport);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

//       const finalZipBlob = await mainZip.generateAsync({
//         type: "blob",
//         compression: "DEFLATE",
//         compressionOptions: { level: 6 },
//       });

//       const downloadUrl = window.URL.createObjectURL(finalZipBlob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `All_Batches_${selectedZipType}_${timestamp}.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       if (failCount === 0) {
//         toast.success(`All ${successCount} batches downloaded successfully with images!`);
//       } else {
//         toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
//       }
//     } catch (error) {
//       console.error("Error downloading all reports:", error);
//       toast.error("Error downloading reports: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // GENERATE CONSOLIDATED SIMULATOR REPORT
//   // ============================
//   const generateConsolidatedSimulatorReport = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to process");
//       return;
//     }

//     try {
//       setLoader(true);
//       setConsolidatedSimulatorModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Fetching Simulator reports for ${filteredBatches.length} batches...`
//       });

//       const allStudents = [];
//       let failedBatches = [];
//       let totalSerialNo = 1;

//       const scenarioNames = [
//         'Simulator(City_Driving)', 
//         'Simulator(Highway_Driving)', 
//         'Simulator(Practice_Area)', 
//         'Simulator(Country_Driving)', 
//         'Simulator(Hill_Driving)'
//       ];

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Processing batch ${i + 1}/${filteredBatches.length}: ${batch.batchName} Simulator Report`
//         });

//         try {
//           const apiUrl = downloadBatchSimulatorReport(batch.id);
//           const response = await axios.get(apiUrl, { 
//             responseType: "blob", 
//             timeout: 120000
//           });
          
//           if (!response.data || response.data.size === 0) {
//             failedBatches.push({ name: batch.batchName, error: "No data received" });
//             continue;
//           }

//           const excelBlob = response.data;
          
//           const trainers = batchTrainersMap[batch.id] || [];
//           const trainerName = formatTrainerNames(trainers);
          
//           let depotManagerName = "";
//           try {
//             if (trainers.length > 0) {
//               depotManagerName = "Mohd Haque";
//             }
//           } catch (e) {
//             depotManagerName = "";
//           }
          
//           const batchInfo = {
//             batchId: batch.id,
//             batchName: batch.batchName,
//             trainerName: trainerName,
//             depotManagerName: depotManagerName,
//             depot: batch.depot,
//             state: batch.state,
//             type: batch.department || "",
//             startDate: formatDateToDDMMYYYY(batch.trainingStartDate),
//             endDate: formatDateToDDMMYYYY(batch.trainingEndDate),
//             department: batch.department
//           };
          
//           let students = [];
//           try {
//             students = await extractStudentsFromSimulatorExcel(excelBlob, batchInfo);
//           } catch (extractError) {
//             console.error(`Error extracting students from Simulator Excel for batch ${batch.batchName}:`, extractError);
//             failedBatches.push({ name: batch.batchName, error: "Failed to parse Excel data" });
//             continue;
//           }
          
//           if (students.length === 0) {
//             console.warn(`No students found in batch ${batch.batchName}`);
//             const placeholderStudent = {
//               "S.No.": totalSerialNo++,
//               "Training Name": batch.batchName,
//               "Trainer Name": trainerName,
//               "Depot Manager Name": depotManagerName,
//               "Depot (Training)": batch.depot || "N/A",
//               "Type": batch.department || "",
//               "State (Training)": batch.state || "N/A",
//               "Training Start Date": formatDateToDDMMYYYY(batch.trainingStartDate),
//               "Training End Date": formatDateToDDMMYYYY(batch.trainingEndDate),
//               "Depot (Student)": "",
//               "State (Student)": "",
//               "Candidate Assigned by": "",
//               "Company": "",
//               "Employee Id": "N/A",
//               "Aadhaar Number": "",
//               "Phone Number": "",
//               "Email Id": "",
//               "Participant Name": "No Data Available",
//               "Father Name": "",
//               "Designation": "",
//               "Date of Service": "",
//               "Last Attend Date": "",
//               "Attendance Days": 0,
//               "Post Test Start Date": "",
//               "Post Test End Date": "",
//               "Pre Test": "0%",
//               "Post Test": "0%",
//               "Practical Grade": "Not Attempted",
//               "Fail/Pass": "Not Attempted",
//               "Student Rating": "",
//               "Remarks": "",
//               "Total Sim Duration (min)": "0.0"
//             };
            
//             scenarioNames.forEach(scenario => {
//               placeholderStudent[scenario] = "NOT_ATTEMPTED";
//             });
            
//             allStudents.push(placeholderStudent);
//             continue;
//           }
          
//           const feedbackRating = batchFeedbackRatings[batch.id];
          
//           for (const student of students) {
//             student["S.No."] = totalSerialNo++;
            
//             if (feedbackRating) {
//               student["Student Rating"] = formatRatingWithStars(feedbackRating);
//             }
            
//             scenarioNames.forEach(scenario => {
//               if (!student[scenario] || student[scenario] === "" || student[scenario] === "undefined") {
//                 student[scenario] = "NOT_ATTEMPTED";
//               }
//             });
            
//             if (!student["Total Sim Duration (min)"] || student["Total Sim Duration (min)"] === "") {
//               student["Total Sim Duration (min)"] = "0.0";
//             }
            
//             const requiredColumns = [
//               "Training Name", "Trainer Name", "Depot Manager Name",
//               "Depot (Training)", "Type", "State (Training)",
//               "Training Start Date", "Training End Date",
//               "Depot (Student)", "State (Student)", "Candidate Assigned by", 
//               "Company", "Employee Id", "Aadhaar Number", "Phone Number", 
//               "Email Id", "Participant Name", "Father Name", "Designation", 
//               "Date of Service", "Last Attend Date", "Attendance Days",
//               "Post Test Start Date", "Post Test End Date", "Pre Test", 
//               "Post Test", "Practical Grade", "Fail/Pass", "Student Rating", "Remarks"
//             ];
            
//             requiredColumns.forEach(col => {
//               if (!student[col] || student[col] === "" || student[col] === "undefined") {
//                 if (col === "Attendance Days") {
//                   student[col] = 0;
//                 } else if (col === "Pre Test" || col === "Post Test") {
//                   student[col] = "0%";
//                 } else if (col === "Practical Grade") {
//                   student[col] = "Not Attempted";
//                 } else if (col === "Fail/Pass") {
//                   student[col] = "Not Attempted";
//                 } else if (col === "Student Rating") {
//                   student[col] = "";
//                 } else {
//                   student[col] = "";
//                 }
//               }
//             });
            
//             allStudents.push(student);
//           }
          
//           toast.success(`Processed ${students.length} students from ${batch.batchName} (Simulator)`);
          
//         } catch (error) {
//           console.error(`Error processing batch ${batch.batchName}:`, error);
//           failedBatches.push({ name: batch.batchName, error: error.message || "Unknown error" });
//         }
//       }

//       if (allStudents.length === 0) {
//         toast.error("No student data extracted from any batch");
//         setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
//         setLoader(false);
//         return;
//       }

//       const wb = XLSX.utils.book_new();
      
//       const fieldOrder = [
//         "S.No.", "Training Name", "Trainer Name", "Depot Manager Name",
//         "Depot (Training)", "Type", "State (Training)",
//         "Training Start Date", "Training End Date",
//         "Depot (Student)", "State (Student)", "Candidate Assigned by", 
//         "Company", "Employee Id", "Aadhaar Number", "Phone Number", 
//         "Email Id", "Participant Name", "Father Name", "Designation", 
//         "Date of Service", "Last Attend Date", "Attendance Days",
//         "Post Test Start Date", "Post Test End Date", "Pre Test", 
//         "Post Test", "Practical Grade", "Fail/Pass", "Student Rating", "Remarks",
//         "Simulator(City_Driving)", "Simulator(Highway_Driving)", 
//         "Simulator(Practice_Area)", "Simulator(Country_Driving)", 
//         "Simulator(Hill_Driving)", "Total Sim Duration (min)"
//       ];
      
//       const reportData = allStudents.map((student) => {
//         const row = {};
//         fieldOrder.forEach(field => {
//           row[field] = student[field] !== undefined && student[field] !== null ? student[field] : "";
//         });
//         return row;
//       });
      
//       const wsData = XLSX.utils.json_to_sheet(reportData);
      
//       const colWidths = [
//         { wch: 8 }, { wch: 35 }, { wch: 25 }, { wch: 20 }, { wch: 20 },
//         { wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 20 },
//         { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 18 },
//         { wch: 15 }, { wch: 30 }, { wch: 25 }, { wch: 20 }, { wch: 20 },
//         { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 20 }, { wch: 20 },
//         { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 25 },
//         { wch: 35 }, { wch: 18 }, { wch: 18 }, { wch: 18 }, { wch: 18 },
//         { wch: 18 }, { wch: 20 }
//       ];
//       wsData["!cols"] = colWidths;
      
//       XLSX.utils.book_append_sheet(wb, wsData, "Consolidated_Simulator");
      
//       const passedCount = reportData.filter(s => String(s["Fail/Pass"] || "").toUpperCase() === "PASS").length;
//       const failedCount = reportData.filter(s => String(s["Fail/Pass"] || "").toUpperCase() === "FAIL").length;
//       const notAttemptedCount = reportData.filter(s => String(s["Fail/Pass"] || "").toUpperCase() === "NOT ATTEMPTED" || s["Fail/Pass"] === "").length;
      
//       const summaryData = [
//         ["CONSOLIDATED SIMULATOR REPORT SUMMARY"],
//         [`Report Type: Simulator`],
//         [`Generated: ${new Date().toLocaleString()}`],
//         [`Total Batches Processed: ${filteredBatches.length}`],
//         [`Successful Batches: ${filteredBatches.length - failedBatches.length}`],
//         [`Failed Batches: ${failedBatches.length}`],
//         [`Total Students: ${reportData.length}`],
//         [],
//         ["STUDENT RESULTS SUMMARY"],
//         [`Passed: ${passedCount} (${reportData.length > 0 ? ((passedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
//         [`Failed: ${failedCount} (${reportData.length > 0 ? ((failedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
//         [`Not Attempted: ${notAttemptedCount} (${reportData.length > 0 ? ((notAttemptedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
//         [],
//         ["SCENARIO-WISE SUMMARY"],
//         ...['Simulator(City_Driving)', 'Simulator(Highway_Driving)', 'Simulator(Practice_Area)', 'Simulator(Country_Driving)', 'Simulator(Hill_Driving)'].map(scenario => {
//           const passCountScenario = reportData.filter(s => String(s[scenario] || "").toUpperCase() === 'PASS').length;
//           const failCountScenario = reportData.filter(s => String(s[scenario] || "").toUpperCase() === 'FAIL').length;
//           const notAttemptedScenario = reportData.filter(s => String(s[scenario] || "").toUpperCase() === 'NOT_ATTEMPTED' || s[scenario] === "").length;
//           return [scenario, `Pass: ${passCountScenario}`, `Fail: ${failCountScenario}`, `Not Attempted: ${notAttemptedScenario}`];
//         }),
//         [],
//         ["BATCH-WISE STUDENT COUNT"],
//         ...filteredBatches.map(batch => [
//           batch.batchName,
//           reportData.filter(s => s["Training Name"] === batch.batchName).length
//         ])
//       ];
      
//       if (failedBatches.length > 0) {
//         summaryData.push([], ["FAILED BATCHES"], ...failedBatches.map((f, idx) => [`${idx + 1}. ${f.name}`, f.error]));
//       }
      
//       const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
//       XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");
      
//       const fileName = `Consolidated_Simulator_Report_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;
//       const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//       saveAs(new Blob([buffer]), fileName);
      
//       const successCount = filteredBatches.length - failedBatches.length;
//       toast.success(`Simulator report generated! ${reportData.length} students from ${successCount} batches`);
      
//     } catch (error) {
//       console.error("Error generating consolidated simulator report:", error);
//       toast.error("Failed to generate consolidated simulator report: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
//     }
//   };

//   // ============================
//   // EXTRACT EXCEL FROM ZIP
//   // ============================
//   const extractExcelFromZip = async (zipBlob) => {
//     try {
//       const zip = await JSZip.loadAsync(zipBlob);
      
//       const excelFiles = Object.keys(zip.files).filter(
//         (filename) => filename.endsWith(".xlsx") || filename.endsWith(".xls") || filename.endsWith(".csv")
//       );
      
//       if (excelFiles.length === 0) {
//         throw new Error("No Excel file found in the zip archive");
//       }
      
//       const excelFile = excelFiles[0];
//       const excelData = await zip.files[excelFile].async("blob");
      
//       return excelData;
//     } catch (error) {
//       console.error("Error extracting Excel from ZIP:", error);
//       throw error;
//     }
//   };

//   // ============================
//   // EXTRACT STUDENTS FROM EXCEL
//   // ============================
//   const extractStudentsFromExcel = async (excelBlob, batchInfo) => {
//     return new Promise((resolve, reject) => {
//       const reader = new FileReader();
//       reader.onload = async (e) => {
//         try {
//           const data = new Uint8Array(e.target.result);
//           const workbook = XLSX.read(data, { type: 'array' });
          
//           const firstSheetName = workbook.SheetNames[0];
//           const worksheet = workbook.Sheets[firstSheetName];
          
//           const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
//           if (!rows || rows.length === 0) {
//             resolve([]);
//             return;
//           }
          
//           let headers = [];
//           let dataStartRow = 0;
          
//           for (let i = 0; i < Math.min(rows.length, 50); i++) {
//             const row = rows[i];
//             if (row && Array.isArray(row)) {
//               const rowStr = JSON.stringify(row).toLowerCase();
//               if ((rowStr.includes('s.no') || rowStr.includes('serial')) && 
//                   (rowStr.includes('name') || rowStr.includes('participant') || rowStr.includes('employee'))) {
//                 headers = row;
//                 dataStartRow = i + 1;
//                 break;
//               }
//             }
//           }
          
//           if (headers.length === 0 && rows.length > 0) {
//             headers = rows[0];
//             dataStartRow = 1;
//           }
          
//           const students = [];
//           for (let i = dataStartRow; i < rows.length; i++) {
//             const row = rows[i];
//             if (!row || !Array.isArray(row)) continue;
            
//             const hasData = row.some(cell => cell && String(cell).trim() !== '');
//             if (!hasData) continue;
            
//             const student = {};
//             headers.forEach((header, idx) => {
//               if (header && idx < row.length) {
//                 const headerKey = String(header).trim();
//                 const value = row[idx] || "";
//                 student[headerKey] = value;
//               }
//             });
            
//             if (!student["Training Name"] && batchInfo.batchName) {
//               student["Training Name"] = batchInfo.batchName;
//             }
//             if (!student["Trainer Name"] && batchInfo.trainerName) {
//               student["Trainer Name"] = batchInfo.trainerName;
//             }
//             if (!student["Depot (Training)"] && batchInfo.depot) {
//               student["Depot (Training)"] = batchInfo.depot;
//             }
//             if (!student["State (Training)"] && batchInfo.state) {
//               student["State (Training)"] = batchInfo.state;
//             }
//             if (!student["Training Start Date"] && batchInfo.startDate) {
//               student["Training Start Date"] = batchInfo.startDate;
//             }
//             if (!student["Training End Date"] && batchInfo.endDate) {
//               student["Training End Date"] = batchInfo.endDate;
//             }
            
//             if (student["Participant Name"] || student["Employee Id"] || student["Name"]) {
//               if (!student["Participant Name"] && student["Name"]) {
//                 student["Participant Name"] = student["Name"];
//               }
//               students.push(student);
//             }
//           }
          
//           resolve(students);
//         } catch (error) {
//           reject(error);
//         }
//       };
//       reader.onerror = reject;
//       reader.readAsArrayBuffer(excelBlob);
//     });
//   };

//   // ============================
//   // FETCH SINGLE BATCH REPORT DATA
//   // ============================
//   const fetchBatchReportData = async (batch, reportType) => {
//     try {
//       const batchId = batch.id;
//       if (!batchId) {
//         return null;
//       }

//       const apiUrl = `${downloadBatchReport}${batchId}?type=${reportType}`;
//       const response = await axios.get(apiUrl, { 
//         responseType: "blob", 
//         timeout: 120000
//       });
      
//       return response.data;
//     } catch (error) {
//       console.error(`Error fetching report for batch ${batch.batchName}:`, error);
//       return null;
//     }
//   };

//   // ============================
//   // GENERATE CONSOLIDATED SINGLE SHEET REPORT
//   // ============================
//   const generateConsolidatedReport = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to process");
//       return;
//     }

//     try {
//       setLoader(true);
//       setConsolidatedModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Fetching ${selectedConsolidatedType} reports for ${filteredBatches.length} batches...`
//       });

//       const allStudents = [];
//       let failedBatches = [];
//       let totalSerialNo = 1;

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Processing batch ${i + 1}/${filteredBatches.length}: ${batch.batchName}`
//         });

//         try {
//           const zipBlob = await fetchBatchReportData(batch, selectedConsolidatedType);
          
//           if (!zipBlob) {
//             failedBatches.push({ name: batch.batchName, error: "Failed to fetch report" });
//             continue;
//           }

//           let excelBlob;
//           try {
//             excelBlob = await extractExcelFromZip(zipBlob);
//           } catch (zipError) {
//             console.error(`Error extracting Excel from ZIP for batch ${batch.batchName}:`, zipError);
//             failedBatches.push({ name: batch.batchName, error: "Invalid ZIP file or no Excel found" });
//             continue;
//           }

//           const trainers = batchTrainersMap[batch.id] || [];
//           const trainerName = formatTrainerNames(trainers);
          
//           const batchInfo = {
//             batchName: batch.batchName,
//             trainerName: trainerName,
//             depot: batch.depot,
//             state: batch.state,
//             startDate: formatDateToDDMMYYYY(batch.trainingStartDate),
//             endDate: formatDateToDDMMYYYY(batch.trainingEndDate),
//             department: batch.department
//           };
          
//           let students = [];
//           try {
//             students = await extractStudentsFromExcel(excelBlob, batchInfo);
//           } catch (extractError) {
//             console.error(`Error extracting students from Excel for batch ${batch.batchName}:`, extractError);
//             failedBatches.push({ name: batch.batchName, error: "Failed to parse Excel data" });
//             continue;
//           }
          
//           if (students.length === 0) {
//             console.warn(`No students found in batch ${batch.batchName}`);
//             continue;
//           }
          
//           const feedbackRating = batchFeedbackRatings[batch.id];
          
//           for (const student of students) {
//             student["S.No."] = totalSerialNo++;
//             if (feedbackRating && !student["Student Rating"]) {
//               student["Student Rating"] = formatRatingWithStars(feedbackRating);
//             }
//             if (!student["Fail/Pass"]) {
//               student["Fail/Pass"] = "Not Attempted";
//             }
//             allStudents.push(student);
//           }
          
//           toast.success(`Processed ${students.length} students from ${batch.batchName}`);
          
//         } catch (error) {
//           console.error(`Error processing batch ${batch.batchName}:`, error);
//           failedBatches.push({ name: batch.batchName, error: error.message || "Unknown error" });
//         }
//       }

//       if (allStudents.length === 0) {
//         toast.error("No student data extracted from any batch");
//         setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
//         setLoader(false);
//         return;
//       }

//       const wb = XLSX.utils.book_new();
      
//       const fieldOrder = [
//         "S.No.", "Training Name", "Trainer Name", "Depot Manager Name",
//         "Depot (Training)", "Type", "State (Training)",
//         "Training Start Date", "Training End Date",
//         "Post Test Start Date", "Post Test End Date",
//         "Attendance Days", "Student Rating",
//         "Depot (Student)", "State (Student)", "Candidate Assigned by", "Company", "Employee Id",
//         "Aadhaar Number", "Phone Number", "Email Id", "Participant Name",
//         "Father Name", "Designation", "Date of Service", "Last Attend Date",
//         "Pre Test", "Post Test", "Practical Grade", "Fail/Pass", "Remarks"
//       ];
      
//       const reportData = allStudents.map((student) => {
//         const row = {};
//         fieldOrder.forEach(field => {
//           row[field] = student[field] || "";
//         });
//         return row;
//       });
      
//       const wsData = XLSX.utils.json_to_sheet(reportData);
      
//       const colWidths = [
//         { wch: 8 }, { wch: 35 }, { wch: 25 }, { wch: 20 }, { wch: 20 },
//         { wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
//         { wch: 15 }, { wch: 12 }, { wch: 15 }, { wch: 20 }, { wch: 20 },
//         { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 18 }, { wch: 15 },
//         { wch: 30 }, { wch: 25 }, { wch: 20 }, { wch: 20 }, { wch: 15 },
//         { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 },
//         { wch: 35 }
//       ];
//       wsData["!cols"] = colWidths;
      
//       XLSX.utils.book_append_sheet(wb, wsData, `${selectedConsolidatedType}_Students`);
      
//       const passedCount = reportData.filter(s => s["Fail/Pass"] === "Pass").length;
//       const failedCount = reportData.filter(s => s["Fail/Pass"] === "Fail").length;
//       const notAttemptedCount = reportData.filter(s => s["Fail/Pass"] === "Not Attempted").length;
      
//       const summaryData = [
//         ["CONSOLIDATED REPORT SUMMARY"],
//         [`Report Type: ${selectedConsolidatedType}`],
//         [`Generated: ${new Date().toLocaleString()}`],
//         [`Total Batches Processed: ${filteredBatches.length}`],
//         [`Successful Batches: ${filteredBatches.length - failedBatches.length}`],
//         [`Failed Batches: ${failedBatches.length}`],
//         [`Total Students: ${reportData.length}`],
//         [],
//         ["STUDENT RESULTS SUMMARY"],
//         [`Passed: ${passedCount} (${reportData.length > 0 ? ((passedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
//         [`Failed: ${failedCount} (${reportData.length > 0 ? ((failedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
//         [`Not Attempted: ${notAttemptedCount} (${reportData.length > 0 ? ((notAttemptedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
//         [],
//         ["BATCH-WISE STUDENT COUNT"],
//         ...filteredBatches.map(batch => [
//           batch.batchName,
//           reportData.filter(s => s["Training Name"] === batch.batchName).length
//         ])
//       ];
      
//       if (failedBatches.length > 0) {
//         summaryData.push([], ["FAILED BATCHES"], ...failedBatches.map((f, idx) => [`${idx + 1}. ${f.name}`, f.error]));
//       }
      
//       const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
//       XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");
      
//       const fileName = `Consolidated_${selectedConsolidatedType}_Report_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;
//       const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//       saveAs(new Blob([buffer]), fileName);
      
//       const successCount = filteredBatches.length - failedBatches.length;
//       toast.success(`Report generated! ${reportData.length} students from ${successCount} batches`);
      
//     } catch (error) {
//       console.error("Error generating consolidated report:", error);
//       toast.error("Failed to generate consolidated report: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
//     }
//   };

//   // ============================
//   // HELPER FUNCTIONS
//   // ============================
//   const formatRatingWithStars = (rating) => {
//     if (!rating) return "Not Rated";
//     const fullStars = Math.floor(rating);
//     const emptyStars = 5 - fullStars;
//     return `${"★".repeat(fullStars)}${"☆".repeat(emptyStars)} ${rating.toFixed(1)}/5.0`;
//   };

//   const formatTrainerNames = (trainers) => {
//     if (!trainers || trainers.length === 0) return "No Trainer Assigned";
//     const trainerNames = trainers.map((t) => {
//       if (t.name) return t.name;
//       if (t.firstName && t.lastName) return `${t.firstName} ${t.lastName}`;
//       if (t.firstName) return t.firstName;
//       if (t.fullName) return t.fullName;
//       if (t.email) return t.email.split("@")[0];
//       return `Trainer ${t.id}`;
//     });
//     if (trainers.length === 1) return trainerNames[0];
//     return `${trainerNames[0]} +${trainers.length - 1}`;
//   };

//   // ============================
//   // APPLY FILTERS
//   // ============================
//   const applyFilters = () => {
//     let filtered = [...allBatch];

//     if (filterState && filterState !== "") {
//       filtered = filtered.filter(batch => batch.state === filterState);
//     }

//     if (filterDepot && filterDepot !== "") {
//       filtered = filtered.filter(batch => batch.depot === filterDepot);
//     }

//     if (filterPeriod && filterPeriod !== "ALL") {
//       const today = moment().startOf('day');
      
//       filtered = filtered.filter(batch => {
//         if (!batch.trainingStartDate) return false;
        
//         let startDate = parseDate(batch.trainingStartDate);
        
//         if (!startDate || !startDate.isValid()) {
//           return false;
//         }
        
//         startDate = startDate.startOf('day');
        
//         switch (filterPeriod) {
//           case "TODAY":
//             return startDate.isSame(today, 'day');
//           case "WEEKLY":
//             return startDate.isSame(today, 'week');
//           case "MONTHLY":
//             return startDate.isSame(today, 'month');
//           case "YEARLY":
//             return startDate.isSame(today, 'year');
//           default:
//             return true;
//         }
//       });
//     }

//     if (isCustomDateRangeActive && customStartDate && customEndDate) {
//       const start = moment(customStartDate).startOf('day');
//       const end = moment(customEndDate).endOf('day');
      
//       filtered = filtered.filter(batch => {
//         if (!batch.trainingStartDate) return false;
//         const batchDate = parseDate(batch.trainingStartDate);
//         if (!batchDate || !batchDate.isValid()) return false;
//         return batchDate.isBetween(start, end, null, '[]');
//       });
//     }

//     if (searchText) {
//       const search = searchText.toLowerCase().trim();
//       filtered = filtered.filter(batch => {
//         const batchId = batch.id;
//         const trainers = batchTrainersMap[batchId] || [];
//         const trainerNames = trainers.map(t => t.name || `${t.firstName || ""} ${t.lastName || ""}`).join(" ").toLowerCase();
        
//         return (
//           (batch.batchName || "").toLowerCase().includes(search) ||
//           (batch.department || "").toLowerCase().includes(search) ||
//           (batch.depot || "").toLowerCase().includes(search) ||
//           (batch.state || "").toLowerCase().includes(search) ||
//           trainerNames.includes(search) ||
//           (batch.trainerNames || "").toLowerCase().includes(search) ||
//           formatDateToDDMMYYYY(batch.trainingStartDate).includes(search) ||
//           formatDateToDDMMYYYY(batch.trainingEndDate).includes(search)
//         );
//       });
//     }

//     setFilteredBatches(filtered);
//   };

//   const parseDate = (dateStr) => {
//     if (!dateStr) return null;
    
//     if (moment(dateStr, moment.ISO_8601, true).isValid()) {
//       return moment(dateStr);
//     }
//     if (moment(dateStr, "DD/MM/YYYY", true).isValid()) {
//       return moment(dateStr, "DD/MM/YYYY");
//     }
//     if (moment(dateStr, "DD-MM-YYYY", true).isValid()) {
//       return moment(dateStr, "DD-MM-YYYY");
//     }
//     if (moment(dateStr, "YYYY-MM-DD", true).isValid()) {
//       return moment(dateStr, "YYYY-MM-DD");
//     }
    
//     const parsed = moment(dateStr);
//     return parsed.isValid() ? parsed : null;
//   };

//   const formatDateToDDMMYYYY = useCallback((dateStr) => {
//     if (!dateStr) return "N/A";
    
//     const date = parseDate(dateStr);
//     if (date && date.isValid()) {
//       return date.format("DD/MM/YYYY");
//     }
    
//     try {
//       if (typeof dateStr === "string") {
//         if (dateStr.includes("-")) {
//           const datePart = dateStr.split("T")[0];
//           const [year, month, day] = datePart.split("-");
//           return `${day}/${month}/${year}`;
//         }
//         if (dateStr.includes("/")) {
//           return dateStr;
//         }
//       }
//       if (dateStr instanceof Date) {
//         const day = dateStr.getDate().toString().padStart(2, "0");
//         const month = (dateStr.getMonth() + 1).toString().padStart(2, "0");
//         const year = dateStr.getFullYear();
//         return `${day}/${month}/${year}`;
//       }
//       return String(dateStr);
//     } catch (error) {
//       return String(dateStr);
//     }
//   }, []);

//   const renderStarRating = (rating, count = 0) => {
//     if (!rating || count === 0) {
//       return (
//         <Tooltip title="No feedback responses yet">
//           <span style={{ color: "#6c757d", fontStyle: "italic" }}>No Rating</span>
//         </Tooltip>
//       );
//     }

//     const fullStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 >= 0.5;
//     const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

//     return (
//       <Tooltip title={`Based on ${count} response(s) - Average Rating: ${rating.toFixed(1)}/5.0`}>
//         <Box display="flex" alignItems="center" gap={1} sx={{ cursor: "pointer" }}>
//           <Box display="flex" alignItems="center" gap={0.2}>
//             {[...Array(fullStars)].map((_, i) => (
//               <span key={`full-${i}`} style={{ color: "#ffb400", fontSize: "16px" }}>★</span>
//             ))}
//             {hasHalfStar && (
//               <span style={{ color: "#ffb400", fontSize: "16px", position: "relative", display: "inline-block" }}>
//                 <span style={{ position: "absolute", overflow: "hidden", width: "50%", color: "#ffb400" }}>★</span>
//                 <span style={{ color: "#e4e5e9" }}>★</span>
//               </span>
//             )}
//             {[...Array(emptyStars)].map((_, i) => (
//               <span key={`empty-${i}`} style={{ color: "#e4e5e9", fontSize: "16px" }}>★</span>
//             ))}
//           </Box>
//           <Typography 
//             variant="body2" 
//             sx={{ 
//               fontWeight: "bold", 
//               color: "#ffb400",
//               backgroundColor: "#fff3e0",
//               padding: "2px 6px",
//               borderRadius: "12px",
//               fontSize: "12px"
//             }}
//           >
//             {rating.toFixed(1)}
//           </Typography>
//         </Box>
//       </Tooltip>
//     );
//   };

//   const getFilteredStats = useCallback(() => {
//     let totalStudents = 0;
//     let totalPassed = 0;
//     let totalFailed = 0;
//     let totalNotAttempted = 0;
//     let totalRatingSum = 0;
//     let totalRatingCount = 0;
//     let totalFeedbackGiven = 0;
//     let totalNotFeedbackGiven = 0;

//     filteredBatches.forEach((batch) => {
//       totalStudents += batch.totalStudents || 0;
//       totalPassed += batch.passedStudents || 0;
//       totalFailed += batch.failedStudents || 0;
//       totalNotAttempted += batch.notAttemptedStudents || 0;
      
//       const rating = batchFeedbackRatings[batch.id];
//       if (rating) {
//         totalRatingSum += rating;
//         totalRatingCount++;
//       }
      
//       totalFeedbackGiven += batchFeedbackGivenCounts[batch.id] || 0;
//       totalNotFeedbackGiven += batchNotFeedbackGivenCounts[batch.id] || 0;
//     });

//     const passRate = totalStudents > 0 ? ((totalPassed / totalStudents) * 100).toFixed(1) : 0;
//     const avgRating = totalRatingCount > 0 ? (totalRatingSum / totalRatingCount).toFixed(1) : 0;

//     return {
//       totalStudents,
//       totalPassed,
//       totalFailed,
//       totalNotAttempted,
//       passRate,
//       avgRating,
//       totalRatingCount,
//       totalFeedbackGiven,
//       totalNotFeedbackGiven
//     };
//   }, [filteredBatches, batchFeedbackRatings, batchFeedbackGivenCounts, batchNotFeedbackGivenCounts]);

//   const filteredStats = getFilteredStats();

//   // ============================
//   // EDIT/DELETE FUNCTIONS
//   // ============================
//   const handleRowClick = (row) => {
//     setModalShow(true);
//     navigate(`/batch/${row.id}`);
//     setId(row.id);
//     setName(row.batchName || "");
//   };

//   const handleUpdate = async () => {
//     if (!name) {
//       setSpanDisplay("inline");
//       return;
//     }

//     try {
//       setLoader(true);
//       const result = await updateBatch({ id, batchName: name });
//       if (result?.success) {
//         toast.success(result?.message);
//         getAllBatches();
//         setModalShow(false);
//         setName("");
//         setId("");
//         setSpanDisplay("none");
//       } else {
//         toast.error(result?.message);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to update batch");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       setLoader(true);
//       const result = await deleteBatch(id);
//       if (result?.success) {
//         toast.success(result?.message);
//         getAllBatches();
//         setDeleteModalShow(false);
//         setModalShow(false);
//         setName("");
//         setId("");
//       } else {
//         toast.error(result?.message);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to delete batch");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleViewDetails = (row) => {
//     navigate(`/batch/${row.id}`);
//   };

//   const resetFilters = () => {
//     setFilterState("");
//     setFilterDepot("");
//     setFilterPeriod("ALL");
//     setSearchText("");
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setFilterAnchorEl(null);
//   };

//   const handleFilterClick = (event) => {
//     setFilterAnchorEl(event.currentTarget);
//   };

//   const handleFilterClose = () => {
//     setFilterAnchorEl(null);
//   };

//   const openCustomDateRangeModal = () => {
//     setDateRangeModalShow(true);
//     handleFilterClose();
//   };

//   const applyCustomDateRange = () => {
//     if (!customStartDate || !customEndDate) {
//       toast.error("Please select both start and end dates");
//       return;
//     }

//     if (moment(customStartDate).isAfter(moment(customEndDate))) {
//       toast.error("Start date cannot be after end date");
//       return;
//     }

//     setIsCustomDateRangeActive(true);
//     setFilterPeriod("ALL");
//     setDateRangeModalShow(false);
//     toast.success(`Custom date range applied: ${formatDateToDDMMYYYY(customStartDate)} to ${formatDateToDDMMYYYY(customEndDate)}`);
//   };

//   const clearCustomDateRange = () => {
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     toast.success("Custom date range cleared");
//   };

//   const applySerialRangeFilter = () => {
//     if (!fromSerial || !toSerial) {
//       toast.error("Please enter both from and to serial numbers");
//       return;
//     }

//     const from = parseInt(fromSerial);
//     const to = parseInt(toSerial);

//     if (isNaN(from) || isNaN(to)) {
//       toast.error("Please enter valid numbers");
//       return;
//     }

//     if (from < 1 || to > allBatch.length) {
//       toast.error(`Please enter serial numbers between 1 and ${allBatch.length}`);
//       return;
//     }

//     if (from > to) {
//       toast.error("'From' serial number must be less than or equal to 'To' serial number");
//       return;
//     }

//     const filtered = allBatch.filter((_, index) => {
//       const serialNo = index + 1;
//       return serialNo >= from && serialNo <= to;
//     });

//     setFilteredBatches(filtered);
//     setSerialRangeModalShow(false);
//     toast.success(`Showing ${filtered.length} batches`);
//   };

//   const clearAllFilters = () => {
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setFromSerial("");
//     setToSerial("");
//     setSearchText("");
//     setFilterState("");
//     setFilterDepot("");
//     setFilterPeriod("ALL");
//     setFilteredBatches(allBatch);
//     toast.success("All filters cleared");
//   };

//   const refreshData = () => {
//     getAllBatches();
//     toast.info("Refreshing data from server...");
//   };

//   // ============================
//   // DOWNLOAD EXCEL WITH DATE RANGE
//   // ============================
//   const downloadExcel = async () => {
//     try {
//       setLoader(true);
      
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) {
//         toast.error("Organization ID not found. Please log in again.");
//         return;
//       }
      
//       let startDate = null;
//       let endDate = null;
      
//       if (isCustomDateRangeActive && customStartDate && customEndDate) {
//         startDate = moment(customStartDate).format("YYYY-MM-DD");
//         endDate = moment(customEndDate).format("YYYY-MM-DD");
//       } else if (filterPeriod !== "ALL") {
//         const today = moment().startOf('day');
//         switch (filterPeriod) {
//           case "TODAY":
//             startDate = today.format("YYYY-MM-DD");
//             endDate = today.format("YYYY-MM-DD");
//             break;
//           case "WEEKLY":
//             startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//             break;
//           case "MONTHLY":
//             startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//             break;
//           case "YEARLY":
//             startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//             break;
//           default:
//             break;
//         }
//       }
      
//       toast.info(startDate && endDate ? 
//         `Downloading report for Training End Date between ${moment(startDate).format('DD/MM/YYYY')} and ${moment(endDate).format('DD/MM/YYYY')}...` : 
//         "Downloading all batch report...");
      
//       const response = await batchDetailFile(startDate, endDate);
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const firstBytes = await response.data.slice(0, 100).text();
//       const trimmedFirstBytes = firstBytes.trim();
//       if (trimmedFirstBytes.startsWith('{') || trimmedFirstBytes.startsWith('[')) {
//         try {
//           const fullText = await response.data.text();
//           const errorData = JSON.parse(fullText);
//           toast.error(errorData.message || "Failed to download file");
//           return;
//         } catch (e) {
//           toast.error("Failed to download file");
//           return;
//         }
//       }
      
//       const blob = new Blob([response.data], {
//         type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       });
      
//       const downloadUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
      
//       let filename = `Batch_Details`;
//       if (startDate && endDate) {
//         filename += `_${moment(startDate).format("YYYYMMDD")}_to_${moment(endDate).format("YYYYMMDD")}`;
//       } else if (startDate) {
//         filename += `_from_${moment(startDate).format("YYYYMMDD")}`;
//       } else if (endDate) {
//         filename += `_upto_${moment(endDate).format("YYYYMMDD")}`;
//       }
//       filename += `.xlsx`;
      
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success("File downloaded successfully!");
//     } catch (error) {
//       console.error("Error downloading file:", error);
//       toast.error(error.response?.data?.message || "Failed to download file");
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // PAGE CHANGE HANDLERS
//   // ============================
//   const handlePageChange = (newPage) => {
//     if (newPage >= 0 && newPage < totalPages) {
//       setPage(newPage);
//     }
//   };

//   const handlePageSizeChange = (newSize) => {
//     setPageSize(newSize);
//     setPage(0);
//   };

//   // ============================
//   // PAGINATION RENDER
//   // ============================
//   const renderPagination = () => {
//     if (totalPages <= 1) return null;

//     const pageNumbers = [];
//     const maxVisible = 5;
//     let startPage = Math.max(0, page - Math.floor(maxVisible / 2));
//     let endPage = Math.min(totalPages - 1, startPage + maxVisible - 1);
    
//     if (endPage - startPage < maxVisible - 1) {
//       startPage = Math.max(0, endPage - maxVisible + 1);
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pageNumbers.push(i);
//     }

//     return (
//       <div className="d-flex justify-content-between align-items-center mt-3">
//         <div className="d-flex align-items-center gap-2">
//           <span className="text-muted" style={{ fontSize: "14px" }}>
//             Showing {page * pageSize + 1} to {Math.min((page + 1) * pageSize, totalItems)} of {totalItems} entries
//           </span>
//         </div>
//         <div className="d-flex align-items-center gap-2">
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(0)}
//             disabled={page === 0}
//           >
//             <FirstPageIcon style={{ fontSize: "18px" }} />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(page - 1)}
//             disabled={page === 0}
//           >
//             <NavigateBeforeIcon style={{ fontSize: "18px" }} />
//           </Button>
//           {pageNumbers.map((num) => (
//             <Button
//               key={num}
//               color={num === page ? "primary" : "secondary"}
//               size="sm"
//               onClick={() => handlePageChange(num)}
//               style={{ minWidth: "35px" }}
//             >
//               {num + 1}
//             </Button>
//           ))}
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(page + 1)}
//             disabled={page >= totalPages - 1}
//           >
//             <NavigateNextIcon style={{ fontSize: "18px" }} />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(totalPages - 1)}
//             disabled={page >= totalPages - 1}
//           >
//             <LastPageIcon style={{ fontSize: "18px" }} />
//           </Button>
//           <Select
//             options={pageSizeOptions}
//             value={pageSizeOptions.find(opt => opt.value === pageSize)}
//             onChange={(option) => handlePageSizeChange(option.value)}
//             className="ms-2"
//             styles={{
//               control: (base) => ({
//                 ...base,
//                 minHeight: "32px",
//                 width: "70px",
//               }),
//             }}
//           />
//         </div>
//       </div>
//     );
//   };

//   // ============================
//   // EFFECTS
//   // ============================
//   useEffect(() => {
//     props.setBreadcrumbItems("All Batches", breadcrumbItems);
//   }, []);

//   useEffect(() => {
//     getAllBatches();
//   }, [getAllBatches]);

//   useEffect(() => {
//     if (allBatch.length > 0) {
//       fetchTrainersForBatches(allBatch);
//       fetchFeedbackRatingsOnly(allBatch);
//     }
//   }, [allBatch]);

//   // ============================
//   // COLUMNS DEFINITION
//   // ============================
//   const columns = [
//     { field: "serialNo", headerName: "S.No", width: 70 },
//     {
//       field: "batchName",
//       headerName: "Batch Name",
//       width: 200,
//       renderCell: (params) => {
//         return (
//           <span
//             style={{ cursor: "pointer", color: "#0d6efd", fontWeight: 500, textDecoration: "underline" }}
//             onClick={() => handleViewDetails(params.row)}
//             title={`${params.row.totalStudents || 0} student(s)`}
//           >
//             {params.value}
//           </span>
//         );
//       },
//     },
//     { field: "department", headerName: "Department", width: 150 },
//     {
//       field: "trainerNames",
//       headerName: "Trainer(s)",
//       width: 250,
//       renderCell: (params) => {
//         return <span>{params.value || "No Trainer Assigned"}</span>;
//       },
//     },
//     {
//       field: "state",
//       headerName: "State",
//       width: 130,
//       renderCell: (params) => params.value || "N/A",
//     },
//     {
//       field: "depot",
//       headerName: "Depot",
//       width: 130,
//       renderCell: (params) => params.value || "N/A",
//     },
//     {
//       field: "trainingStartDate",
//       headerName: "Start Date",
//       width: 130,
//       renderCell: (params) => formatDateToDDMMYYYY(params.value),
//     },
//     {
//       field: "trainingEndDate",
//       headerName: "End Date",
//       width: 130,
//       renderCell: (params) => formatDateToDDMMYYYY(params.value),
//     },
//     {
//       field: "totalStudents",
//       headerName: "Students",
//       width: 90,
//       renderCell: (params) => (
//         <span style={{ fontWeight: params.value > 0 ? "bold" : "normal", color: params.value > 0 ? "#198754" : "#6c757d" }}>
//           {params.value || 0}
//         </span>
//       ),
//     },
//     {
//       field: "passedStudents",
//       headerName: "Passed",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ color: "#198754", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "failedStudents",
//       headerName: "Failed",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ color: "#dc3545", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "notAttemptedStudents",
//       headerName: "Not Attempted",
//       width: 100,
//       renderCell: (params) => (
//         <span style={{ color: "#ffc107", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "passPercentage",
//       headerName: "Pass %",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ fontWeight: "bold" }}>{params.value || 0}%</span>
//       ),
//     },
//     {
//       field: "feedbackRating",
//       headerName: "Rating",
//       width: 220,
//       renderCell: (params) => {
//         const rating = batchFeedbackRatings[params.row.id];
//         const count = batchFeedbackCounts[params.row.id] || 0;
//         const loading = loadingRatings[params.row.id];

//         if (loading) {
//           return <CircularProgress size={25} />;
//         }

//         return renderStarRating(rating, count);
//       },
//     },
//     {
//       field: "feedbackGiven",
//       headerName: "Feedback Given",
//       width: 130,
//       renderCell: (params) => {
//         const given = batchFeedbackGivenCounts[params.row.id] || 0;
//         const notGiven = batchNotFeedbackGivenCounts[params.row.id] || 0;
//         return (
//           <Tooltip title={`${given} students gave feedback, ${notGiven} students did not`}>
//             <span style={{ color: given > 0 ? "#198754" : "#6c757d" }}>
//               {given} / {given + notGiven}
//             </span>
//           </Tooltip>
//         );
//       },
//     },
//     {
//       field: "edit",
//       headerName: "Edit",
//       width: 80,
//       renderCell: (p) => (
//         <Button size="sm" color="warning" onClick={() => handleRowClick(p.row)} style={{ padding: "4px 12px" }}>
//           Edit
//         </Button>
//       ),
//     },
//     {
//       field: "download",
//       headerName: "Download Report",
//       width: 130,
//       renderCell: (p) => (
//         <Button 
//           size="sm" 
//           color="success" 
//           onClick={() => openBatchReportModal(p.row)}
//           style={{ padding: "4px 8px", marginRight: "4px" }}
//         >
//           <DownloadIcon style={{ fontSize: "14px" }} />
//         </Button>
//       ),
//     },
//     {
//       field: "downloadSimulator",
//       headerName: "Simulator",
//       width: 100,
//       renderCell: (p) => (
//         <Button 
//           size="sm" 
//           color="primary" 
//           onClick={() => openBatchSimulatorReportModal(p.row)}
//           style={{ padding: "4px 8px" }}
//         >
//           <ScienceIcon style={{ fontSize: "14px" }} />
//         </Button>
//       ),
//     },
//   ];

//   // ============================
//   // RENDER
//   // ============================
//   return (
//     <>
//       {loader && <Loader />}

//       {consolidatedProgress.active && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             zIndex: 9999,
//             backgroundColor: "rgba(255,255,255,0.95)",
//             padding: "15px 20px",
//             boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//           }}
//         >
//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <span className="fw-bold text-primary">
//               <i className="fas fa-spinner fa-spin me-2"></i>
//               {consolidatedProgress.message}
//             </span>
//             <span className="text-muted">
//               {consolidatedProgress.current}/{consolidatedProgress.total}
//             </span>
//           </div>
//           <LinearProgress
//             variant="determinate"
//             value={consolidatedProgress.total > 0 ? (consolidatedProgress.current / consolidatedProgress.total) * 100 : 0}
//           />
//         </div>
//       )}

//       <Row>
//         <Col>
//           <Card>
//             <CardBody>
//               <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
//                 <CardTitle className="h4 mb-0">
//                   All Batches
//                   {filterState && <span className="ms-2 fs-6 text-muted">(State: {filterState})</span>}
//                   {filterDepot && <span className="ms-2 fs-6 text-muted">(Depot: {filterDepot})</span>}
//                   {filterPeriod !== "ALL" && (
//                     <span className="ms-2 fs-6 text-muted">(Period: {filterPeriod})</span>
//                   )}
//                   {isCustomDateRangeActive && customStartDate && customEndDate && (
//                     <span className="ms-2 fs-6 text-muted">
//                       (Custom Range: {formatDateToDDMMYYYY(customStartDate)} - {formatDateToDDMMYYYY(customEndDate)})
//                     </span>
//                   )}
//                 </CardTitle>
//                 <div className="d-flex flex-wrap gap-2">
//                   <Button color="secondary" size="sm" onClick={handleFilterClick}>
//                     <FilterListIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Filters
//                   </Button>
//                   <Menu
//                     anchorEl={filterAnchorEl}
//                     open={Boolean(filterAnchorEl)}
//                     onClose={handleFilterClose}
//                   >
//                     <div style={{ padding: "16px", minWidth: "250px" }}>
//                       <Typography variant="subtitle2" className="mb-2">State</Typography>
//                       <Select
//                         options={availableStates.map(s => ({ value: s, label: s }))}
//                         value={filterState ? { value: filterState, label: filterState } : null}
//                         onChange={(option) => setFilterState(option?.value || "")}
//                         placeholder="All States"
//                         isClearable
//                         className="mb-3"
//                       />
//                       <Typography variant="subtitle2" className="mb-2">Depot</Typography>
//                       <Select
//                         options={availableDepots.map(d => ({ value: d, label: d }))}
//                         value={filterDepot ? { value: filterDepot, label: filterDepot } : null}
//                         onChange={(option) => setFilterDepot(option?.value || "")}
//                         placeholder="All Depots"
//                         isClearable
//                         className="mb-3"
//                       />
//                       <Typography variant="subtitle2" className="mb-2">Period</Typography>
//                       <Select
//                         options={periodOptions}
//                         value={periodOptions.find(p => p.value === filterPeriod)}
//                         onChange={(option) => {
//                           setFilterPeriod(option?.value || "ALL");
//                           if (option?.value !== "CUSTOM") {
//                             setIsCustomDateRangeActive(false);
//                           }
//                         }}
//                         className="mb-3"
//                       />
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={openCustomDateRangeModal}
//                         fullWidth
//                         style={{ marginBottom: "8px" }}
//                       >
//                         Custom Date Range
//                       </Button>
//                       {isCustomDateRangeActive && (
//                         <Button 
//                           size="small" 
//                           variant="outlined" 
//                           onClick={clearCustomDateRange}
//                           fullWidth
//                           style={{ marginBottom: "8px", backgroundColor: "#ffebee" }}
//                         >
//                           Clear Date Range
//                         </Button>
//                       )}
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={() => setSerialRangeModalShow(true)}
//                         fullWidth
//                         style={{ marginBottom: "8px" }}
//                       >
//                         Serial Range
//                       </Button>
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={resetFilters}
//                         fullWidth
//                       >
//                         Reset All Filters
//                       </Button>
//                     </div>
//                   </Menu>
//                   <Button color="secondary" size="sm" onClick={() => setSerialRangeModalShow(true)}>
//                     <i className="fas fa-sort-numeric-up-alt me-1"></i>Serial Range
//                   </Button>
//                   {(filterState || filterDepot || filterPeriod !== "ALL" || isCustomDateRangeActive || fromSerial || toSerial || searchText) && (
//                     <Button color="danger" size="sm" onClick={clearAllFilters}>
//                       <i className="fas fa-times me-1"></i>Clear All
//                     </Button>
//                   )}
//                   <Button color="info" size="sm" onClick={downloadExcel}>
//                     <i className="fas fa-download me-1"></i>Excel
//                   </Button>
//                   <Button color="success" size="sm" onClick={() => setZipDownloadModalShow(true)}>
//                     <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Download ZIP
//                   </Button>
//                   <Button color="success" size="sm" onClick={() => setZipSimulatorDownloadModalShow(true)}>
//                     <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Simulator ZIP
//                   </Button>
//                   <Button color="warning" size="sm" onClick={() => setConsolidatedModalShow(true)}>
//                     <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Consolidated Report
//                   </Button>
//                   <Button color="warning" size="sm" onClick={() => setConsolidatedSimulatorModalShow(true)}>
//                     <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Combined Consolidated
//                   </Button>
//                   <Button color="primary" size="sm" onClick={refreshData}>
//                     <RefreshIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Refresh
//                   </Button>
//                 </div>
//               </div>

//               <Row className="mb-3">
//                 <Col md={6}>
//                   <TextField
//                     fullWidth
//                     label="Search..."
//                     placeholder="Batch name, department, depot, state, trainer, date"
//                     value={searchText}
//                     onChange={(e) => setSearchText(e.target.value)}
//                     variant="outlined"
//                     size="small"
//                     InputProps={{
//                       startAdornment: <i className="fas fa-search" style={{ marginRight: 8, color: "#6c757d" }}></i>,
//                     }}
//                   />
//                 </Col>
//                 <Col md={6} className="d-flex align-items-center">
//                   <small className="text-muted">
//                     <span className="me-2">Batches: <strong>{filteredBatches.length}</strong></span>
//                     <span className="me-2">| Students: <strong>{filteredStats.totalStudents}</strong></span>
//                     <span className="me-2 text-success">| Passed: <strong>{filteredStats.totalPassed}</strong></span>
//                     <span className="me-2 text-danger">| Failed: <strong>{filteredStats.totalFailed}</strong></span>
//                     <span className="me-2 text-warning">| Not Attempted: <strong>{filteredStats.totalNotAttempted}</strong></span>
//                     <span>| Pass Rate: <strong>{filteredStats.passRate}%</strong></span>
//                     <span className="ms-2" style={{ color: "#ffb400" }}>
//                       | Avg Rating: <strong>{filteredStats.avgRating > 0 ? filteredStats.avgRating + " ★" : "No Ratings"}</strong>
//                     </span>
//                     <span className="ms-2 text-success">
//                       | Feedback Given: <strong>{filteredStats.totalFeedbackGiven}</strong>
//                     </span>
//                     <span className="ms-2 text-danger">
//                       | Not Given: <strong>{filteredStats.totalNotFeedbackGiven}</strong>
//                     </span>
//                   </small>
//                 </Col>
//               </Row>

//               <Paper elevation={0} style={{ border: "1px solid #e0e0e0" }}>
//                 <DataGrid
//                   autoHeight
//                   rows={filteredBatches.map((r, i) => ({
//                     ...r,
//                     serialNo: page * pageSize + i + 1,
//                     id: r.id,
//                   }))}
//                   columns={columns}
//                   pageSizeOptions={[5, 10, 25, 50]}
//                   initialState={{
//                     pagination: { paginationModel: { pageSize: pageSize, page: 0 } },
//                   }}
//                   disableRowSelectionOnClick
//                   sx={{
//                     "& .MuiDataGrid-cell:focus": { outline: "none" },
//                     "& .MuiDataGrid-columnHeaders": { backgroundColor: "#f8f9fa", fontWeight: "bold" },
//                   }}
//                 />
//               </Paper>

//               {renderPagination()}
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>

//       {/* ============================ */}
//       {/* ALL MODALS - Keep from original */}
//       {/* ============================ */}
//       {/* Include all modal components from the original code */}
//       {/* Custom Date Range Modal */}
//       <Modal show={dateRangeModalShow} centered onHide={() => setDateRangeModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Select Custom Date Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="row">
//             <div className="col-md-6 mb-3">
//               <label className="form-label fw-bold">Start Date</label>
//               <DatePicker
//                 selected={customStartDate}
//                 onChange={(date) => setCustomStartDate(date)}
//                 selectsStart
//                 startDate={customStartDate}
//                 endDate={customEndDate}
//                 className="form-control"
//                 dateFormat="dd/MM/yyyy"
//                 placeholderText="Select start date"
//                 maxDate={customEndDate || undefined}
//                 showYearDropdown
//                 showMonthDropdown
//                 dropdownMode="select"
//               />
//             </div>
//             <div className="col-md-6 mb-3">
//               <label className="form-label fw-bold">End Date</label>
//               <DatePicker
//                 selected={customEndDate}
//                 onChange={(date) => setCustomEndDate(date)}
//                 selectsEnd
//                 startDate={customStartDate}
//                 endDate={customEndDate}
//                 minDate={customStartDate}
//                 className="form-control"
//                 dateFormat="dd/MM/yyyy"
//                 placeholderText="Select end date"
//                 showYearDropdown
//                 showMonthDropdown
//                 dropdownMode="select"
//               />
//             </div>
//           </div>
//           <div className="mt-2 p-2 bg-light rounded">
//             <small className="text-muted">
//               <i className="fas fa-info-circle me-1"></i>
//               Select a date range to show batches that started within this period.
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDateRangeModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={applyCustomDateRange}>
//             Apply Filter
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Serial Range Modal */}
//       <Modal show={serialRangeModalShow} centered onHide={() => setSerialRangeModalShow(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Serial Number Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="mb-3">
//             <label className="form-label fw-bold">From</label>
//             <input
//               type="number"
//               className="form-control"
//               min="1"
//               max={allBatch.length}
//               value={fromSerial}
//               onChange={(e) => setFromSerial(e.target.value)}
//               placeholder={`1 to ${allBatch.length}`}
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label fw-bold">To</label>
//             <input
//               type="number"
//               className="form-control"
//               min="1"
//               max={allBatch.length}
//               value={toSerial}
//               onChange={(e) => setToSerial(e.target.value)}
//               placeholder={`1 to ${allBatch.length}`}
//             />
//           </div>
//           <div className="mt-2 p-2 bg-light rounded">
//             <small className="text-muted">
//               <i className="fas fa-info-circle me-1"></i>
//               Enter serial number range to filter batches by their position in the list.
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setSerialRangeModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={applySerialRangeFilter}>
//             Apply
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Batch Modal */}
//       <Modal show={modalShow} size="lg" centered onHide={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Batch</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Row className="mb-3">
//             <label htmlFor="batch-name-input" className="col-md-2 col-form-label">
//               Batch Name
//             </label>
//             <div className="col-md-10">
//               <input
//                 id="batch-name-input"
//                 type="text"
//                 className="form-control"
//                 placeholder="Enter new batch name"
//                 maxLength="50"
//                 value={name}
//                 onChange={(e) => { setName(e.target.value); setSpanDisplay("none"); }}
//               />
//               <span style={{ color: "red", display: spanDisplay, fontSize: "12px", marginTop: "5px" }}>
//                 Batch name is required
//               </span>
//             </div>
//           </Row>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button color="secondary" onClick={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
//             Close
//           </Button>
//           <Button color="success" onClick={handleUpdate}>
//             Update
//           </Button>
//           <Button color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false); }}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Modal */}
//       <Modal show={deleteModalShow} centered onHide={() => setDeleteModalShow(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Delete</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="text-center py-3">
//             <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: "48px" }}></i>
//             <h5 className="mt-3">Delete this batch?</h5>
//             <p className="text-muted">This action cannot be undone.</p>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button color="secondary" onClick={() => { setDeleteModalShow(false); setModalShow(true); }}>
//             Cancel
//           </Button>
//           <Button color="danger" onClick={handleDelete}>
//             Yes, Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Individual Batch Report Modal */}
//       <Modal show={batchReportModalShow} centered onHide={() => setBatchReportModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download Batch Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
//             <DownloadIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
//             <div>
//               <strong>Download Report for {selectedBatchForReport?.batchName || "Batch"}</strong>
//               <small className="d-block text-muted">
//                 Select report type to download with images
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batch</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.batchName || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Department</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.department || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.totalStudents || 0}</div>
//             </div>
//             <div>
//               <small className="text-muted">Depot</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.depot || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">State</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.state || "N/A"}</div>
//             </div>
//           </div>

//           <label className="mb-2 fw-bold">Select Report Type:</label>
//           <Select
//             options={reportTypeOptions}
//             value={reportTypeOptions.find((opt) => opt.value === selectedReportType)}
//             onChange={(option) => setSelectedReportType(option?.value || "Other")}
//             placeholder="Choose report type..."
//             isSearchable={false}
//           />

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The downloaded file will be a ZIP containing:
//               <ul className="mt-2 mb-0">
//                 <li>Excel report with all student data</li>
//                 <li>Images folder with all uploaded images</li>
//                 <li>Complete with all fields including Pre Test, Post Test, Practical Grade, etc.</li>
//               </ul>
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBatchReportModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="success" onClick={downloadSingleBatchReport}>
//             <DownloadIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download {selectedReportType} Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Individual Batch Simulator Report Modal */}
//       <Modal show={batchSimulatorReportModalShow} centered onHide={() => setBatchSimulatorReportModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download Simulator Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Download Simulator Report for {selectedBatchForSimulatorReport?.batchName || "Batch"}</strong>
//               <small className="d-block text-muted">
//                 Download complete simulator report with all scenarios (PASS/FAIL/NOT_ATTEMPTED)
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batch</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.batchName || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Department</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.department || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.totalStudents || 0}</div>
//             </div>
//             <div>
//               <small className="text-muted">Depot</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.depot || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">State</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.state || "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The simulator report includes:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
//                 <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//               </ul>
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBatchSimulatorReportModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadSingleBatchSimulatorReport}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download Simulator Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Consolidated Report Modal */}
//       <Modal show={consolidatedModalShow} centered onHide={() => setConsolidatedModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Generate Consolidated Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
//             <MergeTypeIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
//             <div>
//               <strong>Single Sheet Consolidated Report</strong>
//               <small className="d-block text-muted">
//                 Combines all student data from {filteredBatches.length} filtered batches into a single Excel sheet
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Process</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//             <div>
//               <small className="text-muted">Avg Rating</small>
//               <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
//             </div>
//           </div>

//           <label className="mb-2 fw-bold">Report Type:</label>
//           <Select
//             options={consolidatedOptions}
//             value={consolidatedOptions.find((opt) => opt.value === selectedConsolidatedType)}
//             onChange={(option) => setSelectedConsolidatedType(option.value)}
//             placeholder="Choose..."
//             isSearchable={false}
//           />

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               This will generate a single Excel file containing:
//               <ul className="mt-2 mb-0">
//                 <li>Main Sheet: All student data from all batches with 30+ fields including Attendance Days, Student Rating (with stars), Practical Grade, etc.</li>
//                 <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Processing {filteredBatches.length} batches may take several minutes. Each batch report is fetched and merged.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConsolidatedModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="success" onClick={generateConsolidatedReport}>
//             <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Generate Single Sheet Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Consolidated Simulator Report Modal */}
//       <Modal show={consolidatedSimulatorModalShow} centered onHide={() => setConsolidatedSimulatorModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Generate Consolidated Simulator Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Single Sheet Consolidated Simulator Report</strong>
//               <small className="d-block text-muted">
//                 Combines all simulator data from {filteredBatches.length} filtered batches into a single Excel sheet
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Process</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//             <div>
//               <small className="text-muted">Avg Rating</small>
//               <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               This will generate a single Excel file containing simulator data:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
//                 <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//                 <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Processing {filteredBatches.length} batches may take several minutes. Each batch report is fetched and merged.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConsolidatedSimulatorModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={generateConsolidatedSimulatorReport}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Generate Simulator Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ZIP Download Modal */}
//       <Modal show={zipDownloadModalShow} centered onHide={() => setZipDownloadModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download All Batches as ZIP</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ArchiveIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Batch-wise ZIP Download with Images</strong>
//               <small className="d-block text-muted">
//                 Downloads each batch's report as a separate folder in a single ZIP file
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Download</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//           </div>

//           <label className="mb-2 fw-bold">Report Type:</label>
//           <Select
//             options={zipDownloadOptions}
//             value={zipDownloadOptions.find((opt) => opt.value === selectedZipType)}
//             onChange={(option) => setSelectedZipType(option?.value || "Other")}
//             placeholder="Choose report type..."
//             isSearchable={false}
//           />

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The ZIP file will contain:
//               <ul className="mt-2 mb-0">
//                 <li>Each batch in a separate folder with original report ZIP</li>
//                 <li>Batch_Info.json with complete batch details</li>
//                 <li>Images folder with all uploaded images</li>
//                 <li>Download_Summary.txt with overall statistics</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Downloading {filteredBatches.length} batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setZipDownloadModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadAllBatchesAsZip}>
//             <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download All as ZIP ({filteredBatches.length} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ZIP Simulator Download Modal */}
//       <Modal show={zipSimulatorDownloadModalShow} centered onHide={() => setZipSimulatorDownloadModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download All Simulator Reports as ZIP</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Batch-wise Simulator Reports ZIP Download</strong>
//               <small className="d-block text-muted">
//                 Downloads each batch's simulator report as a separate folder in a single ZIP file
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Download</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The ZIP file will contain:
//               <ul className="mt-2 mb-0">
//                 <li>Each batch in a separate folder with Simulator_Report.xlsx</li>
//                 <li>Batch_Info.json with complete batch details</li>
//                 <li>Download_Summary.txt with overall statistics</li>
//                 <li>Complete simulator data with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>All scenarios (PASS/FAIL/NOT_ATTEMPTED)</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Downloading {filteredBatches.length} batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setZipSimulatorDownloadModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadAllBatchesSimulatorAsZip}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download All Simulator Reports ({filteredBatches.length} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default connect(null, { setBreadcrumbItems })(AllGroup);









// // AllGroup.js - Complete working component with all features

// import React, { useEffect, useState, useCallback } from "react";
// import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
// import { connect } from "react-redux";
// import { setBreadcrumbItems } from "../../store/actions";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import moment from "moment";

// import { Paper, TextField, LinearProgress, Tooltip, CircularProgress, Box, Typography, Menu, MenuItem } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { Modal } from "react-bootstrap";
// import Select from "react-select";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import FilterListIcon from '@mui/icons-material/FilterList';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import MergeTypeIcon from '@mui/icons-material/MergeType';
// import DownloadIcon from '@mui/icons-material/Download';
// import ArchiveIcon from '@mui/icons-material/Archive';
// import ScienceIcon from '@mui/icons-material/Science';
// import FirstPageIcon from '@mui/icons-material/FirstPage';
// import LastPageIcon from '@mui/icons-material/LastPage';
// import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';

// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import axios from "axios";
// import JSZip from "jszip";

// import Loader from "components/Loader/Loader";
// import {
//   fetchAllBatchesWithPagination,
//   fetchAllBatch,
//   fetchAllBatchOfTrainer,
//   getAllTrainerOfBatch,
//   getAllStudentOfBatch,
//   updateBatch,
//   deleteBatch,
//   batchDetailFile,
//   batchDetailFileWithFullFilters,
//   getDistinctStates,
//   getDistinctDepots,
// } from "helpers/batch_helper";
// import { downloadBatchReport, url } from "helpers/url_helper";
// import { getResult } from "helpers/exam_helper";
// import { fetchAllFeedbackOfBatch, getAllResponsesOfFeedback } from "helpers/feedback_helper";

// // ============================
// // SIMULATOR API HELPER FUNCTIONS
// // ============================
// const SIMULATOR_EXCEL_URL = url + "api/simulator/excel/";

// const downloadBatchSimulatorReport = (batchId) => {
//   return `${SIMULATOR_EXCEL_URL}${batchId}`;
// };

// // ============================
// // PROGRESS TOAST FUNCTIONS
// // ============================
// let progressToastId = null;

// const showProgressToast = (message, isProcessing = true) => {
//   if (progressToastId) {
//     toast.update(progressToastId, {
//       render: message,
//       type: isProcessing ? "info" : "success",
//       isLoading: isProcessing,
//       autoClose: isProcessing ? false : 5000,
//     });
//   } else {
//     progressToastId = toast.info(message, {
//       autoClose: false,
//       isLoading: true,
//     });
//   }
// };

// const hideProgressToast = (message, isSuccess = true) => {
//   if (progressToastId) {
//     toast.update(progressToastId, {
//       render: message,
//       type: isSuccess ? "success" : "error",
//       isLoading: false,
//       autoClose: 5000,
//     });
//     progressToastId = null;
//   }
// };

// const AllGroup = (props) => {
//   document.title = "Content Management | All Batches";
//   const navigate = useNavigate();

//   // ============================
//   // STATE DECLARATIONS
//   // ============================
//   const [loader, setLoader] = useState(false);
//   const [allBatch, setAllBatch] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [searchText, setSearchText] = useState("");
//   const [debouncedSearchText, setDebouncedSearchText] = useState("");
//   const [modalShow, setModalShow] = useState(false);
//   const [deleteModalShow, setDeleteModalShow] = useState(false);
//   const [name, setName] = useState("");
//   const [id, setId] = useState({});
//   const [spanDisplay, setSpanDisplay] = useState("none");

//   // Pagination states
//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalItems, setTotalItems] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);

//   // Filter states
//   const [filterState, setFilterState] = useState("");
//   const [filterDepot, setFilterDepot] = useState("");
//   const [filterPeriod, setFilterPeriod] = useState("ALL");
//   const [availableStates, setAvailableStates] = useState([]);
//   const [availableDepots, setAvailableDepots] = useState([]);
//   const [filterAnchorEl, setFilterAnchorEl] = useState(null);

//   // Additional filter states
//   const [departmentFilter, setDepartmentFilter] = useState("");
//   const [trainerNameFilter, setTrainerNameFilter] = useState("");
//   const [batchTypeFilter, setBatchTypeFilter] = useState("");
//   const [availableDepartments, setAvailableDepartments] = useState([]);
//   const [availableTrainers, setAvailableTrainers] = useState([]);
//   const [availableBatchTypes, setAvailableBatchTypes] = useState([]);

//   // Report generation states
//   const [consolidatedModalShow, setConsolidatedModalShow] = useState(false);
//   const [selectedConsolidatedType, setSelectedConsolidatedType] = useState("Other");
//   const [dateRangeModalShow, setDateRangeModalShow] = useState(false);
//   const [serialRangeModalShow, setSerialRangeModalShow] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState(null);
//   const [customEndDate, setCustomEndDate] = useState(null);
//   const [isCustomDateRangeActive, setIsCustomDateRangeActive] = useState(false);
//   const [fromSerial, setFromSerial] = useState("");
//   const [toSerial, setToSerial] = useState("");

//   // Individual Batch Report Download States
//   const [batchReportModalShow, setBatchReportModalShow] = useState(false);
//   const [selectedBatchForReport, setSelectedBatchForReport] = useState(null);
//   const [selectedReportType, setSelectedReportType] = useState("Other");

//   // Individual Batch Simulator Report Download States
//   const [batchSimulatorReportModalShow, setBatchSimulatorReportModalShow] = useState(false);
//   const [selectedBatchForSimulatorReport, setSelectedBatchForSimulatorReport] = useState(null);

//   // ZIP Download States
//   const [zipDownloadModalShow, setZipDownloadModalShow] = useState(false);
//   const [selectedZipType, setSelectedZipType] = useState("Other");

//   // ZIP Simulator Download States
//   const [zipSimulatorDownloadModalShow, setZipSimulatorDownloadModalShow] = useState(false);

//   // Consolidated Simulator Report States
//   const [consolidatedSimulatorModalShow, setConsolidatedSimulatorModalShow] = useState(false);

//   // Store data maps
//   const [batchTrainersMap, setBatchTrainersMap] = useState({});
//   const [batchFeedbackRatings, setBatchFeedbackRatings] = useState({});
//   const [batchFeedbackCounts, setBatchFeedbackCounts] = useState({});
//   const [batchFeedbackGivenCounts, setBatchFeedbackGivenCounts] = useState({});
//   const [batchNotFeedbackGivenCounts, setBatchNotFeedbackGivenCounts] = useState({});
//   const [loadingRatings, setLoadingRatings] = useState({});
//   const [ratingsFetched, setRatingsFetched] = useState(false);

//   // Progress tracking
//   const [consolidatedProgress, setConsolidatedProgress] = useState({ 
//     active: false, 
//     current: 0, 
//     total: 0, 
//     message: "" 
//   });

//   // All filtered batches state (for consolidated report)
//   const [allFilteredBatchCount, setAllFilteredBatchCount] = useState(0);
//   const [allFilteredBatchData, setAllFilteredBatchData] = useState([]);

//   // Search state to prevent multiple API calls
//   const [isSearching, setIsSearching] = useState(false);
//   const searchTimeoutRef = React.useRef(null);

//   // ============================
//   // HELPER FUNCTIONS
//   // ============================
//   const formatTrainerNames = (trainers) => {
//     if (!trainers || trainers.length === 0) return "No Trainer Assigned";
//     const trainerNames = trainers.map((t) => {
//       if (t.name) return t.name;
//       if (t.firstName && t.lastName) return `${t.firstName} ${t.lastName}`;
//       if (t.firstName) return t.firstName;
//       if (t.fullName) return t.fullName;
//       if (t.email) return t.email.split("@")[0];
//       return `Trainer ${t.id}`;
//     });
//     if (trainers.length === 1) return trainerNames[0];
//     return `${trainerNames[0]} +${trainers.length - 1}`;
//   };

//   const formatRatingWithStars = (rating) => {
//     if (!rating) return "Not Rated";
//     const fullStars = Math.floor(rating);
//     const emptyStars = 5 - fullStars;
//     return `${"★".repeat(fullStars)}${"☆".repeat(emptyStars)} ${rating.toFixed(1)}/5.0`;
//   };

//   // ============================
//   // DEBOUNCE SEARCH EFFECT
//   // ============================
//   useEffect(() => {
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }

//     searchTimeoutRef.current = setTimeout(() => {
//       setDebouncedSearchText(searchText);
//     }, 500);

//     return () => {
//       if (searchTimeoutRef.current) {
//         clearTimeout(searchTimeoutRef.current);
//       }
//     };
//   }, [searchText]);

//   // ============================
//   // RESET PAGE WHEN SEARCH CHANGES
//   // ============================
//   useEffect(() => {
//     setPage(0);
//   }, [debouncedSearchText]);

//   // ============================
//   // OPTIONS
//   // ============================
//   const consolidatedOptions = [
//     { value: "DDT", label: "DDT Report (Single Sheet)" },
//     { value: "DASP", label: "DASP Report (Single Sheet)" },
//     { value: "Other", label: "Other Report (Single Sheet)" },
//   ];

//   const reportTypeOptions = [
//     { value: "DDT", label: "DDT Report" },
//     { value: "DASP", label: "DASP Report" },
//     { value: "Other", label: "Other Report" },
//   ];

//   const zipDownloadOptions = [
//     { value: "DDT", label: "DDT Reports (Batch-wise ZIP)" },
//     { value: "DASP", label: "DASP Reports (Batch-wise ZIP)" },
//     { value: "Other", label: "Other Reports (Batch-wise ZIP)" },
//   ];

//   const periodOptions = [
//     { value: "ALL", label: "All Time" },
//     { value: "TODAY", label: "Today" },
//     { value: "WEEKLY", label: "This Week" },
//     { value: "MONTHLY", label: "This Month" },
//     { value: "YEARLY", label: "This Year" },
//   ];

//   const pageSizeOptions = [
//     { value: 5, label: "5" },
//     { value: 10, label: "10" },
//     { value: 25, label: "25" },
//     { value: 50, label: "50" },
//     { value: 100, label: "100" },
//   ];

//   const breadcrumbItems = [
//     { title: "Batch", link: "#" },
//     { title: "All Batches", link: "#" },
//   ];

//   // ============================
//   // FETCH ALL BATCHES FOR CONSOLIDATED REPORT
//   // ============================
//   const fetchAllBatchesForConsolidated = useCallback(async () => {
//     try {
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) return;

//       let startDate = null;
//       let endDate = null;
      
//       if (isCustomDateRangeActive && customStartDate && customEndDate) {
//         startDate = moment(customStartDate).format("YYYY-MM-DD");
//         endDate = moment(customEndDate).format("YYYY-MM-DD");
//       } else if (filterPeriod !== "ALL") {
//         const today = moment().startOf('day');
//         switch (filterPeriod) {
//           case "TODAY":
//             startDate = today.format("YYYY-MM-DD");
//             endDate = today.format("YYYY-MM-DD");
//             break;
//           case "WEEKLY":
//             startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//             break;
//           case "MONTHLY":
//             startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//             break;
//           case "YEARLY":
//             startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//             break;
//           default:
//             break;
//         }
//       }

//       const response = await fetchAllBatchesWithPagination(
//         0, 
//         10000,
//         startDate,
//         endDate,
//         filterState,
//         filterDepot,
//         debouncedSearchText
//       );

//       if (response.data?.success) {
//         const batches = response.data.result || [];
//         setAllFilteredBatchData(batches);
//         setAllFilteredBatchCount(batches.length);
//       }
//     } catch (error) {
//       console.error("Error fetching all batches for consolidated:", error);
//     }
//   }, [isCustomDateRangeActive, customStartDate, customEndDate, filterPeriod, filterState, filterDepot, debouncedSearchText]);

//   // ============================
//   // FETCH DISTINCT FILTERS
//   // ============================
//   const fetchDistinctFilters = useCallback(async () => {
//     try {
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser?.organizationId) return;

//       const [statesRes, depotsRes] = await Promise.all([
//         getDistinctStates(),
//         getDistinctDepots()
//       ]);

//       if (statesRes?.data) {
//         setAvailableStates(statesRes.data);
//       }
//       if (depotsRes?.data) {
//         setAvailableDepots(depotsRes.data);
//       }

//       const depts = new Set();
//       const trainers = new Set();
//       const types = new Set();

//       allBatch.forEach(batch => {
//         if (batch.department) depts.add(batch.department);
//         if (batch.batchType) types.add(batch.batchType);
//         if (batch.trainerNames && batch.trainerNames !== "No Trainer Assigned") {
//           trainers.add(batch.trainerNames);
//         }
//       });

//       setAvailableDepartments([...depts]);
//       setAvailableTrainers([...trainers]);
//       setAvailableBatchTypes([...types]);

//     } catch (error) {
//       console.error("Error fetching distinct filters:", error);
//     }
//   }, [allBatch]);

//   // ============================
//   // FETCH FEEDBACK RATINGS
//   // ============================
//   const fetchFeedbackRatingsOnly = async (batches) => {
//     if (ratingsFetched) return;
    
//     const feedbackRatingsMap = {};
//     const feedbackCountsMap = {};
//     const feedbackGivenCountsMap = {};
//     const notFeedbackGivenCountsMap = {};
    
//     const asyncPool = async (concurrency, items, iteratorFn) => {
//       const results = [];
//       const executing = new Set();
//       for (const [index, item] of items.entries()) {
//         const promise = Promise.resolve().then(() => iteratorFn(item, index));
//         results.push(promise);
//         executing.add(promise);
//         const clean = () => executing.delete(promise);
//         promise.then(clean, clean);
//         if (executing.size >= concurrency) {
//           await Promise.race(executing);
//         }
//       }
//       return Promise.all(results);
//     };
    
//     await asyncPool(5, batches, async (batch) => {
//       const batchId = batch.id || batch._id;
//       if (!batchId) return;
      
//       try {
//         setLoadingRatings(prev => ({ ...prev, [batchId]: true }));
        
//         const feedbacksResponse = await fetchAllFeedbackOfBatch(batchId);
        
//         if (!feedbacksResponse?.success || !feedbacksResponse?.result?.length) {
//           feedbackRatingsMap[batchId] = null;
//           feedbackCountsMap[batchId] = 0;
//           feedbackGivenCountsMap[batchId] = 0;
//           notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
//           setBatchFeedbackRatings(prev => ({ ...prev, [batchId]: null }));
//           setBatchFeedbackCounts(prev => ({ ...prev, [batchId]: 0 }));
//           setBatchFeedbackGivenCounts(prev => ({ ...prev, [batchId]: 0 }));
//           setBatchNotFeedbackGivenCounts(prev => ({ ...prev, [batchId]: batch.totalStudents || 0 }));
//           return;
//         }

//         let totalRatingSum = 0;
//         let totalResponseCount = 0;
//         let totalFeedbackGiven = 0;

//         for (const feedback of feedbacksResponse.result) {
//           const responsesResponse = await getAllResponsesOfFeedback(feedback.id);
          
//           if (responsesResponse?.success && responsesResponse?.responseResult?.length) {
//             const feedbackRatingSum = responsesResponse.responseResult.reduce(
//               (sum, response) => sum + (response.rating || 0), 
//               0
//             );
//             totalRatingSum += feedbackRatingSum;
//             totalResponseCount += responsesResponse.responseResult.length;
//             totalFeedbackGiven += responsesResponse.responseResult.length;
//           }
//         }

//         const averageRating = totalResponseCount > 0 ? totalRatingSum / totalResponseCount : null;
//         const totalStudents = batch.totalStudents || 0;
//         const notFeedbackGiven = totalStudents - totalFeedbackGiven;
        
//         feedbackRatingsMap[batchId] = averageRating;
//         feedbackCountsMap[batchId] = totalResponseCount;
//         feedbackGivenCountsMap[batchId] = totalFeedbackGiven;
//         notFeedbackGivenCountsMap[batchId] = notFeedbackGiven > 0 ? notFeedbackGiven : 0;
        
//         setBatchFeedbackRatings(prev => ({ ...prev, [batchId]: averageRating }));
//         setBatchFeedbackCounts(prev => ({ ...prev, [batchId]: totalResponseCount }));
//         setBatchFeedbackGivenCounts(prev => ({ ...prev, [batchId]: totalFeedbackGiven }));
//         setBatchNotFeedbackGivenCounts(prev => ({ ...prev, [batchId]: notFeedbackGiven > 0 ? notFeedbackGiven : 0 }));
//       } catch (error) {
//         console.error(`Error fetching feedback rating for batch ${batchId}:`, error);
//         feedbackRatingsMap[batchId] = null;
//         feedbackCountsMap[batchId] = 0;
//         feedbackGivenCountsMap[batchId] = 0;
//         notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
//         setBatchFeedbackRatings(prev => ({ ...prev, [batchId]: null }));
//         setBatchFeedbackCounts(prev => ({ ...prev, [batchId]: 0 }));
//         setBatchFeedbackGivenCounts(prev => ({ ...prev, [batchId]: 0 }));
//         setBatchNotFeedbackGivenCounts(prev => ({ ...prev, [batchId]: batch.totalStudents || 0 }));
//       } finally {
//         setLoadingRatings(prev => ({ ...prev, [batchId]: false }));
//       }
//     });
    
//     setRatingsFetched(true);
//   };

//   // ============================
//   // FETCH TRAINERS FOR BATCHES
//   // ============================
//   const fetchTrainersForBatches = async (batches) => {
//     const trainersMap = {};
    
//     const asyncPool = async (concurrency, items, iteratorFn) => {
//       const results = [];
//       const executing = new Set();
//       for (const [index, item] of items.entries()) {
//         const promise = Promise.resolve().then(() => iteratorFn(item, index));
//         results.push(promise);
//         executing.add(promise);
//         const clean = () => executing.delete(promise);
//         promise.then(clean, clean);
//         if (executing.size >= concurrency) {
//           await Promise.race(executing);
//         }
//       }
//       return Promise.all(results);
//     };
    
//     await asyncPool(5, batches, async (batch) => {
//       const batchId = batch.id || batch._id;
//       if (!batchId) return;
//       try {
//         const trainers = await getAllTrainerOfBatch(batchId).catch(() => []);
//         trainersMap[batchId] = trainers?.success ? trainers.result || [] : [];
//       } catch (error) {
//         trainersMap[batchId] = [];
//       }
//     });
    
//     setBatchTrainersMap(trainersMap);
//   };

//   // ============================
//   // GET ALL BATCHES WITH PAGINATION - DATABASE LEVEL SEARCH
//   // ============================
//   const getAllBatches = useCallback(async () => {
//     try {
//       setLoader(true);
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       const type = authUser?.userType;
      
//       if (type === "Tata Trainer") {
//         const res = await fetchAllBatchOfTrainer();
//         if (res?.success) {
//           let batches = (res.result || []).map(batch => ({
//             id: batch.id || batch._id,
//             batchName: batch.batchName,
//             department: batch.department,
//             state: batch.state,
//             depot: batch.depot,
//             trainingStartDate: batch.trainingStartDate,
//             trainingEndDate: batch.trainingEndDate,
//             totalStudents: batch.totalStudents || batch.students?.length || 0,
//             passedStudents: batch.passedStudents || 0,
//             failedStudents: batch.failedStudents || 0,
//             notAttemptedStudents: batch.notAttemptedStudents || 0,
//             passPercentage: batch.passPercentage || 0,
//             trainerNames: batch.trainerNames || "No Trainer Assigned",
//             totalTrainers: batch.totalTrainers || 0,
//             entryBy: batch.entryBy,
//             entryAt: batch.entryAt,
//             updatedBy: batch.updatedBy,
//             updatedAt: batch.updatedAt,
//             feedbackGivenCount: batch.feedbackGivenCount || 0,
//             notFeedbackGivenCount: batch.notFeedbackGivenCount || 0,
//             batchType: batch.batchType || "Offline"
//           }));

//           if (debouncedSearchText && debouncedSearchText.trim()) {
//             const searchLower = debouncedSearchText.toLowerCase().trim();
//             batches = batches.filter(batch => {
//               return (
//                 (batch.batchName || "").toLowerCase().includes(searchLower) ||
//                 (batch.department || "").toLowerCase().includes(searchLower) ||
//                 (batch.state || "").toLowerCase().includes(searchLower) ||
//                 (batch.depot || "").toLowerCase().includes(searchLower) ||
//                 (batch.trainerNames || "").toLowerCase().includes(searchLower) ||
//                 (batch.batchType || "").toLowerCase().includes(searchLower)
//               );
//             });
//           }

//           if (filterState) {
//             batches = batches.filter(b => b.state === filterState);
//           }
//           if (filterDepot) {
//             batches = batches.filter(b => b.depot === filterDepot);
//           }
//           if (departmentFilter) {
//             batches = batches.filter(b => b.department === departmentFilter);
//           }

//           setAllBatch(batches);
//           setFilteredBatches(batches);
//           setTotalItems(batches.length);
//           setTotalPages(Math.ceil(batches.length / pageSize));
          
//           if (batches.length > 0) {
//             await Promise.all([
//               fetchTrainersForBatches(batches),
//               fetchFeedbackRatingsOnly(batches)
//             ]);
//           }
          
//           if (batches.length === 0 && debouncedSearchText) {
//             toast.info(`No batches found for "${debouncedSearchText}"`);
//           }
//         }
//       } else {
//         let startDate = null;
//         let endDate = null;
        
//         if (isCustomDateRangeActive && customStartDate && customEndDate) {
//           startDate = moment(customStartDate).format("YYYY-MM-DD");
//           endDate = moment(customEndDate).format("YYYY-MM-DD");
//         } else if (filterPeriod !== "ALL") {
//           const today = moment().startOf('day');
//           switch (filterPeriod) {
//             case "TODAY":
//               startDate = today.format("YYYY-MM-DD");
//               endDate = today.format("YYYY-MM-DD");
//               break;
//             case "WEEKLY":
//               startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//               break;
//             case "MONTHLY":
//               startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//               break;
//             case "YEARLY":
//               startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//               break;
//             default:
//               break;
//           }
//         }
        
//         const searchValue = debouncedSearchText && debouncedSearchText.trim() ? debouncedSearchText.trim() : null;
//         const currentPage = searchValue ? 0 : page;
        
//         const response = await fetchAllBatchesWithPagination(
//           currentPage, 
//           pageSize, 
//           startDate, 
//           endDate, 
//           filterState || null, 
//           filterDepot || null, 
//           searchValue
//         );
        
//         if (response.data?.success) {
//           const batches = (response.data.result || []).map(batch => ({
//             id: batch.id || batch._id,
//             batchName: batch.batchName,
//             department: batch.department,
//             state: batch.state,
//             depot: batch.depot,
//             trainingStartDate: batch.trainingStartDate,
//             trainingEndDate: batch.trainingEndDate,
//             totalStudents: batch.totalStudents || 0,
//             passedStudents: batch.passedStudents || 0,
//             failedStudents: batch.failedStudents || 0,
//             notAttemptedStudents: batch.notAttemptedStudents || 0,
//             passPercentage: batch.passPercentage || 0,
//             trainerNames: batch.trainerNames || "No Trainer Assigned",
//             totalTrainers: batch.totalTrainers || 0,
//             entryBy: batch.entryBy,
//             entryAt: batch.entryAt,
//             updatedBy: batch.updatedBy,
//             updatedAt: batch.updatedAt,
//             feedbackGivenCount: batch.feedbackGivenCount || 0,
//             notFeedbackGivenCount: batch.notFeedbackGivenCount || 0,
//             batchType: batch.batchType || "Offline"
//           }));
          
//           setAllBatch(batches);
//           setFilteredBatches(batches);
//           setTotalItems(response.data.totalItems || 0);
//           setTotalPages(response.data.totalPages || 0);
          
//           if (searchValue && batches.length === 0 && page !== 0) {
//             setPage(0);
//           }
          
//           if (batches.length > 0) {
//             await Promise.all([
//               fetchTrainersForBatches(batches),
//               fetchFeedbackRatingsOnly(batches)
//             ]);
//           }
          
//           if (batches.length === 0 && searchValue) {
//             toast.info(`No batches found for "${searchValue}"`);
//           }
//         } else {
//           toast.error(response.data?.message || "Failed to load batches");
//         }
//       }
//     } catch (error) {
//       console.error("Error in getAllBatches:", error);
//       toast.error(error?.response?.data?.message || "Failed to load batches");
//     } finally {
//       setLoader(false);
//       setIsSearching(false);
//     }
//   }, [page, pageSize, filterState, filterDepot, filterPeriod, debouncedSearchText, customStartDate, customEndDate, isCustomDateRangeActive, departmentFilter]);

//   // ============================
//   // DOWNLOAD CONSOLIDATED SIMULATOR REPORT
//   // ============================
//   const downloadConsolidatedSimulator = async () => {
//     try {
//       setLoader(true);
//       setConsolidatedSimulatorModalShow(false);
      
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) {
//         toast.error("Organization ID not found. Please log in again.");
//         setLoader(false);
//         return;
//       }
      
//       let startDate = null;
//       let endDate = null;
      
//       if (isCustomDateRangeActive && customStartDate && customEndDate) {
//         startDate = moment(customStartDate).format("YYYY-MM-DD");
//         endDate = moment(customEndDate).format("YYYY-MM-DD");
//       } else if (filterPeriod !== "ALL") {
//         const today = moment().startOf('day');
//         switch (filterPeriod) {
//           case "TODAY":
//             startDate = today.format("YYYY-MM-DD");
//             endDate = today.format("YYYY-MM-DD");
//             break;
//           case "WEEKLY":
//             startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//             break;
//           case "MONTHLY":
//             startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//             break;
//           case "YEARLY":
//             startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//             break;
//           default:
//             break;
//         }
//       }
      
//       const filters = [];
//       if (startDate && endDate) {
//         filters.push(`Training End Date: ${moment(startDate).format('DD-MM-YYYY')} to ${moment(endDate).format('DD-MM-YYYY')}`);
//       } else if (startDate) {
//         filters.push(`From: ${moment(startDate).format('DD-MM-YYYY')}`);
//       } else if (endDate) {
//         filters.push(`Until: ${moment(endDate).format('DD-MM-YYYY')}`);
//       }
//       if (filterState) filters.push(`State: ${filterState}`);
//       if (filterDepot) filters.push(`Depot: ${filterDepot}`);
//       if (debouncedSearchText) filters.push(`Search: "${debouncedSearchText}"`);
//       if (departmentFilter) filters.push(`Department: ${departmentFilter}`);
//       if (trainerNameFilter) filters.push(`Trainer: ${trainerNameFilter}`);
//       if (batchTypeFilter) filters.push(`Batch Type: ${batchTypeFilter}`);
      
//       const baseUrl = "https://backend.skillserve.in/api/";
//       let apiUrl = `${baseUrl}simulator/consolidated-report`;
      
//       const params = new URLSearchParams();
//       if (startDate) params.append("startDate", startDate);
//       if (endDate) params.append("endDate", endDate);
//       if (filterState && filterState !== "") params.append("state", filterState);
//       if (filterDepot && filterDepot !== "") params.append("depot", filterDepot);
//       if (debouncedSearchText && debouncedSearchText !== "") params.append("search", debouncedSearchText);
//       if (departmentFilter && departmentFilter !== "") params.append("department", departmentFilter);
//       if (trainerNameFilter && trainerNameFilter !== "") params.append("trainerName", trainerNameFilter);
//       if (batchTypeFilter && batchTypeFilter !== "") params.append("batchType", batchTypeFilter);
      
//       if (params.toString()) {
//         apiUrl += "?" + params.toString();
//       }
      
//       console.log("Calling consolidated report URL:", apiUrl);
      
//       showProgressToast(`⏳ Generating Consolidated Simulator Report for ${allFilteredBatchCount} batches... This may take several minutes.`, true);
      
//       const response = await axios({
//         method: 'get',
//         url: apiUrl,
//         responseType: 'blob',
//         timeout: 600000,
//         headers: {
//           'X-Organization-ID': authUser.organizationId || ''
//         }
//       });
      
//       hideProgressToast("✅ Report generated successfully! Downloading...", true);
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         setLoader(false);
//         return;
//       }
      
//       const firstBytes = await response.data.slice(0, 100).text();
//       const trimmedFirstBytes = firstBytes.trim();
//       if (trimmedFirstBytes.startsWith('{') || trimmedFirstBytes.startsWith('[')) {
//         try {
//           const fullText = await response.data.text();
//           const errorData = JSON.parse(fullText);
//           toast.error(errorData.message || "Failed to download file");
//           setLoader(false);
//           return;
//         } catch (e) {
//           toast.error("Failed to download file");
//           setLoader(false);
//           return;
//         }
//       }
      
//       const blob = new Blob([response.data], {
//         type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       });
      
//       const downloadUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
      
//       let filename = `Consolidated_Simulator_Report`;
//       if (startDate && endDate) {
//         filename += `_${moment(startDate).format("DD-MM-YYYY")}_to_${moment(endDate).format("DD-MM-YYYY")}`;
//       } else if (startDate) {
//         filename += `_from_${moment(startDate).format("DD-MM-YYYY")}`;
//       } else if (endDate) {
//         filename += `_upto_${moment(endDate).format("DD-MM-YYYY")}`;
//       }
//       if (filterState) {
//         filename += `_state_${filterState}`;
//       }
//       if (filterDepot) {
//         filename += `_depot_${filterDepot}`;
//       }
//       if (departmentFilter) {
//         filename += `_dept_${departmentFilter.replace(/\s+/g, '_')}`;
//       }
//       if (trainerNameFilter) {
//         filename += `_trainer_${trainerNameFilter.replace(/\s+/g, '_')}`;
//       }
//       if (batchTypeFilter) {
//         filename += `_type_${batchTypeFilter}`;
//       }
//       filename += `.xlsx`;
      
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`✅ Consolidated Simulator Report downloaded successfully! (${allFilteredBatchCount} batches)`);
//     } catch (error) {
//       console.error("Error downloading consolidated simulator report:", error);
//       hideProgressToast("❌ Failed to generate report. Please try again.", false);
      
//       if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
//         toast.error("⏱️ Report generation is taking longer than expected. Please try again with fewer filters or try again later.");
//       } else if (error.response?.data) {
//         try {
//           const errorText = await error.response.data.text();
//           const errorJson = JSON.parse(errorText);
//           toast.error(errorJson.message || "Failed to generate report");
//         } catch (e) {
//           toast.error("Failed to generate report. Server error occurred.");
//         }
//       } else if (error.message) {
//         toast.error(`Failed to generate report: ${error.message}`);
//       } else {
//         toast.error("Failed to generate report. Please try again.");
//       }
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // OPEN CONSOLIDATED MODALS
//   // ============================
//   const openConsolidatedModal = async () => {
//     await fetchAllBatchesForConsolidated();
//     setConsolidatedModalShow(true);
//   };

//   const openConsolidatedSimulatorModal = async () => {
//     await fetchAllBatchesForConsolidated();
//     setConsolidatedSimulatorModalShow(true);
//   };

//   // ============================
//   // DOWNLOAD EXCEL WITH FULL FILTERS
//   // ============================
//   const downloadExcel = async () => {
//     try {
//       setLoader(true);
      
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) {
//         toast.error("Organization ID not found. Please log in again.");
//         return;
//       }
      
//       let startDate = null;
//       let endDate = null;
      
//       if (isCustomDateRangeActive && customStartDate && customEndDate) {
//         startDate = moment(customStartDate).format("YYYY-MM-DD");
//         endDate = moment(customEndDate).format("YYYY-MM-DD");
//       } else if (filterPeriod !== "ALL") {
//         const today = moment().startOf('day');
//         switch (filterPeriod) {
//           case "TODAY":
//             startDate = today.format("YYYY-MM-DD");
//             endDate = today.format("YYYY-MM-DD");
//             break;
//           case "WEEKLY":
//             startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//             break;
//           case "MONTHLY":
//             startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//             break;
//           case "YEARLY":
//             startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//             break;
//           default:
//             break;
//         }
//       }
      
//       const filters = [];
//       if (startDate && endDate) {
//         filters.push(`Training End Date: ${moment(startDate).format('DD-MM-YYYY')} to ${moment(endDate).format('DD-MM-YYYY')}`);
//       } else if (startDate) {
//         filters.push(`From: ${moment(startDate).format('DD-MM-YYYY')}`);
//       } else if (endDate) {
//         filters.push(`Until: ${moment(endDate).format('DD-MM-YYYY')}`);
//       }
//       if (filterState) filters.push(`State: ${filterState}`);
//       if (filterDepot) filters.push(`Depot: ${filterDepot}`);
//       if (debouncedSearchText) filters.push(`Search: "${debouncedSearchText}"`);
//       if (departmentFilter) filters.push(`Department: ${departmentFilter}`);
      
//       toast.info(filters.length > 0 ? 
//         `Downloading report with filters: ${filters.join(', ')}...` : 
//         "Downloading all batch report...");
      
//       const response = await batchDetailFileWithFullFilters(
//         startDate, 
//         endDate, 
//         filterState, 
//         filterDepot, 
//         debouncedSearchText
//       );
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const firstBytes = await response.data.slice(0, 100).text();
//       const trimmedFirstBytes = firstBytes.trim();
//       if (trimmedFirstBytes.startsWith('{') || trimmedFirstBytes.startsWith('[')) {
//         try {
//           const fullText = await response.data.text();
//           const errorData = JSON.parse(fullText);
//           toast.error(errorData.message || "Failed to download file");
//           return;
//         } catch (e) {
//           toast.error("Failed to download file");
//           return;
//         }
//       }
      
//       const blob = new Blob([response.data], {
//         type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       });
      
//       const downloadUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
      
//       let filename = `Batch_Details`;
//       if (startDate && endDate) {
//         filename += `_${moment(startDate).format("DD-MM-YYYY")}_to_${moment(endDate).format("DD-MM-YYYY")}`;
//       } else if (startDate) {
//         filename += `_from_${moment(startDate).format("DD-MM-YYYY")}`;
//       } else if (endDate) {
//         filename += `_upto_${moment(endDate).format("DD-MM-YYYY")}`;
//       }
//       if (filterState) {
//         filename += `_state_${filterState}`;
//       }
//       if (filterDepot) {
//         filename += `_depot_${filterDepot}`;
//       }
//       if (debouncedSearchText) {
//         filename += `_search_${debouncedSearchText.replace(/\s+/g, '_')}`;
//       }
//       if (departmentFilter) {
//         filename += `_dept_${departmentFilter.replace(/\s+/g, '_')}`;
//       }
//       filename += `.xlsx`;
      
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success("File downloaded successfully!");
//     } catch (error) {
//       console.error("Error downloading file:", error);
//       toast.error(error.response?.data?.message || "Failed to download file");
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // PAGE CHANGE HANDLERS
//   // ============================
//   const handlePageChange = (newPage) => {
//     if (newPage >= 0 && newPage < totalPages) {
//       setPage(newPage);
//     }
//   };

//   const handlePageSizeChange = (newSize) => {
//     setPageSize(newSize);
//     setPage(0);
//   };

//   // ============================
//   // PAGINATION RENDER
//   // ============================
//   const renderPagination = () => {
//     if (totalPages <= 1) return null;

//     const pageNumbers = [];
//     const maxVisible = 5;
//     let startPage = Math.max(0, page - Math.floor(maxVisible / 2));
//     let endPage = Math.min(totalPages - 1, startPage + maxVisible - 1);
    
//     if (endPage - startPage < maxVisible - 1) {
//       startPage = Math.max(0, endPage - maxVisible + 1);
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pageNumbers.push(i);
//     }

//     return (
//       <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
//         <div className="d-flex align-items-center gap-2">
//           <span className="text-muted" style={{ fontSize: "14px" }}>
//             Showing {page * pageSize + 1} to {Math.min((page + 1) * pageSize, totalItems)} of {totalItems} entries
//           </span>
//         </div>
//         <div className="d-flex align-items-center gap-2 flex-wrap">
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(0)}
//             disabled={page === 0}
//           >
//             <FirstPageIcon style={{ fontSize: "18px" }} />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(page - 1)}
//             disabled={page === 0}
//           >
//             <NavigateBeforeIcon style={{ fontSize: "18px" }} />
//           </Button>
//           {pageNumbers.map((num) => (
//             <Button
//               key={num}
//               color={num === page ? "primary" : "secondary"}
//               size="sm"
//               onClick={() => handlePageChange(num)}
//               style={{ minWidth: "35px" }}
//             >
//               {num + 1}
//             </Button>
//           ))}
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(page + 1)}
//             disabled={page >= totalPages - 1}
//           >
//             <NavigateNextIcon style={{ fontSize: "18px" }} />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(totalPages - 1)}
//             disabled={page >= totalPages - 1}
//           >
//             <LastPageIcon style={{ fontSize: "18px" }} />
//           </Button>
          
//           <div className="d-flex align-items-center ms-2 gap-2">
//             <span className="text-muted" style={{ fontSize: "13px" }}>Rows:</span>
//             <Select
//               options={pageSizeOptions}
//               value={pageSizeOptions.find(opt => opt.value === pageSize)}
//               onChange={(option) => handlePageSizeChange(option.value)}
//               className="page-size-select"
//               styles={{
//                 control: (base) => ({
//                   ...base,
//                   minHeight: "32px",
//                   width: "70px",
//                   borderColor: "#ced4da",
//                   boxShadow: "none",
//                   "&:hover": {
//                     borderColor: "#80bdff",
//                   },
//                 }),
//                 menu: (base) => ({
//                   ...base,
//                   zIndex: 9999,
//                 }),
//                 option: (base, state) => ({
//                   ...base,
//                   backgroundColor: state.isSelected ? "#0d6efd" : state.isFocused ? "#e9ecef" : "white",
//                   color: state.isSelected ? "white" : "#212529",
//                   "&:active": {
//                     backgroundColor: "#0d6efd",
//                     color: "white",
//                   },
//                 }),
//               }}
//               isSearchable={false}
//               menuPortalTarget={document.body}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // ============================
//   // EFFECTS
//   // ============================
//   useEffect(() => {
//     props.setBreadcrumbItems("All Batches", breadcrumbItems);
//   }, []);

//   useEffect(() => {
//     getAllBatches();
//   }, [getAllBatches]);

//   useEffect(() => {
//     if (allBatch.length > 0) {
//       fetchTrainersForBatches(allBatch);
//       fetchFeedbackRatingsOnly(allBatch);
//       fetchDistinctFilters();
//     }
//   }, [allBatch]);

//   // ============================
//   // COLUMNS DEFINITION
//   // ============================
//   const columns = [
//     { field: "serialNo", headerName: "S.No", width: 70 },
//     {
//       field: "batchName",
//       headerName: "Batch Name",
//       width: 200,
//       renderCell: (params) => {
//         return (
//           <span
//             style={{ cursor: "pointer", color: "#0d6efd", fontWeight: 500, textDecoration: "underline" }}
//             onClick={() => handleViewDetails(params.row)}
//             title={`${params.row.totalStudents || 0} student(s)`}
//           >
//             {params.value}
//           </span>
//         );
//       },
//     },
//     { field: "department", headerName: "Department", width: 150 },
//     {
//       field: "trainerNames",
//       headerName: "Trainer(s)",
//       width: 250,
//       renderCell: (params) => {
//         return <span>{params.value || "No Trainer Assigned"}</span>;
//       },
//     },
//     {
//       field: "state",
//       headerName: "State",
//       width: 130,
//       renderCell: (params) => params.value || "N/A",
//     },
//     {
//       field: "depot",
//       headerName: "Depot",
//       width: 130,
//       renderCell: (params) => params.value || "N/A",
//     },
//     {
//       field: "trainingStartDate",
//       headerName: "Start Date",
//       width: 130,
//       renderCell: (params) => formatDateToDDMMYYYY(params.value),
//     },
//     {
//       field: "trainingEndDate",
//       headerName: "End Date",
//       width: 130,
//       renderCell: (params) => formatDateToDDMMYYYY(params.value),
//     },
//     {
//       field: "totalStudents",
//       headerName: "Students",
//       width: 90,
//       renderCell: (params) => (
//         <span style={{ fontWeight: params.value > 0 ? "bold" : "normal", color: params.value > 0 ? "#198754" : "#6c757d" }}>
//           {params.value || 0}
//         </span>
//       ),
//     },
//     {
//       field: "passedStudents",
//       headerName: "Passed",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ color: "#198754", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "failedStudents",
//       headerName: "Failed",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ color: "#dc3545", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "notAttemptedStudents",
//       headerName: "Not Attempted",
//       width: 100,
//       renderCell: (params) => (
//         <span style={{ color: "#ffc107", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "passPercentage",
//       headerName: "Pass %",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ fontWeight: "bold" }}>{params.value || 0}%</span>
//       ),
//     },
//     {
//       field: "feedbackRating",
//       headerName: "Rating",
//       width: 220,
//       renderCell: (params) => {
//         const rating = batchFeedbackRatings[params.row.id];
//         const count = batchFeedbackCounts[params.row.id] || 0;
//         const loading = loadingRatings[params.row.id];

//         if (loading) {
//           return <CircularProgress size={25} />;
//         }

//         return renderStarRating(rating, count);
//       },
//     },
//     {
//       field: "feedbackGiven",
//       headerName: "Feedback Given",
//       width: 130,
//       renderCell: (params) => {
//         const given = batchFeedbackGivenCounts[params.row.id] || 0;
//         const notGiven = batchNotFeedbackGivenCounts[params.row.id] || 0;
//         return (
//           <Tooltip title={`${given} students gave feedback, ${notGiven} students did not`}>
//             <span style={{ color: given > 0 ? "#198754" : "#6c757d" }}>
//               {given} / {given + notGiven}
//             </span>
//           </Tooltip>
//         );
//       },
//     },
//     {
//       field: "edit",
//       headerName: "Edit",
//       width: 80,
//       renderCell: (p) => (
//         <Button size="sm" color="warning" onClick={() => handleRowClick(p.row)} style={{ padding: "4px 12px" }}>
//           Edit
//         </Button>
//       ),
//     },
//     {
//       field: "download",
//       headerName: "Download Report",
//       width: 130,
//       renderCell: (p) => (
//         <Button 
//           size="sm" 
//           color="success" 
//           onClick={() => openBatchReportModal(p.row)}
//           style={{ padding: "4px 8px", marginRight: "4px" }}
//         >
//           <DownloadIcon style={{ fontSize: "14px" }} />
//         </Button>
//       ),
//     },
//     {
//       field: "downloadSimulator",
//       headerName: "Simulator",
//       width: 100,
//       renderCell: (p) => (
//         <Button 
//           size="sm" 
//           color="primary" 
//           onClick={() => openBatchSimulatorReportModal(p.row)}
//           style={{ padding: "4px 8px" }}
//         >
//           <ScienceIcon style={{ fontSize: "14px" }} />
//         </Button>
//       ),
//     },
//   ];

//   // ============================
//   // HELPER FUNCTIONS FOR DISPLAY - CHANGED TO DD-MM-YYYY
//   // ============================
//   const formatDateToDDMMYYYY = useCallback((dateStr) => {
//     if (!dateStr) return "N/A";
//     try {
//       const date = moment(dateStr);
//       if (date.isValid()) {
//         return date.format("DD-MM-YYYY");
//       }
//       return String(dateStr);
//     } catch (error) {
//       return String(dateStr);
//     }
//   }, []);

//   const renderStarRating = (rating, count = 0) => {
//     if (!rating || count === 0) {
//       return (
//         <Tooltip title="No feedback responses yet">
//           <span style={{ color: "#6c757d", fontStyle: "italic" }}>No Rating</span>
//         </Tooltip>
//       );
//     }

//     const fullStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 >= 0.5;
//     const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

//     return (
//       <Tooltip title={`Based on ${count} response(s) - Average Rating: ${rating.toFixed(1)}/5.0`}>
//         <Box display="flex" alignItems="center" gap={1} sx={{ cursor: "pointer" }}>
//           <Box display="flex" alignItems="center" gap={0.2}>
//             {[...Array(fullStars)].map((_, i) => (
//               <span key={`full-${i}`} style={{ color: "#ffb400", fontSize: "16px" }}>★</span>
//             ))}
//             {hasHalfStar && (
//               <span style={{ color: "#ffb400", fontSize: "16px", position: "relative", display: "inline-block" }}>
//                 <span style={{ position: "absolute", overflow: "hidden", width: "50%", color: "#ffb400" }}>★</span>
//                 <span style={{ color: "#e4e5e9" }}>★</span>
//               </span>
//             )}
//             {[...Array(emptyStars)].map((_, i) => (
//               <span key={`empty-${i}`} style={{ color: "#e4e5e9", fontSize: "16px" }}>★</span>
//             ))}
//           </Box>
//           <Typography 
//             variant="body2" 
//             sx={{ 
//               fontWeight: "bold", 
//               color: "#ffb400",
//               backgroundColor: "#fff3e0",
//               padding: "2px 6px",
//               borderRadius: "12px",
//               fontSize: "12px"
//             }}
//           >
//             {rating.toFixed(1)}
//           </Typography>
//         </Box>
//       </Tooltip>
//     );
//   };

//   const getFilteredStats = useCallback(() => {
//     let totalStudents = 0;
//     let totalPassed = 0;
//     let totalFailed = 0;
//     let totalNotAttempted = 0;
//     let totalRatingSum = 0;
//     let totalRatingCount = 0;
//     let totalFeedbackGiven = 0;
//     let totalNotFeedbackGiven = 0;

//     filteredBatches.forEach((batch) => {
//       totalStudents += batch.totalStudents || 0;
//       totalPassed += batch.passedStudents || 0;
//       totalFailed += batch.failedStudents || 0;
//       totalNotAttempted += batch.notAttemptedStudents || 0;
      
//       const rating = batchFeedbackRatings[batch.id];
//       if (rating) {
//         totalRatingSum += rating;
//         totalRatingCount++;
//       }
      
//       totalFeedbackGiven += batchFeedbackGivenCounts[batch.id] || 0;
//       totalNotFeedbackGiven += batchNotFeedbackGivenCounts[batch.id] || 0;
//     });

//     const passRate = totalStudents > 0 ? ((totalPassed / totalStudents) * 100).toFixed(1) : 0;
//     const avgRating = totalRatingCount > 0 ? (totalRatingSum / totalRatingCount).toFixed(1) : 0;

//     return {
//       totalStudents,
//       totalPassed,
//       totalFailed,
//       totalNotAttempted,
//       passRate,
//       avgRating,
//       totalRatingCount,
//       totalFeedbackGiven,
//       totalNotFeedbackGiven
//     };
//   }, [filteredBatches, batchFeedbackRatings, batchFeedbackGivenCounts, batchNotFeedbackGivenCounts]);

//   const filteredStats = getFilteredStats();

//   // ============================
//   // EDIT/DELETE FUNCTIONS
//   // ============================
//   const handleRowClick = (row) => {
//     setModalShow(true);
//     navigate(`/batch/${row.id}`);
//     setId(row.id);
//     setName(row.batchName || "");
//   };

//   const handleUpdate = async () => {
//     if (!name) {
//       setSpanDisplay("inline");
//       return;
//     }

//     try {
//       setLoader(true);
//       const result = await updateBatch({ id, batchName: name });
//       if (result?.success) {
//         toast.success(result?.message);
//         getAllBatches();
//         setModalShow(false);
//         setName("");
//         setId("");
//         setSpanDisplay("none");
//       } else {
//         toast.error(result?.message);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to update batch");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       setLoader(true);
//       const result = await deleteBatch(id);
//       if (result?.success) {
//         toast.success(result?.message);
//         getAllBatches();
//         setDeleteModalShow(false);
//         setModalShow(false);
//         setName("");
//         setId("");
//       } else {
//         toast.error(result?.message);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to delete batch");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleViewDetails = (row) => {
//     navigate(`/batch/${row.id}`);
//   };

//   const resetFilters = () => {
//     setFilterState("");
//     setFilterDepot("");
//     setFilterPeriod("ALL");
//     setSearchText("");
//     setDebouncedSearchText("");
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setFilterAnchorEl(null);
//     setDepartmentFilter("");
//     setTrainerNameFilter("");
//     setBatchTypeFilter("");
//     setPage(0);
//   };

//   const handleFilterClick = (event) => {
//     setFilterAnchorEl(event.currentTarget);
//   };

//   const handleFilterClose = () => {
//     setFilterAnchorEl(null);
//   };

//   const openCustomDateRangeModal = () => {
//     setDateRangeModalShow(true);
//     handleFilterClose();
//   };

//   const applyCustomDateRange = () => {
//     if (!customStartDate || !customEndDate) {
//       toast.error("Please select both start and end dates");
//       return;
//     }

//     if (moment(customStartDate).isAfter(moment(customEndDate))) {
//       toast.error("Start date cannot be after end date");
//       return;
//     }

//     setIsCustomDateRangeActive(true);
//     setFilterPeriod("ALL");
//     setDateRangeModalShow(false);
//     setPage(0);
//     toast.success(`Custom date range applied: ${formatDateToDDMMYYYY(customStartDate)} to ${formatDateToDDMMYYYY(customEndDate)}`);
//   };

//   const clearCustomDateRange = () => {
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setPage(0);
//     toast.success("Custom date range cleared");
//   };

//   const applySerialRangeFilter = () => {
//     if (!fromSerial || !toSerial) {
//       toast.error("Please enter both from and to serial numbers");
//       return;
//     }

//     const from = parseInt(fromSerial);
//     const to = parseInt(toSerial);

//     if (isNaN(from) || isNaN(to)) {
//       toast.error("Please enter valid numbers");
//       return;
//     }

//     if (from < 1 || to > allBatch.length) {
//       toast.error(`Please enter serial numbers between 1 and ${allBatch.length}`);
//       return;
//     }

//     if (from > to) {
//       toast.error("'From' serial number must be less than or equal to 'To' serial number");
//       return;
//     }

//     const filtered = allBatch.filter((_, index) => {
//       const serialNo = index + 1;
//       return serialNo >= from && serialNo <= to;
//     });

//     setFilteredBatches(filtered);
//     setSerialRangeModalShow(false);
//     toast.success(`Showing ${filtered.length} batches`);
//   };

//   const clearAllFilters = () => {
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setFromSerial("");
//     setToSerial("");
//     setSearchText("");
//     setDebouncedSearchText("");
//     setFilterState("");
//     setFilterDepot("");
//     setFilterPeriod("ALL");
//     setDepartmentFilter("");
//     setTrainerNameFilter("");
//     setBatchTypeFilter("");
//     setPage(0);
//     toast.success("All filters cleared");
//   };

//   const refreshData = () => {
//     setPage(0);
//     getAllBatches();
//     toast.info("Refreshing data from server...");
//   };

//   // ============================
//   // MODAL FUNCTIONS
//   // ============================
//   const openBatchReportModal = (batch) => {
//     setSelectedBatchForReport(batch);
//     setSelectedReportType("Other");
//     setBatchReportModalShow(true);
//   };

//   const openBatchSimulatorReportModal = (batch) => {
//     setSelectedBatchForSimulatorReport(batch);
//     setBatchSimulatorReportModalShow(true);
//   };

//   // ============================
//   // DOWNLOAD SINGLE BATCH REPORT
//   // ============================
//   const downloadSingleBatchReport = async () => {
//     if (!selectedBatchForReport) {
//       toast.error("No batch selected");
//       return;
//     }

//     try {
//       setLoader(true);
//       setBatchReportModalShow(false);
      
//       const batchId = selectedBatchForReport.id;
//       const batchName = selectedBatchForReport.batchName || "Batch";
      
//       toast.info(`Downloading ${selectedReportType} report for ${batchName}...`);
      
//       const apiUrl = `${downloadBatchReport}${batchId}?type=${selectedReportType}`;
//       const response = await axios.get(apiUrl, { 
//         responseType: "blob", 
//         timeout: 120000
//       });
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `${batchName}_${selectedReportType}_Report.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`${selectedReportType} report downloaded for ${batchName}`);
      
//     } catch (error) {
//       console.error(`Error downloading report:`, error);
//       toast.error(`Failed to download report: ${error.message}`);
//     } finally {
//       setLoader(false);
//       setSelectedBatchForReport(null);
//     }
//   };

//   // ============================
//   // DOWNLOAD SINGLE BATCH SIMULATOR REPORT
//   // ============================
//   const downloadSingleBatchSimulatorReport = async () => {
//     if (!selectedBatchForSimulatorReport) {
//       toast.error("No batch selected");
//       return;
//     }

//     try {
//       setLoader(true);
//       setBatchSimulatorReportModalShow(false);
      
//       const batchId = selectedBatchForSimulatorReport.id;
//       const batchName = selectedBatchForSimulatorReport.batchName || "Batch";
      
//       toast.info(`Downloading Simulator report for ${batchName}...`);
      
//       const apiUrl = downloadBatchSimulatorReport(batchId);
//       const response = await axios.get(apiUrl, { 
//         responseType: "blob", 
//         timeout: 120000
//       });
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `${batchName}_Simulator_Report.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`Simulator report downloaded for ${batchName}`);
      
//     } catch (error) {
//       console.error(`Error downloading simulator report:`, error);
//       toast.error(`Failed to download simulator report: ${error.message}`);
//     } finally {
//       setLoader(false);
//       setSelectedBatchForSimulatorReport(null);
//     }
//   };

//   // ============================
//   // DOWNLOAD ALL BATCHES AS ZIP
//   // ============================
//   const downloadAllBatchesAsZip = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to download");
//       return;
//     }

//     try {
//       setLoader(true);
//       setZipDownloadModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Downloading ${selectedZipType} reports for ${filteredBatches.length} batches...`
//       });

//       const mainZip = new JSZip();
//       const timestamp = moment().format("DD-MM-YYYY_HHmmss");
//       const reportsFolder = mainZip.folder(`All_Reports_${selectedZipType}_${timestamp}`);

//       let successCount = 0;
//       let failCount = 0;
//       const failedBatches = [];

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Downloading ${i + 1}/${filteredBatches.length}: ${batch.batchName}`
//         });
        
//         try {
//           const apiUrl = `${downloadBatchReport}${batch.id}?type=${selectedZipType}`;
//           const response = await axios.get(apiUrl, { 
//             responseType: "blob", 
//             timeout: 120000
//           });
          
//           if (response.data && response.data.size > 0) {
//             const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
//             const batchFolder = reportsFolder.folder(batchFolderName);
            
//             batchFolder.file(`${selectedZipType}_Report.zip`, response.data);
            
//             const trainers = batchTrainersMap[batch.id] || [];
//             const trainerName = formatTrainerNames(trainers);
//             const feedbackRating = batchFeedbackRatings[batch.id];
//             const feedbackCount = batchFeedbackCounts[batch.id] || 0;
//             const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
//             const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
//             const batchInfo = {
//               batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
//               batchName: batch.batchName,
//               batchId: batch.id,
//               department: batch.department,
//               depot: batch.depot,
//               state: batch.state,
//               startDate: formatDateToDDMMYYYY(batch.trainingStartDate),
//               endDate: formatDateToDDMMYYYY(batch.trainingEndDate),
//               trainers: trainers.map(t => ({
//                 id: t.id,
//                 name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
//               })),
//               trainerName: trainerName,
//               totalStudents: batch.totalStudents || 0,
//               passedStudents: batch.passedStudents || 0,
//               failedStudents: batch.failedStudents || 0,
//               notAttemptedStudents: batch.notAttemptedStudents || 0,
//               passPercentage: batch.passPercentage || 0,
//               feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
//               feedbackCount: feedbackCount,
//               feedbackGivenCount: feedbackGivenCount,
//               notFeedbackGivenCount: notFeedbackGivenCount,
//               reportType: selectedZipType,
//               downloadedAt: new Date().toISOString()
//             };
            
//             batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
//             try {
//               const downloadedZip = await JSZip.loadAsync(response.data);
//               const imageFiles = Object.keys(downloadedZip.files).filter(
//                 filename => filename.startsWith('images/') && 
//                 (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png') || filename.endsWith('.gif'))
//               );
              
//               if (imageFiles.length > 0) {
//                 const imagesFolder = batchFolder.folder("Images");
//                 for (const imageFile of imageFiles) {
//                   const imageData = await downloadedZip.files[imageFile].async("blob");
//                   const imageName = imageFile.split('/').pop();
//                   imagesFolder.file(imageName, imageData);
//                 }
//               }
//             } catch (imageError) {
//               console.log(`No images found for batch ${batch.batchName}`);
//             }
            
//             successCount++;
//           } else {
//             failCount++;
//             failedBatches.push({ name: batch.batchName, error: "Empty response" });
//           }
//         } catch (error) {
//           console.error(`Error downloading batch ${batch.batchName}:`, error);
//           failCount++;
//           failedBatches.push({ name: batch.batchName, error: error.message });
//         }
//       }

//       const summaryReport = [
//         "DOWNLOAD SUMMARY",
//         "================",
//         `Report Type: ${selectedZipType}`,
//         `Date: ${moment().format("DD-MM-YYYY HH:mm:ss")}`,
//         `Total Batches: ${filteredBatches.length}`,
//         `Successfully Downloaded: ${successCount}`,
//         `Failed: ${failCount}`,
//         "",
//         failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
//         ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
//         "",
//         "BATCH SUMMARY",
//         "==============",
//         ...filteredBatches.map((batch, idx) => {
//           const rating = batchFeedbackRatings[batch.id];
//           const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
//           const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
//           return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
//         })
//       ].join("\n");

//       reportsFolder.file("Download_Summary.txt", summaryReport);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

//       const finalZipBlob = await mainZip.generateAsync({
//         type: "blob",
//         compression: "DEFLATE",
//         compressionOptions: { level: 6 },
//       });

//       const downloadUrl = window.URL.createObjectURL(finalZipBlob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `All_Batches_${selectedZipType}_${timestamp}.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       if (failCount === 0) {
//         toast.success(`All ${successCount} batches downloaded successfully with images!`);
//       } else {
//         toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
//       }
//     } catch (error) {
//       console.error("Error downloading all reports:", error);
//       toast.error("Error downloading reports: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // DOWNLOAD ALL BATCHES SIMULATOR AS ZIP
//   // ============================
//   const downloadAllBatchesSimulatorAsZip = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to download");
//       return;
//     }

//     try {
//       setLoader(true);
//       setZipSimulatorDownloadModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Downloading Simulator reports for ${filteredBatches.length} batches...`
//       });

//       const mainZip = new JSZip();
//       const timestamp = moment().format("DD-MM-YYYY_HHmmss");
//       const reportsFolder = mainZip.folder(`All_Simulator_Reports_${timestamp}`);

//       let successCount = 0;
//       let failCount = 0;
//       const failedBatches = [];

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Downloading ${i + 1}/${filteredBatches.length}: ${batch.batchName} Simulator Report`
//         });
        
//         try {
//           const apiUrl = downloadBatchSimulatorReport(batch.id);
//           const response = await axios.get(apiUrl, { 
//             responseType: "blob", 
//             timeout: 120000
//           });
          
//           if (response.data && response.data.size > 0) {
//             const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
//             const batchFolder = reportsFolder.folder(batchFolderName);
            
//             batchFolder.file(`Simulator_Report.xlsx`, response.data);
            
//             const trainers = batchTrainersMap[batch.id] || [];
//             const trainerName = formatTrainerNames(trainers);
//             const feedbackRating = batchFeedbackRatings[batch.id];
//             const feedbackCount = batchFeedbackCounts[batch.id] || 0;
//             const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
//             const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
//             const batchInfo = {
//               batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
//               batchName: batch.batchName,
//               batchId: batch.id,
//               department: batch.department,
//               depot: batch.depot,
//               state: batch.state,
//               startDate: formatDateToDDMMYYYY(batch.trainingStartDate),
//               endDate: formatDateToDDMMYYYY(batch.trainingEndDate),
//               trainers: trainers.map(t => ({
//                 id: t.id,
//                 name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
//               })),
//               trainerName: trainerName,
//               totalStudents: batch.totalStudents || 0,
//               passedStudents: batch.passedStudents || 0,
//               failedStudents: batch.failedStudents || 0,
//               notAttemptedStudents: batch.notAttemptedStudents || 0,
//               passPercentage: batch.passPercentage || 0,
//               feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
//               feedbackCount: feedbackCount,
//               feedbackGivenCount: feedbackGivenCount,
//               notFeedbackGivenCount: notFeedbackGivenCount,
//               reportType: "Simulator",
//               downloadedAt: new Date().toISOString()
//             };
            
//             batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
//             successCount++;
//           } else {
//             failCount++;
//             failedBatches.push({ name: batch.batchName, error: "Empty response" });
//           }
//         } catch (error) {
//           console.error(`Error downloading simulator report for batch ${batch.batchName}:`, error);
//           failCount++;
//           failedBatches.push({ name: batch.batchName, error: error.message });
//         }
//       }

//       const summaryReport = [
//         "SIMULATOR DOWNLOAD SUMMARY",
//         "========================",
//         `Report Type: Simulator`,
//         `Date: ${moment().format("DD-MM-YYYY HH:mm:ss")}`,
//         `Total Batches: ${filteredBatches.length}`,
//         `Successfully Downloaded: ${successCount}`,
//         `Failed: ${failCount}`,
//         "",
//         failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
//         ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
//         "",
//         "BATCH SUMMARY",
//         "==============",
//         ...filteredBatches.map((batch, idx) => {
//           const rating = batchFeedbackRatings[batch.id];
//           const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
//           const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
//           return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
//         })
//       ].join("\n");

//       reportsFolder.file("Download_Summary.txt", summaryReport);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

//       const finalZipBlob = await mainZip.generateAsync({
//         type: "blob",
//         compression: "DEFLATE",
//         compressionOptions: { level: 6 },
//       });

//       const downloadUrl = window.URL.createObjectURL(finalZipBlob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `All_Batches_Simulator_Reports_${timestamp}.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       if (failCount === 0) {
//         toast.success(`All ${successCount} simulator reports downloaded successfully!`);
//       } else {
//         toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
//       }
//     } catch (error) {
//       console.error("Error downloading simulator reports:", error);
//       toast.error("Error downloading simulator reports: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // RENDER
//   // ============================
//   return (
//     <>
//       {loader && <Loader />}

//       {consolidatedProgress.active && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             zIndex: 9999,
//             backgroundColor: "rgba(255,255,255,0.95)",
//             padding: "15px 20px",
//             boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//           }}
//         >
//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <span className="fw-bold text-primary">
//               <i className="fas fa-spinner fa-spin me-2"></i>
//               {consolidatedProgress.message}
//             </span>
//             <span className="text-muted">
//               {consolidatedProgress.current}/{consolidatedProgress.total}
//             </span>
//           </div>
//           <LinearProgress
//             variant="determinate"
//             value={consolidatedProgress.total > 0 ? (consolidatedProgress.current / consolidatedProgress.total) * 100 : 0}
//           />
//         </div>
//       )}

//       <Row>
//         <Col>
//           <Card>
//             <CardBody>
//               {/* Header Section */}
//               <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
//                 <CardTitle className="h4 mb-0">
//                   All Batches
//                   {filterState && <span className="ms-2 fs-6 text-muted">(State: {filterState})</span>}
//                   {filterDepot && <span className="ms-2 fs-6 text-muted">(Depot: {filterDepot})</span>}
//                   {filterPeriod !== "ALL" && (
//                     <span className="ms-2 fs-6 text-muted">(Period: {filterPeriod})</span>
//                   )}
//                   {isCustomDateRangeActive && customStartDate && customEndDate && (
//                     <span className="ms-2 fs-6 text-muted">
//                       (Custom Range: {formatDateToDDMMYYYY(customStartDate)} - {formatDateToDDMMYYYY(customEndDate)})
//                     </span>
//                   )}
//                   {departmentFilter && (
//                     <span className="ms-2 fs-6 text-muted">(Dept: {departmentFilter})</span>
//                   )}
//                   {debouncedSearchText && (
//                     <span className="ms-2 fs-6 text-info">(Search: "{debouncedSearchText}")</span>
//                   )}
//                 </CardTitle>
//                 <div className="d-flex flex-wrap gap-2">
//                   <Button color="secondary" size="sm" onClick={handleFilterClick}>
//                     <FilterListIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Filters
//                   </Button>
//                   <Menu
//                     anchorEl={filterAnchorEl}
//                     open={Boolean(filterAnchorEl)}
//                     onClose={handleFilterClose}
//                   >
//                     <div style={{ padding: "16px", minWidth: "280px" }}>
//                       <Typography variant="subtitle2" className="mb-2">State</Typography>
//                       <Select
//                         options={availableStates.map(s => ({ value: s, label: s }))}
//                         value={filterState ? { value: filterState, label: filterState } : null}
//                         onChange={(option) => {
//                           setFilterState(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All States"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Depot</Typography>
//                       <Select
//                         options={availableDepots.map(d => ({ value: d, label: d }))}
//                         value={filterDepot ? { value: filterDepot, label: filterDepot } : null}
//                         onChange={(option) => {
//                           setFilterDepot(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All Depots"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Department</Typography>
//                       <Select
//                         options={availableDepartments.map(d => ({ value: d, label: d }))}
//                         value={departmentFilter ? { value: departmentFilter, label: departmentFilter } : null}
//                         onChange={(option) => {
//                           setDepartmentFilter(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All Departments"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Period</Typography>
//                       <Select
//                         options={periodOptions}
//                         value={periodOptions.find(p => p.value === filterPeriod)}
//                         onChange={(option) => {
//                           setFilterPeriod(option?.value || "ALL");
//                           setPage(0);
//                           if (option?.value !== "CUSTOM") {
//                             setIsCustomDateRangeActive(false);
//                           }
//                         }}
//                         className="mb-3"
//                       />
                      
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={openCustomDateRangeModal}
//                         fullWidth
//                         style={{ marginBottom: "8px" }}
//                       >
//                         Custom Date Range
//                       </Button>
//                       {isCustomDateRangeActive && (
//                         <Button 
//                           size="small" 
//                           variant="outlined" 
//                           onClick={clearCustomDateRange}
//                           fullWidth
//                           style={{ marginBottom: "8px", backgroundColor: "#ffebee" }}
//                         >
//                           Clear Date Range
//                         </Button>
//                       )}
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={() => setSerialRangeModalShow(true)}
//                         fullWidth
//                         style={{ marginBottom: "8px" }}
//                       >
//                         Serial Range
//                       </Button>
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={resetFilters}
//                         fullWidth
//                       >
//                         Reset All Filters
//                       </Button>
//                     </div>
//                   </Menu>
                  
//                   <Button color="secondary" size="sm" onClick={() => setSerialRangeModalShow(true)}>
//                     <i className="fas fa-sort-numeric-up-alt me-1"></i>Serial Range
//                   </Button>
                  
//                   {(filterState || filterDepot || filterPeriod !== "ALL" || isCustomDateRangeActive || fromSerial || toSerial || searchText || departmentFilter) && (
//                     <Button color="danger" size="sm" onClick={clearAllFilters}>
//                       <i className="fas fa-times me-1"></i>Clear All
//                     </Button>
//                   )}
                  
//                   <Button color="info" size="sm" onClick={downloadExcel}>
//                     <i className="fas fa-download me-1"></i>Excel
//                   </Button>
                  
//                   <Button color="success" size="sm" onClick={() => setZipDownloadModalShow(true)}>
//                     <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Download ZIP
//                   </Button>
                  
//                   <Button color="success" size="sm" onClick={() => setZipSimulatorDownloadModalShow(true)}>
//                     <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Simulator ZIP
//                   </Button>
                  
//                   <Button color="warning" size="sm" onClick={openConsolidatedModal}>
//                     <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Consolidated Report
//                   </Button>
                  
//                   <Button color="warning" size="sm" onClick={openConsolidatedSimulatorModal}>
//                     <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Combined Consolidated
//                   </Button>
                  
//                   <Button color="primary" size="sm" onClick={refreshData}>
//                     <RefreshIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Refresh
//                   </Button>
//                 </div>
//               </div>

//               {/* Search and Stats */}
//               <Row className="mb-3">
//                 <Col md={6}>
//                   <TextField
//                     fullWidth
//                     label="Search..."
//                     placeholder="Batch name, department, depot, state, trainer, date"
//                     value={searchText}
//                     onChange={(e) => {
//                       setSearchText(e.target.value);
//                     }}
//                     variant="outlined"
//                     size="small"
//                     InputProps={{
//                       startAdornment: <i className="fas fa-search" style={{ marginRight: 8, color: "#6c757d" }}></i>,
//                       endAdornment: searchText !== debouncedSearchText && searchText ? (
//                         <CircularProgress size={20} style={{ marginRight: 8 }} />
//                       ) : null,
//                     }}
//                     helperText={searchText !== debouncedSearchText && searchText ? "Searching..." : ""}
//                   />
//                 </Col>
//                 <Col md={6} className="d-flex align-items-center">
//                   <small className="text-muted">
//                     <span className="me-2">Batches: <strong>{totalItems}</strong></span>
//                     <span className="me-2">| Students: <strong>{filteredStats.totalStudents}</strong></span>
//                     <span className="me-2 text-success">| Passed: <strong>{filteredStats.totalPassed}</strong></span>
//                     <span className="me-2 text-danger">| Failed: <strong>{filteredStats.totalFailed}</strong></span>
//                     <span className="me-2 text-warning">| Not Attempted: <strong>{filteredStats.totalNotAttempted}</strong></span>
//                     <span>| Pass Rate: <strong>{filteredStats.passRate}%</strong></span>
//                     <span className="ms-2" style={{ color: "#ffb400" }}>
//                       | Avg Rating: <strong>{filteredStats.avgRating > 0 ? filteredStats.avgRating + " ★" : "No Ratings"}</strong>
//                     </span>
//                     <span className="ms-2 text-success">
//                       | Feedback Given: <strong>{filteredStats.totalFeedbackGiven}</strong>
//                     </span>
//                     <span className="ms-2 text-danger">
//                       | Not Given: <strong>{filteredStats.totalNotFeedbackGiven}</strong>
//                     </span>
//                   </small>
//                 </Col>
//               </Row>

//               {/* Data Grid */}
//               <Paper elevation={0} style={{ border: "1px solid #e0e0e0" }}>
//                 <DataGrid
//                   autoHeight
//                   rows={filteredBatches.map((r, i) => ({
//                     ...r,
//                     serialNo: page * pageSize + i + 1,
//                     id: r.id,
//                   }))}
//                   columns={columns}
//                   pageSizeOptions={[5, 10, 25, 50, 100]}
//                   initialState={{
//                     pagination: { paginationModel: { pageSize: pageSize, page: 0 } },
//                   }}
//                   onPaginationModelChange={(model) => {
//                     if (model.pageSize !== pageSize) {
//                       handlePageSizeChange(model.pageSize);
//                     }
//                   }}
//                   disableRowSelectionOnClick
//                   sx={{
//                     "& .MuiDataGrid-cell:focus": { outline: "none" },
//                     "& .MuiDataGrid-columnHeaders": { backgroundColor: "#f8f9fa", fontWeight: "bold" },
//                   }}
//                 />
//               </Paper>

//               {renderPagination()}
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>

//       {/* ============================ */}
//       {/* MODALS */}
//       {/* ============================ */}

//       {/* Custom Date Range Modal */}
//       <Modal show={dateRangeModalShow} centered onHide={() => setDateRangeModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Select Custom Date Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="row">
//             <div className="col-md-6 mb-3">
//               <label className="form-label fw-bold">Start Date</label>
//               <DatePicker
//                 selected={customStartDate}
//                 onChange={(date) => setCustomStartDate(date)}
//                 selectsStart
//                 startDate={customStartDate}
//                 endDate={customEndDate}
//                 className="form-control"
//                 dateFormat="dd-MM-yyyy"
//                 placeholderText="Select start date"
//                 maxDate={customEndDate || undefined}
//                 showYearDropdown
//                 showMonthDropdown
//                 dropdownMode="select"
//               />
//             </div>
//             <div className="col-md-6 mb-3">
//               <label className="form-label fw-bold">End Date</label>
//               <DatePicker
//                 selected={customEndDate}
//                 onChange={(date) => setCustomEndDate(date)}
//                 selectsEnd
//                 startDate={customStartDate}
//                 endDate={customEndDate}
//                 minDate={customStartDate}
//                 className="form-control"
//                 dateFormat="dd-MM-yyyy"
//                 placeholderText="Select end date"
//                 showYearDropdown
//                 showMonthDropdown
//                 dropdownMode="select"
//               />
//             </div>
//           </div>
//           <div className="mt-2 p-2 bg-light rounded">
//             <small className="text-muted">
//               <i className="fas fa-info-circle me-1"></i>
//               Select a date range to show batches that started within this period.
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDateRangeModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={applyCustomDateRange}>
//             Apply Filter
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Serial Range Modal */}
//       <Modal show={serialRangeModalShow} centered onHide={() => setSerialRangeModalShow(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Serial Number Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="mb-3">
//             <label className="form-label fw-bold">From</label>
//             <input
//               type="number"
//               className="form-control"
//               min="1"
//               max={allBatch.length}
//               value={fromSerial}
//               onChange={(e) => setFromSerial(e.target.value)}
//               placeholder={`1 to ${allBatch.length}`}
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label fw-bold">To</label>
//             <input
//               type="number"
//               className="form-control"
//               min="1"
//               max={allBatch.length}
//               value={toSerial}
//               onChange={(e) => setToSerial(e.target.value)}
//               placeholder={`1 to ${allBatch.length}`}
//             />
//           </div>
//           <div className="mt-2 p-2 bg-light rounded">
//             <small className="text-muted">
//               <i className="fas fa-info-circle me-1"></i>
//               Enter serial number range to filter batches by their position in the list.
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setSerialRangeModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={applySerialRangeFilter}>
//             Apply
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Batch Modal */}
//       <Modal show={modalShow} size="lg" centered onHide={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Batch</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Row className="mb-3">
//             <label htmlFor="batch-name-input" className="col-md-2 col-form-label">
//               Batch Name
//             </label>
//             <div className="col-md-10">
//               <input
//                 id="batch-name-input"
//                 type="text"
//                 className="form-control"
//                 placeholder="Enter new batch name"
//                 maxLength="50"
//                 value={name}
//                 onChange={(e) => { setName(e.target.value); setSpanDisplay("none"); }}
//               />
//               <span style={{ color: "red", display: spanDisplay, fontSize: "12px", marginTop: "5px" }}>
//                 Batch name is required
//               </span>
//             </div>
//           </Row>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button color="secondary" onClick={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
//             Close
//           </Button>
//           <Button color="success" onClick={handleUpdate}>
//             Update
//           </Button>
//           <Button color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false); }}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Modal */}
//       <Modal show={deleteModalShow} centered onHide={() => setDeleteModalShow(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Delete</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="text-center py-3">
//             <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: "48px" }}></i>
//             <h5 className="mt-3">Delete this batch?</h5>
//             <p className="text-muted">This action cannot be undone.</p>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button color="secondary" onClick={() => { setDeleteModalShow(false); setModalShow(true); }}>
//             Cancel
//           </Button>
//           <Button color="danger" onClick={handleDelete}>
//             Yes, Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Individual Batch Report Modal */}
//       <Modal show={batchReportModalShow} centered onHide={() => setBatchReportModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download Batch Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
//             <DownloadIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
//             <div>
//               <strong>Download Report for {selectedBatchForReport?.batchName || "Batch"}</strong>
//               <small className="d-block text-muted">
//                 Select report type to download with images
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batch</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.batchName || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Department</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.department || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.totalStudents || 0}</div>
//             </div>
//             <div>
//               <small className="text-muted">Depot</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.depot || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">State</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.state || "N/A"}</div>
//             </div>
//           </div>

//           <label className="mb-2 fw-bold">Select Report Type:</label>
//           <Select
//             options={reportTypeOptions}
//             value={reportTypeOptions.find((opt) => opt.value === selectedReportType)}
//             onChange={(option) => setSelectedReportType(option?.value || "Other")}
//             placeholder="Choose report type..."
//             isSearchable={false}
//           />

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The downloaded file will be a ZIP containing:
//               <ul className="mt-2 mb-0">
//                 <li>Excel report with all student data</li>
//                 <li>Images folder with all uploaded images</li>
//                 <li>Complete with all fields including Pre Test, Post Test, Practical Grade, etc.</li>
//               </ul>
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBatchReportModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="success" onClick={downloadSingleBatchReport}>
//             <DownloadIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download {selectedReportType} Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Individual Batch Simulator Report Modal */}
//       <Modal show={batchSimulatorReportModalShow} centered onHide={() => setBatchSimulatorReportModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download Simulator Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Download Simulator Report for {selectedBatchForSimulatorReport?.batchName || "Batch"}</strong>
//               <small className="d-block text-muted">
//                 Download complete simulator report with all scenarios (PASS/FAIL/NOT_ATTEMPTED)
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batch</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.batchName || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Department</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.department || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.totalStudents || 0}</div>
//             </div>
//             <div>
//               <small className="text-muted">Depot</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.depot || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">State</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.state || "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The simulator report includes:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
//                 <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//               </ul>
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBatchSimulatorReportModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadSingleBatchSimulatorReport}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download Simulator Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Consolidated Report Modal */}
//       <Modal show={consolidatedModalShow} centered onHide={() => setConsolidatedModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Generate Consolidated Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
//             <MergeTypeIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
//             <div>
//               <strong>Single Sheet Consolidated Report</strong>
//               <small className="d-block text-muted">
//                 Combines all data from <strong>{allFilteredBatchCount}</strong> filtered batches into a single Excel sheet
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Process</small>
//               <div className="fw-bold fs-5">{allFilteredBatchCount}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//             <div>
//               <small className="text-muted">Avg Rating</small>
//               <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               This will generate a single Excel file containing all data with:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
//               </ul>
//             </small>
//           </div>

//           {allFilteredBatchCount > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Processing <strong>{allFilteredBatchCount}</strong> batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConsolidatedModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="success" onClick={downloadConsolidatedSimulator}>
//             <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Generate Report ({allFilteredBatchCount} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Consolidated Simulator Report Modal */}
//       <Modal show={consolidatedSimulatorModalShow} centered onHide={() => setConsolidatedSimulatorModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Generate Consolidated Simulator Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Single Sheet Consolidated Simulator Report</strong>
//               <small className="d-block text-muted">
//                 Combines all simulator data from <strong>{allFilteredBatchCount}</strong> filtered batches into a single Excel sheet
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Process</small>
//               <div className="fw-bold fs-5">{allFilteredBatchCount}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//             <div>
//               <small className="text-muted">Avg Rating</small>
//               <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               This will generate a single Excel file containing simulator data:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
//                 <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//                 <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
//               </ul>
//             </small>
//           </div>

//           {allFilteredBatchCount > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Processing <strong>{allFilteredBatchCount}</strong> batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConsolidatedSimulatorModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadConsolidatedSimulator}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Generate Simulator Report ({allFilteredBatchCount} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ZIP Download Modal */}
//       <Modal show={zipDownloadModalShow} centered onHide={() => setZipDownloadModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download All Batches as ZIP</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ArchiveIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Batch-wise ZIP Download with Images</strong>
//               <small className="d-block text-muted">
//                 Downloads each batch's report as a separate folder in a single ZIP file
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Download</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//           </div>

//           <label className="mb-2 fw-bold">Report Type:</label>
//           <Select
//             options={zipDownloadOptions}
//             value={zipDownloadOptions.find((opt) => opt.value === selectedZipType)}
//             onChange={(option) => setSelectedZipType(option?.value || "Other")}
//             placeholder="Choose report type..."
//             isSearchable={false}
//           />

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The ZIP file will contain:
//               <ul className="mt-2 mb-0">
//                 <li>Each batch in a separate folder with original report ZIP</li>
//                 <li>Batch_Info.json with complete batch details</li>
//                 <li>Images folder with all uploaded images</li>
//                 <li>Download_Summary.txt with overall statistics</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Downloading {filteredBatches.length} batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setZipDownloadModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadAllBatchesAsZip}>
//             <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download All as ZIP ({filteredBatches.length} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ZIP Simulator Download Modal */}
//       <Modal show={zipSimulatorDownloadModalShow} centered onHide={() => setZipSimulatorDownloadModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download All Simulator Reports as ZIP</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Batch-wise Simulator Reports ZIP Download</strong>
//               <small className="d-block text-muted">
//                 Downloads each batch's simulator report as a separate folder in a single ZIP file
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Download</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The ZIP file will contain:
//               <ul className="mt-2 mb-0">
//                 <li>Each batch in a separate folder with Simulator_Report.xlsx</li>
//                 <li>Batch_Info.json with complete batch details</li>
//                 <li>Download_Summary.txt with overall statistics</li>
//                 <li>Complete simulator data with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>All scenarios (PASS/FAIL/NOT_ATTEMPTED)</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Downloading {filteredBatches.length} batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setZipSimulatorDownloadModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadAllBatchesSimulatorAsZip}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download All Simulator Reports ({filteredBatches.length} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default connect(null, { setBreadcrumbItems })(AllGroup);



// AllGroup.js - Complete working component with all features

// import React, { useEffect, useState, useCallback } from "react";
// import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
// import { connect } from "react-redux";
// import { setBreadcrumbItems } from "../../store/actions";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import moment from "moment";

// import { Paper, TextField, LinearProgress, Tooltip, CircularProgress, Box, Typography, Menu, MenuItem } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { Modal } from "react-bootstrap";
// import Select from "react-select";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import FilterListIcon from '@mui/icons-material/FilterList';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import MergeTypeIcon from '@mui/icons-material/MergeType';
// import DownloadIcon from '@mui/icons-material/Download';
// import ArchiveIcon from '@mui/icons-material/Archive';
// import ScienceIcon from '@mui/icons-material/Science';
// import FirstPageIcon from '@mui/icons-material/FirstPage';
// import LastPageIcon from '@mui/icons-material/LastPage';
// import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';

// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import axios from "axios";
// import JSZip from "jszip";

// import Loader from "components/Loader/Loader";
// import {
//   fetchAllBatchesWithPagination,
//   fetchAllBatch,
//   fetchAllBatchOfTrainer,
//   getAllTrainerOfBatch,
//   getAllStudentOfBatch,
//   updateBatch,
//   deleteBatch,
//   batchDetailFile,
//   batchDetailFileWithFullFilters,
//   getDistinctStates,
//   getDistinctDepots,
// } from "helpers/batch_helper";
// import { downloadBatchReport, url } from "helpers/url_helper";
// import { getResult } from "helpers/exam_helper";
// import { fetchAllFeedbackOfBatch, getAllResponsesOfFeedback } from "helpers/feedback_helper";

// // ============================
// // SIMULATOR API HELPER FUNCTIONS
// // ============================
// const SIMULATOR_EXCEL_URL = url + "api/simulator/excel/";

// const downloadBatchSimulatorReport = (batchId) => {
//   return `${SIMULATOR_EXCEL_URL}${batchId}`;
// };

// // ============================
// // PROGRESS TOAST FUNCTIONS
// // ============================
// let progressToastId = null;

// const showProgressToast = (message, isProcessing = true) => {
//   if (progressToastId) {
//     toast.update(progressToastId, {
//       render: message,
//       type: isProcessing ? "info" : "success",
//       isLoading: isProcessing,
//       autoClose: isProcessing ? false : 5000,
//     });
//   } else {
//     progressToastId = toast.info(message, {
//       autoClose: false,
//       isLoading: true,
//     });
//   }
// };

// const hideProgressToast = (message, isSuccess = true) => {
//   if (progressToastId) {
//     toast.update(progressToastId, {
//       render: message,
//       type: isSuccess ? "success" : "error",
//       isLoading: false,
//       autoClose: 5000,
//     });
//     progressToastId = null;
//   }
// };

// // ============================
// // SAFE DATE PARSER - FIXES DATE FORMAT ISSUE
// // ============================
// /**
//  * Safely parse a date string without ambiguity.
//  * Tries multiple formats explicitly to avoid MM-DD vs DD-MM confusion.
//  * 
//  * Priority order:
//  * 1. ISO 8601 (from backend - most reliable): "2026-07-12T00:00:00.000Z" or "2026-07-12"
//  * 2. DD-MM-YYYY (Indian format)
//  * 3. DD/MM/YYYY (Indian format with slash)
//  * 4. Fallback to moment auto-detect
//  */
// const parseDateSafely = (dateStr) => {
//   if (!dateStr) return null;
  
//   // If already a Date object
//   if (dateStr instanceof Date) {
//     return moment(dateStr);
//   }
  
//   const str = String(dateStr).trim();
  
//   // 1. Try ISO 8601 format (from backend) - has T separator or is YYYY-MM-DD
//   // This is the most reliable since backend usually sends ISO format
//   if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
//     const parsed = moment(str, moment.ISO_8601, true);
//     if (parsed.isValid()) return parsed;
//   }
  
//   // 2. Try DD-MM-YYYY format (Indian format) - EXPLICIT
//   // This ensures "07-12-2026" is parsed as 7th December, not July 12th
//   if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(str)) {
//     const parsed = moment(str, "DD-MM-YYYY", true);
//     if (parsed.isValid()) return parsed;
//   }
  
//   // 3. Try DD/MM/YYYY format
//   if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(str)) {
//     const parsed = moment(str, "DD/MM/YYYY", true);
//     if (parsed.isValid()) return parsed;
//   }
  
//   // 4. Try with timestamp (e.g., "2026-07-12 10:30:00")
//   const parsedISO = moment(str, "YYYY-MM-DD HH:mm:ss", true);
//   if (parsedISO.isValid()) return parsedISO;
  
//   // 5. Fallback: try moment's default parser
//   const fallback = moment(str);
//   if (fallback.isValid()) return fallback;
  
//   return null;
// };

// // ============================
// // FORMAT DATE FOR DISPLAY - ALWAYS DD-MM-YYYY
// // ============================
// const formatDateForDisplay = (dateStr) => {
//   if (!dateStr) return "N/A";
  
//   const parsed = parseDateSafely(dateStr);
//   if (parsed && parsed.isValid()) {
//     return parsed.format("DD-MM-YYYY");
//   }
  
//   return String(dateStr);
// };

// const AllGroup = (props) => {
//   document.title = "Content Management | All Batches";
//   const navigate = useNavigate();

//   // ============================
//   // STATE DECLARATIONS
//   // ============================
//   const [loader, setLoader] = useState(false);
//   const [allBatch, setAllBatch] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [searchText, setSearchText] = useState("");
//   const [debouncedSearchText, setDebouncedSearchText] = useState("");
//   const [modalShow, setModalShow] = useState(false);
//   const [deleteModalShow, setDeleteModalShow] = useState(false);
//   const [name, setName] = useState("");
//   const [id, setId] = useState({});
//   const [spanDisplay, setSpanDisplay] = useState("none");

//   // Pagination states
//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalItems, setTotalItems] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);

//   // Filter states
//   const [filterState, setFilterState] = useState("");
//   const [filterDepot, setFilterDepot] = useState("");
//   const [filterPeriod, setFilterPeriod] = useState("ALL");
//   const [availableStates, setAvailableStates] = useState([]);
//   const [availableDepots, setAvailableDepots] = useState([]);
//   const [filterAnchorEl, setFilterAnchorEl] = useState(null);

//   // Additional filter states
//   const [departmentFilter, setDepartmentFilter] = useState("");
//   const [trainerNameFilter, setTrainerNameFilter] = useState("");
//   const [batchTypeFilter, setBatchTypeFilter] = useState("");
//   const [availableDepartments, setAvailableDepartments] = useState([]);
//   const [availableTrainers, setAvailableTrainers] = useState([]);
//   const [availableBatchTypes, setAvailableBatchTypes] = useState([]);

//   // Report generation states
//   const [consolidatedModalShow, setConsolidatedModalShow] = useState(false);
//   const [selectedConsolidatedType, setSelectedConsolidatedType] = useState("Other");
//   const [dateRangeModalShow, setDateRangeModalShow] = useState(false);
//   const [serialRangeModalShow, setSerialRangeModalShow] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState(null);
//   const [customEndDate, setCustomEndDate] = useState(null);
//   const [isCustomDateRangeActive, setIsCustomDateRangeActive] = useState(false);
//   const [fromSerial, setFromSerial] = useState("");
//   const [toSerial, setToSerial] = useState("");

//   // Individual Batch Report Download States
//   const [batchReportModalShow, setBatchReportModalShow] = useState(false);
//   const [selectedBatchForReport, setSelectedBatchForReport] = useState(null);
//   const [selectedReportType, setSelectedReportType] = useState("Other");

//   // Individual Batch Simulator Report Download States
//   const [batchSimulatorReportModalShow, setBatchSimulatorReportModalShow] = useState(false);
//   const [selectedBatchForSimulatorReport, setSelectedBatchForSimulatorReport] = useState(null);

//   // ZIP Download States
//   const [zipDownloadModalShow, setZipDownloadModalShow] = useState(false);
//   const [selectedZipType, setSelectedZipType] = useState("Other");

//   // ZIP Simulator Download States
//   const [zipSimulatorDownloadModalShow, setZipSimulatorDownloadModalShow] = useState(false);

//   // Consolidated Simulator Report States
//   const [consolidatedSimulatorModalShow, setConsolidatedSimulatorModalShow] = useState(false);

//   // Store data maps
//   const [batchTrainersMap, setBatchTrainersMap] = useState({});
//   const [batchFeedbackRatings, setBatchFeedbackRatings] = useState({});
//   const [batchFeedbackCounts, setBatchFeedbackCounts] = useState({});
//   const [batchFeedbackGivenCounts, setBatchFeedbackGivenCounts] = useState({});
//   const [batchNotFeedbackGivenCounts, setBatchNotFeedbackGivenCounts] = useState({});
//   const [loadingRatings, setLoadingRatings] = useState({});
//   const [ratingsFetched, setRatingsFetched] = useState(false);

//   // Progress tracking
//   const [consolidatedProgress, setConsolidatedProgress] = useState({ 
//     active: false, 
//     current: 0, 
//     total: 0, 
//     message: "" 
//   });

//   // All filtered batches state (for consolidated report)
//   const [allFilteredBatchCount, setAllFilteredBatchCount] = useState(0);
//   const [allFilteredBatchData, setAllFilteredBatchData] = useState([]);

//   // Search state to prevent multiple API calls
//   const [isSearching, setIsSearching] = useState(false);
//   const searchTimeoutRef = React.useRef(null);

//   // ============================
//   // HELPER FUNCTIONS
//   // ============================
//   const formatTrainerNames = (trainers) => {
//     if (!trainers || trainers.length === 0) return "No Trainer Assigned";
//     const trainerNames = trainers.map((t) => {
//       if (t.name) return t.name;
//       if (t.firstName && t.lastName) return `${t.firstName} ${t.lastName}`;
//       if (t.firstName) return t.firstName;
//       if (t.fullName) return t.fullName;
//       if (t.email) return t.email.split("@")[0];
//       return `Trainer ${t.id}`;
//     });
//     if (trainers.length === 1) return trainerNames[0];
//     return `${trainerNames[0]} +${trainers.length - 1}`;
//   };

//   const formatRatingWithStars = (rating) => {
//     if (!rating) return "Not Rated";
//     const fullStars = Math.floor(rating);
//     const emptyStars = 5 - fullStars;
//     return `${"★".repeat(fullStars)}${"☆".repeat(emptyStars)} ${rating.toFixed(1)}/5.0`;
//   };

//   // ============================
//   // DEBOUNCE SEARCH EFFECT
//   // ============================
//   useEffect(() => {
//     if (searchTimeoutRef.current) {
//       clearTimeout(searchTimeoutRef.current);
//     }

//     searchTimeoutRef.current = setTimeout(() => {
//       setDebouncedSearchText(searchText);
//     }, 500);

//     return () => {
//       if (searchTimeoutRef.current) {
//         clearTimeout(searchTimeoutRef.current);
//       }
//     };
//   }, [searchText]);

//   // ============================
//   // RESET PAGE WHEN SEARCH CHANGES
//   // ============================
//   useEffect(() => {
//     setPage(0);
//   }, [debouncedSearchText]);

//   // ============================
//   // OPTIONS
//   // ============================
//   const consolidatedOptions = [
//     { value: "DDT", label: "DDT Report (Single Sheet)" },
//     { value: "DASP", label: "DASP Report (Single Sheet)" },
//     { value: "Other", label: "Other Report (Single Sheet)" },
//   ];

//   const reportTypeOptions = [
//     { value: "DDT", label: "DDT Report" },
//     { value: "DASP", label: "DASP Report" },
//     { value: "Other", label: "Other Report" },
//   ];

//   const zipDownloadOptions = [
//     { value: "DDT", label: "DDT Reports (Batch-wise ZIP)" },
//     { value: "DASP", label: "DASP Reports (Batch-wise ZIP)" },
//     { value: "Other", label: "Other Reports (Batch-wise ZIP)" },
//   ];

//   const periodOptions = [
//     { value: "ALL", label: "All Time" },
//     { value: "TODAY", label: "Today" },
//     { value: "WEEKLY", label: "This Week" },
//     { value: "MONTHLY", label: "This Month" },
//     { value: "YEARLY", label: "This Year" },
//   ];

//   const pageSizeOptions = [
//     { value: 5, label: "5" },
//     { value: 10, label: "10" },
//     { value: 25, label: "25" },
//     { value: 50, label: "50" },
//     { value: 100, label: "100" },
//   ];

//   const breadcrumbItems = [
//     { title: "Batch", link: "#" },
//     { title: "All Batches", link: "#" },
//   ];

//   // ============================
//   // FETCH ALL BATCHES FOR CONSOLIDATED REPORT
//   // ============================
//   const fetchAllBatchesForConsolidated = useCallback(async () => {
//     try {
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) return;

//       let startDate = null;
//       let endDate = null;
      
//       if (isCustomDateRangeActive && customStartDate && customEndDate) {
//         startDate = moment(customStartDate).format("YYYY-MM-DD");
//         endDate = moment(customEndDate).format("YYYY-MM-DD");
//       } else if (filterPeriod !== "ALL") {
//         const today = moment().startOf('day');
//         switch (filterPeriod) {
//           case "TODAY":
//             startDate = today.format("YYYY-MM-DD");
//             endDate = today.format("YYYY-MM-DD");
//             break;
//           case "WEEKLY":
//             startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//             break;
//           case "MONTHLY":
//             startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//             break;
//           case "YEARLY":
//             startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//             break;
//           default:
//             break;
//         }
//       }

//       const response = await fetchAllBatchesWithPagination(
//         0, 
//         10000,
//         startDate,
//         endDate,
//         filterState,
//         filterDepot,
//         debouncedSearchText
//       );

//       if (response.data?.success) {
//         const batches = response.data.result || [];
//         setAllFilteredBatchData(batches);
//         setAllFilteredBatchCount(batches.length);
//       }
//     } catch (error) {
//       console.error("Error fetching all batches for consolidated:", error);
//     }
//   }, [isCustomDateRangeActive, customStartDate, customEndDate, filterPeriod, filterState, filterDepot, debouncedSearchText]);

//   // ============================
//   // FETCH DISTINCT FILTERS
//   // ============================
//   const fetchDistinctFilters = useCallback(async () => {
//     try {
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser?.organizationId) return;

//       const [statesRes, depotsRes] = await Promise.all([
//         getDistinctStates(),
//         getDistinctDepots()
//       ]);

//       if (statesRes?.data) {
//         setAvailableStates(statesRes.data);
//       }
//       if (depotsRes?.data) {
//         setAvailableDepots(depotsRes.data);
//       }

//       const depts = new Set();
//       const trainers = new Set();
//       const types = new Set();

//       allBatch.forEach(batch => {
//         if (batch.department) depts.add(batch.department);
//         if (batch.batchType) types.add(batch.batchType);
//         if (batch.trainerNames && batch.trainerNames !== "No Trainer Assigned") {
//           trainers.add(batch.trainerNames);
//         }
//       });

//       setAvailableDepartments([...depts]);
//       setAvailableTrainers([...trainers]);
//       setAvailableBatchTypes([...types]);

//     } catch (error) {
//       console.error("Error fetching distinct filters:", error);
//     }
//   }, [allBatch]);

//   // ============================
//   // FETCH FEEDBACK RATINGS
//   // ============================
//   const fetchFeedbackRatingsOnly = async (batches) => {
//     if (ratingsFetched) return;
    
//     const feedbackRatingsMap = {};
//     const feedbackCountsMap = {};
//     const feedbackGivenCountsMap = {};
//     const notFeedbackGivenCountsMap = {};
    
//     const asyncPool = async (concurrency, items, iteratorFn) => {
//       const results = [];
//       const executing = new Set();
//       for (const [index, item] of items.entries()) {
//         const promise = Promise.resolve().then(() => iteratorFn(item, index));
//         results.push(promise);
//         executing.add(promise);
//         const clean = () => executing.delete(promise);
//         promise.then(clean, clean);
//         if (executing.size >= concurrency) {
//           await Promise.race(executing);
//         }
//       }
//       return Promise.all(results);
//     };
    
//     await asyncPool(5, batches, async (batch) => {
//       const batchId = batch.id || batch._id;
//       if (!batchId) return;
      
//       try {
//         setLoadingRatings(prev => ({ ...prev, [batchId]: true }));
        
//         const feedbacksResponse = await fetchAllFeedbackOfBatch(batchId);
        
//         if (!feedbacksResponse?.success || !feedbacksResponse?.result?.length) {
//           feedbackRatingsMap[batchId] = null;
//           feedbackCountsMap[batchId] = 0;
//           feedbackGivenCountsMap[batchId] = 0;
//           notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
//           setBatchFeedbackRatings(prev => ({ ...prev, [batchId]: null }));
//           setBatchFeedbackCounts(prev => ({ ...prev, [batchId]: 0 }));
//           setBatchFeedbackGivenCounts(prev => ({ ...prev, [batchId]: 0 }));
//           setBatchNotFeedbackGivenCounts(prev => ({ ...prev, [batchId]: batch.totalStudents || 0 }));
//           return;
//         }

//         let totalRatingSum = 0;
//         let totalResponseCount = 0;
//         let totalFeedbackGiven = 0;

//         for (const feedback of feedbacksResponse.result) {
//           const responsesResponse = await getAllResponsesOfFeedback(feedback.id);
          
//           if (responsesResponse?.success && responsesResponse?.responseResult?.length) {
//             const feedbackRatingSum = responsesResponse.responseResult.reduce(
//               (sum, response) => sum + (response.rating || 0), 
//               0
//             );
//             totalRatingSum += feedbackRatingSum;
//             totalResponseCount += responsesResponse.responseResult.length;
//             totalFeedbackGiven += responsesResponse.responseResult.length;
//           }
//         }

//         const averageRating = totalResponseCount > 0 ? totalRatingSum / totalResponseCount : null;
//         const totalStudents = batch.totalStudents || 0;
//         const notFeedbackGiven = totalStudents - totalFeedbackGiven;
        
//         feedbackRatingsMap[batchId] = averageRating;
//         feedbackCountsMap[batchId] = totalResponseCount;
//         feedbackGivenCountsMap[batchId] = totalFeedbackGiven;
//         notFeedbackGivenCountsMap[batchId] = notFeedbackGiven > 0 ? notFeedbackGiven : 0;
        
//         setBatchFeedbackRatings(prev => ({ ...prev, [batchId]: averageRating }));
//         setBatchFeedbackCounts(prev => ({ ...prev, [batchId]: totalResponseCount }));
//         setBatchFeedbackGivenCounts(prev => ({ ...prev, [batchId]: totalFeedbackGiven }));
//         setBatchNotFeedbackGivenCounts(prev => ({ ...prev, [batchId]: notFeedbackGiven > 0 ? notFeedbackGiven : 0 }));
//       } catch (error) {
//         console.error(`Error fetching feedback rating for batch ${batchId}:`, error);
//         feedbackRatingsMap[batchId] = null;
//         feedbackCountsMap[batchId] = 0;
//         feedbackGivenCountsMap[batchId] = 0;
//         notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
//         setBatchFeedbackRatings(prev => ({ ...prev, [batchId]: null }));
//         setBatchFeedbackCounts(prev => ({ ...prev, [batchId]: 0 }));
//         setBatchFeedbackGivenCounts(prev => ({ ...prev, [batchId]: 0 }));
//         setBatchNotFeedbackGivenCounts(prev => ({ ...prev, [batchId]: batch.totalStudents || 0 }));
//       } finally {
//         setLoadingRatings(prev => ({ ...prev, [batchId]: false }));
//       }
//     });
    
//     setRatingsFetched(true);
//   };

//   // ============================
//   // FETCH TRAINERS FOR BATCHES
//   // ============================
//   const fetchTrainersForBatches = async (batches) => {
//     const trainersMap = {};
    
//     const asyncPool = async (concurrency, items, iteratorFn) => {
//       const results = [];
//       const executing = new Set();
//       for (const [index, item] of items.entries()) {
//         const promise = Promise.resolve().then(() => iteratorFn(item, index));
//         results.push(promise);
//         executing.add(promise);
//         const clean = () => executing.delete(promise);
//         promise.then(clean, clean);
//         if (executing.size >= concurrency) {
//           await Promise.race(executing);
//         }
//       }
//       return Promise.all(results);
//     };
    
//     await asyncPool(5, batches, async (batch) => {
//       const batchId = batch.id || batch._id;
//       if (!batchId) return;
//       try {
//         const trainers = await getAllTrainerOfBatch(batchId).catch(() => []);
//         trainersMap[batchId] = trainers?.success ? trainers.result || [] : [];
//       } catch (error) {
//         trainersMap[batchId] = [];
//       }
//     });
    
//     setBatchTrainersMap(trainersMap);
//   };

//   // ============================
//   // GET ALL BATCHES WITH PAGINATION - DATABASE LEVEL SEARCH
//   // ============================
//   const getAllBatches = useCallback(async () => {
//     try {
//       setLoader(true);
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       const type = authUser?.userType;
      
//       if (type === "Tata Trainer") {
//         const res = await fetchAllBatchOfTrainer();
//         if (res?.success) {
//           let batches = (res.result || []).map(batch => ({
//             id: batch.id || batch._id,
//             batchName: batch.batchName,
//             department: batch.department,
//             state: batch.state,
//             depot: batch.depot,
//             trainingStartDate: batch.trainingStartDate,
//             trainingEndDate: batch.trainingEndDate,
//             totalStudents: batch.totalStudents || batch.students?.length || 0,
//             passedStudents: batch.passedStudents || 0,
//             failedStudents: batch.failedStudents || 0,
//             notAttemptedStudents: batch.notAttemptedStudents || 0,
//             passPercentage: batch.passPercentage || 0,
//             trainerNames: batch.trainerNames || "No Trainer Assigned",
//             totalTrainers: batch.totalTrainers || 0,
//             entryBy: batch.entryBy,
//             entryAt: batch.entryAt,
//             updatedBy: batch.updatedBy,
//             updatedAt: batch.updatedAt,
//             feedbackGivenCount: batch.feedbackGivenCount || 0,
//             notFeedbackGivenCount: batch.notFeedbackGivenCount || 0,
//             batchType: batch.batchType || "Offline"
//           }));

//           if (debouncedSearchText && debouncedSearchText.trim()) {
//             const searchLower = debouncedSearchText.toLowerCase().trim();
//             batches = batches.filter(batch => {
//               return (
//                 (batch.batchName || "").toLowerCase().includes(searchLower) ||
//                 (batch.department || "").toLowerCase().includes(searchLower) ||
//                 (batch.state || "").toLowerCase().includes(searchLower) ||
//                 (batch.depot || "").toLowerCase().includes(searchLower) ||
//                 (batch.trainerNames || "").toLowerCase().includes(searchLower) ||
//                 (batch.batchType || "").toLowerCase().includes(searchLower)
//               );
//             });
//           }

//           if (filterState) {
//             batches = batches.filter(b => b.state === filterState);
//           }
//           if (filterDepot) {
//             batches = batches.filter(b => b.depot === filterDepot);
//           }
//           if (departmentFilter) {
//             batches = batches.filter(b => b.department === departmentFilter);
//           }

//           setAllBatch(batches);
//           setFilteredBatches(batches);
//           setTotalItems(batches.length);
//           setTotalPages(Math.ceil(batches.length / pageSize));
          
//           if (batches.length > 0) {
//             await Promise.all([
//               fetchTrainersForBatches(batches),
//               fetchFeedbackRatingsOnly(batches)
//             ]);
//           }
          
//           if (batches.length === 0 && debouncedSearchText) {
//             toast.info(`No batches found for "${debouncedSearchText}"`);
//           }
//         }
//       } else {
//         let startDate = null;
//         let endDate = null;
        
//         if (isCustomDateRangeActive && customStartDate && customEndDate) {
//           startDate = moment(customStartDate).format("YYYY-MM-DD");
//           endDate = moment(customEndDate).format("YYYY-MM-DD");
//         } else if (filterPeriod !== "ALL") {
//           const today = moment().startOf('day');
//           switch (filterPeriod) {
//             case "TODAY":
//               startDate = today.format("YYYY-MM-DD");
//               endDate = today.format("YYYY-MM-DD");
//               break;
//             case "WEEKLY":
//               startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//               break;
//             case "MONTHLY":
//               startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//               break;
//             case "YEARLY":
//               startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//               endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//               break;
//             default:
//               break;
//           }
//         }
        
//         const searchValue = debouncedSearchText && debouncedSearchText.trim() ? debouncedSearchText.trim() : null;
//         const currentPage = searchValue ? 0 : page;
        
//         const response = await fetchAllBatchesWithPagination(
//           currentPage, 
//           pageSize, 
//           startDate, 
//           endDate, 
//           filterState || null, 
//           filterDepot || null, 
//           searchValue
//         );
        
//         if (response.data?.success) {
//           const batches = (response.data.result || []).map(batch => ({
//             id: batch.id || batch._id,
//             batchName: batch.batchName,
//             department: batch.department,
//             state: batch.state,
//             depot: batch.depot,
//             trainingStartDate: batch.trainingStartDate,
//             trainingEndDate: batch.trainingEndDate,
//             totalStudents: batch.totalStudents || 0,
//             passedStudents: batch.passedStudents || 0,
//             failedStudents: batch.failedStudents || 0,
//             notAttemptedStudents: batch.notAttemptedStudents || 0,
//             passPercentage: batch.passPercentage || 0,
//             trainerNames: batch.trainerNames || "No Trainer Assigned",
//             totalTrainers: batch.totalTrainers || 0,
//             entryBy: batch.entryBy,
//             entryAt: batch.entryAt,
//             updatedBy: batch.updatedBy,
//             updatedAt: batch.updatedAt,
//             feedbackGivenCount: batch.feedbackGivenCount || 0,
//             notFeedbackGivenCount: batch.notFeedbackGivenCount || 0,
//             batchType: batch.batchType || "Offline"
//           }));
          
//           setAllBatch(batches);
//           setFilteredBatches(batches);
//           setTotalItems(response.data.totalItems || 0);
//           setTotalPages(response.data.totalPages || 0);
          
//           if (searchValue && batches.length === 0 && page !== 0) {
//             setPage(0);
//           }
          
//           if (batches.length > 0) {
//             await Promise.all([
//               fetchTrainersForBatches(batches),
//               fetchFeedbackRatingsOnly(batches)
//             ]);
//           }
          
//           if (batches.length === 0 && searchValue) {
//             toast.info(`No batches found for "${searchValue}"`);
//           }
//         } else {
//           toast.error(response.data?.message || "Failed to load batches");
//         }
//       }
//     } catch (error) {
//       console.error("Error in getAllBatches:", error);
//       toast.error(error?.response?.data?.message || "Failed to load batches");
//     } finally {
//       setLoader(false);
//       setIsSearching(false);
//     }
//   }, [page, pageSize, filterState, filterDepot, filterPeriod, debouncedSearchText, customStartDate, customEndDate, isCustomDateRangeActive, departmentFilter]);

//   // ============================
//   // DOWNLOAD CONSOLIDATED SIMULATOR REPORT
//   // ============================
//   const downloadConsolidatedSimulator = async () => {
//     try {
//       setLoader(true);
//       setConsolidatedSimulatorModalShow(false);
      
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) {
//         toast.error("Organization ID not found. Please log in again.");
//         setLoader(false);
//         return;
//       }
      
//       let startDate = null;
//       let endDate = null;
      
//       if (isCustomDateRangeActive && customStartDate && customEndDate) {
//         startDate = moment(customStartDate).format("YYYY-MM-DD");
//         endDate = moment(customEndDate).format("YYYY-MM-DD");
//       } else if (filterPeriod !== "ALL") {
//         const today = moment().startOf('day');
//         switch (filterPeriod) {
//           case "TODAY":
//             startDate = today.format("YYYY-MM-DD");
//             endDate = today.format("YYYY-MM-DD");
//             break;
//           case "WEEKLY":
//             startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//             break;
//           case "MONTHLY":
//             startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//             break;
//           case "YEARLY":
//             startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//             break;
//           default:
//             break;
//         }
//       }
      
//       const filters = [];
//       if (startDate && endDate) {
//         filters.push(`Training End Date: ${moment(startDate).format('DD-MM-YYYY')} to ${moment(endDate).format('DD-MM-YYYY')}`);
//       } else if (startDate) {
//         filters.push(`From: ${moment(startDate).format('DD-MM-YYYY')}`);
//       } else if (endDate) {
//         filters.push(`Until: ${moment(endDate).format('DD-MM-YYYY')}`);
//       }
//       if (filterState) filters.push(`State: ${filterState}`);
//       if (filterDepot) filters.push(`Depot: ${filterDepot}`);
//       if (debouncedSearchText) filters.push(`Search: "${debouncedSearchText}"`);
//       if (departmentFilter) filters.push(`Department: ${departmentFilter}`);
//       if (trainerNameFilter) filters.push(`Trainer: ${trainerNameFilter}`);
//       if (batchTypeFilter) filters.push(`Batch Type: ${batchTypeFilter}`);
      
//       const baseUrl = "https://backend.skillserve.in/api/";
//       let apiUrl = `${baseUrl}simulator/consolidated-report`;
      
//       const params = new URLSearchParams();
//       if (startDate) params.append("startDate", startDate);
//       if (endDate) params.append("endDate", endDate);
//       if (filterState && filterState !== "") params.append("state", filterState);
//       if (filterDepot && filterDepot !== "") params.append("depot", filterDepot);
//       if (debouncedSearchText && debouncedSearchText !== "") params.append("search", debouncedSearchText);
//       if (departmentFilter && departmentFilter !== "") params.append("department", departmentFilter);
//       if (trainerNameFilter && trainerNameFilter !== "") params.append("trainerName", trainerNameFilter);
//       if (batchTypeFilter && batchTypeFilter !== "") params.append("batchType", batchTypeFilter);
      
//       if (params.toString()) {
//         apiUrl += "?" + params.toString();
//       }
      
//       console.log("Calling consolidated report URL:", apiUrl);
      
//       showProgressToast(`⏳ Generating Consolidated Simulator Report for ${allFilteredBatchCount} batches... This may take several minutes.`, true);
      
//       const response = await axios({
//         method: 'get',
//         url: apiUrl,
//         responseType: 'blob',
//         timeout: 600000,
//         headers: {
//           'X-Organization-ID': authUser.organizationId || ''
//         }
//       });
      
//       hideProgressToast("✅ Report generated successfully! Downloading...", true);
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         setLoader(false);
//         return;
//       }
      
//       const firstBytes = await response.data.slice(0, 100).text();
//       const trimmedFirstBytes = firstBytes.trim();
//       if (trimmedFirstBytes.startsWith('{') || trimmedFirstBytes.startsWith('[')) {
//         try {
//           const fullText = await response.data.text();
//           const errorData = JSON.parse(fullText);
//           toast.error(errorData.message || "Failed to download file");
//           setLoader(false);
//           return;
//         } catch (e) {
//           toast.error("Failed to download file");
//           setLoader(false);
//           return;
//         }
//       }
      
//       const blob = new Blob([response.data], {
//         type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       });
      
//       const downloadUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
      
//       let filename = `Consolidated_Simulator_Report`;
//       if (startDate && endDate) {
//         filename += `_${moment(startDate).format("DD-MM-YYYY")}_to_${moment(endDate).format("DD-MM-YYYY")}`;
//       } else if (startDate) {
//         filename += `_from_${moment(startDate).format("DD-MM-YYYY")}`;
//       } else if (endDate) {
//         filename += `_upto_${moment(endDate).format("DD-MM-YYYY")}`;
//       }
//       if (filterState) {
//         filename += `_state_${filterState}`;
//       }
//       if (filterDepot) {
//         filename += `_depot_${filterDepot}`;
//       }
//       if (departmentFilter) {
//         filename += `_dept_${departmentFilter.replace(/\s+/g, '_')}`;
//       }
//       if (trainerNameFilter) {
//         filename += `_trainer_${trainerNameFilter.replace(/\s+/g, '_')}`;
//       }
//       if (batchTypeFilter) {
//         filename += `_type_${batchTypeFilter}`;
//       }
//       filename += `.xlsx`;
      
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`✅ Consolidated Simulator Report downloaded successfully! (${allFilteredBatchCount} batches)`);
//     } catch (error) {
//       console.error("Error downloading consolidated simulator report:", error);
//       hideProgressToast("❌ Failed to generate report. Please try again.", false);
      
//       if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
//         toast.error("⏱️ Report generation is taking longer than expected. Please try again with fewer filters or try again later.");
//       } else if (error.response?.data) {
//         try {
//           const errorText = await error.response.data.text();
//           const errorJson = JSON.parse(errorText);
//           toast.error(errorJson.message || "Failed to generate report");
//         } catch (e) {
//           toast.error("Failed to generate report. Server error occurred.");
//         }
//       } else if (error.message) {
//         toast.error(`Failed to generate report: ${error.message}`);
//       } else {
//         toast.error("Failed to generate report. Please try again.");
//       }
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // OPEN CONSOLIDATED MODALS
//   // ============================
//   const openConsolidatedModal = async () => {
//     await fetchAllBatchesForConsolidated();
//     setConsolidatedModalShow(true);
//   };

//   const openConsolidatedSimulatorModal = async () => {
//     await fetchAllBatchesForConsolidated();
//     setConsolidatedSimulatorModalShow(true);
//   };

//   // ============================
//   // DOWNLOAD EXCEL WITH FULL FILTERS
//   // ============================
//   const downloadExcel = async () => {
//     try {
//       setLoader(true);
      
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) {
//         toast.error("Organization ID not found. Please log in again.");
//         return;
//       }
      
//       let startDate = null;
//       let endDate = null;
      
//       if (isCustomDateRangeActive && customStartDate && customEndDate) {
//         startDate = moment(customStartDate).format("YYYY-MM-DD");
//         endDate = moment(customEndDate).format("YYYY-MM-DD");
//       } else if (filterPeriod !== "ALL") {
//         const today = moment().startOf('day');
//         switch (filterPeriod) {
//           case "TODAY":
//             startDate = today.format("YYYY-MM-DD");
//             endDate = today.format("YYYY-MM-DD");
//             break;
//           case "WEEKLY":
//             startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//             break;
//           case "MONTHLY":
//             startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//             break;
//           case "YEARLY":
//             startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//             endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//             break;
//           default:
//             break;
//         }
//       }
      
//       const filters = [];
//       if (startDate && endDate) {
//         filters.push(`Training End Date: ${moment(startDate).format('DD-MM-YYYY')} to ${moment(endDate).format('DD-MM-YYYY')}`);
//       } else if (startDate) {
//         filters.push(`From: ${moment(startDate).format('DD-MM-YYYY')}`);
//       } else if (endDate) {
//         filters.push(`Until: ${moment(endDate).format('DD-MM-YYYY')}`);
//       }
//       if (filterState) filters.push(`State: ${filterState}`);
//       if (filterDepot) filters.push(`Depot: ${filterDepot}`);
//       if (debouncedSearchText) filters.push(`Search: "${debouncedSearchText}"`);
//       if (departmentFilter) filters.push(`Department: ${departmentFilter}`);
      
//       toast.info(filters.length > 0 ? 
//         `Downloading report with filters: ${filters.join(', ')}...` : 
//         "Downloading all batch report...");
      
//       const response = await batchDetailFileWithFullFilters(
//         startDate, 
//         endDate, 
//         filterState, 
//         filterDepot, 
//         debouncedSearchText
//       );
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const firstBytes = await response.data.slice(0, 100).text();
//       const trimmedFirstBytes = firstBytes.trim();
//       if (trimmedFirstBytes.startsWith('{') || trimmedFirstBytes.startsWith('[')) {
//         try {
//           const fullText = await response.data.text();
//           const errorData = JSON.parse(fullText);
//           toast.error(errorData.message || "Failed to download file");
//           return;
//         } catch (e) {
//           toast.error("Failed to download file");
//           return;
//         }
//       }
      
//       const blob = new Blob([response.data], {
//         type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       });
      
//       const downloadUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
      
//       let filename = `Batch_Details`;
//       if (startDate && endDate) {
//         filename += `_${moment(startDate).format("DD-MM-YYYY")}_to_${moment(endDate).format("DD-MM-YYYY")}`;
//       } else if (startDate) {
//         filename += `_from_${moment(startDate).format("DD-MM-YYYY")}`;
//       } else if (endDate) {
//         filename += `_upto_${moment(endDate).format("DD-MM-YYYY")}`;
//       }
//       if (filterState) {
//         filename += `_state_${filterState}`;
//       }
//       if (filterDepot) {
//         filename += `_depot_${filterDepot}`;
//       }
//       if (debouncedSearchText) {
//         filename += `_search_${debouncedSearchText.replace(/\s+/g, '_')}`;
//       }
//       if (departmentFilter) {
//         filename += `_dept_${departmentFilter.replace(/\s+/g, '_')}`;
//       }
//       filename += `.xlsx`;
      
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success("File downloaded successfully!");
//     } catch (error) {
//       console.error("Error downloading file:", error);
//       toast.error(error.response?.data?.message || "Failed to download file");
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // PAGE CHANGE HANDLERS
//   // ============================
//   const handlePageChange = (newPage) => {
//     if (newPage >= 0 && newPage < totalPages) {
//       setPage(newPage);
//     }
//   };

//   const handlePageSizeChange = (newSize) => {
//     setPageSize(newSize);
//     setPage(0);
//   };

//   // ============================
//   // PAGINATION RENDER
//   // ============================
//   const renderPagination = () => {
//     if (totalPages <= 1) return null;

//     const pageNumbers = [];
//     const maxVisible = 5;
//     let startPage = Math.max(0, page - Math.floor(maxVisible / 2));
//     let endPage = Math.min(totalPages - 1, startPage + maxVisible - 1);
    
//     if (endPage - startPage < maxVisible - 1) {
//       startPage = Math.max(0, endPage - maxVisible + 1);
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pageNumbers.push(i);
//     }

//     return (
//       <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
//         <div className="d-flex align-items-center gap-2">
//           <span className="text-muted" style={{ fontSize: "14px" }}>
//             Showing {page * pageSize + 1} to {Math.min((page + 1) * pageSize, totalItems)} of {totalItems} entries
//           </span>
//         </div>
//         <div className="d-flex align-items-center gap-2 flex-wrap">
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(0)}
//             disabled={page === 0}
//           >
//             <FirstPageIcon style={{ fontSize: "18px" }} />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(page - 1)}
//             disabled={page === 0}
//           >
//             <NavigateBeforeIcon style={{ fontSize: "18px" }} />
//           </Button>
//           {pageNumbers.map((num) => (
//             <Button
//               key={num}
//               color={num === page ? "primary" : "secondary"}
//               size="sm"
//               onClick={() => handlePageChange(num)}
//               style={{ minWidth: "35px" }}
//             >
//               {num + 1}
//             </Button>
//           ))}
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(page + 1)}
//             disabled={page >= totalPages - 1}
//           >
//             <NavigateNextIcon style={{ fontSize: "18px" }} />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(totalPages - 1)}
//             disabled={page >= totalPages - 1}
//           >
//             <LastPageIcon style={{ fontSize: "18px" }} />
//           </Button>
          
//           <div className="d-flex align-items-center ms-2 gap-2">
//             <span className="text-muted" style={{ fontSize: "13px" }}>Rows:</span>
//             <Select
//               options={pageSizeOptions}
//               value={pageSizeOptions.find(opt => opt.value === pageSize)}
//               onChange={(option) => handlePageSizeChange(option.value)}
//               className="page-size-select"
//               styles={{
//                 control: (base) => ({
//                   ...base,
//                   minHeight: "32px",
//                   width: "70px",
//                   borderColor: "#ced4da",
//                   boxShadow: "none",
//                   "&:hover": {
//                     borderColor: "#80bdff",
//                   },
//                 }),
//                 menu: (base) => ({
//                   ...base,
//                   zIndex: 9999,
//                 }),
//                 option: (base, state) => ({
//                   ...base,
//                   backgroundColor: state.isSelected ? "#0d6efd" : state.isFocused ? "#e9ecef" : "white",
//                   color: state.isSelected ? "white" : "#212529",
//                   "&:active": {
//                     backgroundColor: "#0d6efd",
//                     color: "white",
//                   },
//                 }),
//               }}
//               isSearchable={false}
//               menuPortalTarget={document.body}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // ============================
//   // EFFECTS
//   // ============================
//   useEffect(() => {
//     props.setBreadcrumbItems("All Batches", breadcrumbItems);
//   }, []);

//   useEffect(() => {
//     getAllBatches();
//   }, [getAllBatches]);

//   useEffect(() => {
//     if (allBatch.length > 0) {
//       fetchTrainersForBatches(allBatch);
//       fetchFeedbackRatingsOnly(allBatch);
//       fetchDistinctFilters();
//     }
//   }, [allBatch]);

//   // ============================
//   // COLUMNS DEFINITION
//   // ============================
//   const columns = [
//     { field: "serialNo", headerName: "S.No", width: 70 },
//     {
//       field: "batchName",
//       headerName: "Batch Name",
//       width: 200,
//       renderCell: (params) => {
//         return (
//           <span
//             style={{ cursor: "pointer", color: "#0d6efd", fontWeight: 500, textDecoration: "underline" }}
//             onClick={() => handleViewDetails(params.row)}
//             title={`${params.row.totalStudents || 0} student(s)`}
//           >
//             {params.value}
//           </span>
//         );
//       },
//     },
//     { field: "department", headerName: "Department", width: 150 },
//     {
//       field: "trainerNames",
//       headerName: "Trainer(s)",
//       width: 250,
//       renderCell: (params) => {
//         return <span>{params.value || "No Trainer Assigned"}</span>;
//       },
//     },
//     {
//       field: "state",
//       headerName: "State",
//       width: 130,
//       renderCell: (params) => params.value || "N/A",
//     },
//     {
//       field: "depot",
//       headerName: "Depot",
//       width: 130,
//       renderCell: (params) => params.value || "N/A",
//     },
//     {
//       field: "trainingStartDate",
//       headerName: "Start Date",
//       width: 130,
//       renderCell: (params) => formatDateForDisplay(params.value),
//     },
//     {
//       field: "trainingEndDate",
//       headerName: "End Date",
//       width: 130,
//       renderCell: (params) => formatDateForDisplay(params.value),
//     },
//     {
//       field: "totalStudents",
//       headerName: "Students",
//       width: 90,
//       renderCell: (params) => (
//         <span style={{ fontWeight: params.value > 0 ? "bold" : "normal", color: params.value > 0 ? "#198754" : "#6c757d" }}>
//           {params.value || 0}
//         </span>
//       ),
//     },
//     {
//       field: "passedStudents",
//       headerName: "Passed",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ color: "#198754", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "failedStudents",
//       headerName: "Failed",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ color: "#dc3545", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "notAttemptedStudents",
//       headerName: "Not Attempted",
//       width: 100,
//       renderCell: (params) => (
//         <span style={{ color: "#ffc107", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "passPercentage",
//       headerName: "Pass %",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ fontWeight: "bold" }}>{params.value || 0}%</span>
//       ),
//     },
//     {
//       field: "feedbackRating",
//       headerName: "Rating",
//       width: 220,
//       renderCell: (params) => {
//         const rating = batchFeedbackRatings[params.row.id];
//         const count = batchFeedbackCounts[params.row.id] || 0;
//         const loading = loadingRatings[params.row.id];

//         if (loading) {
//           return <CircularProgress size={25} />;
//         }

//         return renderStarRating(rating, count);
//       },
//     },
//     {
//       field: "feedbackGiven",
//       headerName: "Feedback Given",
//       width: 130,
//       renderCell: (params) => {
//         const given = batchFeedbackGivenCounts[params.row.id] || 0;
//         const notGiven = batchNotFeedbackGivenCounts[params.row.id] || 0;
//         return (
//           <Tooltip title={`${given} students gave feedback, ${notGiven} students did not`}>
//             <span style={{ color: given > 0 ? "#198754" : "#6c757d" }}>
//               {given} / {given + notGiven}
//             </span>
//           </Tooltip>
//         );
//       },
//     },
//     {
//       field: "edit",
//       headerName: "Edit",
//       width: 80,
//       renderCell: (p) => (
//         <Button size="sm" color="warning" onClick={() => handleRowClick(p.row)} style={{ padding: "4px 12px" }}>
//           Edit
//         </Button>
//       ),
//     },
//     {
//       field: "download",
//       headerName: "Download Report",
//       width: 130,
//       renderCell: (p) => (
//         <Button 
//           size="sm" 
//           color="success" 
//           onClick={() => openBatchReportModal(p.row)}
//           style={{ padding: "4px 8px", marginRight: "4px" }}
//         >
//           <DownloadIcon style={{ fontSize: "14px" }} />
//         </Button>
//       ),
//     },
//     {
//       field: "downloadSimulator",
//       headerName: "Simulator",
//       width: 100,
//       renderCell: (p) => (
//         <Button 
//           size="sm" 
//           color="primary" 
//           onClick={() => openBatchSimulatorReportModal(p.row)}
//           style={{ padding: "4px 8px" }}
//         >
//           <ScienceIcon style={{ fontSize: "14px" }} />
//         </Button>
//       ),
//     },
//   ];

//   // ============================
//   // HELPER FUNCTIONS FOR DISPLAY - DD-MM-YYYY
//   // ============================
//   const formatDateToDDMMYYYY = useCallback((dateStr) => {
//     return formatDateForDisplay(dateStr);
//   }, []);

//   const renderStarRating = (rating, count = 0) => {
//     if (!rating || count === 0) {
//       return (
//         <Tooltip title="No feedback responses yet">
//           <span style={{ color: "#6c757d", fontStyle: "italic" }}>No Rating</span>
//         </Tooltip>
//       );
//     }

//     const fullStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 >= 0.5;
//     const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

//     return (
//       <Tooltip title={`Based on ${count} response(s) - Average Rating: ${rating.toFixed(1)}/5.0`}>
//         <Box display="flex" alignItems="center" gap={1} sx={{ cursor: "pointer" }}>
//           <Box display="flex" alignItems="center" gap={0.2}>
//             {[...Array(fullStars)].map((_, i) => (
//               <span key={`full-${i}`} style={{ color: "#ffb400", fontSize: "16px" }}>★</span>
//             ))}
//             {hasHalfStar && (
//               <span style={{ color: "#ffb400", fontSize: "16px", position: "relative", display: "inline-block" }}>
//                 <span style={{ position: "absolute", overflow: "hidden", width: "50%", color: "#ffb400" }}>★</span>
//                 <span style={{ color: "#e4e5e9" }}>★</span>
//               </span>
//             )}
//             {[...Array(emptyStars)].map((_, i) => (
//               <span key={`empty-${i}`} style={{ color: "#e4e5e9", fontSize: "16px" }}>★</span>
//             ))}
//           </Box>
//           <Typography 
//             variant="body2" 
//             sx={{ 
//               fontWeight: "bold", 
//               color: "#ffb400",
//               backgroundColor: "#fff3e0",
//               padding: "2px 6px",
//               borderRadius: "12px",
//               fontSize: "12px"
//             }}
//           >
//             {rating.toFixed(1)}
//           </Typography>
//         </Box>
//       </Tooltip>
//     );
//   };

//   const getFilteredStats = useCallback(() => {
//     let totalStudents = 0;
//     let totalPassed = 0;
//     let totalFailed = 0;
//     let totalNotAttempted = 0;
//     let totalRatingSum = 0;
//     let totalRatingCount = 0;
//     let totalFeedbackGiven = 0;
//     let totalNotFeedbackGiven = 0;

//     filteredBatches.forEach((batch) => {
//       totalStudents += batch.totalStudents || 0;
//       totalPassed += batch.passedStudents || 0;
//       totalFailed += batch.failedStudents || 0;
//       totalNotAttempted += batch.notAttemptedStudents || 0;
      
//       const rating = batchFeedbackRatings[batch.id];
//       if (rating) {
//         totalRatingSum += rating;
//         totalRatingCount++;
//       }
      
//       totalFeedbackGiven += batchFeedbackGivenCounts[batch.id] || 0;
//       totalNotFeedbackGiven += batchNotFeedbackGivenCounts[batch.id] || 0;
//     });

//     const passRate = totalStudents > 0 ? ((totalPassed / totalStudents) * 100).toFixed(1) : 0;
//     const avgRating = totalRatingCount > 0 ? (totalRatingSum / totalRatingCount).toFixed(1) : 0;

//     return {
//       totalStudents,
//       totalPassed,
//       totalFailed,
//       totalNotAttempted,
//       passRate,
//       avgRating,
//       totalRatingCount,
//       totalFeedbackGiven,
//       totalNotFeedbackGiven
//     };
//   }, [filteredBatches, batchFeedbackRatings, batchFeedbackGivenCounts, batchNotFeedbackGivenCounts]);

//   const filteredStats = getFilteredStats();

//   // ============================
//   // EDIT/DELETE FUNCTIONS
//   // ============================
//   const handleRowClick = (row) => {
//     setModalShow(true);
//     navigate(`/batch/${row.id}`);
//     setId(row.id);
//     setName(row.batchName || "");
//   };

//   const handleUpdate = async () => {
//     if (!name) {
//       setSpanDisplay("inline");
//       return;
//     }

//     try {
//       setLoader(true);
//       const result = await updateBatch({ id, batchName: name });
//       if (result?.success) {
//         toast.success(result?.message);
//         getAllBatches();
//         setModalShow(false);
//         setName("");
//         setId("");
//         setSpanDisplay("none");
//       } else {
//         toast.error(result?.message);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to update batch");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       setLoader(true);
//       const result = await deleteBatch(id);
//       if (result?.success) {
//         toast.success(result?.message);
//         getAllBatches();
//         setDeleteModalShow(false);
//         setModalShow(false);
//         setName("");
//         setId("");
//       } else {
//         toast.error(result?.message);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to delete batch");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleViewDetails = (row) => {
//     navigate(`/batch/${row.id}`);
//   };

//   const resetFilters = () => {
//     setFilterState("");
//     setFilterDepot("");
//     setFilterPeriod("ALL");
//     setSearchText("");
//     setDebouncedSearchText("");
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setFilterAnchorEl(null);
//     setDepartmentFilter("");
//     setTrainerNameFilter("");
//     setBatchTypeFilter("");
//     setPage(0);
//   };

//   const handleFilterClick = (event) => {
//     setFilterAnchorEl(event.currentTarget);
//   };

//   const handleFilterClose = () => {
//     setFilterAnchorEl(null);
//   };

//   const openCustomDateRangeModal = () => {
//     setDateRangeModalShow(true);
//     handleFilterClose();
//   };

//   const applyCustomDateRange = () => {
//     if (!customStartDate || !customEndDate) {
//       toast.error("Please select both start and end dates");
//       return;
//     }

//     if (moment(customStartDate).isAfter(moment(customEndDate))) {
//       toast.error("Start date cannot be after end date");
//       return;
//     }

//     setIsCustomDateRangeActive(true);
//     setFilterPeriod("ALL");
//     setDateRangeModalShow(false);
//     setPage(0);
//     toast.success(`Custom date range applied: ${formatDateToDDMMYYYY(customStartDate)} to ${formatDateToDDMMYYYY(customEndDate)}`);
//   };

//   const clearCustomDateRange = () => {
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setPage(0);
//     toast.success("Custom date range cleared");
//   };

//   const applySerialRangeFilter = () => {
//     if (!fromSerial || !toSerial) {
//       toast.error("Please enter both from and to serial numbers");
//       return;
//     }

//     const from = parseInt(fromSerial);
//     const to = parseInt(toSerial);

//     if (isNaN(from) || isNaN(to)) {
//       toast.error("Please enter valid numbers");
//       return;
//     }

//     if (from < 1 || to > allBatch.length) {
//       toast.error(`Please enter serial numbers between 1 and ${allBatch.length}`);
//       return;
//     }

//     if (from > to) {
//       toast.error("'From' serial number must be less than or equal to 'To' serial number");
//       return;
//     }

//     const filtered = allBatch.filter((_, index) => {
//       const serialNo = index + 1;
//       return serialNo >= from && serialNo <= to;
//     });

//     setFilteredBatches(filtered);
//     setSerialRangeModalShow(false);
//     toast.success(`Showing ${filtered.length} batches`);
//   };

//   const clearAllFilters = () => {
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setFromSerial("");
//     setToSerial("");
//     setSearchText("");
//     setDebouncedSearchText("");
//     setFilterState("");
//     setFilterDepot("");
//     setFilterPeriod("ALL");
//     setDepartmentFilter("");
//     setTrainerNameFilter("");
//     setBatchTypeFilter("");
//     setPage(0);
//     toast.success("All filters cleared");
//   };

//   const refreshData = () => {
//     setPage(0);
//     getAllBatches();
//     toast.info("Refreshing data from server...");
//   };

//   // ============================
//   // MODAL FUNCTIONS
//   // ============================
//   const openBatchReportModal = (batch) => {
//     setSelectedBatchForReport(batch);
//     setSelectedReportType("Other");
//     setBatchReportModalShow(true);
//   };

//   const openBatchSimulatorReportModal = (batch) => {
//     setSelectedBatchForSimulatorReport(batch);
//     setBatchSimulatorReportModalShow(true);
//   };

//   // ============================
//   // DOWNLOAD SINGLE BATCH REPORT
//   // ============================
//   const downloadSingleBatchReport = async () => {
//     if (!selectedBatchForReport) {
//       toast.error("No batch selected");
//       return;
//     }

//     try {
//       setLoader(true);
//       setBatchReportModalShow(false);
      
//       const batchId = selectedBatchForReport.id;
//       const batchName = selectedBatchForReport.batchName || "Batch";
      
//       toast.info(`Downloading ${selectedReportType} report for ${batchName}...`);
      
//       const apiUrl = `${downloadBatchReport}${batchId}?type=${selectedReportType}`;
//       const response = await axios.get(apiUrl, { 
//         responseType: "blob", 
//         timeout: 120000
//       });
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `${batchName}_${selectedReportType}_Report.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`${selectedReportType} report downloaded for ${batchName}`);
      
//     } catch (error) {
//       console.error(`Error downloading report:`, error);
//       toast.error(`Failed to download report: ${error.message}`);
//     } finally {
//       setLoader(false);
//       setSelectedBatchForReport(null);
//     }
//   };

//   // ============================
//   // DOWNLOAD SINGLE BATCH SIMULATOR REPORT
//   // ============================
//   const downloadSingleBatchSimulatorReport = async () => {
//     if (!selectedBatchForSimulatorReport) {
//       toast.error("No batch selected");
//       return;
//     }

//     try {
//       setLoader(true);
//       setBatchSimulatorReportModalShow(false);
      
//       const batchId = selectedBatchForSimulatorReport.id;
//       const batchName = selectedBatchForSimulatorReport.batchName || "Batch";
      
//       toast.info(`Downloading Simulator report for ${batchName}...`);
      
//       const apiUrl = downloadBatchSimulatorReport(batchId);
//       const response = await axios.get(apiUrl, { 
//         responseType: "blob", 
//         timeout: 120000
//       });
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `${batchName}_Simulator_Report.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`Simulator report downloaded for ${batchName}`);
      
//     } catch (error) {
//       console.error(`Error downloading simulator report:`, error);
//       toast.error(`Failed to download simulator report: ${error.message}`);
//     } finally {
//       setLoader(false);
//       setSelectedBatchForSimulatorReport(null);
//     }
//   };

//   // ============================
//   // DOWNLOAD ALL BATCHES AS ZIP
//   // ============================
//   const downloadAllBatchesAsZip = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to download");
//       return;
//     }

//     try {
//       setLoader(true);
//       setZipDownloadModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Downloading ${selectedZipType} reports for ${filteredBatches.length} batches...`
//       });

//       const mainZip = new JSZip();
//       const timestamp = moment().format("DD-MM-YYYY_HHmmss");
//       const reportsFolder = mainZip.folder(`All_Reports_${selectedZipType}_${timestamp}`);

//       let successCount = 0;
//       let failCount = 0;
//       const failedBatches = [];

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Downloading ${i + 1}/${filteredBatches.length}: ${batch.batchName}`
//         });
        
//         try {
//           const apiUrl = `${downloadBatchReport}${batch.id}?type=${selectedZipType}`;
//           const response = await axios.get(apiUrl, { 
//             responseType: "blob", 
//             timeout: 120000
//           });
          
//           if (response.data && response.data.size > 0) {
//             const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
//             const batchFolder = reportsFolder.folder(batchFolderName);
            
//             batchFolder.file(`${selectedZipType}_Report.zip`, response.data);
            
//             const trainers = batchTrainersMap[batch.id] || [];
//             const trainerName = formatTrainerNames(trainers);
//             const feedbackRating = batchFeedbackRatings[batch.id];
//             const feedbackCount = batchFeedbackCounts[batch.id] || 0;
//             const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
//             const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
//             const batchInfo = {
//               batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
//               batchName: batch.batchName,
//               batchId: batch.id,
//               department: batch.department,
//               depot: batch.depot,
//               state: batch.state,
//               startDate: formatDateForDisplay(batch.trainingStartDate),
//               endDate: formatDateForDisplay(batch.trainingEndDate),
//               trainers: trainers.map(t => ({
//                 id: t.id,
//                 name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
//               })),
//               trainerName: trainerName,
//               totalStudents: batch.totalStudents || 0,
//               passedStudents: batch.passedStudents || 0,
//               failedStudents: batch.failedStudents || 0,
//               notAttemptedStudents: batch.notAttemptedStudents || 0,
//               passPercentage: batch.passPercentage || 0,
//               feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
//               feedbackCount: feedbackCount,
//               feedbackGivenCount: feedbackGivenCount,
//               notFeedbackGivenCount: notFeedbackGivenCount,
//               reportType: selectedZipType,
//               downloadedAt: new Date().toISOString()
//             };
            
//             batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
//             try {
//               const downloadedZip = await JSZip.loadAsync(response.data);
//               const imageFiles = Object.keys(downloadedZip.files).filter(
//                 filename => filename.startsWith('images/') && 
//                 (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png') || filename.endsWith('.gif'))
//               );
              
//               if (imageFiles.length > 0) {
//                 const imagesFolder = batchFolder.folder("Images");
//                 for (const imageFile of imageFiles) {
//                   const imageData = await downloadedZip.files[imageFile].async("blob");
//                   const imageName = imageFile.split('/').pop();
//                   imagesFolder.file(imageName, imageData);
//                 }
//               }
//             } catch (imageError) {
//               console.log(`No images found for batch ${batch.batchName}`);
//             }
            
//             successCount++;
//           } else {
//             failCount++;
//             failedBatches.push({ name: batch.batchName, error: "Empty response" });
//           }
//         } catch (error) {
//           console.error(`Error downloading batch ${batch.batchName}:`, error);
//           failCount++;
//           failedBatches.push({ name: batch.batchName, error: error.message });
//         }
//       }

//       const summaryReport = [
//         "DOWNLOAD SUMMARY",
//         "================",
//         `Report Type: ${selectedZipType}`,
//         `Date: ${moment().format("DD-MM-YYYY HH:mm:ss")}`,
//         `Total Batches: ${filteredBatches.length}`,
//         `Successfully Downloaded: ${successCount}`,
//         `Failed: ${failCount}`,
//         "",
//         failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
//         ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
//         "",
//         "BATCH SUMMARY",
//         "==============",
//         ...filteredBatches.map((batch, idx) => {
//           const rating = batchFeedbackRatings[batch.id];
//           const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
//           const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
//           return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
//         })
//       ].join("\n");

//       reportsFolder.file("Download_Summary.txt", summaryReport);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

//       const finalZipBlob = await mainZip.generateAsync({
//         type: "blob",
//         compression: "DEFLATE",
//         compressionOptions: { level: 6 },
//       });

//       const downloadUrl = window.URL.createObjectURL(finalZipBlob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `All_Batches_${selectedZipType}_${timestamp}.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       if (failCount === 0) {
//         toast.success(`All ${successCount} batches downloaded successfully with images!`);
//       } else {
//         toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
//       }
//     } catch (error) {
//       console.error("Error downloading all reports:", error);
//       toast.error("Error downloading reports: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // DOWNLOAD ALL BATCHES SIMULATOR AS ZIP
//   // ============================
//   const downloadAllBatchesSimulatorAsZip = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to download");
//       return;
//     }

//     try {
//       setLoader(true);
//       setZipSimulatorDownloadModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Downloading Simulator reports for ${filteredBatches.length} batches...`
//       });

//       const mainZip = new JSZip();
//       const timestamp = moment().format("DD-MM-YYYY_HHmmss");
//       const reportsFolder = mainZip.folder(`All_Simulator_Reports_${timestamp}`);

//       let successCount = 0;
//       let failCount = 0;
//       const failedBatches = [];

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Downloading ${i + 1}/${filteredBatches.length}: ${batch.batchName} Simulator Report`
//         });
        
//         try {
//           const apiUrl = downloadBatchSimulatorReport(batch.id);
//           const response = await axios.get(apiUrl, { 
//             responseType: "blob", 
//             timeout: 120000
//           });
          
//           if (response.data && response.data.size > 0) {
//             const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
//             const batchFolder = reportsFolder.folder(batchFolderName);
            
//             batchFolder.file(`Simulator_Report.xlsx`, response.data);
            
//             const trainers = batchTrainersMap[batch.id] || [];
//             const trainerName = formatTrainerNames(trainers);
//             const feedbackRating = batchFeedbackRatings[batch.id];
//             const feedbackCount = batchFeedbackCounts[batch.id] || 0;
//             const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
//             const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
//             const batchInfo = {
//               batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
//               batchName: batch.batchName,
//               batchId: batch.id,
//               department: batch.department,
//               depot: batch.depot,
//               state: batch.state,
//               startDate: formatDateForDisplay(batch.trainingStartDate),
//               endDate: formatDateForDisplay(batch.trainingEndDate),
//               trainers: trainers.map(t => ({
//                 id: t.id,
//                 name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
//               })),
//               trainerName: trainerName,
//               totalStudents: batch.totalStudents || 0,
//               passedStudents: batch.passedStudents || 0,
//               failedStudents: batch.failedStudents || 0,
//               notAttemptedStudents: batch.notAttemptedStudents || 0,
//               passPercentage: batch.passPercentage || 0,
//               feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
//               feedbackCount: feedbackCount,
//               feedbackGivenCount: feedbackGivenCount,
//               notFeedbackGivenCount: notFeedbackGivenCount,
//               reportType: "Simulator",
//               downloadedAt: new Date().toISOString()
//             };
            
//             batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
//             successCount++;
//           } else {
//             failCount++;
//             failedBatches.push({ name: batch.batchName, error: "Empty response" });
//           }
//         } catch (error) {
//           console.error(`Error downloading simulator report for batch ${batch.batchName}:`, error);
//           failCount++;
//           failedBatches.push({ name: batch.batchName, error: error.message });
//         }
//       }

//       const summaryReport = [
//         "SIMULATOR DOWNLOAD SUMMARY",
//         "========================",
//         `Report Type: Simulator`,
//         `Date: ${moment().format("DD-MM-YYYY HH:mm:ss")}`,
//         `Total Batches: ${filteredBatches.length}`,
//         `Successfully Downloaded: ${successCount}`,
//         `Failed: ${failCount}`,
//         "",
//         failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
//         ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
//         "",
//         "BATCH SUMMARY",
//         "==============",
//         ...filteredBatches.map((batch, idx) => {
//           const rating = batchFeedbackRatings[batch.id];
//           const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
//           const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
//           return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
//         })
//       ].join("\n");

//       reportsFolder.file("Download_Summary.txt", summaryReport);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

//       const finalZipBlob = await mainZip.generateAsync({
//         type: "blob",
//         compression: "DEFLATE",
//         compressionOptions: { level: 6 },
//       });

//       const downloadUrl = window.URL.createObjectURL(finalZipBlob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `All_Batches_Simulator_Reports_${timestamp}.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       if (failCount === 0) {
//         toast.success(`All ${successCount} simulator reports downloaded successfully!`);
//       } else {
//         toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
//       }
//     } catch (error) {
//       console.error("Error downloading simulator reports:", error);
//       toast.error("Error downloading simulator reports: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // RENDER
//   // ============================
//   return (
//     <>
//       {loader && <Loader />}

//       {consolidatedProgress.active && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             zIndex: 9999,
//             backgroundColor: "rgba(255,255,255,0.95)",
//             padding: "15px 20px",
//             boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//           }}
//         >
//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <span className="fw-bold text-primary">
//               <i className="fas fa-spinner fa-spin me-2"></i>
//               {consolidatedProgress.message}
//             </span>
//             <span className="text-muted">
//               {consolidatedProgress.current}/{consolidatedProgress.total}
//             </span>
//           </div>
//           <LinearProgress
//             variant="determinate"
//             value={consolidatedProgress.total > 0 ? (consolidatedProgress.current / consolidatedProgress.total) * 100 : 0}
//           />
//         </div>
//       )}

//       <Row>
//         <Col>
//           <Card>
//             <CardBody>
//               {/* Header Section */}
//               <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
//                 <CardTitle className="h4 mb-0">
//                   All Batches
//                   {filterState && <span className="ms-2 fs-6 text-muted">(State: {filterState})</span>}
//                   {filterDepot && <span className="ms-2 fs-6 text-muted">(Depot: {filterDepot})</span>}
//                   {filterPeriod !== "ALL" && (
//                     <span className="ms-2 fs-6 text-muted">(Period: {filterPeriod})</span>
//                   )}
//                   {isCustomDateRangeActive && customStartDate && customEndDate && (
//                     <span className="ms-2 fs-6 text-muted">
//                       (Custom Range: {formatDateToDDMMYYYY(customStartDate)} - {formatDateToDDMMYYYY(customEndDate)})
//                     </span>
//                   )}
//                   {departmentFilter && (
//                     <span className="ms-2 fs-6 text-muted">(Dept: {departmentFilter})</span>
//                   )}
//                   {debouncedSearchText && (
//                     <span className="ms-2 fs-6 text-info">(Search: "{debouncedSearchText}")</span>
//                   )}
//                 </CardTitle>
//                 <div className="d-flex flex-wrap gap-2">
//                   <Button color="secondary" size="sm" onClick={handleFilterClick}>
//                     <FilterListIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Filters
//                   </Button>
//                   <Menu
//                     anchorEl={filterAnchorEl}
//                     open={Boolean(filterAnchorEl)}
//                     onClose={handleFilterClose}
//                   >
//                     <div style={{ padding: "16px", minWidth: "280px" }}>
//                       <Typography variant="subtitle2" className="mb-2">State</Typography>
//                       <Select
//                         options={availableStates.map(s => ({ value: s, label: s }))}
//                         value={filterState ? { value: filterState, label: filterState } : null}
//                         onChange={(option) => {
//                           setFilterState(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All States"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Depot</Typography>
//                       <Select
//                         options={availableDepots.map(d => ({ value: d, label: d }))}
//                         value={filterDepot ? { value: filterDepot, label: filterDepot } : null}
//                         onChange={(option) => {
//                           setFilterDepot(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All Depots"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Department</Typography>
//                       <Select
//                         options={availableDepartments.map(d => ({ value: d, label: d }))}
//                         value={departmentFilter ? { value: departmentFilter, label: departmentFilter } : null}
//                         onChange={(option) => {
//                           setDepartmentFilter(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All Departments"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Period</Typography>
//                       <Select
//                         options={periodOptions}
//                         value={periodOptions.find(p => p.value === filterPeriod)}
//                         onChange={(option) => {
//                           setFilterPeriod(option?.value || "ALL");
//                           setPage(0);
//                           if (option?.value !== "CUSTOM") {
//                             setIsCustomDateRangeActive(false);
//                           }
//                         }}
//                         className="mb-3"
//                       />
                      
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={openCustomDateRangeModal}
//                         fullWidth
//                         style={{ marginBottom: "8px" }}
//                       >
//                         Custom Date Range
//                       </Button>
//                       {isCustomDateRangeActive && (
//                         <Button 
//                           size="small" 
//                           variant="outlined" 
//                           onClick={clearCustomDateRange}
//                           fullWidth
//                           style={{ marginBottom: "8px", backgroundColor: "#ffebee" }}
//                         >
//                           Clear Date Range
//                         </Button>
//                       )}
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={() => setSerialRangeModalShow(true)}
//                         fullWidth
//                         style={{ marginBottom: "8px" }}
//                       >
//                         Serial Range
//                       </Button>
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={resetFilters}
//                         fullWidth
//                       >
//                         Reset All Filters
//                       </Button>
//                     </div>
//                   </Menu>
                  
//                   <Button color="secondary" size="sm" onClick={() => setSerialRangeModalShow(true)}>
//                     <i className="fas fa-sort-numeric-up-alt me-1"></i>Serial Range
//                   </Button>
                  
//                   {(filterState || filterDepot || filterPeriod !== "ALL" || isCustomDateRangeActive || fromSerial || toSerial || searchText || departmentFilter) && (
//                     <Button color="danger" size="sm" onClick={clearAllFilters}>
//                       <i className="fas fa-times me-1"></i>Clear All
//                     </Button>
//                   )}
                  
//                   <Button color="info" size="sm" onClick={downloadExcel}>
//                     <i className="fas fa-download me-1"></i>Excel
//                   </Button>
                  
//                   <Button color="success" size="sm" onClick={() => setZipDownloadModalShow(true)}>
//                     <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Download ZIP
//                   </Button>
                  
//                   <Button color="success" size="sm" onClick={() => setZipSimulatorDownloadModalShow(true)}>
//                     <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Simulator ZIP
//                   </Button>
                  
//                   <Button color="warning" size="sm" onClick={openConsolidatedModal}>
//                     <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Consolidated Report
//                   </Button>
                  
//                   <Button color="warning" size="sm" onClick={openConsolidatedSimulatorModal}>
//                     <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Combined Consolidated
//                   </Button>
                  
//                   <Button color="primary" size="sm" onClick={refreshData}>
//                     <RefreshIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Refresh
//                   </Button>
//                 </div>
//               </div>

//               {/* Search and Stats */}
//               <Row className="mb-3">
//                 <Col md={6}>
//                   <TextField
//                     fullWidth
//                     label="Search..."
//                     placeholder="Batch name, department, depot, state, trainer, date"
//                     value={searchText}
//                     onChange={(e) => {
//                       setSearchText(e.target.value);
//                     }}
//                     variant="outlined"
//                     size="small"
//                     InputProps={{
//                       startAdornment: <i className="fas fa-search" style={{ marginRight: 8, color: "#6c757d" }}></i>,
//                       endAdornment: searchText !== debouncedSearchText && searchText ? (
//                         <CircularProgress size={20} style={{ marginRight: 8 }} />
//                       ) : null,
//                     }}
//                     helperText={searchText !== debouncedSearchText && searchText ? "Searching..." : ""}
//                   />
//                 </Col>
//                 <Col md={6} className="d-flex align-items-center">
//                   <small className="text-muted">
//                     <span className="me-2">Batches: <strong>{totalItems}</strong></span>
//                     <span className="me-2">| Students: <strong>{filteredStats.totalStudents}</strong></span>
//                     <span className="me-2 text-success">| Passed: <strong>{filteredStats.totalPassed}</strong></span>
//                     <span className="me-2 text-danger">| Failed: <strong>{filteredStats.totalFailed}</strong></span>
//                     <span className="me-2 text-warning">| Not Attempted: <strong>{filteredStats.totalNotAttempted}</strong></span>
//                     <span>| Pass Rate: <strong>{filteredStats.passRate}%</strong></span>
//                     <span className="ms-2" style={{ color: "#ffb400" }}>
//                       | Avg Rating: <strong>{filteredStats.avgRating > 0 ? filteredStats.avgRating + " ★" : "No Ratings"}</strong>
//                     </span>
//                     <span className="ms-2 text-success">
//                       | Feedback Given: <strong>{filteredStats.totalFeedbackGiven}</strong>
//                     </span>
//                     <span className="ms-2 text-danger">
//                       | Not Given: <strong>{filteredStats.totalNotFeedbackGiven}</strong>
//                     </span>
//                   </small>
//                 </Col>
//               </Row>

//               {/* Data Grid */}
//               <Paper elevation={0} style={{ border: "1px solid #e0e0e0" }}>
//                 <DataGrid
//                   autoHeight
//                   rows={filteredBatches.map((r, i) => ({
//                     ...r,
//                     serialNo: page * pageSize + i + 1,
//                     id: r.id,
//                   }))}
//                   columns={columns}
//                   pageSizeOptions={[5, 10, 25, 50, 100]}
//                   initialState={{
//                     pagination: { paginationModel: { pageSize: pageSize, page: 0 } },
//                   }}
//                   onPaginationModelChange={(model) => {
//                     if (model.pageSize !== pageSize) {
//                       handlePageSizeChange(model.pageSize);
//                     }
//                   }}
//                   disableRowSelectionOnClick
//                   sx={{
//                     "& .MuiDataGrid-cell:focus": { outline: "none" },
//                     "& .MuiDataGrid-columnHeaders": { backgroundColor: "#f8f9fa", fontWeight: "bold" },
//                   }}
//                 />
//               </Paper>

//               {renderPagination()}
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>

//       {/* ============================ */}
//       {/* MODALS */}
//       {/* ============================ */}

//       {/* Custom Date Range Modal */}
//       <Modal show={dateRangeModalShow} centered onHide={() => setDateRangeModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Select Custom Date Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="row">
//             <div className="col-md-6 mb-3">
//               <label className="form-label fw-bold">Start Date</label>
//               <DatePicker
//                 selected={customStartDate}
//                 onChange={(date) => setCustomStartDate(date)}
//                 selectsStart
//                 startDate={customStartDate}
//                 endDate={customEndDate}
//                 className="form-control"
//                 dateFormat="dd-MM-yyyy"
//                 placeholderText="Select start date"
//                 maxDate={customEndDate || undefined}
//                 showYearDropdown
//                 showMonthDropdown
//                 dropdownMode="select"
//               />
//             </div>
//             <div className="col-md-6 mb-3">
//               <label className="form-label fw-bold">End Date</label>
//               <DatePicker
//                 selected={customEndDate}
//                 onChange={(date) => setCustomEndDate(date)}
//                 selectsEnd
//                 startDate={customStartDate}
//                 endDate={customEndDate}
//                 minDate={customStartDate}
//                 className="form-control"
//                 dateFormat="dd-MM-yyyy"
//                 placeholderText="Select end date"
//                 showYearDropdown
//                 showMonthDropdown
//                 dropdownMode="select"
//               />
//             </div>
//           </div>
//           <div className="mt-2 p-2 bg-light rounded">
//             <small className="text-muted">
//               <i className="fas fa-info-circle me-1"></i>
//               Select a date range to show batches that started within this period.
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDateRangeModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={applyCustomDateRange}>
//             Apply Filter
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Serial Range Modal */}
//       <Modal show={serialRangeModalShow} centered onHide={() => setSerialRangeModalShow(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Serial Number Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="mb-3">
//             <label className="form-label fw-bold">From</label>
//             <input
//               type="number"
//               className="form-control"
//               min="1"
//               max={allBatch.length}
//               value={fromSerial}
//               onChange={(e) => setFromSerial(e.target.value)}
//               placeholder={`1 to ${allBatch.length}`}
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label fw-bold">To</label>
//             <input
//               type="number"
//               className="form-control"
//               min="1"
//               max={allBatch.length}
//               value={toSerial}
//               onChange={(e) => setToSerial(e.target.value)}
//               placeholder={`1 to ${allBatch.length}`}
//             />
//           </div>
//           <div className="mt-2 p-2 bg-light rounded">
//             <small className="text-muted">
//               <i className="fas fa-info-circle me-1"></i>
//               Enter serial number range to filter batches by their position in the list.
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setSerialRangeModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={applySerialRangeFilter}>
//             Apply
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Batch Modal */}
//       <Modal show={modalShow} size="lg" centered onHide={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Batch</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Row className="mb-3">
//             <label htmlFor="batch-name-input" className="col-md-2 col-form-label">
//               Batch Name
//             </label>
//             <div className="col-md-10">
//               <input
//                 id="batch-name-input"
//                 type="text"
//                 className="form-control"
//                 placeholder="Enter new batch name"
//                 maxLength="50"
//                 value={name}
//                 onChange={(e) => { setName(e.target.value); setSpanDisplay("none"); }}
//               />
//               <span style={{ color: "red", display: spanDisplay, fontSize: "12px", marginTop: "5px" }}>
//                 Batch name is required
//               </span>
//             </div>
//           </Row>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button color="secondary" onClick={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
//             Close
//           </Button>
//           <Button color="success" onClick={handleUpdate}>
//             Update
//           </Button>
//           <Button color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false); }}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Modal */}
//       <Modal show={deleteModalShow} centered onHide={() => setDeleteModalShow(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Delete</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="text-center py-3">
//             <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: "48px" }}></i>
//             <h5 className="mt-3">Delete this batch?</h5>
//             <p className="text-muted">This action cannot be undone.</p>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button color="secondary" onClick={() => { setDeleteModalShow(false); setModalShow(true); }}>
//             Cancel
//           </Button>
//           <Button color="danger" onClick={handleDelete}>
//             Yes, Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Individual Batch Report Modal */}
//       <Modal show={batchReportModalShow} centered onHide={() => setBatchReportModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download Batch Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
//             <DownloadIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
//             <div>
//               <strong>Download Report for {selectedBatchForReport?.batchName || "Batch"}</strong>
//               <small className="d-block text-muted">
//                 Select report type to download with images
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batch</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.batchName || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Department</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.department || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.totalStudents || 0}</div>
//             </div>
//             <div>
//               <small className="text-muted">Depot</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.depot || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">State</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.state || "N/A"}</div>
//             </div>
//           </div>

//           <label className="mb-2 fw-bold">Select Report Type:</label>
//           <Select
//             options={reportTypeOptions}
//             value={reportTypeOptions.find((opt) => opt.value === selectedReportType)}
//             onChange={(option) => setSelectedReportType(option?.value || "Other")}
//             placeholder="Choose report type..."
//             isSearchable={false}
//           />

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The downloaded file will be a ZIP containing:
//               <ul className="mt-2 mb-0">
//                 <li>Excel report with all student data</li>
//                 <li>Images folder with all uploaded images</li>
//                 <li>Complete with all fields including Pre Test, Post Test, Practical Grade, etc.</li>
//               </ul>
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBatchReportModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="success" onClick={downloadSingleBatchReport}>
//             <DownloadIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download {selectedReportType} Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Individual Batch Simulator Report Modal */}
//       <Modal show={batchSimulatorReportModalShow} centered onHide={() => setBatchSimulatorReportModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download Simulator Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Download Simulator Report for {selectedBatchForSimulatorReport?.batchName || "Batch"}</strong>
//               <small className="d-block text-muted">
//                 Download complete simulator report with all scenarios (PASS/FAIL/NOT_ATTEMPTED)
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batch</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.batchName || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Department</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.department || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.totalStudents || 0}</div>
//             </div>
//             <div>
//               <small className="text-muted">Depot</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.depot || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">State</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.state || "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The simulator report includes:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
//                 <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//               </ul>
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBatchSimulatorReportModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadSingleBatchSimulatorReport}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download Simulator Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Consolidated Report Modal */}
//       <Modal show={consolidatedModalShow} centered onHide={() => setConsolidatedModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Generate Consolidated Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
//             <MergeTypeIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
//             <div>
//               <strong>Single Sheet Consolidated Report</strong>
//               <small className="d-block text-muted">
//                 Combines all data from <strong>{allFilteredBatchCount}</strong> filtered batches into a single Excel sheet
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Process</small>
//               <div className="fw-bold fs-5">{allFilteredBatchCount}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//             <div>
//               <small className="text-muted">Avg Rating</small>
//               <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               This will generate a single Excel file containing all data with:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
//               </ul>
//             </small>
//           </div>

//           {allFilteredBatchCount > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Processing <strong>{allFilteredBatchCount}</strong> batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConsolidatedModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="success" onClick={downloadConsolidatedSimulator}>
//             <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Generate Report ({allFilteredBatchCount} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Consolidated Simulator Report Modal */}
//       <Modal show={consolidatedSimulatorModalShow} centered onHide={() => setConsolidatedSimulatorModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Generate Consolidated Simulator Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Single Sheet Consolidated Simulator Report</strong>
//               <small className="d-block text-muted">
//                 Combines all simulator data from <strong>{allFilteredBatchCount}</strong> filtered batches into a single Excel sheet
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Process</small>
//               <div className="fw-bold fs-5">{allFilteredBatchCount}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//             <div>
//               <small className="text-muted">Avg Rating</small>
//               <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               This will generate a single Excel file containing simulator data:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
//                 <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//                 <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
//               </ul>
//             </small>
//           </div>

//           {allFilteredBatchCount > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Processing <strong>{allFilteredBatchCount}</strong> batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConsolidatedSimulatorModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadConsolidatedSimulator}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Generate Simulator Report ({allFilteredBatchCount} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ZIP Download Modal */}
//       <Modal show={zipDownloadModalShow} centered onHide={() => setZipDownloadModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download All Batches as ZIP</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ArchiveIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Batch-wise ZIP Download with Images</strong>
//               <small className="d-block text-muted">
//                 Downloads each batch's report as a separate folder in a single ZIP file
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Download</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//           </div>

//           <label className="mb-2 fw-bold">Report Type:</label>
//           <Select
//             options={zipDownloadOptions}
//             value={zipDownloadOptions.find((opt) => opt.value === selectedZipType)}
//             onChange={(option) => setSelectedZipType(option?.value || "Other")}
//             placeholder="Choose report type..."
//             isSearchable={false}
//           />

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The ZIP file will contain:
//               <ul className="mt-2 mb-0">
//                 <li>Each batch in a separate folder with original report ZIP</li>
//                 <li>Batch_Info.json with complete batch details</li>
//                 <li>Images folder with all uploaded images</li>
//                 <li>Download_Summary.txt with overall statistics</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Downloading {filteredBatches.length} batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setZipDownloadModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadAllBatchesAsZip}>
//             <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download All as ZIP ({filteredBatches.length} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ZIP Simulator Download Modal */}
//       <Modal show={zipSimulatorDownloadModalShow} centered onHide={() => setZipSimulatorDownloadModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download All Simulator Reports as ZIP</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Batch-wise Simulator Reports ZIP Download</strong>
//               <small className="d-block text-muted">
//                 Downloads each batch's simulator report as a separate folder in a single ZIP file
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Download</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The ZIP file will contain:
//               <ul className="mt-2 mb-0">
//                 <li>Each batch in a separate folder with Simulator_Report.xlsx</li>
//                 <li>Batch_Info.json with complete batch details</li>
//                 <li>Download_Summary.txt with overall statistics</li>
//                 <li>Complete simulator data with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>All scenarios (PASS/FAIL/NOT_ATTEMPTED)</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Downloading {filteredBatches.length} batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setZipSimulatorDownloadModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadAllBatchesSimulatorAsZip}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download All Simulator Reports ({filteredBatches.length} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default connect(null, { setBreadcrumbItems })(AllGroup);












// AllGroup.js - Complete working component with all features

// import React, { useEffect, useState, useCallback } from "react";
// import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
// import { connect } from "react-redux";
// import { setBreadcrumbItems } from "../../store/actions";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
// import moment from "moment";

// import { Paper, TextField, LinearProgress, Tooltip, CircularProgress, Box, Typography, Menu, MenuItem } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import { Modal } from "react-bootstrap";
// import Select from "react-select";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import FilterListIcon from '@mui/icons-material/FilterList';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import MergeTypeIcon from '@mui/icons-material/MergeType';
// import DownloadIcon from '@mui/icons-material/Download';
// import ArchiveIcon from '@mui/icons-material/Archive';
// import ScienceIcon from '@mui/icons-material/Science';
// import FirstPageIcon from '@mui/icons-material/FirstPage';
// import LastPageIcon from '@mui/icons-material/LastPage';
// import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
// import NavigateNextIcon from '@mui/icons-material/NavigateNext';

// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";
// import axios from "axios";
// import JSZip from "jszip";

// import Loader from "components/Loader/Loader";
// import {
//   fetchAllBatchesWithPagination,
//   fetchAllBatch,
//   fetchAllBatchOfTrainer,
//   getAllTrainerOfBatch,
//   getAllStudentOfBatch,
//   updateBatch,
//   deleteBatch,
//   batchDetailFile,
//   batchDetailFileWithFullFilters,
//   getDistinctStates,
//   getDistinctDepots,
// } from "helpers/batch_helper";
// import { downloadBatchReport, url } from "helpers/url_helper";
// import { getResult } from "helpers/exam_helper";
// import { fetchAllFeedbackOfBatch, getAllResponsesOfFeedback } from "helpers/feedback_helper";

// // ============================
// // SIMULATOR API HELPER FUNCTIONS
// // ============================
// const SIMULATOR_EXCEL_URL = url + "api/simulator/excel/";

// const downloadBatchSimulatorReport = (batchId) => {
//   return `${SIMULATOR_EXCEL_URL}${batchId}`;
// };

// // ============================
// // PROGRESS TOAST FUNCTIONS
// // ============================
// let progressToastId = null;

// const showProgressToast = (message, isProcessing = true) => {
//   if (progressToastId) {
//     toast.update(progressToastId, {
//       render: message,
//       type: isProcessing ? "info" : "success",
//       isLoading: isProcessing,
//       autoClose: isProcessing ? false : 5000,
//     });
//   } else {
//     progressToastId = toast.info(message, {
//       autoClose: false,
//       isLoading: true,
//     });
//   }
// };

// const hideProgressToast = (message, isSuccess = true) => {
//   if (progressToastId) {
//     toast.update(progressToastId, {
//       render: message,
//       type: isSuccess ? "success" : "error",
//       isLoading: false,
//       autoClose: 5000,
//     });
//     progressToastId = null;
//   }
// };

// const AllGroup = (props) => {
//   document.title = "Content Management | All Batches";
//   const navigate = useNavigate();

//   // ============================
//   // STATE DECLARATIONS
//   // ============================
//   const [loader, setLoader] = useState(false);
//   const [allBatch, setAllBatch] = useState([]);
//   const [filteredBatches, setFilteredBatches] = useState([]);
//   const [searchText, setSearchText] = useState("");
//   const [modalShow, setModalShow] = useState(false);
//   const [deleteModalShow, setDeleteModalShow] = useState(false);
//   const [name, setName] = useState("");
//   const [id, setId] = useState({});
//   const [spanDisplay, setSpanDisplay] = useState("none");

//   // Pagination states
//   const [page, setPage] = useState(0);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalItems, setTotalItems] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);

//   // Filter states
//   const [filterState, setFilterState] = useState("");
//   const [filterDepot, setFilterDepot] = useState("");
//   const [filterPeriod, setFilterPeriod] = useState("ALL");
//   const [availableStates, setAvailableStates] = useState([]);
//   const [availableDepots, setAvailableDepots] = useState([]);
//   const [filterAnchorEl, setFilterAnchorEl] = useState(null);

//   // Additional filter states
//   const [departmentFilter, setDepartmentFilter] = useState("");
//   const [trainerNameFilter, setTrainerNameFilter] = useState("");
//   const [batchTypeFilter, setBatchTypeFilter] = useState("");
//   const [availableDepartments, setAvailableDepartments] = useState([]);
//   const [availableTrainers, setAvailableTrainers] = useState([]);
//   const [availableBatchTypes, setAvailableBatchTypes] = useState([]);

//   // Report generation states
//   const [consolidatedModalShow, setConsolidatedModalShow] = useState(false);
//   const [selectedConsolidatedType, setSelectedConsolidatedType] = useState("Other");
//   const [dateRangeModalShow, setDateRangeModalShow] = useState(false);
//   const [serialRangeModalShow, setSerialRangeModalShow] = useState(false);
//   const [customStartDate, setCustomStartDate] = useState(null);
//   const [customEndDate, setCustomEndDate] = useState(null);
//   const [isCustomDateRangeActive, setIsCustomDateRangeActive] = useState(false);
//   const [fromSerial, setFromSerial] = useState("");
//   const [toSerial, setToSerial] = useState("");

//   // Individual Batch Report Download States
//   const [batchReportModalShow, setBatchReportModalShow] = useState(false);
//   const [selectedBatchForReport, setSelectedBatchForReport] = useState(null);
//   const [selectedReportType, setSelectedReportType] = useState("Other");

//   // Individual Batch Simulator Report Download States
//   const [batchSimulatorReportModalShow, setBatchSimulatorReportModalShow] = useState(false);
//   const [selectedBatchForSimulatorReport, setSelectedBatchForSimulatorReport] = useState(null);

//   // ZIP Download States
//   const [zipDownloadModalShow, setZipDownloadModalShow] = useState(false);
//   const [selectedZipType, setSelectedZipType] = useState("Other");

//   // ZIP Simulator Download States
//   const [zipSimulatorDownloadModalShow, setZipSimulatorDownloadModalShow] = useState(false);

//   // Consolidated Simulator Report States
//   const [consolidatedSimulatorModalShow, setConsolidatedSimulatorModalShow] = useState(false);

//   // Store data maps
//   const [batchTrainersMap, setBatchTrainersMap] = useState({});
//   const [batchFeedbackRatings, setBatchFeedbackRatings] = useState({});
//   const [batchFeedbackCounts, setBatchFeedbackCounts] = useState({});
//   const [batchFeedbackGivenCounts, setBatchFeedbackGivenCounts] = useState({});
//   const [batchNotFeedbackGivenCounts, setBatchNotFeedbackGivenCounts] = useState({});
//   const [loadingRatings, setLoadingRatings] = useState({});
//   const [ratingsFetched, setRatingsFetched] = useState(false);

//   // Progress tracking
//   const [consolidatedProgress, setConsolidatedProgress] = useState({ 
//     active: false, 
//     current: 0, 
//     total: 0, 
//     message: "" 
//   });

//   // All filtered batches state (for consolidated report) - CRITICAL FIX
//   const [allFilteredBatchCount, setAllFilteredBatchCount] = useState(0);
//   const [allFilteredBatchData, setAllFilteredBatchData] = useState([]);
//   const [loadingAllBatches, setLoadingAllBatches] = useState(false);

//   // ============================
//   // HELPER FUNCTIONS
//   // ============================
//   const formatTrainerNames = (trainers) => {
//     if (!trainers || trainers.length === 0) return "No Trainer Assigned";
//     const trainerNames = trainers.map((t) => {
//       if (t.name) return t.name;
//       if (t.firstName && t.lastName) return `${t.firstName} ${t.lastName}`;
//       if (t.firstName) return t.firstName;
//       if (t.fullName) return t.fullName;
//       if (t.email) return t.email.split("@")[0];
//       return `Trainer ${t.id}`;
//     });
//     if (trainers.length === 1) return trainerNames[0];
//     return `${trainerNames[0]} +${trainers.length - 1}`;
//   };

//   const formatRatingWithStars = (rating) => {
//     if (!rating) return "Not Rated";
//     const fullStars = Math.floor(rating);
//     const emptyStars = 5 - fullStars;
//     return `${"★".repeat(fullStars)}${"☆".repeat(emptyStars)} ${rating.toFixed(1)}/5.0`;
//   };

//   // ============================
//   // OPTIONS
//   // ============================
//   const consolidatedOptions = [
//     { value: "DDT", label: "DDT Report (Single Sheet)" },
//     { value: "DASP", label: "DASP Report (Single Sheet)" },
//     { value: "Other", label: "Other Report (Single Sheet)" },
//   ];

//   const reportTypeOptions = [
//     { value: "DDT", label: "DDT Report" },
//     { value: "DASP", label: "DASP Report" },
//     { value: "Other", label: "Other Report" },
//   ];

//   const zipDownloadOptions = [
//     { value: "DDT", label: "DDT Reports (Batch-wise ZIP)" },
//     { value: "DASP", label: "DASP Reports (Batch-wise ZIP)" },
//     { value: "Other", label: "Other Reports (Batch-wise ZIP)" },
//   ];

//   const periodOptions = [
//     { value: "ALL", label: "All Time" },
//     { value: "TODAY", label: "Today" },
//     { value: "WEEKLY", label: "This Week" },
//     { value: "MONTHLY", label: "This Month" },
//     { value: "YEARLY", label: "This Year" },
//   ];

//   const pageSizeOptions = [
//     { value: 5, label: "5" },
//     { value: 10, label: "10" },
//     { value: 25, label: "25" },
//     { value: 50, label: "50" },
//     { value: 100, label: "100" },
//   ];

//   const breadcrumbItems = [
//     { title: "Batch", link: "#" },
//     { title: "All Batches", link: "#" },
//   ];

//   // ============================
//   // HELPER: Build date range from filters
//   // ============================
//   const buildDateRange = useCallback(() => {
//     let startDate = null;
//     let endDate = null;

//     if (isCustomDateRangeActive && customStartDate && customEndDate) {
//       startDate = moment(customStartDate).format("YYYY-MM-DD");
//       endDate = moment(customEndDate).format("YYYY-MM-DD");
//     } else if (filterPeriod !== "ALL") {
//       const today = moment().startOf('day');
//       switch (filterPeriod) {
//         case "TODAY":
//           startDate = today.format("YYYY-MM-DD");
//           endDate = today.format("YYYY-MM-DD");
//           break;
//         case "WEEKLY":
//           startDate = today.clone().startOf('week').format("YYYY-MM-DD");
//           endDate = today.clone().endOf('week').format("YYYY-MM-DD");
//           break;
//         case "MONTHLY":
//           startDate = today.clone().startOf('month').format("YYYY-MM-DD");
//           endDate = today.clone().endOf('month').format("YYYY-MM-DD");
//           break;
//         case "YEARLY":
//           startDate = today.clone().startOf('year').format("YYYY-MM-DD");
//           endDate = today.clone().endOf('year').format("YYYY-MM-DD");
//           break;
//         default:
//           break;
//       }
//     }

//     return { startDate, endDate };
//   }, [isCustomDateRangeActive, customStartDate, customEndDate, filterPeriod]);

//   // ============================
//   // FETCH ALL BATCHES FOR CONSOLIDATED REPORT
//   // This fetches ALL batches matching filters, not just current page
//   // ============================
//   const fetchAllBatchesForConsolidated = useCallback(async () => {
//     try {
//       setLoadingAllBatches(true);
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) {
//         toast.error("Organization ID not found");
//         setLoadingAllBatches(false);
//         return;
//       }

//       const { startDate, endDate } = buildDateRange();
      
//       console.log("Fetching ALL batches for consolidated report with filters:", {
//         startDate,
//         endDate,
//         filterState,
//         filterDepot,
//         searchText,
//         departmentFilter,
//         trainerNameFilter,
//         batchTypeFilter
//       });

//       // Fetch ALL batches with a very high page size to get everything
//       // Use page=0 and pageSize=100000 to ensure we get ALL batches
//       const response = await fetchAllBatchesWithPagination(
//         0, 
//         100000,  // Very high number to get all batches
//         startDate,
//         endDate,
//         filterState || null,
//         filterDepot || null,
//         searchText || null
//       );

//       if (response.data?.success) {
//         let batches = response.data.result || [];
        
//         // Apply additional client-side filters if needed
//         if (departmentFilter) {
//           batches = batches.filter(b => 
//             b.department && b.department.toLowerCase().includes(departmentFilter.toLowerCase())
//           );
//         }
//         if (trainerNameFilter) {
//           batches = batches.filter(b => 
//             b.trainerNames && b.trainerNames.toLowerCase().includes(trainerNameFilter.toLowerCase())
//           );
//         }
//         if (batchTypeFilter) {
//           batches = batches.filter(b => 
//             b.batchType && b.batchType.toLowerCase() === batchTypeFilter.toLowerCase()
//           );
//         }

//         console.log(`✅ Fetched ${batches.length} batches for consolidated report`);
//         setAllFilteredBatchData(batches);
//         setAllFilteredBatchCount(batches.length);
        
//         return batches;
//       } else {
//         console.error("Failed to fetch batches:", response.data?.message);
//         toast.error("Failed to fetch batches for consolidated report");
//         setAllFilteredBatchCount(0);
//         setAllFilteredBatchData([]);
//         return [];
//       }
//     } catch (error) {
//       console.error("Error fetching all batches for consolidated:", error);
//       toast.error("Error fetching batches for consolidated report");
//       setAllFilteredBatchCount(0);
//       setAllFilteredBatchData([]);
//       return [];
//     } finally {
//       setLoadingAllBatches(false);
//     }
//   }, [buildDateRange, filterState, filterDepot, searchText, departmentFilter, trainerNameFilter, batchTypeFilter]);

//   // ============================
//   // FETCH DISTINCT FILTERS
//   // ============================
//   const fetchDistinctFilters = useCallback(async () => {
//     try {
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser?.organizationId) return;

//       const [statesRes, depotsRes] = await Promise.all([
//         getDistinctStates(),
//         getDistinctDepots()
//       ]);

//       if (statesRes?.data) {
//         setAvailableStates(statesRes.data);
//       }
//       if (depotsRes?.data) {
//         setAvailableDepots(depotsRes.data);
//       }

//       const depts = new Set();
//       const trainers = new Set();
//       const types = new Set();

//       allBatch.forEach(batch => {
//         if (batch.department) depts.add(batch.department);
//         if (batch.batchType) types.add(batch.batchType);
//         if (batch.trainerNames && batch.trainerNames !== "No Trainer Assigned") {
//           trainers.add(batch.trainerNames);
//         }
//       });

//       setAvailableDepartments([...depts]);
//       setAvailableTrainers([...trainers]);
//       setAvailableBatchTypes([...types]);

//     } catch (error) {
//       console.error("Error fetching distinct filters:", error);
//     }
//   }, [allBatch]);

//   // ============================
//   // FETCH FEEDBACK RATINGS
//   // ============================
//   const fetchFeedbackRatingsOnly = async (batches) => {
//     if (ratingsFetched) return;
    
//     const feedbackRatingsMap = {};
//     const feedbackCountsMap = {};
//     const feedbackGivenCountsMap = {};
//     const notFeedbackGivenCountsMap = {};
    
//     const asyncPool = async (concurrency, items, iteratorFn) => {
//       const results = [];
//       const executing = new Set();
//       for (const [index, item] of items.entries()) {
//         const promise = Promise.resolve().then(() => iteratorFn(item, index));
//         results.push(promise);
//         executing.add(promise);
//         const clean = () => executing.delete(promise);
//         promise.then(clean, clean);
//         if (executing.size >= concurrency) {
//           await Promise.race(executing);
//         }
//       }
//       return Promise.all(results);
//     };
    
//     await asyncPool(5, batches, async (batch) => {
//       const batchId = batch.id || batch._id;
//       if (!batchId) return;
      
//       try {
//         setLoadingRatings(prev => ({ ...prev, [batchId]: true }));
        
//         const feedbacksResponse = await fetchAllFeedbackOfBatch(batchId);
        
//         if (!feedbacksResponse?.success || !feedbacksResponse?.result?.length) {
//           feedbackRatingsMap[batchId] = null;
//           feedbackCountsMap[batchId] = 0;
//           feedbackGivenCountsMap[batchId] = 0;
//           notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
//           return;
//         }

//         let totalRatingSum = 0;
//         let totalResponseCount = 0;
//         let totalFeedbackGiven = 0;

//         for (const feedback of feedbacksResponse.result) {
//           const responsesResponse = await getAllResponsesOfFeedback(feedback.id);
          
//           if (responsesResponse?.success && responsesResponse?.responseResult?.length) {
//             const feedbackRatingSum = responsesResponse.responseResult.reduce(
//               (sum, response) => sum + (response.rating || 0), 
//               0
//             );
//             totalRatingSum += feedbackRatingSum;
//             totalResponseCount += responsesResponse.responseResult.length;
//             totalFeedbackGiven += responsesResponse.responseResult.length;
//           }
//         }

//         const averageRating = totalResponseCount > 0 ? totalRatingSum / totalResponseCount : null;
//         const totalStudents = batch.totalStudents || 0;
//         const notFeedbackGiven = totalStudents - totalFeedbackGiven;
        
//         feedbackRatingsMap[batchId] = averageRating;
//         feedbackCountsMap[batchId] = totalResponseCount;
//         feedbackGivenCountsMap[batchId] = totalFeedbackGiven;
//         notFeedbackGivenCountsMap[batchId] = notFeedbackGiven > 0 ? notFeedbackGiven : 0;
        
//         setBatchFeedbackRatings(prev => ({ ...prev, [batchId]: averageRating }));
//         setBatchFeedbackCounts(prev => ({ ...prev, [batchId]: totalResponseCount }));
//         setBatchFeedbackGivenCounts(prev => ({ ...prev, [batchId]: totalFeedbackGiven }));
//         setBatchNotFeedbackGivenCounts(prev => ({ ...prev, [batchId]: notFeedbackGiven > 0 ? notFeedbackGiven : 0 }));
//       } catch (error) {
//         console.error(`Error fetching feedback rating for batch ${batchId}:`, error);
//         feedbackRatingsMap[batchId] = null;
//         feedbackCountsMap[batchId] = 0;
//         feedbackGivenCountsMap[batchId] = 0;
//         notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
//       } finally {
//         setLoadingRatings(prev => ({ ...prev, [batchId]: false }));
//       }
//     });
    
//     setRatingsFetched(true);
//   };

//   // ============================
//   // FETCH TRAINERS FOR BATCHES
//   // ============================
//   const fetchTrainersForBatches = async (batches) => {
//     const trainersMap = {};
    
//     const asyncPool = async (concurrency, items, iteratorFn) => {
//       const results = [];
//       const executing = new Set();
//       for (const [index, item] of items.entries()) {
//         const promise = Promise.resolve().then(() => iteratorFn(item, index));
//         results.push(promise);
//         executing.add(promise);
//         const clean = () => executing.delete(promise);
//         promise.then(clean, clean);
//         if (executing.size >= concurrency) {
//           await Promise.race(executing);
//         }
//       }
//       return Promise.all(results);
//     };
    
//     await asyncPool(5, batches, async (batch) => {
//       const batchId = batch.id || batch._id;
//       if (!batchId) return;
//       try {
//         const trainers = await getAllTrainerOfBatch(batchId).catch(() => []);
//         trainersMap[batchId] = trainers?.success ? trainers.result || [] : [];
//       } catch (error) {
//         trainersMap[batchId] = [];
//       }
//     });
    
//     setBatchTrainersMap(trainersMap);
//   };

//   // ============================
//   // GET ALL BATCHES WITH PAGINATION
//   // ============================
//   const getAllBatches = useCallback(async () => {
//     try {
//       setLoader(true);
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       const type = authUser?.userType;
      
//       if (type === "Tata Trainer") {
//         const res = await fetchAllBatchOfTrainer();
//         if (res?.success) {
//           const batches = (res.result || []).map(batch => ({
//             id: batch.id || batch._id,
//             batchName: batch.batchName,
//             department: batch.department,
//             state: batch.state,
//             depot: batch.depot,
//             trainingStartDate: batch.trainingStartDate,
//             trainingEndDate: batch.trainingEndDate,
//             totalStudents: batch.totalStudents || batch.students?.length || 0,
//             passedStudents: batch.passedStudents || 0,
//             failedStudents: batch.failedStudents || 0,
//             notAttemptedStudents: batch.notAttemptedStudents || 0,
//             passPercentage: batch.passPercentage || 0,
//             trainerNames: batch.trainerNames || "No Trainer Assigned",
//             totalTrainers: batch.totalTrainers || 0,
//             entryBy: batch.entryBy,
//             entryAt: batch.entryAt,
//             updatedBy: batch.updatedBy,
//             updatedAt: batch.updatedAt,
//             feedbackGivenCount: batch.feedbackGivenCount || 0,
//             notFeedbackGivenCount: batch.notFeedbackGivenCount || 0,
//             batchType: batch.batchType || "Offline"
//           }));
//           setAllBatch(batches);
//           setFilteredBatches(batches);
//           setTotalItems(batches.length);
//           setTotalPages(1);
//           toast.success(`${batches.length} batches loaded successfully`);
          
//           if (batches.length > 0) {
//             await Promise.all([
//               fetchTrainersForBatches(batches),
//               fetchFeedbackRatingsOnly(batches)
//             ]);
//           }
//         }
//       } else {
//         const { startDate, endDate } = buildDateRange();
        
//         const searchValue = searchText || null;
        
//         const response = await fetchAllBatchesWithPagination(
//           page, 
//           pageSize, 
//           startDate, 
//           endDate, 
//           filterState || null, 
//           filterDepot || null, 
//           searchValue
//         );
        
//         if (response.data?.success) {
//           const batches = (response.data.result || []).map(batch => ({
//             id: batch.id || batch._id,
//             batchName: batch.batchName,
//             department: batch.department,
//             state: batch.state,
//             depot: batch.depot,
//             trainingStartDate: batch.trainingStartDate,
//             trainingEndDate: batch.trainingEndDate,
//             totalStudents: batch.totalStudents || 0,
//             passedStudents: batch.passedStudents || 0,
//             failedStudents: batch.failedStudents || 0,
//             notAttemptedStudents: batch.notAttemptedStudents || 0,
//             passPercentage: batch.passPercentage || 0,
//             trainerNames: batch.trainerNames || "No Trainer Assigned",
//             totalTrainers: batch.totalTrainers || 0,
//             entryBy: batch.entryBy,
//             entryAt: batch.entryAt,
//             updatedBy: batch.updatedBy,
//             updatedAt: batch.updatedAt,
//             feedbackGivenCount: batch.feedbackGivenCount || 0,
//             notFeedbackGivenCount: batch.notFeedbackGivenCount || 0,
//             batchType: batch.batchType || "Offline"
//           }));
          
//           setAllBatch(batches);
//           setFilteredBatches(batches);
//           setTotalItems(response.data.totalItems || 0);
//           setTotalPages(response.data.totalPages || 0);
          
//           if (batches.length > 0) {
//             await Promise.all([
//               fetchTrainersForBatches(batches),
//               fetchFeedbackRatingsOnly(batches)
//             ]);
//           }
          
//           if (batches.length === 0) {
//             toast.info("No batches found for the selected filters");
//           }
//         } else {
//           toast.error(response.data?.message || "Failed to load batches");
//         }
//       }
//     } catch (error) {
//       console.error("Error in getAllBatches:", error);
//       toast.error(error?.response?.data?.message || "Failed to load batches");
//     } finally {
//       setLoader(false);
//     }
//   }, [page, pageSize, filterState, filterDepot, filterPeriod, searchText, customStartDate, customEndDate, isCustomDateRangeActive, buildDateRange]);

//   // ============================
//   // DOWNLOAD CONSOLIDATED SIMULATOR REPORT
//   // This now uses ALL filtered batches, not just current page
//   // ============================
//   const downloadConsolidatedSimulator = async () => {
//     try {
//       setLoader(true);
//       setConsolidatedSimulatorModalShow(false);
      
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) {
//         toast.error("Organization ID not found. Please log in again.");
//         setLoader(false);
//         return;
//       }
      
//       const { startDate, endDate } = buildDateRange();
      
//       // Build filter message
//       const filters = [];
//       if (startDate && endDate) {
//         filters.push(`Training End Date: ${moment(startDate).format('DD/MM/YYYY')} to ${moment(endDate).format('DD/MM/YYYY')}`);
//       } else if (startDate) {
//         filters.push(`From: ${moment(startDate).format('DD/MM/YYYY')}`);
//       } else if (endDate) {
//         filters.push(`Until: ${moment(endDate).format('DD/MM/YYYY')}`);
//       }
//       if (filterState) filters.push(`State: ${filterState}`);
//       if (filterDepot) filters.push(`Depot: ${filterDepot}`);
//       if (searchText) filters.push(`Search: "${searchText}"`);
//       if (departmentFilter) filters.push(`Department: ${departmentFilter}`);
//       if (trainerNameFilter) filters.push(`Trainer: ${trainerNameFilter}`);
//       if (batchTypeFilter) filters.push(`Batch Type: ${batchTypeFilter}`);
      
//       // Build the URL correctly with /api prefix
//       const baseUrl = "https://backend.skillserve.in/api/";
//       let apiUrl = `${baseUrl}simulator/consolidated-report`;
      
//       const params = new URLSearchParams();
//       if (startDate) params.append("startDate", startDate);
//       if (endDate) params.append("endDate", endDate);
//       if (filterState && filterState !== "") params.append("state", filterState);
//       if (filterDepot && filterDepot !== "") params.append("depot", filterDepot);
//       if (searchText && searchText !== "") params.append("search", searchText);
//       if (departmentFilter && departmentFilter !== "") params.append("department", departmentFilter);
//       if (trainerNameFilter && trainerNameFilter !== "") params.append("trainerName", trainerNameFilter);
//       if (batchTypeFilter && batchTypeFilter !== "") params.append("batchType", batchTypeFilter);
      
//       if (params.toString()) {
//         apiUrl += "?" + params.toString();
//       }
      
//       console.log("Calling consolidated report URL:", apiUrl);
//       console.log("Total batches to process:", allFilteredBatchCount);
      
//       showProgressToast(`⏳ Generating Consolidated Simulator Report for ${allFilteredBatchCount} batches... This may take several minutes.`, true);
      
//       // Make request with extended timeout
//       const response = await axios({
//         method: 'get',
//         url: apiUrl,
//         responseType: 'blob',
//         timeout: 600000,
//         headers: {
//           'X-Organization-ID': authUser.organizationId || ''
//         }
//       });
      
//       hideProgressToast("✅ Report generated successfully! Downloading...", true);
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         setLoader(false);
//         return;
//       }
      
//       // Check if response is JSON error
//       const firstBytes = await response.data.slice(0, 100).text();
//       const trimmedFirstBytes = firstBytes.trim();
//       if (trimmedFirstBytes.startsWith('{') || trimmedFirstBytes.startsWith('[')) {
//         try {
//           const fullText = await response.data.text();
//           const errorData = JSON.parse(fullText);
//           toast.error(errorData.message || "Failed to download file");
//           setLoader(false);
//           return;
//         } catch (e) {
//           toast.error("Failed to download file");
//           setLoader(false);
//           return;
//         }
//       }
      
//       const blob = new Blob([response.data], {
//         type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       });
      
//       const downloadUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
      
//       let filename = `Consolidated_Simulator_Report`;
//       if (startDate && endDate) {
//         filename += `_${moment(startDate).format("YYYYMMDD")}_to_${moment(endDate).format("YYYYMMDD")}`;
//       } else if (startDate) {
//         filename += `_from_${moment(startDate).format("YYYYMMDD")}`;
//       } else if (endDate) {
//         filename += `_upto_${moment(endDate).format("YYYYMMDD")}`;
//       }
//       if (filterState) {
//         filename += `_state_${filterState}`;
//       }
//       if (filterDepot) {
//         filename += `_depot_${filterDepot}`;
//       }
//       if (departmentFilter) {
//         filename += `_dept_${departmentFilter.replace(/\s+/g, '_')}`;
//       }
//       if (trainerNameFilter) {
//         filename += `_trainer_${trainerNameFilter.replace(/\s+/g, '_')}`;
//       }
//       if (batchTypeFilter) {
//         filename += `_type_${batchTypeFilter}`;
//       }
//       filename += `.xlsx`;
      
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`✅ Consolidated Simulator Report downloaded successfully! (${allFilteredBatchCount} batches)`);
//     } catch (error) {
//       console.error("Error downloading consolidated simulator report:", error);
//       hideProgressToast("❌ Failed to generate report. Please try again.", false);
      
//       if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
//         toast.error("⏱️ Report generation is taking longer than expected. Please try again with fewer filters or try again later.");
//       } else if (error.response?.data) {
//         try {
//           const errorText = await error.response.data.text();
//           const errorJson = JSON.parse(errorText);
//           toast.error(errorJson.message || "Failed to generate report");
//         } catch (e) {
//           toast.error("Failed to generate report. Server error occurred.");
//         }
//       } else if (error.message) {
//         toast.error(`Failed to generate report: ${error.message}`);
//       } else {
//         toast.error("Failed to generate report. Please try again.");
//       }
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // OPEN CONSOLIDATED MODALS
//   // These now fetch ALL batches matching filters before opening the modal
//   // ============================
//   const openConsolidatedModal = async () => {
//     const batches = await fetchAllBatchesForConsolidated();
//     if (batches && batches.length > 0) {
//       setConsolidatedModalShow(true);
//     } else {
//       toast.warning("No batches found for the selected filters");
//     }
//   };

//   const openConsolidatedSimulatorModal = async () => {
//     const batches = await fetchAllBatchesForConsolidated();
//     if (batches && batches.length > 0) {
//       setConsolidatedSimulatorModalShow(true);
//     } else {
//       toast.warning("No batches found for the selected filters");
//     }
//   };

//   // ============================
//   // DOWNLOAD EXCEL WITH FULL FILTERS
//   // ============================
//   const downloadExcel = async () => {
//     try {
//       setLoader(true);
      
//       const authUser = JSON.parse(localStorage.getItem("authUser"));
//       if (!authUser || !authUser.organizationId) {
//         toast.error("Organization ID not found. Please log in again.");
//         return;
//       }
      
//       const { startDate, endDate } = buildDateRange();
      
//       const filters = [];
//       if (startDate && endDate) {
//         filters.push(`Training End Date: ${moment(startDate).format('DD/MM/YYYY')} to ${moment(endDate).format('DD/MM/YYYY')}`);
//       } else if (startDate) {
//         filters.push(`From: ${moment(startDate).format('DD/MM/YYYY')}`);
//       } else if (endDate) {
//         filters.push(`Until: ${moment(endDate).format('DD/MM/YYYY')}`);
//       }
//       if (filterState) filters.push(`State: ${filterState}`);
//       if (filterDepot) filters.push(`Depot: ${filterDepot}`);
//       if (searchText) filters.push(`Search: "${searchText}"`);
//       if (departmentFilter) filters.push(`Department: ${departmentFilter}`);
      
//       toast.info(filters.length > 0 ? 
//         `Downloading report with filters: ${filters.join(', ')}...` : 
//         "Downloading all batch report...");
      
//       const response = await batchDetailFileWithFullFilters(
//         startDate, 
//         endDate, 
//         filterState, 
//         filterDepot, 
//         searchText
//       );
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const firstBytes = await response.data.slice(0, 100).text();
//       const trimmedFirstBytes = firstBytes.trim();
//       if (trimmedFirstBytes.startsWith('{') || trimmedFirstBytes.startsWith('[')) {
//         try {
//           const fullText = await response.data.text();
//           const errorData = JSON.parse(fullText);
//           toast.error(errorData.message || "Failed to download file");
//           return;
//         } catch (e) {
//           toast.error("Failed to download file");
//           return;
//         }
//       }
      
//       const blob = new Blob([response.data], {
//         type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//       });
      
//       const downloadUrl = window.URL.createObjectURL(blob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
      
//       let filename = `Batch_Details`;
//       if (startDate && endDate) {
//         filename += `_${moment(startDate).format("YYYYMMDD")}_to_${moment(endDate).format("YYYYMMDD")}`;
//       } else if (startDate) {
//         filename += `_from_${moment(startDate).format("YYYYMMDD")}`;
//       } else if (endDate) {
//         filename += `_upto_${moment(endDate).format("YYYYMMDD")}`;
//       }
//       if (filterState) {
//         filename += `_state_${filterState}`;
//       }
//       if (filterDepot) {
//         filename += `_depot_${filterDepot}`;
//       }
//       if (searchText) {
//         filename += `_search_${searchText.replace(/\s+/g, '_')}`;
//       }
//       if (departmentFilter) {
//         filename += `_dept_${departmentFilter.replace(/\s+/g, '_')}`;
//       }
//       filename += `.xlsx`;
      
//       link.download = filename;
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success("File downloaded successfully!");
//     } catch (error) {
//       console.error("Error downloading file:", error);
//       toast.error(error.response?.data?.message || "Failed to download file");
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // PAGE CHANGE HANDLERS
//   // ============================
//   const handlePageChange = (newPage) => {
//     if (newPage >= 0 && newPage < totalPages) {
//       setPage(newPage);
//     }
//   };

//   const handlePageSizeChange = (newSize) => {
//     setPageSize(newSize);
//     setPage(0);
//   };

//   // ============================
//   // PAGINATION RENDER
//   // ============================
//   const renderPagination = () => {
//     if (totalPages <= 1) return null;

//     const pageNumbers = [];
//     const maxVisible = 5;
//     let startPage = Math.max(0, page - Math.floor(maxVisible / 2));
//     let endPage = Math.min(totalPages - 1, startPage + maxVisible - 1);
    
//     if (endPage - startPage < maxVisible - 1) {
//       startPage = Math.max(0, endPage - maxVisible + 1);
//     }

//     for (let i = startPage; i <= endPage; i++) {
//       pageNumbers.push(i);
//     }

//     return (
//       <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap gap-2">
//         <div className="d-flex align-items-center gap-2">
//           <span className="text-muted" style={{ fontSize: "14px" }}>
//             Showing {page * pageSize + 1} to {Math.min((page + 1) * pageSize, totalItems)} of {totalItems} entries
//           </span>
//         </div>
//         <div className="d-flex align-items-center gap-2 flex-wrap">
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(0)}
//             disabled={page === 0}
//           >
//             <FirstPageIcon style={{ fontSize: "18px" }} />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(page - 1)}
//             disabled={page === 0}
//           >
//             <NavigateBeforeIcon style={{ fontSize: "18px" }} />
//           </Button>
//           {pageNumbers.map((num) => (
//             <Button
//               key={num}
//               color={num === page ? "primary" : "secondary"}
//               size="sm"
//               onClick={() => handlePageChange(num)}
//               style={{ minWidth: "35px" }}
//             >
//               {num + 1}
//             </Button>
//           ))}
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(page + 1)}
//             disabled={page >= totalPages - 1}
//           >
//             <NavigateNextIcon style={{ fontSize: "18px" }} />
//           </Button>
//           <Button
//             color="secondary"
//             size="sm"
//             onClick={() => handlePageChange(totalPages - 1)}
//             disabled={page >= totalPages - 1}
//           >
//             <LastPageIcon style={{ fontSize: "18px" }} />
//           </Button>
          
//           <div className="d-flex align-items-center ms-2 gap-2">
//             <span className="text-muted" style={{ fontSize: "13px" }}>Rows:</span>
//             <Select
//               options={pageSizeOptions}
//               value={pageSizeOptions.find(opt => opt.value === pageSize)}
//               onChange={(option) => handlePageSizeChange(option.value)}
//               className="page-size-select"
//               styles={{
//                 control: (base) => ({
//                   ...base,
//                   minHeight: "32px",
//                   width: "70px",
//                   borderColor: "#ced4da",
//                   boxShadow: "none",
//                   "&:hover": {
//                     borderColor: "#80bdff",
//                   },
//                 }),
//                 menu: (base) => ({
//                   ...base,
//                   zIndex: 9999,
//                 }),
//                 option: (base, state) => ({
//                   ...base,
//                   backgroundColor: state.isSelected ? "#0d6efd" : state.isFocused ? "#e9ecef" : "white",
//                   color: state.isSelected ? "white" : "#212529",
//                   "&:active": {
//                     backgroundColor: "#0d6efd",
//                     color: "white",
//                   },
//                 }),
//               }}
//               isSearchable={false}
//               menuPortalTarget={document.body}
//             />
//           </div>
//         </div>
//       </div>
//     );
//   };

//   // ============================
//   // EFFECTS
//   // ============================
//   useEffect(() => {
//     props.setBreadcrumbItems("All Batches", breadcrumbItems);
//   }, []);

//   useEffect(() => {
//     getAllBatches();
//   }, [getAllBatches]);

//   useEffect(() => {
//     if (allBatch.length > 0) {
//       fetchTrainersForBatches(allBatch);
//       fetchFeedbackRatingsOnly(allBatch);
//       fetchDistinctFilters();
//     }
//   }, [allBatch]);

//   // ============================
//   // COLUMNS DEFINITION
//   // ============================
//   const columns = [
//     { field: "serialNo", headerName: "S.No", width: 70 },
//     {
//       field: "batchName",
//       headerName: "Batch Name",
//       width: 200,
//       renderCell: (params) => {
//         return (
//           <span
//             style={{ cursor: "pointer", color: "#0d6efd", fontWeight: 500, textDecoration: "underline" }}
//             onClick={() => handleViewDetails(params.row)}
//             title={`${params.row.totalStudents || 0} student(s)`}
//           >
//             {params.value}
//           </span>
//         );
//       },
//     },
//     { field: "department", headerName: "Department", width: 150 },
//     {
//       field: "trainerNames",
//       headerName: "Trainer(s)",
//       width: 250,
//       renderCell: (params) => {
//         return <span>{params.value || "No Trainer Assigned"}</span>;
//       },
//     },
//     {
//       field: "state",
//       headerName: "State",
//       width: 130,
//       renderCell: (params) => params.value || "N/A",
//     },
//     {
//       field: "depot",
//       headerName: "Depot",
//       width: 130,
//       renderCell: (params) => params.value || "N/A",
//     },
//     {
//       field: "trainingStartDate",
//       headerName: "Start Date",
//       width: 130,
//       renderCell: (params) => formatDateToDDMMYYYY(params.value),
//     },
//     {
//       field: "trainingEndDate",
//       headerName: "End Date",
//       width: 130,
//       renderCell: (params) => formatDateToDDMMYYYY(params.value),
//     },
//     {
//       field: "totalStudents",
//       headerName: "Students",
//       width: 90,
//       renderCell: (params) => (
//         <span style={{ fontWeight: params.value > 0 ? "bold" : "normal", color: params.value > 0 ? "#198754" : "#6c757d" }}>
//           {params.value || 0}
//         </span>
//       ),
//     },
//     {
//       field: "passedStudents",
//       headerName: "Passed",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ color: "#198754", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "failedStudents",
//       headerName: "Failed",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ color: "#dc3545", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "notAttemptedStudents",
//       headerName: "Not Attempted",
//       width: 100,
//       renderCell: (params) => (
//         <span style={{ color: "#ffc107", fontWeight: "bold" }}>{params.value || 0}</span>
//       ),
//     },
//     {
//       field: "passPercentage",
//       headerName: "Pass %",
//       width: 80,
//       renderCell: (params) => (
//         <span style={{ fontWeight: "bold" }}>{params.value || 0}%</span>
//       ),
//     },
//     {
//       field: "feedbackRating",
//       headerName: "Rating",
//       width: 220,
//       renderCell: (params) => {
//         const rating = batchFeedbackRatings[params.row.id];
//         const count = batchFeedbackCounts[params.row.id] || 0;
//         const loading = loadingRatings[params.row.id];

//         if (loading) {
//           return <CircularProgress size={25} />;
//         }

//         return renderStarRating(rating, count);
//       },
//     },
//     {
//       field: "feedbackGiven",
//       headerName: "Feedback Given",
//       width: 130,
//       renderCell: (params) => {
//         const given = batchFeedbackGivenCounts[params.row.id] || 0;
//         const notGiven = batchNotFeedbackGivenCounts[params.row.id] || 0;
//         return (
//           <Tooltip title={`${given} students gave feedback, ${notGiven} students did not`}>
//             <span style={{ color: given > 0 ? "#198754" : "#6c757d" }}>
//               {given} / {given + notGiven}
//             </span>
//           </Tooltip>
//         );
//       },
//     },
//     {
//       field: "edit",
//       headerName: "Edit",
//       width: 80,
//       renderCell: (p) => (
//         <Button size="sm" color="warning" onClick={() => handleRowClick(p.row)} style={{ padding: "4px 12px" }}>
//           Edit
//         </Button>
//       ),
//     },
//     {
//       field: "download",
//       headerName: "Download Report",
//       width: 130,
//       renderCell: (p) => (
//         <Button 
//           size="sm" 
//           color="success" 
//           onClick={() => openBatchReportModal(p.row)}
//           style={{ padding: "4px 8px", marginRight: "4px" }}
//         >
//           <DownloadIcon style={{ fontSize: "14px" }} />
//         </Button>
//       ),
//     },
//     {
//       field: "downloadSimulator",
//       headerName: "Simulator",
//       width: 100,
//       renderCell: (p) => (
//         <Button 
//           size="sm" 
//           color="primary" 
//           onClick={() => openBatchSimulatorReportModal(p.row)}
//           style={{ padding: "4px 8px" }}
//         >
//           <ScienceIcon style={{ fontSize: "14px" }} />
//         </Button>
//       ),
//     },
//   ];

//   // ============================
//   // HELPER FUNCTIONS FOR DISPLAY
//   // ============================
//   const formatDateToDDMMYYYY = useCallback((dateStr) => {
//     if (!dateStr) return "N/A";
//     try {
//       const date = moment(dateStr);
//       if (date.isValid()) {
//         return date.format("DD/MM/YYYY");
//       }
//       return String(dateStr);
//     } catch (error) {
//       return String(dateStr);
//     }
//   }, []);

//   const renderStarRating = (rating, count = 0) => {
//     if (!rating || count === 0) {
//       return (
//         <Tooltip title="No feedback responses yet">
//           <span style={{ color: "#6c757d", fontStyle: "italic" }}>No Rating</span>
//         </Tooltip>
//       );
//     }

//     const fullStars = Math.floor(rating);
//     const hasHalfStar = rating % 1 >= 0.5;
//     const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

//     return (
//       <Tooltip title={`Based on ${count} response(s) - Average Rating: ${rating.toFixed(1)}/5.0`}>
//         <Box display="flex" alignItems="center" gap={1} sx={{ cursor: "pointer" }}>
//           <Box display="flex" alignItems="center" gap={0.2}>
//             {[...Array(fullStars)].map((_, i) => (
//               <span key={`full-${i}`} style={{ color: "#ffb400", fontSize: "16px" }}>★</span>
//             ))}
//             {hasHalfStar && (
//               <span style={{ color: "#ffb400", fontSize: "16px", position: "relative", display: "inline-block" }}>
//                 <span style={{ position: "absolute", overflow: "hidden", width: "50%", color: "#ffb400" }}>★</span>
//                 <span style={{ color: "#e4e5e9" }}>★</span>
//               </span>
//             )}
//             {[...Array(emptyStars)].map((_, i) => (
//               <span key={`empty-${i}`} style={{ color: "#e4e5e9", fontSize: "16px" }}>★</span>
//             ))}
//           </Box>
//           <Typography 
//             variant="body2" 
//             sx={{ 
//               fontWeight: "bold", 
//               color: "#ffb400",
//               backgroundColor: "#fff3e0",
//               padding: "2px 6px",
//               borderRadius: "12px",
//               fontSize: "12px"
//             }}
//           >
//             {rating.toFixed(1)}
//           </Typography>
//         </Box>
//       </Tooltip>
//     );
//   };

//   const getFilteredStats = useCallback(() => {
//     let totalStudents = 0;
//     let totalPassed = 0;
//     let totalFailed = 0;
//     let totalNotAttempted = 0;
//     let totalRatingSum = 0;
//     let totalRatingCount = 0;
//     let totalFeedbackGiven = 0;
//     let totalNotFeedbackGiven = 0;

//     filteredBatches.forEach((batch) => {
//       totalStudents += batch.totalStudents || 0;
//       totalPassed += batch.passedStudents || 0;
//       totalFailed += batch.failedStudents || 0;
//       totalNotAttempted += batch.notAttemptedStudents || 0;
      
//       const rating = batchFeedbackRatings[batch.id];
//       if (rating) {
//         totalRatingSum += rating;
//         totalRatingCount++;
//       }
      
//       totalFeedbackGiven += batchFeedbackGivenCounts[batch.id] || 0;
//       totalNotFeedbackGiven += batchNotFeedbackGivenCounts[batch.id] || 0;
//     });

//     const passRate = totalStudents > 0 ? ((totalPassed / totalStudents) * 100).toFixed(1) : 0;
//     const avgRating = totalRatingCount > 0 ? (totalRatingSum / totalRatingCount).toFixed(1) : 0;

//     return {
//       totalStudents,
//       totalPassed,
//       totalFailed,
//       totalNotAttempted,
//       passRate,
//       avgRating,
//       totalRatingCount,
//       totalFeedbackGiven,
//       totalNotFeedbackGiven
//     };
//   }, [filteredBatches, batchFeedbackRatings, batchFeedbackGivenCounts, batchNotFeedbackGivenCounts]);

//   const filteredStats = getFilteredStats();

//   // ============================
//   // EDIT/DELETE FUNCTIONS
//   // ============================
//   const handleRowClick = (row) => {
//     setModalShow(true);
//     navigate(`/batch/${row.id}`);
//     setId(row.id);
//     setName(row.batchName || "");
//   };

//   const handleUpdate = async () => {
//     if (!name) {
//       setSpanDisplay("inline");
//       return;
//     }

//     try {
//       setLoader(true);
//       const result = await updateBatch({ id, batchName: name });
//       if (result?.success) {
//         toast.success(result?.message);
//         getAllBatches();
//         setModalShow(false);
//         setName("");
//         setId("");
//         setSpanDisplay("none");
//       } else {
//         toast.error(result?.message);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to update batch");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleDelete = async () => {
//     try {
//       setLoader(true);
//       const result = await deleteBatch(id);
//       if (result?.success) {
//         toast.success(result?.message);
//         getAllBatches();
//         setDeleteModalShow(false);
//         setModalShow(false);
//         setName("");
//         setId("");
//       } else {
//         toast.error(result?.message);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Failed to delete batch");
//     } finally {
//       setLoader(false);
//     }
//   };

//   const handleViewDetails = (row) => {
//     navigate(`/batch/${row.id}`);
//   };

//   const resetFilters = () => {
//     setFilterState("");
//     setFilterDepot("");
//     setFilterPeriod("ALL");
//     setSearchText("");
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setFilterAnchorEl(null);
//     setDepartmentFilter("");
//     setTrainerNameFilter("");
//     setBatchTypeFilter("");
//     setPage(0);
//   };

//   const handleFilterClick = (event) => {
//     setFilterAnchorEl(event.currentTarget);
//   };

//   const handleFilterClose = () => {
//     setFilterAnchorEl(null);
//   };

//   const openCustomDateRangeModal = () => {
//     setDateRangeModalShow(true);
//     handleFilterClose();
//   };

//   const applyCustomDateRange = () => {
//     if (!customStartDate || !customEndDate) {
//       toast.error("Please select both start and end dates");
//       return;
//     }

//     if (moment(customStartDate).isAfter(moment(customEndDate))) {
//       toast.error("Start date cannot be after end date");
//       return;
//     }

//     setIsCustomDateRangeActive(true);
//     setFilterPeriod("ALL");
//     setDateRangeModalShow(false);
//     setPage(0);
//     toast.success(`Custom date range applied: ${formatDateToDDMMYYYY(customStartDate)} to ${formatDateToDDMMYYYY(customEndDate)}`);
//   };

//   const clearCustomDateRange = () => {
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setPage(0);
//     toast.success("Custom date range cleared");
//   };

//   const applySerialRangeFilter = () => {
//     if (!fromSerial || !toSerial) {
//       toast.error("Please enter both from and to serial numbers");
//       return;
//     }

//     const from = parseInt(fromSerial);
//     const to = parseInt(toSerial);

//     if (isNaN(from) || isNaN(to)) {
//       toast.error("Please enter valid numbers");
//       return;
//     }

//     if (from < 1 || to > allBatch.length) {
//       toast.error(`Please enter serial numbers between 1 and ${allBatch.length}`);
//       return;
//     }

//     if (from > to) {
//       toast.error("'From' serial number must be less than or equal to 'To' serial number");
//       return;
//     }

//     const filtered = allBatch.filter((_, index) => {
//       const serialNo = index + 1;
//       return serialNo >= from && serialNo <= to;
//     });

//     setFilteredBatches(filtered);
//     setSerialRangeModalShow(false);
//     toast.success(`Showing ${filtered.length} batches`);
//   };

//   const clearAllFilters = () => {
//     setCustomStartDate(null);
//     setCustomEndDate(null);
//     setIsCustomDateRangeActive(false);
//     setFromSerial("");
//     setToSerial("");
//     setSearchText("");
//     setFilterState("");
//     setFilterDepot("");
//     setFilterPeriod("ALL");
//     setDepartmentFilter("");
//     setTrainerNameFilter("");
//     setBatchTypeFilter("");
//     setPage(0);
//     toast.success("All filters cleared");
//   };

//   const refreshData = () => {
//     setPage(0);
//     getAllBatches();
//     toast.info("Refreshing data from server...");
//   };

//   // ============================
//   // MODAL FUNCTIONS
//   // ============================
//   const openBatchReportModal = (batch) => {
//     setSelectedBatchForReport(batch);
//     setSelectedReportType("Other");
//     setBatchReportModalShow(true);
//   };

//   const openBatchSimulatorReportModal = (batch) => {
//     setSelectedBatchForSimulatorReport(batch);
//     setBatchSimulatorReportModalShow(true);
//   };

//   // ============================
//   // DOWNLOAD SINGLE BATCH REPORT
//   // ============================
//   const downloadSingleBatchReport = async () => {
//     if (!selectedBatchForReport) {
//       toast.error("No batch selected");
//       return;
//     }

//     try {
//       setLoader(true);
//       setBatchReportModalShow(false);
      
//       const batchId = selectedBatchForReport.id;
//       const batchName = selectedBatchForReport.batchName || "Batch";
      
//       toast.info(`Downloading ${selectedReportType} report for ${batchName}...`);
      
//       const apiUrl = `${downloadBatchReport}${batchId}?type=${selectedReportType}`;
//       const response = await axios.get(apiUrl, { 
//         responseType: "blob", 
//         timeout: 120000
//       });
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `${batchName}_${selectedReportType}_Report.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`${selectedReportType} report downloaded for ${batchName}`);
      
//     } catch (error) {
//       console.error(`Error downloading report:`, error);
//       toast.error(`Failed to download report: ${error.message}`);
//     } finally {
//       setLoader(false);
//       setSelectedBatchForReport(null);
//     }
//   };

//   // ============================
//   // DOWNLOAD SINGLE BATCH SIMULATOR REPORT
//   // ============================
//   const downloadSingleBatchSimulatorReport = async () => {
//     if (!selectedBatchForSimulatorReport) {
//       toast.error("No batch selected");
//       return;
//     }

//     try {
//       setLoader(true);
//       setBatchSimulatorReportModalShow(false);
      
//       const batchId = selectedBatchForSimulatorReport.id;
//       const batchName = selectedBatchForSimulatorReport.batchName || "Batch";
      
//       toast.info(`Downloading Simulator report for ${batchName}...`);
      
//       const apiUrl = downloadBatchSimulatorReport(batchId);
//       const response = await axios.get(apiUrl, { 
//         responseType: "blob", 
//         timeout: 120000
//       });
      
//       if (!response.data || response.data.size === 0) {
//         toast.error("No data received from server");
//         return;
//       }
      
//       const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `${batchName}_Simulator_Report.xlsx`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);
      
//       toast.success(`Simulator report downloaded for ${batchName}`);
      
//     } catch (error) {
//       console.error(`Error downloading simulator report:`, error);
//       toast.error(`Failed to download simulator report: ${error.message}`);
//     } finally {
//       setLoader(false);
//       setSelectedBatchForSimulatorReport(null);
//     }
//   };

//   // ============================
//   // DOWNLOAD ALL BATCHES AS ZIP
//   // ============================
//   const downloadAllBatchesAsZip = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to download");
//       return;
//     }

//     try {
//       setLoader(true);
//       setZipDownloadModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Downloading ${selectedZipType} reports for ${filteredBatches.length} batches...`
//       });

//       const mainZip = new JSZip();
//       const timestamp = moment().format("YYYYMMDD_HHmmss");
//       const reportsFolder = mainZip.folder(`All_Reports_${selectedZipType}_${timestamp}`);

//       let successCount = 0;
//       let failCount = 0;
//       const failedBatches = [];

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Downloading ${i + 1}/${filteredBatches.length}: ${batch.batchName}`
//         });
        
//         try {
//           const apiUrl = `${downloadBatchReport}${batch.id}?type=${selectedZipType}`;
//           const response = await axios.get(apiUrl, { 
//             responseType: "blob", 
//             timeout: 120000
//           });
          
//           if (response.data && response.data.size > 0) {
//             const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
//             const batchFolder = reportsFolder.folder(batchFolderName);
            
//             batchFolder.file(`${selectedZipType}_Report.zip`, response.data);
            
//             const trainers = batchTrainersMap[batch.id] || [];
//             const trainerName = formatTrainerNames(trainers);
//             const feedbackRating = batchFeedbackRatings[batch.id];
//             const feedbackCount = batchFeedbackCounts[batch.id] || 0;
//             const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
//             const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
//             const batchInfo = {
//               batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
//               batchName: batch.batchName,
//               batchId: batch.id,
//               department: batch.department,
//               depot: batch.depot,
//               state: batch.state,
//               startDate: formatDateToDDMMYYYY(batch.trainingStartDate),
//               endDate: formatDateToDDMMYYYY(batch.trainingEndDate),
//               trainers: trainers.map(t => ({
//                 id: t.id,
//                 name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
//               })),
//               trainerName: trainerName,
//               totalStudents: batch.totalStudents || 0,
//               passedStudents: batch.passedStudents || 0,
//               failedStudents: batch.failedStudents || 0,
//               notAttemptedStudents: batch.notAttemptedStudents || 0,
//               passPercentage: batch.passPercentage || 0,
//               feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
//               feedbackCount: feedbackCount,
//               feedbackGivenCount: feedbackGivenCount,
//               notFeedbackGivenCount: notFeedbackGivenCount,
//               reportType: selectedZipType,
//               downloadedAt: new Date().toISOString()
//             };
            
//             batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
//             try {
//               const downloadedZip = await JSZip.loadAsync(response.data);
//               const imageFiles = Object.keys(downloadedZip.files).filter(
//                 filename => filename.startsWith('images/') && 
//                 (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png') || filename.endsWith('.gif'))
//               );
              
//               if (imageFiles.length > 0) {
//                 const imagesFolder = batchFolder.folder("Images");
//                 for (const imageFile of imageFiles) {
//                   const imageData = await downloadedZip.files[imageFile].async("blob");
//                   const imageName = imageFile.split('/').pop();
//                   imagesFolder.file(imageName, imageData);
//                 }
//               }
//             } catch (imageError) {
//               console.log(`No images found for batch ${batch.batchName}`);
//             }
            
//             successCount++;
//           } else {
//             failCount++;
//             failedBatches.push({ name: batch.batchName, error: "Empty response" });
//           }
//         } catch (error) {
//           console.error(`Error downloading batch ${batch.batchName}:`, error);
//           failCount++;
//           failedBatches.push({ name: batch.batchName, error: error.message });
//         }
//       }

//       const summaryReport = [
//         "DOWNLOAD SUMMARY",
//         "================",
//         `Report Type: ${selectedZipType}`,
//         `Date: ${new Date().toLocaleString()}`,
//         `Total Batches: ${filteredBatches.length}`,
//         `Successfully Downloaded: ${successCount}`,
//         `Failed: ${failCount}`,
//         "",
//         failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
//         ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
//         "",
//         "BATCH SUMMARY",
//         "==============",
//         ...filteredBatches.map((batch, idx) => {
//           const rating = batchFeedbackRatings[batch.id];
//           const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
//           const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
//           return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
//         })
//       ].join("\n");

//       reportsFolder.file("Download_Summary.txt", summaryReport);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

//       const finalZipBlob = await mainZip.generateAsync({
//         type: "blob",
//         compression: "DEFLATE",
//         compressionOptions: { level: 6 },
//       });

//       const downloadUrl = window.URL.createObjectURL(finalZipBlob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `All_Batches_${selectedZipType}_${timestamp}.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       if (failCount === 0) {
//         toast.success(`All ${successCount} batches downloaded successfully with images!`);
//       } else {
//         toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
//       }
//     } catch (error) {
//       console.error("Error downloading all reports:", error);
//       toast.error("Error downloading reports: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // DOWNLOAD ALL BATCHES SIMULATOR AS ZIP
//   // ============================
//   const downloadAllBatchesSimulatorAsZip = async () => {
//     if (filteredBatches.length === 0) {
//       toast.error("No batches to download");
//       return;
//     }

//     try {
//       setLoader(true);
//       setZipSimulatorDownloadModalShow(false);
      
//       setConsolidatedProgress({
//         active: true,
//         current: 0,
//         total: filteredBatches.length,
//         message: `Downloading Simulator reports for ${filteredBatches.length} batches...`
//       });

//       const mainZip = new JSZip();
//       const timestamp = moment().format("YYYYMMDD_HHmmss");
//       const reportsFolder = mainZip.folder(`All_Simulator_Reports_${timestamp}`);

//       let successCount = 0;
//       let failCount = 0;
//       const failedBatches = [];

//       for (let i = 0; i < filteredBatches.length; i++) {
//         const batch = filteredBatches[i];
        
//         setConsolidatedProgress({
//           active: true,
//           current: i + 1,
//           total: filteredBatches.length,
//           message: `Downloading ${i + 1}/${filteredBatches.length}: ${batch.batchName} Simulator Report`
//         });
        
//         try {
//           const apiUrl = downloadBatchSimulatorReport(batch.id);
//           const response = await axios.get(apiUrl, { 
//             responseType: "blob", 
//             timeout: 120000
//           });
          
//           if (response.data && response.data.size > 0) {
//             const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
//             const batchFolder = reportsFolder.folder(batchFolderName);
            
//             batchFolder.file(`Simulator_Report.xlsx`, response.data);
            
//             const trainers = batchTrainersMap[batch.id] || [];
//             const trainerName = formatTrainerNames(trainers);
//             const feedbackRating = batchFeedbackRatings[batch.id];
//             const feedbackCount = batchFeedbackCounts[batch.id] || 0;
//             const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
//             const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
//             const batchInfo = {
//               batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
//               batchName: batch.batchName,
//               batchId: batch.id,
//               department: batch.department,
//               depot: batch.depot,
//               state: batch.state,
//               startDate: formatDateToDDMMYYYY(batch.trainingStartDate),
//               endDate: formatDateToDDMMYYYY(batch.trainingEndDate),
//               trainers: trainers.map(t => ({
//                 id: t.id,
//                 name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
//               })),
//               trainerName: trainerName,
//               totalStudents: batch.totalStudents || 0,
//               passedStudents: batch.passedStudents || 0,
//               failedStudents: batch.failedStudents || 0,
//               notAttemptedStudents: batch.notAttemptedStudents || 0,
//               passPercentage: batch.passPercentage || 0,
//               feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
//               feedbackCount: feedbackCount,
//               feedbackGivenCount: feedbackGivenCount,
//               notFeedbackGivenCount: notFeedbackGivenCount,
//               reportType: "Simulator",
//               downloadedAt: new Date().toISOString()
//             };
            
//             batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
//             successCount++;
//           } else {
//             failCount++;
//             failedBatches.push({ name: batch.batchName, error: "Empty response" });
//           }
//         } catch (error) {
//           console.error(`Error downloading simulator report for batch ${batch.batchName}:`, error);
//           failCount++;
//           failedBatches.push({ name: batch.batchName, error: error.message });
//         }
//       }

//       const summaryReport = [
//         "SIMULATOR DOWNLOAD SUMMARY",
//         "========================",
//         `Report Type: Simulator`,
//         `Date: ${new Date().toLocaleString()}`,
//         `Total Batches: ${filteredBatches.length}`,
//         `Successfully Downloaded: ${successCount}`,
//         `Failed: ${failCount}`,
//         "",
//         failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
//         ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
//         "",
//         "BATCH SUMMARY",
//         "==============",
//         ...filteredBatches.map((batch, idx) => {
//           const rating = batchFeedbackRatings[batch.id];
//           const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
//           const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
//           return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
//         })
//       ].join("\n");

//       reportsFolder.file("Download_Summary.txt", summaryReport);
//       setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

//       const finalZipBlob = await mainZip.generateAsync({
//         type: "blob",
//         compression: "DEFLATE",
//         compressionOptions: { level: 6 },
//       });

//       const downloadUrl = window.URL.createObjectURL(finalZipBlob);
//       const link = document.createElement("a");
//       link.href = downloadUrl;
//       link.setAttribute("download", `All_Batches_Simulator_Reports_${timestamp}.zip`);
//       document.body.appendChild(link);
//       link.click();
//       link.remove();
//       window.URL.revokeObjectURL(downloadUrl);

//       if (failCount === 0) {
//         toast.success(`All ${successCount} simulator reports downloaded successfully!`);
//       } else {
//         toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
//       }
//     } catch (error) {
//       console.error("Error downloading simulator reports:", error);
//       toast.error("Error downloading simulator reports: " + (error.message || "Unknown error"));
//     } finally {
//       setLoader(false);
//     }
//   };

//   // ============================
//   // RENDER
//   // ============================
//   return (
//     <>
//       {loader && <Loader />}

//       {consolidatedProgress.active && (
//         <div
//           style={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             zIndex: 9999,
//             backgroundColor: "rgba(255,255,255,0.95)",
//             padding: "15px 20px",
//             boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//           }}
//         >
//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <span className="fw-bold text-primary">
//               <i className="fas fa-spinner fa-spin me-2"></i>
//               {consolidatedProgress.message}
//             </span>
//             <span className="text-muted">
//               {consolidatedProgress.current}/{consolidatedProgress.total}
//             </span>
//           </div>
//           <LinearProgress
//             variant="determinate"
//             value={consolidatedProgress.total > 0 ? (consolidatedProgress.current / consolidatedProgress.total) * 100 : 0}
//           />
//         </div>
//       )}

//       <Row>
//         <Col>
//           <Card>
//             <CardBody>
//               {/* Header Section */}
//               <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
//                 <CardTitle className="h4 mb-0">
//                   All Batches
//                   {filterState && <span className="ms-2 fs-6 text-muted">(State: {filterState})</span>}
//                   {filterDepot && <span className="ms-2 fs-6 text-muted">(Depot: {filterDepot})</span>}
//                   {filterPeriod !== "ALL" && (
//                     <span className="ms-2 fs-6 text-muted">(Period: {filterPeriod})</span>
//                   )}
//                   {isCustomDateRangeActive && customStartDate && customEndDate && (
//                     <span className="ms-2 fs-6 text-muted">
//                       (Custom Range: {formatDateToDDMMYYYY(customStartDate)} - {formatDateToDDMMYYYY(customEndDate)})
//                     </span>
//                   )}
//                   {departmentFilter && (
//                     <span className="ms-2 fs-6 text-muted">(Dept: {departmentFilter})</span>
//                   )}
//                 </CardTitle>
//                 <div className="d-flex flex-wrap gap-2">
//                   <Button color="secondary" size="sm" onClick={handleFilterClick}>
//                     <FilterListIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Filters
//                   </Button>
//                   <Menu
//                     anchorEl={filterAnchorEl}
//                     open={Boolean(filterAnchorEl)}
//                     onClose={handleFilterClose}
//                   >
//                     <div style={{ padding: "16px", minWidth: "280px" }}>
//                       <Typography variant="subtitle2" className="mb-2">State</Typography>
//                       <Select
//                         options={availableStates.map(s => ({ value: s, label: s }))}
//                         value={filterState ? { value: filterState, label: filterState } : null}
//                         onChange={(option) => {
//                           setFilterState(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All States"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Depot</Typography>
//                       <Select
//                         options={availableDepots.map(d => ({ value: d, label: d }))}
//                         value={filterDepot ? { value: filterDepot, label: filterDepot } : null}
//                         onChange={(option) => {
//                           setFilterDepot(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All Depots"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Department</Typography>
//                       <Select
//                         options={availableDepartments.map(d => ({ value: d, label: d }))}
//                         value={departmentFilter ? { value: departmentFilter, label: departmentFilter } : null}
//                         onChange={(option) => {
//                           setDepartmentFilter(option?.value || "");
//                           setPage(0);
//                         }}
//                         placeholder="All Departments"
//                         isClearable
//                         className="mb-3"
//                       />
                      
//                       <Typography variant="subtitle2" className="mb-2">Period</Typography>
//                       <Select
//                         options={periodOptions}
//                         value={periodOptions.find(p => p.value === filterPeriod)}
//                         onChange={(option) => {
//                           setFilterPeriod(option?.value || "ALL");
//                           setPage(0);
//                           if (option?.value !== "CUSTOM") {
//                             setIsCustomDateRangeActive(false);
//                           }
//                         }}
//                         className="mb-3"
//                       />
                      
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={openCustomDateRangeModal}
//                         fullWidth
//                         style={{ marginBottom: "8px" }}
//                       >
//                         Custom Date Range
//                       </Button>
//                       {isCustomDateRangeActive && (
//                         <Button 
//                           size="small" 
//                           variant="outlined" 
//                           onClick={clearCustomDateRange}
//                           fullWidth
//                           style={{ marginBottom: "8px", backgroundColor: "#ffebee" }}
//                         >
//                           Clear Date Range
//                         </Button>
//                       )}
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={() => setSerialRangeModalShow(true)}
//                         fullWidth
//                         style={{ marginBottom: "8px" }}
//                       >
//                         Serial Range
//                       </Button>
//                       <Button 
//                         size="small" 
//                         variant="outlined" 
//                         onClick={resetFilters}
//                         fullWidth
//                       >
//                         Reset All Filters
//                       </Button>
//                     </div>
//                   </Menu>
                  
//                   <Button color="secondary" size="sm" onClick={() => setSerialRangeModalShow(true)}>
//                     <i className="fas fa-sort-numeric-up-alt me-1"></i>Serial Range
//                   </Button>
                  
//                   {(filterState || filterDepot || filterPeriod !== "ALL" || isCustomDateRangeActive || fromSerial || toSerial || searchText || departmentFilter) && (
//                     <Button color="danger" size="sm" onClick={clearAllFilters}>
//                       <i className="fas fa-times me-1"></i>Clear All
//                     </Button>
//                   )}
                  
//                   <Button color="info" size="sm" onClick={downloadExcel}>
//                     <i className="fas fa-download me-1"></i>Excel
//                   </Button>
                  
//                   <Button color="success" size="sm" onClick={() => setZipDownloadModalShow(true)}>
//                     <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Download ZIP
//                   </Button>
                  
//                   <Button color="success" size="sm" onClick={() => setZipSimulatorDownloadModalShow(true)}>
//                     <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Simulator ZIP
//                   </Button>
                  
//                   <Button color="warning" size="sm" onClick={openConsolidatedModal}>
//                     <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Consolidated Report
//                   </Button>
                  
//                   <Button color="warning" size="sm" onClick={openConsolidatedSimulatorModal}>
//                     <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Combined Consolidated
//                   </Button>
                  
//                   <Button color="primary" size="sm" onClick={refreshData}>
//                     <RefreshIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//                     Refresh
//                   </Button>
//                 </div>
//               </div>

//               {/* Search and Stats */}
//               <Row className="mb-3">
//                 <Col md={6}>
//                   <TextField
//                     fullWidth
//                     label="Search..."
//                     placeholder="Batch name, department, depot, state, trainer, date"
//                     value={searchText}
//                     onChange={(e) => {
//                       setSearchText(e.target.value);
//                       setPage(0);
//                     }}
//                     variant="outlined"
//                     size="small"
//                     InputProps={{
//                       startAdornment: <i className="fas fa-search" style={{ marginRight: 8, color: "#6c757d" }}></i>,
//                     }}
//                   />
//                 </Col>
//                 <Col md={6} className="d-flex align-items-center">
//                   <small className="text-muted">
//                     <span className="me-2">Batches: <strong>{totalItems}</strong></span>
//                     <span className="me-2">| Students: <strong>{filteredStats.totalStudents}</strong></span>
//                     <span className="me-2 text-success">| Passed: <strong>{filteredStats.totalPassed}</strong></span>
//                     <span className="me-2 text-danger">| Failed: <strong>{filteredStats.totalFailed}</strong></span>
//                     <span className="me-2 text-warning">| Not Attempted: <strong>{filteredStats.totalNotAttempted}</strong></span>
//                     <span>| Pass Rate: <strong>{filteredStats.passRate}%</strong></span>
//                     <span className="ms-2" style={{ color: "#ffb400" }}>
//                       | Avg Rating: <strong>{filteredStats.avgRating > 0 ? filteredStats.avgRating + " ★" : "No Ratings"}</strong>
//                     </span>
//                     <span className="ms-2 text-success">
//                       | Feedback Given: <strong>{filteredStats.totalFeedbackGiven}</strong>
//                     </span>
//                     <span className="ms-2 text-danger">
//                       | Not Given: <strong>{filteredStats.totalNotFeedbackGiven}</strong>
//                     </span>
//                   </small>
//                 </Col>
//               </Row>

//               {/* Data Grid */}
//               <Paper elevation={0} style={{ border: "1px solid #e0e0e0" }}>
//                 <DataGrid
//                   autoHeight
//                   rows={filteredBatches.map((r, i) => ({
//                     ...r,
//                     serialNo: page * pageSize + i + 1,
//                     id: r.id,
//                   }))}
//                   columns={columns}
//                   pageSizeOptions={[5, 10, 25, 50, 100]}
//                   initialState={{
//                     pagination: { paginationModel: { pageSize: pageSize, page: 0 } },
//                   }}
//                   onPaginationModelChange={(model) => {
//                     if (model.pageSize !== pageSize) {
//                       handlePageSizeChange(model.pageSize);
//                     }
//                   }}
//                   disableRowSelectionOnClick
//                   sx={{
//                     "& .MuiDataGrid-cell:focus": { outline: "none" },
//                     "& .MuiDataGrid-columnHeaders": { backgroundColor: "#f8f9fa", fontWeight: "bold" },
//                   }}
//                 />
//               </Paper>

//               {renderPagination()}
//             </CardBody>
//           </Card>
//         </Col>
//       </Row>

//       {/* ============================ */}
//       {/* MODALS */}
//       {/* ============================ */}

//       {/* Custom Date Range Modal */}
//       <Modal show={dateRangeModalShow} centered onHide={() => setDateRangeModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Select Custom Date Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="row">
//             <div className="col-md-6 mb-3">
//               <label className="form-label fw-bold">Start Date</label>
//               <DatePicker
//                 selected={customStartDate}
//                 onChange={(date) => setCustomStartDate(date)}
//                 selectsStart
//                 startDate={customStartDate}
//                 endDate={customEndDate}
//                 className="form-control"
//                 dateFormat="dd/MM/yyyy"
//                 placeholderText="Select start date"
//                 maxDate={customEndDate || undefined}
//                 showYearDropdown
//                 showMonthDropdown
//                 dropdownMode="select"
//               />
//             </div>
//             <div className="col-md-6 mb-3">
//               <label className="form-label fw-bold">End Date</label>
//               <DatePicker
//                 selected={customEndDate}
//                 onChange={(date) => setCustomEndDate(date)}
//                 selectsEnd
//                 startDate={customStartDate}
//                 endDate={customEndDate}
//                 minDate={customStartDate}
//                 className="form-control"
//                 dateFormat="dd/MM/yyyy"
//                 placeholderText="Select end date"
//                 showYearDropdown
//                 showMonthDropdown
//                 dropdownMode="select"
//               />
//             </div>
//           </div>
//           <div className="mt-2 p-2 bg-light rounded">
//             <small className="text-muted">
//               <i className="fas fa-info-circle me-1"></i>
//               Select a date range to show batches that started within this period.
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setDateRangeModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={applyCustomDateRange}>
//             Apply Filter
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Serial Range Modal */}
//       <Modal show={serialRangeModalShow} centered onHide={() => setSerialRangeModalShow(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Serial Number Range</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="mb-3">
//             <label className="form-label fw-bold">From</label>
//             <input
//               type="number"
//               className="form-control"
//               min="1"
//               max={allBatch.length}
//               value={fromSerial}
//               onChange={(e) => setFromSerial(e.target.value)}
//               placeholder={`1 to ${allBatch.length}`}
//             />
//           </div>
//           <div className="mb-3">
//             <label className="form-label fw-bold">To</label>
//             <input
//               type="number"
//               className="form-control"
//               min="1"
//               max={allBatch.length}
//               value={toSerial}
//               onChange={(e) => setToSerial(e.target.value)}
//               placeholder={`1 to ${allBatch.length}`}
//             />
//           </div>
//           <div className="mt-2 p-2 bg-light rounded">
//             <small className="text-muted">
//               <i className="fas fa-info-circle me-1"></i>
//               Enter serial number range to filter batches by their position in the list.
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setSerialRangeModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={applySerialRangeFilter}>
//             Apply
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Edit Batch Modal */}
//       <Modal show={modalShow} size="lg" centered onHide={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
//         <Modal.Header closeButton>
//           <Modal.Title>Edit Batch</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Row className="mb-3">
//             <label htmlFor="batch-name-input" className="col-md-2 col-form-label">
//               Batch Name
//             </label>
//             <div className="col-md-10">
//               <input
//                 id="batch-name-input"
//                 type="text"
//                 className="form-control"
//                 placeholder="Enter new batch name"
//                 maxLength="50"
//                 value={name}
//                 onChange={(e) => { setName(e.target.value); setSpanDisplay("none"); }}
//               />
//               <span style={{ color: "red", display: spanDisplay, fontSize: "12px", marginTop: "5px" }}>
//                 Batch name is required
//               </span>
//             </div>
//           </Row>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button color="secondary" onClick={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
//             Close
//           </Button>
//           <Button color="success" onClick={handleUpdate}>
//             Update
//           </Button>
//           <Button color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false); }}>
//             Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Modal */}
//       <Modal show={deleteModalShow} centered onHide={() => setDeleteModalShow(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Delete</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="text-center py-3">
//             <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: "48px" }}></i>
//             <h5 className="mt-3">Delete this batch?</h5>
//             <p className="text-muted">This action cannot be undone.</p>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button color="secondary" onClick={() => { setDeleteModalShow(false); setModalShow(true); }}>
//             Cancel
//           </Button>
//           <Button color="danger" onClick={handleDelete}>
//             Yes, Delete
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Individual Batch Report Modal */}
//       <Modal show={batchReportModalShow} centered onHide={() => setBatchReportModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download Batch Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
//             <DownloadIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
//             <div>
//               <strong>Download Report for {selectedBatchForReport?.batchName || "Batch"}</strong>
//               <small className="d-block text-muted">
//                 Select report type to download with images
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batch</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.batchName || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Department</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.department || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.totalStudents || 0}</div>
//             </div>
//             <div>
//               <small className="text-muted">Depot</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.depot || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">State</small>
//               <div className="fw-bold fs-6">{selectedBatchForReport?.state || "N/A"}</div>
//             </div>
//           </div>

//           <label className="mb-2 fw-bold">Select Report Type:</label>
//           <Select
//             options={reportTypeOptions}
//             value={reportTypeOptions.find((opt) => opt.value === selectedReportType)}
//             onChange={(option) => setSelectedReportType(option?.value || "Other")}
//             placeholder="Choose report type..."
//             isSearchable={false}
//           />

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The downloaded file will be a ZIP containing:
//               <ul className="mt-2 mb-0">
//                 <li>Excel report with all student data</li>
//                 <li>Images folder with all uploaded images</li>
//                 <li>Complete with all fields including Pre Test, Post Test, Practical Grade, etc.</li>
//               </ul>
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBatchReportModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="success" onClick={downloadSingleBatchReport}>
//             <DownloadIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download {selectedReportType} Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Individual Batch Simulator Report Modal */}
//       <Modal show={batchSimulatorReportModalShow} centered onHide={() => setBatchSimulatorReportModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download Simulator Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Download Simulator Report for {selectedBatchForSimulatorReport?.batchName || "Batch"}</strong>
//               <small className="d-block text-muted">
//                 Download complete simulator report with all scenarios (PASS/FAIL/NOT_ATTEMPTED)
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batch</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.batchName || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Department</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.department || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.totalStudents || 0}</div>
//             </div>
//             <div>
//               <small className="text-muted">Depot</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.depot || "N/A"}</div>
//             </div>
//             <div>
//               <small className="text-muted">State</small>
//               <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.state || "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The simulator report includes:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
//                 <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//               </ul>
//             </small>
//           </div>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setBatchSimulatorReportModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadSingleBatchSimulatorReport}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download Simulator Report
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Consolidated Report Modal */}
//       <Modal show={consolidatedModalShow} centered onHide={() => setConsolidatedModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Generate Consolidated Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
//             <MergeTypeIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
//             <div>
//               <strong>Single Sheet Consolidated Report</strong>
//               <small className="d-block text-muted">
//                 Combines all data from <strong>{allFilteredBatchCount}</strong> filtered batches into a single Excel sheet
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Process</small>
//               <div className="fw-bold fs-5">{allFilteredBatchCount}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//             <div>
//               <small className="text-muted">Avg Rating</small>
//               <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               This will generate a single Excel file containing all data with:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
//               </ul>
//             </small>
//           </div>

//           {allFilteredBatchCount > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Processing <strong>{allFilteredBatchCount}</strong> batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConsolidatedModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="success" onClick={downloadConsolidatedSimulator}>
//             <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Generate Report ({allFilteredBatchCount} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Consolidated Simulator Report Modal */}
//       <Modal show={consolidatedSimulatorModalShow} centered onHide={() => setConsolidatedSimulatorModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Generate Consolidated Simulator Report</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Single Sheet Consolidated Simulator Report</strong>
//               <small className="d-block text-muted">
//                 Combines all simulator data from <strong>{allFilteredBatchCount}</strong> filtered batches into a single Excel sheet
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Process</small>
//               <div className="fw-bold fs-5">{allFilteredBatchCount}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//             <div>
//               <small className="text-muted">Avg Rating</small>
//               <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               This will generate a single Excel file containing simulator data:
//               <ul className="mt-2 mb-0">
//                 <li>All student details with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
//                 <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//                 <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
//               </ul>
//             </small>
//           </div>

//           {allFilteredBatchCount > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Processing <strong>{allFilteredBatchCount}</strong> batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setConsolidatedSimulatorModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadConsolidatedSimulator}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Generate Simulator Report ({allFilteredBatchCount} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ZIP Download Modal */}
//       <Modal show={zipDownloadModalShow} centered onHide={() => setZipDownloadModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download All Batches as ZIP</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ArchiveIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Batch-wise ZIP Download with Images</strong>
//               <small className="d-block text-muted">
//                 Downloads each batch's report as a separate folder in a single ZIP file
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Download</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//           </div>

//           <label className="mb-2 fw-bold">Report Type:</label>
//           <Select
//             options={zipDownloadOptions}
//             value={zipDownloadOptions.find((opt) => opt.value === selectedZipType)}
//             onChange={(option) => setSelectedZipType(option?.value || "Other")}
//             placeholder="Choose report type..."
//             isSearchable={false}
//           />

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The ZIP file will contain:
//               <ul className="mt-2 mb-0">
//                 <li>Each batch in a separate folder with original report ZIP</li>
//                 <li>Batch_Info.json with complete batch details</li>
//                 <li>Images folder with all uploaded images</li>
//                 <li>Download_Summary.txt with overall statistics</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Downloading {filteredBatches.length} batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setZipDownloadModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadAllBatchesAsZip}>
//             <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download All as ZIP ({filteredBatches.length} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* ZIP Simulator Download Modal */}
//       <Modal show={zipSimulatorDownloadModalShow} centered onHide={() => setZipSimulatorDownloadModalShow(false)} size="lg">
//         <Modal.Header closeButton>
//           <Modal.Title>Download All Simulator Reports as ZIP</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
//             <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
//             <div>
//               <strong>Batch-wise Simulator Reports ZIP Download</strong>
//               <small className="d-block text-muted">
//                 Downloads each batch's simulator report as a separate folder in a single ZIP file
//               </small>
//             </div>
//           </div>

//           <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
//             <div>
//               <small className="text-muted">Batches to Download</small>
//               <div className="fw-bold fs-5">{filteredBatches.length}</div>
//             </div>
//             <div>
//               <small className="text-muted">Total Students</small>
//               <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
//             </div>
//             <div>
//               <small className="text-muted">Pass Rate</small>
//               <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
//             </div>
//           </div>

//           <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
//             <small className="text-info">
//               <i className="fas fa-info-circle me-1"></i>
//               The ZIP file will contain:
//               <ul className="mt-2 mb-0">
//                 <li>Each batch in a separate folder with Simulator_Report.xlsx</li>
//                 <li>Batch_Info.json with complete batch details</li>
//                 <li>Download_Summary.txt with overall statistics</li>
//                 <li>Complete simulator data with all fields from the backend</li>
//                 <li>Post Test Start Date & Post Test End Date</li>
//                 <li>Pre Test & Post Test scores</li>
//                 <li>Student Rating with star ratings</li>
//                 <li>All scenarios (PASS/FAIL/NOT_ATTEMPTED)</li>
//                 <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
//               </ul>
//             </small>
//           </div>

//           {filteredBatches.length > 10 && (
//             <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
//               <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
//                 Downloading {filteredBatches.length} batches may take several minutes. Please be patient.
//               </small>
//             </div>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setZipSimulatorDownloadModalShow(false)}>
//             Cancel
//           </Button>
//           <Button color="primary" onClick={downloadAllBatchesSimulatorAsZip}>
//             <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
//             Download All Simulator Reports ({filteredBatches.length} Batches)
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default connect(null, { setBreadcrumbItems })(AllGroup);











import React, { useEffect, useState, useCallback } from "react";
import { Row, Col, Card, CardBody, CardTitle, Button, Spinner } from "reactstrap";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import { Paper, TextField, LinearProgress, Tooltip, CircularProgress, Box, Typography, Menu, MenuItem } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FilterListIcon from '@mui/icons-material/FilterList';
import RefreshIcon from '@mui/icons-material/Refresh';
import MergeTypeIcon from '@mui/icons-material/MergeType';
import DownloadIcon from '@mui/icons-material/Download';
import ArchiveIcon from '@mui/icons-material/Archive';
import ScienceIcon from '@mui/icons-material/Science';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import axios from "axios";
import JSZip from "jszip";

import Loader from "components/Loader/Loader";
import {
  fetchAllBatchesWithPagination,
  fetchAllBatch,
  fetchAllBatchOfTrainer,
  getAllTrainerOfBatch,
  getAllStudentOfBatch,
  updateBatch,
  deleteBatch,
  batchDetailFile,
} from "helpers/batch_helper";
import { downloadBatchReport, url } from "helpers/url_helper";
import { getResult } from "helpers/exam_helper";
import { fetchAllFeedbackOfBatch, getAllResponsesOfFeedback } from "helpers/feedback_helper";

// ============================
// SIMULATOR API HELPER FUNCTIONS
// ============================
const SIMULATOR_EXCEL_URL = url + "api/simulator/excel/";

const downloadBatchSimulatorReport = (batchId) => {
  return `${SIMULATOR_EXCEL_URL}${batchId}`;
};

// ============================
// SAFE DATE PARSER - FIXES DATE FORMAT ISSUE
// ============================
const parseDateSafely = (dateStr) => {
  if (!dateStr) return null;
  
  if (dateStr instanceof Date) {
    return moment(dateStr);
  }
  
  const str = String(dateStr).trim();
  
  // 1. Try ISO 8601 format (from backend) - most reliable
  if (/^\d{4}-\d{2}-\d{2}/.test(str)) {
    const parsed = moment(str, moment.ISO_8601, true);
    if (parsed.isValid()) return parsed;
  }
  
  // 2. Try DD-MM-YYYY format (Indian format) - EXPLICIT
  if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(str)) {
    const parsed = moment(str, "DD-MM-YYYY", true);
    if (parsed.isValid()) return parsed;
  }
  
  // 3. Try DD/MM/YYYY format
  if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(str)) {
    const parsed = moment(str, "DD/MM/YYYY", true);
    if (parsed.isValid()) return parsed;
  }
  
  // 4. Try with timestamp
  const parsedISO = moment(str, "YYYY-MM-DD HH:mm:ss", true);
  if (parsedISO.isValid()) return parsedISO;
  
  // 5. Fallback
  const fallback = moment(str);
  if (fallback.isValid()) return fallback;
  
  return null;
};

const formatDateForDisplay = (dateStr) => {
  if (!dateStr) return "N/A";
  
  const parsed = parseDateSafely(dateStr);
  if (parsed && parsed.isValid()) {
    return parsed.format("DD-MM-YYYY");
  }
  
  return String(dateStr);
};

const AllGroup = (props) => {
  document.title = "Content Management | All Batches";
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [allBatch, setAllBatch] = useState([]);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [name, setName] = useState("");
  const [id, setId] = useState({});
  const [spanDisplay, setSpanDisplay] = useState("none");

  // ============================
  // PAGINATION STATES
  // ============================
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  // Filter states
  const [filterState, setFilterState] = useState("");
  const [filterDepot, setFilterDepot] = useState("");
  const [filterPeriod, setFilterPeriod] = useState("ALL");
  const [availableStates, setAvailableStates] = useState([]);
  const [availableDepots, setAvailableDepots] = useState([]);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  // Report generation states
  const [consolidatedModalShow, setConsolidatedModalShow] = useState(false);
  const [selectedConsolidatedType, setSelectedConsolidatedType] = useState("Other");
  const [dateRangeModalShow, setDateRangeModalShow] = useState(false);
  const [serialRangeModalShow, setSerialRangeModalShow] = useState(false);
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);
  const [isCustomDateRangeActive, setIsCustomDateRangeActive] = useState(false);
  const [fromSerial, setFromSerial] = useState("");
  const [toSerial, setToSerial] = useState("");

  // Individual Batch Report Download States
  const [batchReportModalShow, setBatchReportModalShow] = useState(false);
  const [selectedBatchForReport, setSelectedBatchForReport] = useState(null);
  const [selectedReportType, setSelectedReportType] = useState("Other");

  // Individual Batch Simulator Report Download States
  const [batchSimulatorReportModalShow, setBatchSimulatorReportModalShow] = useState(false);
  const [selectedBatchForSimulatorReport, setSelectedBatchForSimulatorReport] = useState(null);

  // ZIP Download States
  const [zipDownloadModalShow, setZipDownloadModalShow] = useState(false);
  const [selectedZipType, setSelectedZipType] = useState("Other");

  // ZIP Simulator Download States
  const [zipSimulatorDownloadModalShow, setZipSimulatorDownloadModalShow] = useState(false);

  // Consolidated Simulator Report States
  const [consolidatedSimulatorModalShow, setConsolidatedSimulatorModalShow] = useState(false);

  // Store data maps
  const [batchTrainersMap, setBatchTrainersMap] = useState({});
  const [batchFeedbackRatings, setBatchFeedbackRatings] = useState({});
  const [batchFeedbackCounts, setBatchFeedbackCounts] = useState({});
  const [batchFeedbackGivenCounts, setBatchFeedbackGivenCounts] = useState({});
  const [batchNotFeedbackGivenCounts, setBatchNotFeedbackGivenCounts] = useState({});
  const [loadingRatings, setLoadingRatings] = useState({});
  const [ratingsFetched, setRatingsFetched] = useState(false);

  // Progress tracking
  const [consolidatedProgress, setConsolidatedProgress] = useState({ 
    active: false, 
    current: 0, 
    total: 0, 
    message: "" 
  });

  // ============================
  // NEW STATE: All batches for date range (for reports)
  // ============================
  const [allBatchesForReport, setAllBatchesForReport] = useState([]);
  const [allBatchesForReportCount, setAllBatchesForReportCount] = useState(0);
  const [isFetchingAllBatches, setIsFetchingAllBatches] = useState(false);

  const consolidatedOptions = [
    { value: "DDT", label: "DDT Report (Single Sheet)" },
    { value: "DASP", label: "DASP Report (Single Sheet)" },
    { value: "Other", label: "Other Report (Single Sheet)" },
  ];

  const reportTypeOptions = [
    { value: "DDT", label: "DDT Report" },
    { value: "DASP", label: "DASP Report" },
    { value: "Other", label: "Other Report" },
  ];

  const zipDownloadOptions = [
    { value: "DDT", label: "DDT Reports (Batch-wise ZIP)" },
    { value: "DASP", label: "DASP Reports (Batch-wise ZIP)" },
    { value: "Other", label: "Other Reports (Batch-wise ZIP)" },
  ];

  const periodOptions = [
    { value: "ALL", label: "All Time" },
    { value: "TODAY", label: "Today" },
    { value: "WEEKLY", label: "This Week" },
    { value: "MONTHLY", label: "This Month" },
    { value: "YEARLY", label: "This Year" },
  ];

  const pageSizeOptions = [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const breadcrumbItems = [
    { title: "Batch", link: "#" },
    { title: "All Batches", link: "#" },
  ];

  // ============================
  // COMPUTE DATE RANGE
  // ============================
  const getDateRange = useCallback(() => {
    let startDate = null;
    let endDate = null;
    
    if (isCustomDateRangeActive && customStartDate && customEndDate) {
      startDate = moment(customStartDate).format("YYYY-MM-DD");
      endDate = moment(customEndDate).format("YYYY-MM-DD");
    } else if (filterPeriod !== "ALL") {
      const today = moment().startOf('day');
      switch (filterPeriod) {
        case "TODAY":
          startDate = today.format("YYYY-MM-DD");
          endDate = today.format("YYYY-MM-DD");
          break;
        case "WEEKLY":
          startDate = today.clone().startOf('week').format("YYYY-MM-DD");
          endDate = today.clone().endOf('week').format("YYYY-MM-DD");
          break;
        case "MONTHLY":
          startDate = today.clone().startOf('month').format("YYYY-MM-DD");
          endDate = today.clone().endOf('month').format("YYYY-MM-DD");
          break;
        case "YEARLY":
          startDate = today.clone().startOf('year').format("YYYY-MM-DD");
          endDate = today.clone().endOf('year').format("YYYY-MM-DD");
          break;
        default:
          break;
      }
    }
    
    return { startDate, endDate };
  }, [isCustomDateRangeActive, customStartDate, customEndDate, filterPeriod]);

  // ============================
  // FETCH ALL BATCHES FOR REPORT (DATE RANGE)
  // This fetches ALL batches from database (not just current page)
  // ============================
  const fetchAllBatchesForReport = useCallback(async () => {
    try {
      setIsFetchingAllBatches(true);
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const type = authUser?.userType;

      // For Tata Trainer, use their own batches
      if (type === "Tata Trainer") {
        const res = await fetchAllBatchOfTrainer();
        if (res?.success) {
          let batches = (res.result || []).map(batch => ({
            id: batch.id || batch._id,
            batchName: batch.batchName,
            department: batch.department,
            state: batch.state,
            depot: batch.depot,
            trainingStartDate: batch.trainingStartDate,
            trainingEndDate: batch.trainingEndDate,
            totalStudents: batch.totalStudents || batch.students?.length || 0,
            passedStudents: batch.passedStudents || 0,
            failedStudents: batch.failedStudents || 0,
            notAttemptedStudents: batch.notAttemptedStudents || 0,
            passPercentage: batch.passPercentage || 0,
            trainerNames: batch.trainerNames || "No Trainer Assigned",
            totalTrainers: batch.totalTrainers || 0,
            entryBy: batch.entryBy,
            entryAt: batch.entryAt,
            updatedBy: batch.updatedBy,
            updatedAt: batch.updatedAt,
            feedbackGivenCount: batch.feedbackGivenCount || 0,
            notFeedbackGivenCount: batch.notFeedbackGivenCount || 0
          }));

          // Apply date range filter
          const { startDate, endDate } = getDateRange();
          if (startDate || endDate) {
            const start = startDate ? moment(startDate).startOf('day') : null;
            const end = endDate ? moment(endDate).endOf('day') : null;
            
            batches = batches.filter(batch => {
              if (!batch.trainingStartDate) return false;
              const batchDate = parseDateSafely(batch.trainingStartDate);
              if (!batchDate || !batchDate.isValid()) return false;
              
              if (start && end) {
                return batchDate.isBetween(start, end, null, '[]');
              } else if (start) {
                return batchDate.isSameOrAfter(start);
              } else if (end) {
                return batchDate.isSameOrBefore(end);
              }
              return true;
            });
          }

          // Apply other filters
          if (filterState) batches = batches.filter(b => b.state === filterState);
          if (filterDepot) batches = batches.filter(b => b.depot === filterDepot);
          if (searchText) {
            const search = searchText.toLowerCase().trim();
            batches = batches.filter(batch => 
              (batch.batchName || "").toLowerCase().includes(search) ||
              (batch.department || "").toLowerCase().includes(search) ||
              (batch.depot || "").toLowerCase().includes(search) ||
              (batch.state || "").toLowerCase().includes(search) ||
              (batch.trainerNames || "").toLowerCase().includes(search)
            );
          }

          setAllBatchesForReport(batches);
          setAllBatchesForReportCount(batches.length);
          return batches;
        }
      } else {
        // For Admin/others - fetch ALL from database with high limit
        const { startDate, endDate } = getDateRange();
        
        // Use a very high limit to get all batches for the date range
        const response = await fetchAllBatchesWithPagination(
          0,           // page
          100000,      // pageSize - get all
          startDate,
          endDate,
          filterState || null,
          filterDepot || null,
          searchText || null
        );

        if (response.data?.success) {
          const batches = (response.data.result || []).map(batch => ({
            id: batch.id || batch._id,
            batchName: batch.batchName,
            department: batch.department,
            state: batch.state,
            depot: batch.depot,
            trainingStartDate: batch.trainingStartDate,
            trainingEndDate: batch.trainingEndDate,
            totalStudents: batch.totalStudents || 0,
            passedStudents: batch.passedStudents || 0,
            failedStudents: batch.failedStudents || 0,
            notAttemptedStudents: batch.notAttemptedStudents || 0,
            passPercentage: batch.passPercentage || 0,
            trainerNames: batch.trainerNames || "No Trainer Assigned",
            totalTrainers: batch.totalTrainers || 0,
            entryBy: batch.entryBy,
            entryAt: batch.entryAt,
            updatedBy: batch.updatedBy,
            updatedAt: batch.updatedAt,
            feedbackGivenCount: batch.feedbackGivenCount || 0,
            notFeedbackGivenCount: batch.notFeedbackGivenCount || 0
          }));

          setAllBatchesForReport(batches);
          setAllBatchesForReportCount(batches.length);
          
          // Also fetch trainers for these batches
          if (batches.length > 0) {
            fetchTrainersForBatches(batches);
          }
          
          return batches;
        }
      }
      
      return [];
    } catch (error) {
      console.error("Error fetching all batches for report:", error);
      return [];
    } finally {
      setIsFetchingAllBatches(false);
    }
  }, [getDateRange, filterState, filterDepot, searchText]);

  // ============================
  // AUTO-FETCH ALL BATCHES WHEN DATE RANGE CHANGES
  // ============================
  useEffect(() => {
    // Only fetch when there's a date range or when we need all batches
    const { startDate, endDate } = getDateRange();
    
    // If no date range and no filters, use the current filteredBatches
    if (!startDate && !endDate && !filterState && !filterDepot && !searchText) {
      setAllBatchesForReport(filteredBatches);
      setAllBatchesForReportCount(filteredBatches.length);
      return;
    }
    
    // Debounce the fetch
    const timeoutId = setTimeout(() => {
      fetchAllBatchesForReport();
    }, 500);
    
    return () => clearTimeout(timeoutId);
  }, [isCustomDateRangeActive, customStartDate, customEndDate, filterPeriod, filterState, filterDepot, searchText, getDateRange, fetchAllBatchesForReport, filteredBatches]);

  // ============================
  // FETCH FEEDBACK RATINGS
  // ============================
  const fetchFeedbackRatingsOnly = async (batches) => {
    if (ratingsFetched) return;
    
    const feedbackRatingsMap = {};
    const feedbackCountsMap = {};
    const feedbackGivenCountsMap = {};
    const notFeedbackGivenCountsMap = {};
    
    const asyncPool = async (concurrency, items, iteratorFn) => {
      const results = [];
      const executing = new Set();
      for (const [index, item] of items.entries()) {
        const promise = Promise.resolve().then(() => iteratorFn(item, index));
        results.push(promise);
        executing.add(promise);
        const clean = () => executing.delete(promise);
        promise.then(clean, clean);
        if (executing.size >= concurrency) {
          await Promise.race(executing);
        }
      }
      return Promise.all(results);
    };
    
    await asyncPool(5, batches, async (batch) => {
      const batchId = batch.id || batch._id;
      if (!batchId) return;
      
      try {
        setLoadingRatings(prev => ({ ...prev, [batchId]: true }));
        
        const feedbacksResponse = await fetchAllFeedbackOfBatch(batchId);
        
        if (!feedbacksResponse?.success || !feedbacksResponse?.result?.length) {
          feedbackRatingsMap[batchId] = null;
          feedbackCountsMap[batchId] = 0;
          feedbackGivenCountsMap[batchId] = 0;
          notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
          return;
        }

        let totalRatingSum = 0;
        let totalResponseCount = 0;
        let totalFeedbackGiven = 0;

        for (const feedback of feedbacksResponse.result) {
          const responsesResponse = await getAllResponsesOfFeedback(feedback.id);
          
          if (responsesResponse?.success && responsesResponse?.responseResult?.length) {
            const feedbackRatingSum = responsesResponse.responseResult.reduce(
              (sum, response) => sum + (response.rating || 0), 
              0
            );
            totalRatingSum += feedbackRatingSum;
            totalResponseCount += responsesResponse.responseResult.length;
            totalFeedbackGiven += responsesResponse.responseResult.length;
          }
        }

        const averageRating = totalResponseCount > 0 ? totalRatingSum / totalResponseCount : null;
        const totalStudents = batch.totalStudents || 0;
        const notFeedbackGiven = totalStudents - totalFeedbackGiven;
        
        feedbackRatingsMap[batchId] = averageRating;
        feedbackCountsMap[batchId] = totalResponseCount;
        feedbackGivenCountsMap[batchId] = totalFeedbackGiven;
        notFeedbackGivenCountsMap[batchId] = notFeedbackGiven > 0 ? notFeedbackGiven : 0;
        
        setBatchFeedbackRatings(prev => ({ ...prev, [batchId]: averageRating }));
        setBatchFeedbackCounts(prev => ({ ...prev, [batchId]: totalResponseCount }));
        setBatchFeedbackGivenCounts(prev => ({ ...prev, [batchId]: totalFeedbackGiven }));
        setBatchNotFeedbackGivenCounts(prev => ({ ...prev, [batchId]: notFeedbackGiven > 0 ? notFeedbackGiven : 0 }));
      } catch (error) {
        console.error(`Error fetching feedback rating for batch ${batchId}:`, error);
        feedbackRatingsMap[batchId] = null;
        feedbackCountsMap[batchId] = 0;
        feedbackGivenCountsMap[batchId] = 0;
        notFeedbackGivenCountsMap[batchId] = batch.totalStudents || 0;
      } finally {
        setLoadingRatings(prev => ({ ...prev, [batchId]: false }));
      }
    });
    
    setRatingsFetched(true);
  };

  // ============================
  // FETCH TRAINERS FOR BATCHES
  // ============================
  const fetchTrainersForBatches = async (batches) => {
    const trainersMap = { ...batchTrainersMap };
    
    const asyncPool = async (concurrency, items, iteratorFn) => {
      const results = [];
      const executing = new Set();
      for (const [index, item] of items.entries()) {
        const promise = Promise.resolve().then(() => iteratorFn(item, index));
        results.push(promise);
        executing.add(promise);
        const clean = () => executing.delete(promise);
        promise.then(clean, clean);
        if (executing.size >= concurrency) {
          await Promise.race(executing);
        }
      }
      return Promise.all(results);
    };
    
    await asyncPool(5, batches, async (batch) => {
      const batchId = batch.id || batch._id;
      if (!batchId) return;
      // Skip if already have trainers for this batch
      if (trainersMap[batchId] && trainersMap[batchId].length > 0) return;
      try {
        const trainers = await getAllTrainerOfBatch(batchId).catch(() => []);
        trainersMap[batchId] = trainers?.success ? trainers.result || [] : [];
      } catch (error) {
        trainersMap[batchId] = [];
      }
    });
    
    setBatchTrainersMap(trainersMap);
  };

  // ============================
  // GET ALL BATCHES WITH PAGINATION
  // ============================
  const getAllBatches = useCallback(async () => {
    try {
      setLoader(true);
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      const type = authUser?.userType;
      
      if (type === "Tata Trainer") {
        const res = await fetchAllBatchOfTrainer();
        if (res?.success) {
          let batches = (res.result || []).map(batch => ({
            id: batch.id || batch._id,
            batchName: batch.batchName,
            department: batch.department,
            state: batch.state,
            depot: batch.depot,
            trainingStartDate: batch.trainingStartDate,
            trainingEndDate: batch.trainingEndDate,
            totalStudents: batch.totalStudents || batch.students?.length || 0,
            passedStudents: batch.passedStudents || 0,
            failedStudents: batch.failedStudents || 0,
            notAttemptedStudents: batch.notAttemptedStudents || 0,
            passPercentage: batch.passPercentage || 0,
            trainerNames: batch.trainerNames || "No Trainer Assigned",
            totalTrainers: batch.totalTrainers || 0,
            entryBy: batch.entryBy,
            entryAt: batch.entryAt,
            updatedBy: batch.updatedBy,
            updatedAt: batch.updatedAt,
            feedbackGivenCount: batch.feedbackGivenCount || 0,
            notFeedbackGivenCount: batch.notFeedbackGivenCount || 0
          }));

          // Apply date range filter
          const { startDate, endDate } = getDateRange();
          if (startDate || endDate) {
            const start = startDate ? moment(startDate).startOf('day') : null;
            const end = endDate ? moment(endDate).endOf('day') : null;
            
            batches = batches.filter(batch => {
              if (!batch.trainingStartDate) return false;
              const batchDate = parseDateSafely(batch.trainingStartDate);
              if (!batchDate || !batchDate.isValid()) return false;
              
              if (start && end) {
                return batchDate.isBetween(start, end, null, '[]');
              } else if (start) {
                return batchDate.isSameOrAfter(start);
              } else if (end) {
                return batchDate.isSameOrBefore(end);
              }
              return true;
            });
          }

          if (filterState) batches = batches.filter(b => b.state === filterState);
          if (filterDepot) batches = batches.filter(b => b.depot === filterDepot);
          if (searchText) {
            const search = searchText.toLowerCase().trim();
            batches = batches.filter(batch => 
              (batch.batchName || "").toLowerCase().includes(search) ||
              (batch.department || "").toLowerCase().includes(search) ||
              (batch.depot || "").toLowerCase().includes(search) ||
              (batch.state || "").toLowerCase().includes(search) ||
              (batch.trainerNames || "").toLowerCase().includes(search)
            );
          }

          setAllBatch(batches);
          setFilteredBatches(batches);
          setTotalItems(batches.length);
          setTotalPages(Math.ceil(batches.length / pageSize));
          updateAvailableFilters(batches);
          
          if (batches.length > 0) {
            await Promise.all([
              fetchTrainersForBatches(batches),
              fetchFeedbackRatingsOnly(batches)
            ]);
          }
        }
      } else {
        const { startDate, endDate } = getDateRange();
        
        const response = await fetchAllBatchesWithPagination(
          page, 
          pageSize, 
          startDate, 
          endDate, 
          filterState || null, 
          filterDepot || null, 
          searchText || null
        );
        
        if (response.data?.success) {
          const batches = (response.data.result || []).map(batch => ({
            id: batch.id || batch._id,
            batchName: batch.batchName,
            department: batch.department,
            state: batch.state,
            depot: batch.depot,
            trainingStartDate: batch.trainingStartDate,
            trainingEndDate: batch.trainingEndDate,
            totalStudents: batch.totalStudents || 0,
            passedStudents: batch.passedStudents || 0,
            failedStudents: batch.failedStudents || 0,
            notAttemptedStudents: batch.notAttemptedStudents || 0,
            passPercentage: batch.passPercentage || 0,
            trainerNames: batch.trainerNames || "No Trainer Assigned",
            totalTrainers: batch.totalTrainers || 0,
            entryBy: batch.entryBy,
            entryAt: batch.entryAt,
            updatedBy: batch.updatedBy,
            updatedAt: batch.updatedAt,
            feedbackGivenCount: batch.feedbackGivenCount || 0,
            notFeedbackGivenCount: batch.notFeedbackGivenCount || 0
          }));
          
          setAllBatch(batches);
          setFilteredBatches(batches);
          setTotalItems(response.data.totalItems || 0);
          setTotalPages(response.data.totalPages || 0);
          
          updateAvailableFilters(batches);
          
          if (batches.length > 0) {
            await Promise.all([
              fetchTrainersForBatches(batches),
              fetchFeedbackRatingsOnly(batches)
            ]);
          }
          
          if (batches.length === 0) {
            toast.info("No batches found for the selected filters");
          }
        } else {
          toast.error(response.data?.message || "Failed to load batches");
        }
      }
    } catch (error) {
      console.error("Error in getAllBatches:", error);
      toast.error(error?.response?.data?.message || "Failed to load batches");
    } finally {
      setLoader(false);
    }
  }, [page, pageSize, filterState, filterDepot, filterPeriod, searchText, customStartDate, customEndDate, isCustomDateRangeActive, getDateRange]);

  // ============================
  // UPDATE AVAILABLE FILTERS
  // ============================
  const updateAvailableFilters = (batches) => {
    const uniqueStates = new Set();
    const uniqueDepots = new Set();
    batches.forEach(batch => {
      if (batch.state) uniqueStates.add(batch.state);
      if (batch.depot) uniqueDepots.add(batch.depot);
    });
    setAvailableStates([...uniqueStates]);
    setAvailableDepots([...uniqueDepots]);
  };

  // ============================
  // DOWNLOAD SINGLE BATCH REPORT
  // ============================
  const downloadSingleBatchReport = async () => {
    if (!selectedBatchForReport) {
      toast.error("No batch selected");
      return;
    }

    try {
      setLoader(true);
      setBatchReportModalShow(false);
      
      const batchId = selectedBatchForReport.id;
      const batchName = selectedBatchForReport.batchName || "Batch";
      
      toast.info(`Downloading ${selectedReportType} report for ${batchName}...`);
      
      const apiUrl = `${downloadBatchReport}${batchId}?type=${selectedReportType}`;
      const response = await axios.get(apiUrl, { 
        responseType: "blob", 
        timeout: 120000
      });
      
      if (!response.data || response.data.size === 0) {
        toast.error("No data received from server");
        return;
      }
      
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `${batchName}_${selectedReportType}_Report.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
      
      toast.success(`${selectedReportType} report downloaded for ${batchName}`);
      
    } catch (error) {
      console.error(`Error downloading report:`, error);
      toast.error(`Failed to download report: ${error.message}`);
    } finally {
      setLoader(false);
      setSelectedBatchForReport(null);
    }
  };

  // ============================
  // DOWNLOAD SINGLE BATCH SIMULATOR REPORT
  // ============================
  const downloadSingleBatchSimulatorReport = async () => {
    if (!selectedBatchForSimulatorReport) {
      toast.error("No batch selected");
      return;
    }

    try {
      setLoader(true);
      setBatchSimulatorReportModalShow(false);
      
      const batchId = selectedBatchForSimulatorReport.id;
      const batchName = selectedBatchForSimulatorReport.batchName || "Batch";
      
      toast.info(`Downloading Simulator report for ${batchName}...`);
      
      const apiUrl = downloadBatchSimulatorReport(batchId);
      const response = await axios.get(apiUrl, { 
        responseType: "blob", 
        timeout: 120000
      });
      
      if (!response.data || response.data.size === 0) {
        toast.error("No data received from server");
        return;
      }
      
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `${batchName}_Simulator_Report.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
      
      toast.success(`Simulator report downloaded for ${batchName}`);
      
    } catch (error) {
      console.error(`Error downloading simulator report:`, error);
      toast.error(`Failed to download simulator report: ${error.message}`);
    } finally {
      setLoader(false);
      setSelectedBatchForSimulatorReport(null);
    }
  };

  // ============================
  // OPEN BATCH REPORT MODAL
  // ============================
  const openBatchReportModal = (batch) => {
    setSelectedBatchForReport(batch);
    setSelectedReportType("Other");
    setBatchReportModalShow(true);
  };

  // ============================
  // OPEN BATCH SIMULATOR REPORT MODAL
  // ============================
  const openBatchSimulatorReportModal = (batch) => {
    setSelectedBatchForSimulatorReport(batch);
    setBatchSimulatorReportModalShow(true);
  };

  // ============================
  // EXTRACT STUDENTS FROM SIMULATOR EXCEL
  // ============================
  const extractStudentsFromSimulatorExcel = async (excelBlob, batchInfo) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          
          const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
          if (!rows || rows.length === 0) {
            resolve([]);
            return;
          }
          
          let headers = [];
          let dataStartRow = 0;
          let scenarioColumnMap = {};
          
          const scenarioNames = [
            'Simulator(City_Driving)', 
            'Simulator(Highway_Driving)', 
            'Simulator(Practice_Area)', 
            'Simulator(Country_Driving)', 
            'Simulator(Hill_Driving)'
          ];
          
          const scenarioShortNames = [
            'City_Driving', 'Highway_Driving', 'Practice_Area', 
            'Country_Driving', 'Hill_Driving'
          ];
          
          for (let i = 0; i < Math.min(rows.length, 50); i++) {
            const row = rows[i];
            if (row && Array.isArray(row)) {
              const rowStr = JSON.stringify(row).toLowerCase();
              
              const hasScenarioHeaders = scenarioShortNames.some(scenario => 
                rowStr.includes(scenario.toLowerCase())
              );
              
              if (hasScenarioHeaders || 
                  (rowStr.includes('s.no') || rowStr.includes('serial')) && 
                  (rowStr.includes('name') || rowStr.includes('participant') || rowStr.includes('employee'))) {
                headers = row;
                dataStartRow = i + 1;
                
                headers.forEach((header, index) => {
                  const headerStr = String(header).trim();
                  
                  scenarioNames.forEach(scenario => {
                    if (headerStr === scenario) {
                      scenarioColumnMap[scenario] = index;
                    }
                  });
                  
                  scenarioShortNames.forEach((scenario, idx) => {
                    if (headerStr.includes(scenario)) {
                      const fullName = scenarioNames[idx];
                      if (!scenarioColumnMap[fullName]) {
                        scenarioColumnMap[fullName] = index;
                      }
                    }
                  });
                });
                break;
              }
            }
          }
          
          if (headers.length === 0 && rows.length > 0) {
            headers = rows[0];
            dataStartRow = 1;
            
            headers.forEach((header, index) => {
              const headerStr = String(header).trim();
              scenarioShortNames.forEach((scenario, idx) => {
                if (headerStr.includes(scenario)) {
                  const fullName = scenarioNames[idx];
                  scenarioColumnMap[fullName] = index;
                }
              });
            });
          }
          
          const students = [];
          
          for (let i = dataStartRow; i < rows.length; i++) {
            const row = rows[i];
            if (!row || !Array.isArray(row)) continue;
            
            const hasData = row.some(cell => cell && String(cell).trim() !== '');
            if (!hasData) continue;
            
            const student = {};
            headers.forEach((header, idx) => {
              if (header && idx < row.length) {
                const headerKey = String(header).trim();
                const value = row[idx] !== undefined && row[idx] !== null ? row[idx] : "";
                student[headerKey] = value;
              }
            });
            
            if (!student["Training Name"] && batchInfo.batchName) {
              student["Training Name"] = batchInfo.batchName;
            }
            if (!student["Trainer Name"] && batchInfo.trainerName) {
              student["Trainer Name"] = batchInfo.trainerName;
            }
            if (!student["Depot Manager Name"] && batchInfo.depotManagerName) {
              student["Depot Manager Name"] = batchInfo.depotManagerName;
            }
            if (!student["Depot (Training)"] && batchInfo.depot) {
              student["Depot (Training)"] = batchInfo.depot;
            }
            if (!student["State (Training)"] && batchInfo.state) {
              student["State (Training)"] = batchInfo.state;
            }
            if (!student["Training Start Date"] && batchInfo.startDate) {
              student["Training Start Date"] = batchInfo.startDate;
            }
            if (!student["Training End Date"] && batchInfo.endDate) {
              student["Training End Date"] = batchInfo.endDate;
            }
            if (!student["Type"] && batchInfo.type) {
              student["Type"] = batchInfo.type;
            }
            
            scenarioNames.forEach(scenario => {
              const columnIndex = scenarioColumnMap[scenario];
              let value = "NOT_ATTEMPTED";
              
              if (columnIndex !== undefined && row[columnIndex] !== undefined && row[columnIndex] !== null) {
                value = String(row[columnIndex]).trim();
                if (value === "" || value === "undefined" || value === "null") {
                  value = "NOT_ATTEMPTED";
                }
              } else {
                const scenarioKey = Object.keys(student).find(key => 
                  key.includes(scenario) || key.includes(scenarioShortNames[scenarioNames.indexOf(scenario)])
                );
                if (scenarioKey && student[scenarioKey] !== undefined) {
                  value = String(student[scenarioKey]).trim();
                  if (value === "" || value === "undefined" || value === "null") {
                    value = "NOT_ATTEMPTED";
                  }
                }
              }
              
              const upperValue = value.toUpperCase();
              if (upperValue.includes('PASS')) {
                student[scenario] = "PASS";
              } else if (upperValue.includes('FAIL')) {
                student[scenario] = "FAIL";
              } else {
                student[scenario] = "NOT_ATTEMPTED";
              }
            });
            
            if (student["Participant Name"] || student["Employee Id"] || student["Name"]) {
              if (!student["Participant Name"] && student["Name"]) {
                student["Participant Name"] = student["Name"];
              }
              
              let totalSimDuration = 0;
              let durationFound = false;
              
              Object.keys(student).forEach(key => {
                if (key.toLowerCase().includes('total sim duration') || 
                    key.toLowerCase().includes('total duration') || 
                    key.toLowerCase().includes('sim duration')) {
                  const durationValue = parseFloat(student[key]);
                  if (!isNaN(durationValue) && durationValue > 0) {
                    totalSimDuration = durationValue;
                    durationFound = true;
                  }
                }
              });
              
              if (!durationFound) {
                Object.keys(student).forEach(key => {
                  if (key.toLowerCase().includes('duration') && 
                      !key.toLowerCase().includes('total')) {
                    const durationValue = parseFloat(student[key]);
                    if (!isNaN(durationValue) && durationValue > 0) {
                      totalSimDuration += durationValue;
                      durationFound = true;
                    }
                  }
                });
              }
              
              if (!durationFound) {
                const durationKey = Object.keys(student).find(key => 
                  key.includes('Total Sim Duration') || key.includes('Total Duration')
                );
                if (durationKey) {
                  const durationValue = parseFloat(student[durationKey]);
                  if (!isNaN(durationValue) && durationValue > 0) {
                    totalSimDuration = durationValue;
                  }
                }
              }
              
              student["Total Sim Duration (min)"] = totalSimDuration.toFixed(1);
              
              let passCount = 0;
              let failCount = 0;
              let notAttemptedCount = 0;
              
              scenarioNames.forEach(scenario => {
                const value = String(student[scenario] || "NOT_ATTEMPTED").toUpperCase();
                if (value === 'PASS') {
                  passCount++;
                } else if (value === 'FAIL') {
                  failCount++;
                } else {
                  notAttemptedCount++;
                }
              });
              
              if (passCount > 0 && failCount === 0 && notAttemptedCount === 0) {
                student["Fail/Pass"] = "Pass";
              } else if (failCount > 0) {
                student["Fail/Pass"] = "Fail";
              } else if (passCount === 0 && failCount === 0 && notAttemptedCount > 0) {
                student["Fail/Pass"] = "Not Attempted";
              } else if (passCount > 0 && notAttemptedCount > 0) {
                student["Fail/Pass"] = "Pass";
              } else {
                student["Fail/Pass"] = "Not Attempted";
              }
              
              const requiredColumns = [
                "S.No.", "Training Name", "Trainer Name", "Depot Manager Name",
                "Depot (Training)", "Type", "State (Training)",
                "Training Start Date", "Training End Date",
                "Depot (Student)", "State (Student)", "Candidate Assigned by", 
                "Company", "Employee Id", "Aadhaar Number", "Phone Number", 
                "Email Id", "Participant Name", "Father Name", "Designation", 
                "Date of Service", "Last Attend Date", "Attendance Days",
                "Post Test Start Date", "Post Test End Date", "Pre Test", 
                "Post Test", "Practical Grade", "Student Rating", "Remarks"
              ];
              
              requiredColumns.forEach(col => {
                if (!student[col] || student[col] === "" || student[col] === "undefined") {
                  if (col === "Attendance Days") {
                    student[col] = 0;
                  } else if (col === "Pre Test" || col === "Post Test") {
                    student[col] = "0%";
                  } else if (col === "Practical Grade") {
                    student[col] = "Not Attempted";
                  } else if (col === "Student Rating") {
                    student[col] = "";
                  } else {
                    student[col] = "";
                  }
                }
              });
              
              students.push(student);
            }
          }
          
          resolve(students);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(excelBlob);
    });
  };

  // ============================
  // DOWNLOAD ALL BATCHES SIMULATOR AS ZIP
  // NOW USES ALL BATCHES FOR DATE RANGE (NOT JUST CURRENT PAGE)
  // ============================
  const downloadAllBatchesSimulatorAsZip = async () => {
    try {
      setLoader(true);
      setZipSimulatorDownloadModalShow(false);
      
      setConsolidatedProgress({
        active: true,
        current: 0,
        total: 0,
        message: `Fetching all batches for the selected filters...`
      });

      // Fetch ALL batches for the date range (not just current page)
      const batchesToProcess = await fetchAllBatchesForReport();
      
      if (!batchesToProcess || batchesToProcess.length === 0) {
        toast.error("No batches to download");
        setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
        setLoader(false);
        return;
      }
      
      // Fetch trainers and feedback for these batches (if not already)
      await fetchTrainersForBatches(batchesToProcess);
      await fetchFeedbackRatingsOnly(batchesToProcess);

      setConsolidatedProgress({
        active: true,
        current: 0,
        total: batchesToProcess.length,
        message: `Downloading Simulator reports for ${batchesToProcess.length} batches...`
      });

      const mainZip = new JSZip();
      const timestamp = moment().format("DD-MM-YYYY_HHmmss");
      const reportsFolder = mainZip.folder(`All_Simulator_Reports_${timestamp}`);

      let successCount = 0;
      let failCount = 0;
      const failedBatches = [];

      for (let i = 0; i < batchesToProcess.length; i++) {
        const batch = batchesToProcess[i];
        
        setConsolidatedProgress({
          active: true,
          current: i + 1,
          total: batchesToProcess.length,
          message: `Downloading ${i + 1}/${batchesToProcess.length}: ${batch.batchName} Simulator Report`
        });
        
        try {
          const apiUrl = downloadBatchSimulatorReport(batch.id);
          const response = await axios.get(apiUrl, { 
            responseType: "blob", 
            timeout: 120000
          });
          
          if (response.data && response.data.size > 0) {
            const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
            const batchFolder = reportsFolder.folder(batchFolderName);
            
            batchFolder.file(`Simulator_Report.xlsx`, response.data);
            
            const trainers = batchTrainersMap[batch.id] || [];
            const trainerName = formatTrainerNames(trainers);
            const feedbackRating = batchFeedbackRatings[batch.id];
            const feedbackCount = batchFeedbackCounts[batch.id] || 0;
            const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
            const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
            const batchInfo = {
              batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
              batchName: batch.batchName,
              batchId: batch.id,
              department: batch.department,
              depot: batch.depot,
              state: batch.state,
              startDate: formatDateForDisplay(batch.trainingStartDate),
              endDate: formatDateForDisplay(batch.trainingEndDate),
              trainers: trainers.map(t => ({
                id: t.id,
                name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
              })),
              trainerName: trainerName,
              totalStudents: batch.totalStudents || 0,
              passedStudents: batch.passedStudents || 0,
              failedStudents: batch.failedStudents || 0,
              notAttemptedStudents: batch.notAttemptedStudents || 0,
              passPercentage: batch.passPercentage || 0,
              feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
              feedbackCount: feedbackCount,
              feedbackGivenCount: feedbackGivenCount,
              notFeedbackGivenCount: notFeedbackGivenCount,
              reportType: "Simulator",
              downloadedAt: new Date().toISOString()
            };
            
            batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
            successCount++;
          } else {
            failCount++;
            failedBatches.push({ name: batch.batchName, error: "Empty response" });
          }
        } catch (error) {
          console.error(`Error downloading simulator report for batch ${batch.batchName}:`, error);
          failCount++;
          failedBatches.push({ name: batch.batchName, error: error.message });
        }
      }

      const summaryReport = [
        "SIMULATOR DOWNLOAD SUMMARY",
        "========================",
        `Report Type: Simulator`,
        `Date: ${moment().format("DD-MM-YYYY HH:mm:ss")}`,
        `Total Batches: ${batchesToProcess.length}`,
        `Successfully Downloaded: ${successCount}`,
        `Failed: ${failCount}`,
        "",
        failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
        ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
        "",
        "BATCH SUMMARY",
        "==============",
        ...batchesToProcess.map((batch, idx) => {
          const rating = batchFeedbackRatings[batch.id];
          const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
          const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
          return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
        })
      ].join("\n");

      reportsFolder.file("Download_Summary.txt", summaryReport);
      setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

      const finalZipBlob = await mainZip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
        compressionOptions: { level: 6 },
      });

      const downloadUrl = window.URL.createObjectURL(finalZipBlob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `All_Batches_Simulator_Reports_${timestamp}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      if (failCount === 0) {
        toast.success(`All ${successCount} simulator reports downloaded successfully!`);
      } else {
        toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
      }
    } catch (error) {
      console.error("Error downloading simulator reports:", error);
      toast.error("Error downloading simulator reports: " + (error.message || "Unknown error"));
      setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
    } finally {
      setLoader(false);
    }
  };

  // ============================
  // DOWNLOAD ALL BATCHES AS ZIP WITH IMAGES
  // NOW USES ALL BATCHES FOR DATE RANGE (NOT JUST CURRENT PAGE)
  // ============================
  const downloadAllBatchesAsZip = async () => {
    try {
      setLoader(true);
      setZipDownloadModalShow(false);
      
      setConsolidatedProgress({
        active: true,
        current: 0,
        total: 0,
        message: `Fetching all batches for the selected filters...`
      });

      // Fetch ALL batches for the date range (not just current page)
      const batchesToProcess = await fetchAllBatchesForReport();
      
      if (!batchesToProcess || batchesToProcess.length === 0) {
        toast.error("No batches to download");
        setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
        setLoader(false);
        return;
      }
      
      // Fetch trainers and feedback for these batches
      await fetchTrainersForBatches(batchesToProcess);
      await fetchFeedbackRatingsOnly(batchesToProcess);
      
      setConsolidatedProgress({
        active: true,
        current: 0,
        total: batchesToProcess.length,
        message: `Downloading ${selectedZipType} reports for ${batchesToProcess.length} batches...`
      });

      const mainZip = new JSZip();
      const timestamp = moment().format("DD-MM-YYYY_HHmmss");
      const reportsFolder = mainZip.folder(`All_Reports_${selectedZipType}_${timestamp}`);

      let successCount = 0;
      let failCount = 0;
      const failedBatches = [];

      for (let i = 0; i < batchesToProcess.length; i++) {
        const batch = batchesToProcess[i];
        
        setConsolidatedProgress({
          active: true,
          current: i + 1,
          total: batchesToProcess.length,
          message: `Downloading ${i + 1}/${batchesToProcess.length}: ${batch.batchName}`
        });
        
        try {
          const apiUrl = `${downloadBatchReport}${batch.id}?type=${selectedZipType}`;
          const response = await axios.get(apiUrl, { 
            responseType: "blob", 
            timeout: 120000
          });
          
          if (response.data && response.data.size > 0) {
            const batchFolderName = `${String(i + 1).padStart(3, '0')}_${batch.batchName || batch.id}`.replace(/[\\/:*?"<>|]/g, '_');
            const batchFolder = reportsFolder.folder(batchFolderName);
            
            batchFolder.file(`${selectedZipType}_Report.zip`, response.data);
            
            const trainers = batchTrainersMap[batch.id] || [];
            const trainerName = formatTrainerNames(trainers);
            const feedbackRating = batchFeedbackRatings[batch.id];
            const feedbackCount = batchFeedbackCounts[batch.id] || 0;
            const feedbackGivenCount = batchFeedbackGivenCounts[batch.id] || 0;
            const notFeedbackGivenCount = batchNotFeedbackGivenCounts[batch.id] || 0;
            
            const batchInfo = {
              batchSerialNo: `BATCH-${String(i + 1).padStart(3, '0')}`,
              batchName: batch.batchName,
              batchId: batch.id,
              department: batch.department,
              depot: batch.depot,
              state: batch.state,
              startDate: formatDateForDisplay(batch.trainingStartDate),
              endDate: formatDateForDisplay(batch.trainingEndDate),
              trainers: trainers.map(t => ({
                id: t.id,
                name: t.name || `${t.firstName || ""} ${t.lastName || ""}`.trim(),
              })),
              trainerName: trainerName,
              totalStudents: batch.totalStudents || 0,
              passedStudents: batch.passedStudents || 0,
              failedStudents: batch.failedStudents || 0,
              notAttemptedStudents: batch.notAttemptedStudents || 0,
              passPercentage: batch.passPercentage || 0,
              feedbackRating: feedbackRating ? `${feedbackRating.toFixed(2)}/5.0` : "No Rating",
              feedbackCount: feedbackCount,
              feedbackGivenCount: feedbackGivenCount,
              notFeedbackGivenCount: notFeedbackGivenCount,
              reportType: selectedZipType,
              downloadedAt: new Date().toISOString()
            };
            
            batchFolder.file("Batch_Info.json", JSON.stringify(batchInfo, null, 2));
            
            try {
              const downloadedZip = await JSZip.loadAsync(response.data);
              const imageFiles = Object.keys(downloadedZip.files).filter(
                filename => filename.startsWith('images/') && 
                (filename.endsWith('.jpg') || filename.endsWith('.jpeg') || filename.endsWith('.png') || filename.endsWith('.gif'))
              );
              
              if (imageFiles.length > 0) {
                const imagesFolder = batchFolder.folder("Images");
                for (const imageFile of imageFiles) {
                  const imageData = await downloadedZip.files[imageFile].async("blob");
                  const imageName = imageFile.split('/').pop();
                  imagesFolder.file(imageName, imageData);
                }
              }
            } catch (imageError) {
              console.log(`No images found for batch ${batch.batchName}`);
            }
            
            successCount++;
          } else {
            failCount++;
            failedBatches.push({ name: batch.batchName, error: "Empty response" });
          }
        } catch (error) {
          console.error(`Error downloading batch ${batch.batchName}:`, error);
          failCount++;
          failedBatches.push({ name: batch.batchName, error: error.message });
        }
      }

      const summaryReport = [
        "DOWNLOAD SUMMARY",
        "================",
        `Report Type: ${selectedZipType}`,
        `Date: ${moment().format("DD-MM-YYYY HH:mm:ss")}`,
        `Total Batches: ${batchesToProcess.length}`,
        `Successfully Downloaded: ${successCount}`,
        `Failed: ${failCount}`,
        "",
        failCount > 0 ? "FAILED BATCHES:" : "All batches downloaded successfully!",
        ...failedBatches.map((f, idx) => `${idx + 1}. ${f.name} - ${f.error}`),
        "",
        "BATCH SUMMARY",
        "==============",
        ...batchesToProcess.map((batch, idx) => {
          const rating = batchFeedbackRatings[batch.id];
          const feedbackGiven = batchFeedbackGivenCounts[batch.id] || 0;
          const notFeedbackGiven = batchNotFeedbackGivenCounts[batch.id] || 0;
          return `${idx + 1}. ${batch.batchName} - Students: ${batch.totalStudents || 0}, Passed: ${batch.passedStudents || 0}, Failed: ${batch.failedStudents || 0}, Rating: ${rating ? rating.toFixed(2) + "/5.0" : "No Rating"}, Feedback Given: ${feedbackGiven}, Not Given: ${notFeedbackGiven}`;
        })
      ].join("\n");

      reportsFolder.file("Download_Summary.txt", summaryReport);
      setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });

      const finalZipBlob = await mainZip.generateAsync({
        type: "blob",
        compression: "DEFLATE",
        compressionOptions: { level: 6 },
      });

      const downloadUrl = window.URL.createObjectURL(finalZipBlob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", `All_Batches_${selectedZipType}_${timestamp}.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      if (failCount === 0) {
        toast.success(`All ${successCount} batches downloaded successfully with images!`);
      } else {
        toast.warning(`${successCount} downloaded, ${failCount} failed. Check Download_Summary.txt for details.`);
      }
    } catch (error) {
      console.error("Error downloading all reports:", error);
      toast.error("Error downloading reports: " + (error.message || "Unknown error"));
      setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
    } finally {
      setLoader(false);
    }
  };

  // ============================
  // GENERATE CONSOLIDATED SIMULATOR REPORT
  // NOW USES ALL BATCHES FOR DATE RANGE
  // ============================
  const generateConsolidatedSimulatorReport = async () => {
    try {
      setLoader(true);
      setConsolidatedSimulatorModalShow(false);
      
      setConsolidatedProgress({
        active: true,
        current: 0,
        total: 0,
        message: `Fetching all batches for the selected filters...`
      });

      // Fetch ALL batches for the date range
      const batchesToProcess = await fetchAllBatchesForReport();
      
      if (!batchesToProcess || batchesToProcess.length === 0) {
        toast.error("No batches to process");
        setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
        setLoader(false);
        return;
      }
      
      await fetchTrainersForBatches(batchesToProcess);
      await fetchFeedbackRatingsOnly(batchesToProcess);
      
      setConsolidatedProgress({
        active: true,
        current: 0,
        total: batchesToProcess.length,
        message: `Fetching Simulator reports for ${batchesToProcess.length} batches...`
      });

      const allStudents = [];
      let failedBatches = [];
      let totalSerialNo = 1;

      const scenarioNames = [
        'Simulator(City_Driving)', 
        'Simulator(Highway_Driving)', 
        'Simulator(Practice_Area)', 
        'Simulator(Country_Driving)', 
        'Simulator(Hill_Driving)'
      ];

      for (let i = 0; i < batchesToProcess.length; i++) {
        const batch = batchesToProcess[i];
        
        setConsolidatedProgress({
          active: true,
          current: i + 1,
          total: batchesToProcess.length,
          message: `Processing batch ${i + 1}/${batchesToProcess.length}: ${batch.batchName} Simulator Report`
        });

        try {
          const apiUrl = downloadBatchSimulatorReport(batch.id);
          const response = await axios.get(apiUrl, { 
            responseType: "blob", 
            timeout: 120000
          });
          
          if (!response.data || response.data.size === 0) {
            failedBatches.push({ name: batch.batchName, error: "No data received" });
            continue;
          }

          const excelBlob = response.data;
          
          const trainers = batchTrainersMap[batch.id] || [];
          const trainerName = formatTrainerNames(trainers);
          
          let depotManagerName = "";
          try {
            if (trainers.length > 0) {
              depotManagerName = "Mohd Haque";
            }
          } catch (e) {
            depotManagerName = "";
          }
          
          const batchInfo = {
            batchId: batch.id,
            batchName: batch.batchName,
            trainerName: trainerName,
            depotManagerName: depotManagerName,
            depot: batch.depot,
            state: batch.state,
            type: batch.department || "",
            startDate: formatDateForDisplay(batch.trainingStartDate),
            endDate: formatDateForDisplay(batch.trainingEndDate),
            department: batch.department
          };
          
          let students = [];
          try {
            students = await extractStudentsFromSimulatorExcel(excelBlob, batchInfo);
          } catch (extractError) {
            console.error(`Error extracting students from Simulator Excel for batch ${batch.batchName}:`, extractError);
            failedBatches.push({ name: batch.batchName, error: "Failed to parse Excel data" });
            continue;
          }
          
          if (students.length === 0) {
            console.warn(`No students found in batch ${batch.batchName}`);
            const placeholderStudent = {
              "S.No.": totalSerialNo++,
              "Training Name": batch.batchName,
              "Trainer Name": trainerName,
              "Depot Manager Name": depotManagerName,
              "Depot (Training)": batch.depot || "N/A",
              "Type": batch.department || "",
              "State (Training)": batch.state || "N/A",
              "Training Start Date": formatDateForDisplay(batch.trainingStartDate),
              "Training End Date": formatDateForDisplay(batch.trainingEndDate),
              "Depot (Student)": "",
              "State (Student)": "",
              "Candidate Assigned by": "",
              "Company": "",
              "Employee Id": "N/A",
              "Aadhaar Number": "",
              "Phone Number": "",
              "Email Id": "",
              "Participant Name": "No Data Available",
              "Father Name": "",
              "Designation": "",
              "Date of Service": "",
              "Last Attend Date": "",
              "Attendance Days": 0,
              "Post Test Start Date": "",
              "Post Test End Date": "",
              "Pre Test": "0%",
              "Post Test": "0%",
              "Practical Grade": "Not Attempted",
              "Fail/Pass": "Not Attempted",
              "Student Rating": "",
              "Remarks": "",
              "Total Sim Duration (min)": "0.0"
            };
            
            scenarioNames.forEach(scenario => {
              placeholderStudent[scenario] = "NOT_ATTEMPTED";
            });
            
            allStudents.push(placeholderStudent);
            continue;
          }
          
          const feedbackRating = batchFeedbackRatings[batch.id];
          
          for (const student of students) {
            student["S.No."] = totalSerialNo++;
            
            if (feedbackRating) {
              student["Student Rating"] = formatRatingWithStars(feedbackRating);
            }
            
            scenarioNames.forEach(scenario => {
              if (!student[scenario] || student[scenario] === "" || student[scenario] === "undefined") {
                student[scenario] = "NOT_ATTEMPTED";
              }
            });
            
            if (!student["Total Sim Duration (min)"] || student["Total Sim Duration (min)"] === "") {
              student["Total Sim Duration (min)"] = "0.0";
            }
            
            const requiredColumns = [
              "Training Name", "Trainer Name", "Depot Manager Name",
              "Depot (Training)", "Type", "State (Training)",
              "Training Start Date", "Training End Date",
              "Depot (Student)", "State (Student)", "Candidate Assigned by", 
              "Company", "Employee Id", "Aadhaar Number", "Phone Number", 
              "Email Id", "Participant Name", "Father Name", "Designation", 
              "Date of Service", "Last Attend Date", "Attendance Days",
              "Post Test Start Date", "Post Test End Date", "Pre Test", 
              "Post Test", "Practical Grade", "Fail/Pass", "Student Rating", "Remarks"
            ];
            
            requiredColumns.forEach(col => {
              if (!student[col] || student[col] === "" || student[col] === "undefined") {
                if (col === "Attendance Days") {
                  student[col] = 0;
                } else if (col === "Pre Test" || col === "Post Test") {
                  student[col] = "0%";
                } else if (col === "Practical Grade") {
                  student[col] = "Not Attempted";
                } else if (col === "Fail/Pass") {
                  student[col] = "Not Attempted";
                } else if (col === "Student Rating") {
                  student[col] = "";
                } else {
                  student[col] = "";
                }
              }
            });
            
            allStudents.push(student);
          }
          
          toast.success(`Processed ${students.length} students from ${batch.batchName} (Simulator)`);
          
        } catch (error) {
          console.error(`Error processing batch ${batch.batchName}:`, error);
          failedBatches.push({ name: batch.batchName, error: error.message || "Unknown error" });
        }
      }

      if (allStudents.length === 0) {
        toast.error("No student data extracted from any batch");
        setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
        setLoader(false);
        return;
      }

      const wb = XLSX.utils.book_new();
      
      const fieldOrder = [
        "S.No.", "Training Name", "Trainer Name", "Depot Manager Name",
        "Depot (Training)", "Type", "State (Training)",
        "Training Start Date", "Training End Date",
        "Depot (Student)", "State (Student)", "Candidate Assigned by", 
        "Company", "Employee Id", "Aadhaar Number", "Phone Number", 
        "Email Id", "Participant Name", "Father Name", "Designation", 
        "Date of Service", "Last Attend Date", "Attendance Days",
        "Post Test Start Date", "Post Test End Date", "Pre Test", 
        "Post Test", "Practical Grade", "Fail/Pass", "Student Rating", "Remarks",
        "Simulator(City_Driving)", "Simulator(Highway_Driving)", 
        "Simulator(Practice_Area)", "Simulator(Country_Driving)", 
        "Simulator(Hill_Driving)", "Total Sim Duration (min)"
      ];
      
      const reportData = allStudents.map((student) => {
        const row = {};
        fieldOrder.forEach(field => {
          row[field] = student[field] !== undefined && student[field] !== null ? student[field] : "";
        });
        return row;
      });
      
      const wsData = XLSX.utils.json_to_sheet(reportData);
      
      const colWidths = [
        { wch: 8 }, { wch: 35 }, { wch: 25 }, { wch: 20 }, { wch: 20 },
        { wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 20 },
        { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 18 },
        { wch: 15 }, { wch: 30 }, { wch: 25 }, { wch: 20 }, { wch: 20 },
        { wch: 15 }, { wch: 15 }, { wch: 12 }, { wch: 20 }, { wch: 20 },
        { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 25 },
        { wch: 35 }, { wch: 18 }, { wch: 18 }, { wch: 18 }, { wch: 18 },
        { wch: 18 }, { wch: 20 }
      ];
      wsData["!cols"] = colWidths;
      
      XLSX.utils.book_append_sheet(wb, wsData, "Consolidated_Simulator");
      
      const passedCount = reportData.filter(s => String(s["Fail/Pass"] || "").toUpperCase() === "PASS").length;
      const failedCount = reportData.filter(s => String(s["Fail/Pass"] || "").toUpperCase() === "FAIL").length;
      const notAttemptedCount = reportData.filter(s => String(s["Fail/Pass"] || "").toUpperCase() === "NOT ATTEMPTED" || s["Fail/Pass"] === "").length;
      
      const summaryData = [
        ["CONSOLIDATED SIMULATOR REPORT SUMMARY"],
        [`Report Type: Simulator`],
        [`Generated: ${moment().format("DD-MM-YYYY HH:mm:ss")}`],
        [`Total Batches Processed: ${batchesToProcess.length}`],
        [`Successful Batches: ${batchesToProcess.length - failedBatches.length}`],
        [`Failed Batches: ${failedBatches.length}`],
        [`Total Students: ${reportData.length}`],
        [],
        ["STUDENT RESULTS SUMMARY"],
        [`Passed: ${passedCount} (${reportData.length > 0 ? ((passedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
        [`Failed: ${failedCount} (${reportData.length > 0 ? ((failedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
        [`Not Attempted: ${notAttemptedCount} (${reportData.length > 0 ? ((notAttemptedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
        [],
        ["SCENARIO-WISE SUMMARY"],
        ...['Simulator(City_Driving)', 'Simulator(Highway_Driving)', 'Simulator(Practice_Area)', 'Simulator(Country_Driving)', 'Simulator(Hill_Driving)'].map(scenario => {
          const passCountScenario = reportData.filter(s => String(s[scenario] || "").toUpperCase() === 'PASS').length;
          const failCountScenario = reportData.filter(s => String(s[scenario] || "").toUpperCase() === 'FAIL').length;
          const notAttemptedScenario = reportData.filter(s => String(s[scenario] || "").toUpperCase() === 'NOT_ATTEMPTED' || s[scenario] === "").length;
          return [scenario, `Pass: ${passCountScenario}`, `Fail: ${failCountScenario}`, `Not Attempted: ${notAttemptedScenario}`];
        }),
        [],
        ["BATCH-WISE STUDENT COUNT"],
        ...batchesToProcess.map(batch => [
          batch.batchName,
          reportData.filter(s => s["Training Name"] === batch.batchName).length
        ])
      ];
      
      if (failedBatches.length > 0) {
        summaryData.push([], ["FAILED BATCHES"], ...failedBatches.map((f, idx) => [`${idx + 1}. ${f.name}`, f.error]));
      }
      
      const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
      XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");
      
      const fileName = `Consolidated_Simulator_Report_${moment().format("DD-MM-YYYY_HHmmss")}.xlsx`;
      const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([buffer]), fileName);
      
      const successCount = batchesToProcess.length - failedBatches.length;
      toast.success(`Simulator report generated! ${reportData.length} students from ${successCount} batches`);
      
    } catch (error) {
      console.error("Error generating consolidated simulator report:", error);
      toast.error("Failed to generate consolidated simulator report: " + (error.message || "Unknown error"));
    } finally {
      setLoader(false);
      setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
    }
  };

  // ============================
  // EXTRACT EXCEL FROM ZIP
  // ============================
  const extractExcelFromZip = async (zipBlob) => {
    try {
      const zip = await JSZip.loadAsync(zipBlob);
      
      const excelFiles = Object.keys(zip.files).filter(
        (filename) => filename.endsWith(".xlsx") || filename.endsWith(".xls") || filename.endsWith(".csv")
      );
      
      if (excelFiles.length === 0) {
        throw new Error("No Excel file found in the zip archive");
      }
      
      const excelFile = excelFiles[0];
      const excelData = await zip.files[excelFile].async("blob");
      
      return excelData;
    } catch (error) {
      console.error("Error extracting Excel from ZIP:", error);
      throw error;
    }
  };

  // ============================
  // EXTRACT STUDENTS FROM EXCEL
  // ============================
  const extractStudentsFromExcel = async (excelBlob, batchInfo) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          
          const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
          if (!rows || rows.length === 0) {
            resolve([]);
            return;
          }
          
          let headers = [];
          let dataStartRow = 0;
          
          for (let i = 0; i < Math.min(rows.length, 50); i++) {
            const row = rows[i];
            if (row && Array.isArray(row)) {
              const rowStr = JSON.stringify(row).toLowerCase();
              if ((rowStr.includes('s.no') || rowStr.includes('serial')) && 
                  (rowStr.includes('name') || rowStr.includes('participant') || rowStr.includes('employee'))) {
                headers = row;
                dataStartRow = i + 1;
                break;
              }
            }
          }
          
          if (headers.length === 0 && rows.length > 0) {
            headers = rows[0];
            dataStartRow = 1;
          }
          
          const students = [];
          for (let i = dataStartRow; i < rows.length; i++) {
            const row = rows[i];
            if (!row || !Array.isArray(row)) continue;
            
            const hasData = row.some(cell => cell && String(cell).trim() !== '');
            if (!hasData) continue;
            
            const student = {};
            headers.forEach((header, idx) => {
              if (header && idx < row.length) {
                const headerKey = String(header).trim();
                const value = row[idx] || "";
                student[headerKey] = value;
              }
            });
            
            if (!student["Training Name"] && batchInfo.batchName) {
              student["Training Name"] = batchInfo.batchName;
            }
            if (!student["Trainer Name"] && batchInfo.trainerName) {
              student["Trainer Name"] = batchInfo.trainerName;
            }
            if (!student["Depot (Training)"] && batchInfo.depot) {
              student["Depot (Training)"] = batchInfo.depot;
            }
            if (!student["State (Training)"] && batchInfo.state) {
              student["State (Training)"] = batchInfo.state;
            }
            if (!student["Training Start Date"] && batchInfo.startDate) {
              student["Training Start Date"] = batchInfo.startDate;
            }
            if (!student["Training End Date"] && batchInfo.endDate) {
              student["Training End Date"] = batchInfo.endDate;
            }
            
            if (student["Participant Name"] || student["Employee Id"] || student["Name"]) {
              if (!student["Participant Name"] && student["Name"]) {
                student["Participant Name"] = student["Name"];
              }
              students.push(student);
            }
          }
          
          resolve(students);
        } catch (error) {
          reject(error);
        }
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(excelBlob);
    });
  };

  // ============================
  // FETCH SINGLE BATCH REPORT DATA
  // ============================
  const fetchBatchReportData = async (batch, reportType) => {
    try {
      const batchId = batch.id;
      if (!batchId) {
        return null;
      }

      const apiUrl = `${downloadBatchReport}${batchId}?type=${reportType}`;
      const response = await axios.get(apiUrl, { 
        responseType: "blob", 
        timeout: 120000
      });
      
      return response.data;
    } catch (error) {
      console.error(`Error fetching report for batch ${batch.batchName}:`, error);
      return null;
    }
  };

  // ============================
  // GENERATE CONSOLIDATED SINGLE SHEET REPORT
  // NOW USES ALL BATCHES FOR DATE RANGE
  // ============================
  const generateConsolidatedReport = async () => {
    try {
      setLoader(true);
      setConsolidatedModalShow(false);
      
      setConsolidatedProgress({
        active: true,
        current: 0,
        total: 0,
        message: `Fetching all batches for the selected filters...`
      });

      // Fetch ALL batches for the date range
      const batchesToProcess = await fetchAllBatchesForReport();
      
      if (!batchesToProcess || batchesToProcess.length === 0) {
        toast.error("No batches to process");
        setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
        setLoader(false);
        return;
      }
      
      await fetchTrainersForBatches(batchesToProcess);
      await fetchFeedbackRatingsOnly(batchesToProcess);
      
      setConsolidatedProgress({
        active: true,
        current: 0,
        total: batchesToProcess.length,
        message: `Fetching ${selectedConsolidatedType} reports for ${batchesToProcess.length} batches...`
      });

      const allStudents = [];
      let failedBatches = [];
      let totalSerialNo = 1;

      for (let i = 0; i < batchesToProcess.length; i++) {
        const batch = batchesToProcess[i];
        
        setConsolidatedProgress({
          active: true,
          current: i + 1,
          total: batchesToProcess.length,
          message: `Processing batch ${i + 1}/${batchesToProcess.length}: ${batch.batchName}`
        });

        try {
          const zipBlob = await fetchBatchReportData(batch, selectedConsolidatedType);
          
          if (!zipBlob) {
            failedBatches.push({ name: batch.batchName, error: "Failed to fetch report" });
            continue;
          }

          let excelBlob;
          try {
            excelBlob = await extractExcelFromZip(zipBlob);
          } catch (zipError) {
            console.error(`Error extracting Excel from ZIP for batch ${batch.batchName}:`, zipError);
            failedBatches.push({ name: batch.batchName, error: "Invalid ZIP file or no Excel found" });
            continue;
          }

          const trainers = batchTrainersMap[batch.id] || [];
          const trainerName = formatTrainerNames(trainers);
          
          const batchInfo = {
            batchName: batch.batchName,
            trainerName: trainerName,
            depot: batch.depot,
            state: batch.state,
            startDate: formatDateForDisplay(batch.trainingStartDate),
            endDate: formatDateForDisplay(batch.trainingEndDate),
            department: batch.department
          };
          
          let students = [];
          try {
            students = await extractStudentsFromExcel(excelBlob, batchInfo);
          } catch (extractError) {
            console.error(`Error extracting students from Excel for batch ${batch.batchName}:`, extractError);
            failedBatches.push({ name: batch.batchName, error: "Failed to parse Excel data" });
            continue;
          }
          
          if (students.length === 0) {
            console.warn(`No students found in batch ${batch.batchName}`);
            continue;
          }
          
          const feedbackRating = batchFeedbackRatings[batch.id];
          
          for (const student of students) {
            student["S.No."] = totalSerialNo++;
            if (feedbackRating && !student["Student Rating"]) {
              student["Student Rating"] = formatRatingWithStars(feedbackRating);
            }
            if (!student["Fail/Pass"]) {
              student["Fail/Pass"] = "Not Attempted";
            }
            allStudents.push(student);
          }
          
          toast.success(`Processed ${students.length} students from ${batch.batchName}`);
          
        } catch (error) {
          console.error(`Error processing batch ${batch.batchName}:`, error);
          failedBatches.push({ name: batch.batchName, error: error.message || "Unknown error" });
        }
      }

      if (allStudents.length === 0) {
        toast.error("No student data extracted from any batch");
        setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
        setLoader(false);
        return;
      }

      const wb = XLSX.utils.book_new();
      
      const fieldOrder = [
        "S.No.", "Training Name", "Trainer Name", "Depot Manager Name",
        "Depot (Training)", "Type", "State (Training)",
        "Training Start Date", "Training End Date",
        "Post Test Start Date", "Post Test End Date",
        "Attendance Days", "Student Rating",
        "Depot (Student)", "State (Student)", "Candidate Assigned by", "Company", "Employee Id",
        "Aadhaar Number", "Phone Number", "Email Id", "Participant Name",
        "Father Name", "Designation", "Date of Service", "Last Attend Date",
        "Pre Test", "Post Test", "Practical Grade", "Fail/Pass", "Remarks"
      ];
      
      const reportData = allStudents.map((student) => {
        const row = {};
        fieldOrder.forEach(field => {
          row[field] = student[field] || "";
        });
        return row;
      });
      
      const wsData = XLSX.utils.json_to_sheet(reportData);
      
      const colWidths = [
        { wch: 8 }, { wch: 35 }, { wch: 25 }, { wch: 20 }, { wch: 20 },
        { wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 },
        { wch: 15 }, { wch: 12 }, { wch: 15 }, { wch: 20 }, { wch: 20 },
        { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 18 }, { wch: 15 },
        { wch: 30 }, { wch: 25 }, { wch: 20 }, { wch: 20 }, { wch: 15 },
        { wch: 15 }, { wch: 12 }, { wch: 12 }, { wch: 12 }, { wch: 12 },
        { wch: 35 }
      ];
      wsData["!cols"] = colWidths;
      
      XLSX.utils.book_append_sheet(wb, wsData, `${selectedConsolidatedType}_Students`);
      
      const passedCount = reportData.filter(s => s["Fail/Pass"] === "Pass").length;
      const failedCount = reportData.filter(s => s["Fail/Pass"] === "Fail").length;
      const notAttemptedCount = reportData.filter(s => s["Fail/Pass"] === "Not Attempted").length;
      
      const summaryData = [
        ["CONSOLIDATED REPORT SUMMARY"],
        [`Report Type: ${selectedConsolidatedType}`],
        [`Generated: ${moment().format("DD-MM-YYYY HH:mm:ss")}`],
        [`Total Batches Processed: ${batchesToProcess.length}`],
        [`Successful Batches: ${batchesToProcess.length - failedBatches.length}`],
        [`Failed Batches: ${failedBatches.length}`],
        [`Total Students: ${reportData.length}`],
        [],
        ["STUDENT RESULTS SUMMARY"],
        [`Passed: ${passedCount} (${reportData.length > 0 ? ((passedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
        [`Failed: ${failedCount} (${reportData.length > 0 ? ((failedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
        [`Not Attempted: ${notAttemptedCount} (${reportData.length > 0 ? ((notAttemptedCount / reportData.length) * 100).toFixed(2) : 0}%)`],
        [],
        ["BATCH-WISE STUDENT COUNT"],
        ...batchesToProcess.map(batch => [
          batch.batchName,
          reportData.filter(s => s["Training Name"] === batch.batchName).length
        ])
      ];
      
      if (failedBatches.length > 0) {
        summaryData.push([], ["FAILED BATCHES"], ...failedBatches.map((f, idx) => [`${idx + 1}. ${f.name}`, f.error]));
      }
      
      const wsSummary = XLSX.utils.aoa_to_sheet(summaryData);
      XLSX.utils.book_append_sheet(wb, wsSummary, "Summary");
      
      const fileName = `Consolidated_${selectedConsolidatedType}_Report_${moment().format("DD-MM-YYYY_HHmmss")}.xlsx`;
      const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([buffer]), fileName);
      
      const successCount = batchesToProcess.length - failedBatches.length;
      toast.success(`Report generated! ${reportData.length} students from ${successCount} batches`);
      
    } catch (error) {
      console.error("Error generating consolidated report:", error);
      toast.error("Failed to generate consolidated report: " + (error.message || "Unknown error"));
    } finally {
      setLoader(false);
      setConsolidatedProgress({ active: false, current: 0, total: 0, message: "" });
    }
  };

  // ============================
  // HELPER FUNCTIONS
  // ============================
  const formatRatingWithStars = (rating) => {
    if (!rating) return "Not Rated";
    const fullStars = Math.floor(rating);
    const emptyStars = 5 - fullStars;
    return `${"★".repeat(fullStars)}${"☆".repeat(emptyStars)} ${rating.toFixed(1)}/5.0`;
  };

  const formatTrainerNames = (trainers) => {
    if (!trainers || trainers.length === 0) return "No Trainer Assigned";
    const trainerNames = trainers.map((t) => {
      if (t.name) return t.name;
      if (t.firstName && t.lastName) return `${t.firstName} ${t.lastName}`;
      if (t.firstName) return t.firstName;
      if (t.fullName) return t.fullName;
      if (t.email) return t.email.split("@")[0];
      return `Trainer ${t.id}`;
    });
    if (trainers.length === 1) return trainerNames[0];
    return `${trainerNames[0]} +${trainers.length - 1}`;
  };

  // ============================
  // APPLY FILTERS
  // ============================
  const applyFilters = () => {
    let filtered = [...allBatch];

    if (filterState && filterState !== "") {
      filtered = filtered.filter(batch => batch.state === filterState);
    }

    if (filterDepot && filterDepot !== "") {
      filtered = filtered.filter(batch => batch.depot === filterDepot);
    }

    if (filterPeriod && filterPeriod !== "ALL") {
      const today = moment().startOf('day');
      
      filtered = filtered.filter(batch => {
        if (!batch.trainingStartDate) return false;
        
        let startDate = parseDateSafely(batch.trainingStartDate);
        
        if (!startDate || !startDate.isValid()) {
          return false;
        }
        
        startDate = startDate.startOf('day');
        
        switch (filterPeriod) {
          case "TODAY":
            return startDate.isSame(today, 'day');
          case "WEEKLY":
            return startDate.isSame(today, 'week');
          case "MONTHLY":
            return startDate.isSame(today, 'month');
          case "YEARLY":
            return startDate.isSame(today, 'year');
          default:
            return true;
        }
      });
    }

    if (isCustomDateRangeActive && customStartDate && customEndDate) {
      const start = moment(customStartDate).startOf('day');
      const end = moment(customEndDate).endOf('day');
      
      filtered = filtered.filter(batch => {
        if (!batch.trainingStartDate) return false;
        const batchDate = parseDateSafely(batch.trainingStartDate);
        if (!batchDate || !batchDate.isValid()) return false;
        return batchDate.isBetween(start, end, null, '[]');
      });
    }

    if (searchText) {
      const search = searchText.toLowerCase().trim();
      filtered = filtered.filter(batch => {
        const batchId = batch.id;
        const trainers = batchTrainersMap[batchId] || [];
        const trainerNames = trainers.map(t => t.name || `${t.firstName || ""} ${t.lastName || ""}`).join(" ").toLowerCase();
        
        return (
          (batch.batchName || "").toLowerCase().includes(search) ||
          (batch.department || "").toLowerCase().includes(search) ||
          (batch.depot || "").toLowerCase().includes(search) ||
          (batch.state || "").toLowerCase().includes(search) ||
          trainerNames.includes(search) ||
          (batch.trainerNames || "").toLowerCase().includes(search) ||
          formatDateForDisplay(batch.trainingStartDate).includes(search) ||
          formatDateForDisplay(batch.trainingEndDate).includes(search)
        );
      });
    }

    setFilteredBatches(filtered);
  };

  const formatDateToDDMMYYYY = useCallback((dateStr) => {
    return formatDateForDisplay(dateStr);
  }, []);

  const renderStarRating = (rating, count = 0) => {
    if (!rating || count === 0) {
      return (
        <Tooltip title="No feedback responses yet">
          <span style={{ color: "#6c757d", fontStyle: "italic" }}>No Rating</span>
        </Tooltip>
      );
    }

    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <Tooltip title={`Based on ${count} response(s) - Average Rating: ${rating.toFixed(1)}/5.0`}>
        <Box display="flex" alignItems="center" gap={1} sx={{ cursor: "pointer" }}>
          <Box display="flex" alignItems="center" gap={0.2}>
            {[...Array(fullStars)].map((_, i) => (
              <span key={`full-${i}`} style={{ color: "#ffb400", fontSize: "16px" }}>★</span>
            ))}
            {hasHalfStar && (
              <span style={{ color: "#ffb400", fontSize: "16px", position: "relative", display: "inline-block" }}>
                <span style={{ position: "absolute", overflow: "hidden", width: "50%", color: "#ffb400" }}>★</span>
                <span style={{ color: "#e4e5e9" }}>★</span>
              </span>
            )}
            {[...Array(emptyStars)].map((_, i) => (
              <span key={`empty-${i}`} style={{ color: "#e4e5e9", fontSize: "16px" }}>★</span>
            ))}
          </Box>
          <Typography 
            variant="body2" 
            sx={{ 
              fontWeight: "bold", 
              color: "#ffb400",
              backgroundColor: "#fff3e0",
              padding: "2px 6px",
              borderRadius: "12px",
              fontSize: "12px"
            }}
          >
            {rating.toFixed(1)}
          </Typography>
        </Box>
      </Tooltip>
    );
  };

  const getFilteredStats = useCallback(() => {
    let totalStudents = 0;
    let totalPassed = 0;
    let totalFailed = 0;
    let totalNotAttempted = 0;
    let totalRatingSum = 0;
    let totalRatingCount = 0;
    let totalFeedbackGiven = 0;
    let totalNotFeedbackGiven = 0;

    filteredBatches.forEach((batch) => {
      totalStudents += batch.totalStudents || 0;
      totalPassed += batch.passedStudents || 0;
      totalFailed += batch.failedStudents || 0;
      totalNotAttempted += batch.notAttemptedStudents || 0;
      
      const rating = batchFeedbackRatings[batch.id];
      if (rating) {
        totalRatingSum += rating;
        totalRatingCount++;
      }
      
      totalFeedbackGiven += batchFeedbackGivenCounts[batch.id] || 0;
      totalNotFeedbackGiven += batchNotFeedbackGivenCounts[batch.id] || 0;
    });

    const passRate = totalStudents > 0 ? ((totalPassed / totalStudents) * 100).toFixed(1) : 0;
    const avgRating = totalRatingCount > 0 ? (totalRatingSum / totalRatingCount).toFixed(1) : 0;

    return {
      totalStudents,
      totalPassed,
      totalFailed,
      totalNotAttempted,
      passRate,
      avgRating,
      totalRatingCount,
      totalFeedbackGiven,
      totalNotFeedbackGiven
    };
  }, [filteredBatches, batchFeedbackRatings, batchFeedbackGivenCounts, batchNotFeedbackGivenCounts]);

  const filteredStats = getFilteredStats();

  // ============================
  // EDIT/DELETE FUNCTIONS
  // ============================
  const handleRowClick = (row) => {
    setModalShow(true);
    navigate(`/batch/${row.id}`);
    setId(row.id);
    setName(row.batchName || "");
  };

  const handleUpdate = async () => {
    if (!name) {
      setSpanDisplay("inline");
      return;
    }

    try {
      setLoader(true);
      const result = await updateBatch({ id, batchName: name });
      if (result?.success) {
        toast.success(result?.message);
        getAllBatches();
        setModalShow(false);
        setName("");
        setId("");
        setSpanDisplay("none");
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update batch");
    } finally {
      setLoader(false);
    }
  };

  const handleDelete = async () => {
    try {
      setLoader(true);
      const result = await deleteBatch(id);
      if (result?.success) {
        toast.success(result?.message);
        getAllBatches();
        setDeleteModalShow(false);
        setModalShow(false);
        setName("");
        setId("");
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to delete batch");
    } finally {
      setLoader(false);
    }
  };

  const handleViewDetails = (row) => {
    navigate(`/batch/${row.id}`);
  };

  const resetFilters = () => {
    setFilterState("");
    setFilterDepot("");
    setFilterPeriod("ALL");
    setSearchText("");
    setCustomStartDate(null);
    setCustomEndDate(null);
    setIsCustomDateRangeActive(false);
    setFilterAnchorEl(null);
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const openCustomDateRangeModal = () => {
    setDateRangeModalShow(true);
    handleFilterClose();
  };

  const applyCustomDateRange = () => {
    if (!customStartDate || !customEndDate) {
      toast.error("Please select both start and end dates");
      return;
    }

    if (moment(customStartDate).isAfter(moment(customEndDate))) {
      toast.error("Start date cannot be after end date");
      return;
    }

    setIsCustomDateRangeActive(true);
    setFilterPeriod("ALL");
    setDateRangeModalShow(false);
    setPage(0);
    toast.success(`Custom date range applied: ${formatDateForDisplay(customStartDate)} to ${formatDateForDisplay(customEndDate)}`);
  };

  const clearCustomDateRange = () => {
    setCustomStartDate(null);
    setCustomEndDate(null);
    setIsCustomDateRangeActive(false);
    toast.success("Custom date range cleared");
  };

  const applySerialRangeFilter = () => {
    if (!fromSerial || !toSerial) {
      toast.error("Please enter both from and to serial numbers");
      return;
    }

    const from = parseInt(fromSerial);
    const to = parseInt(toSerial);

    if (isNaN(from) || isNaN(to)) {
      toast.error("Please enter valid numbers");
      return;
    }

    if (from < 1 || to > allBatch.length) {
      toast.error(`Please enter serial numbers between 1 and ${allBatch.length}`);
      return;
    }

    if (from > to) {
      toast.error("'From' serial number must be less than or equal to 'To' serial number");
      return;
    }

    const filtered = allBatch.filter((_, index) => {
      const serialNo = index + 1;
      return serialNo >= from && serialNo <= to;
    });

    setFilteredBatches(filtered);
    setSerialRangeModalShow(false);
    toast.success(`Showing ${filtered.length} batches`);
  };

  const clearAllFilters = () => {
    setCustomStartDate(null);
    setCustomEndDate(null);
    setIsCustomDateRangeActive(false);
    setFromSerial("");
    setToSerial("");
    setSearchText("");
    setFilterState("");
    setFilterDepot("");
    setFilterPeriod("ALL");
    setFilteredBatches(allBatch);
    toast.success("All filters cleared");
  };

  const refreshData = () => {
    getAllBatches();
    toast.info("Refreshing data from server...");
  };

  // ============================
  // DOWNLOAD EXCEL WITH DATE RANGE
  // ============================
  const downloadExcel = async () => {
    try {
      setLoader(true);
      
      const authUser = JSON.parse(localStorage.getItem("authUser"));
      if (!authUser || !authUser.organizationId) {
        toast.error("Organization ID not found. Please log in again.");
        return;
      }
      
      const { startDate, endDate } = getDateRange();
      
      toast.info(startDate && endDate ? 
        `Downloading report for Training End Date between ${formatDateForDisplay(startDate)} and ${formatDateForDisplay(endDate)}...` : 
        "Downloading all batch report...");
      
      const response = await batchDetailFile(startDate, endDate);
      
      if (!response.data || response.data.size === 0) {
        toast.error("No data received from server");
        return;
      }
      
      const firstBytes = await response.data.slice(0, 100).text();
      const trimmedFirstBytes = firstBytes.trim();
      if (trimmedFirstBytes.startsWith('{') || trimmedFirstBytes.startsWith('[')) {
        try {
          const fullText = await response.data.text();
          const errorData = JSON.parse(fullText);
          toast.error(errorData.message || "Failed to download file");
          return;
        } catch (e) {
          toast.error("Failed to download file");
          return;
        }
      }
      
      const blob = new Blob([response.data], {
        type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      
      let filename = `Batch_Details`;
      if (startDate && endDate) {
        filename += `_${moment(startDate).format("DD-MM-YYYY")}_to_${moment(endDate).format("DD-MM-YYYY")}`;
      } else if (startDate) {
        filename += `_from_${moment(startDate).format("DD-MM-YYYY")}`;
      } else if (endDate) {
        filename += `_upto_${moment(endDate).format("DD-MM-YYYY")}`;
      }
      filename += `.xlsx`;
      
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
      
      toast.success("File downloaded successfully!");
    } catch (error) {
      console.error("Error downloading file:", error);
      toast.error(error.response?.data?.message || "Failed to download file");
    } finally {
      setLoader(false);
    }
  };

  // ============================
  // PAGE CHANGE HANDLERS
  // ============================
  const handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setPage(newPage);
    }
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setPage(0);
  };

  // ============================
  // PAGINATION RENDER
  // ============================
  const renderPagination = () => {
    if (totalPages <= 1) return null;

    const pageNumbers = [];
    const maxVisible = 5;
    let startPage = Math.max(0, page - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages - 1, startPage + maxVisible - 1);
    
    if (endPage - startPage < maxVisible - 1) {
      startPage = Math.max(0, endPage - maxVisible + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="d-flex align-items-center gap-2">
          <span className="text-muted" style={{ fontSize: "14px" }}>
            Showing {page * pageSize + 1} to {Math.min((page + 1) * pageSize, totalItems)} of {totalItems} entries
          </span>
        </div>
        <div className="d-flex align-items-center gap-2">
          <Button
            color="secondary"
            size="sm"
            onClick={() => handlePageChange(0)}
            disabled={page === 0}
          >
            <FirstPageIcon style={{ fontSize: "18px" }} />
          </Button>
          <Button
            color="secondary"
            size="sm"
            onClick={() => handlePageChange(page - 1)}
            disabled={page === 0}
          >
            <NavigateBeforeIcon style={{ fontSize: "18px" }} />
          </Button>
          {pageNumbers.map((num) => (
            <Button
              key={num}
              color={num === page ? "primary" : "secondary"}
              size="sm"
              onClick={() => handlePageChange(num)}
              style={{ minWidth: "35px" }}
            >
              {num + 1}
            </Button>
          ))}
          <Button
            color="secondary"
            size="sm"
            onClick={() => handlePageChange(page + 1)}
            disabled={page >= totalPages - 1}
          >
            <NavigateNextIcon style={{ fontSize: "18px" }} />
          </Button>
          <Button
            color="secondary"
            size="sm"
            onClick={() => handlePageChange(totalPages - 1)}
            disabled={page >= totalPages - 1}
          >
            <LastPageIcon style={{ fontSize: "18px" }} />
          </Button>
          <Select
            options={pageSizeOptions}
            value={pageSizeOptions.find(opt => opt.value === pageSize)}
            onChange={(option) => handlePageSizeChange(option.value)}
            className="ms-2"
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "32px",
                width: "70px",
              }),
            }}
          />
        </div>
      </div>
    );
  };

  // ============================
  // EFFECTS
  // ============================
  useEffect(() => {
    props.setBreadcrumbItems("All Batches", breadcrumbItems);
  }, []);

  useEffect(() => {
    getAllBatches();
  }, [getAllBatches]);

  useEffect(() => {
    if (allBatch.length > 0) {
      fetchTrainersForBatches(allBatch);
      fetchFeedbackRatingsOnly(allBatch);
    }
  }, [allBatch]);

  // ============================
  // COLUMNS DEFINITION
  // ============================
  const columns = [
    { field: "serialNo", headerName: "S.No", width: 70 },
    {
      field: "batchName",
      headerName: "Batch Name",
      width: 200,
      renderCell: (params) => {
        return (
          <span
            style={{ cursor: "pointer", color: "#0d6efd", fontWeight: 500, textDecoration: "underline" }}
            onClick={() => handleViewDetails(params.row)}
            title={`${params.row.totalStudents || 0} student(s)`}
          >
            {params.value}
          </span>
        );
      },
    },
    { field: "department", headerName: "Department", width: 150 },
    {
      field: "trainerNames",
      headerName: "Trainer(s)",
      width: 250,
      renderCell: (params) => {
        return <span>{params.value || "No Trainer Assigned"}</span>;
      },
    },
    {
      field: "state",
      headerName: "State",
      width: 130,
      renderCell: (params) => params.value || "N/A",
    },
    {
      field: "depot",
      headerName: "Depot",
      width: 130,
      renderCell: (params) => params.value || "N/A",
    },
    {
      field: "trainingStartDate",
      headerName: "Start Date",
      width: 130,
      renderCell: (params) => formatDateForDisplay(params.value),
    },
    {
      field: "trainingEndDate",
      headerName: "End Date",
      width: 130,
      renderCell: (params) => formatDateForDisplay(params.value),
    },
    {
      field: "totalStudents",
      headerName: "Students",
      width: 90,
      renderCell: (params) => (
        <span style={{ fontWeight: params.value > 0 ? "bold" : "normal", color: params.value > 0 ? "#198754" : "#6c757d" }}>
          {params.value || 0}
        </span>
      ),
    },
    {
      field: "passedStudents",
      headerName: "Passed",
      width: 80,
      renderCell: (params) => (
        <span style={{ color: "#198754", fontWeight: "bold" }}>{params.value || 0}</span>
      ),
    },
    {
      field: "failedStudents",
      headerName: "Failed",
      width: 80,
      renderCell: (params) => (
        <span style={{ color: "#dc3545", fontWeight: "bold" }}>{params.value || 0}</span>
      ),
    },
    {
      field: "notAttemptedStudents",
      headerName: "Not Attempted",
      width: 100,
      renderCell: (params) => (
        <span style={{ color: "#ffc107", fontWeight: "bold" }}>{params.value || 0}</span>
      ),
    },
    {
      field: "passPercentage",
      headerName: "Pass %",
      width: 80,
      renderCell: (params) => (
        <span style={{ fontWeight: "bold" }}>{params.value || 0}%</span>
      ),
    },
    {
      field: "feedbackRating",
      headerName: "Rating",
      width: 220,
      renderCell: (params) => {
        const rating = batchFeedbackRatings[params.row.id];
        const count = batchFeedbackCounts[params.row.id] || 0;
        const loading = loadingRatings[params.row.id];

        if (loading) {
          return <CircularProgress size={25} />;
        }

        return renderStarRating(rating, count);
      },
    },
    {
      field: "feedbackGiven",
      headerName: "Feedback Given",
      width: 130,
      renderCell: (params) => {
        const given = batchFeedbackGivenCounts[params.row.id] || 0;
        const notGiven = batchNotFeedbackGivenCounts[params.row.id] || 0;
        return (
          <Tooltip title={`${given} students gave feedback, ${notGiven} students did not`}>
            <span style={{ color: given > 0 ? "#198754" : "#6c757d" }}>
              {given} / {given + notGiven}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      width: 80,
      renderCell: (p) => (
        <Button size="sm" color="warning" onClick={() => handleRowClick(p.row)} style={{ padding: "4px 12px" }}>
          Edit
        </Button>
      ),
    },
    {
      field: "download",
      headerName: "Download Report",
      width: 130,
      renderCell: (p) => (
        <Button 
          size="sm" 
          color="success" 
          onClick={() => openBatchReportModal(p.row)}
          style={{ padding: "4px 8px", marginRight: "4px" }}
        >
          <DownloadIcon style={{ fontSize: "14px" }} />
        </Button>
      ),
    },
    {
      field: "downloadSimulator",
      headerName: "Simulator",
      width: 100,
      renderCell: (p) => (
        <Button 
          size="sm" 
          color="primary" 
          onClick={() => openBatchSimulatorReportModal(p.row)}
          style={{ padding: "4px 8px" }}
        >
          <ScienceIcon style={{ fontSize: "14px" }} />
        </Button>
      ),
    },
  ];

  // ============================
  // RENDER
  // ============================
  return (
    <>
      {loader && <Loader />}

      {consolidatedProgress.active && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            backgroundColor: "rgba(255,255,255,0.95)",
            padding: "15px 20px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          }}
        >
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="fw-bold text-primary">
              <i className="fas fa-spinner fa-spin me-2"></i>
              {consolidatedProgress.message}
            </span>
            <span className="text-muted">
              {consolidatedProgress.current}/{consolidatedProgress.total}
            </span>
          </div>
          <LinearProgress
            variant="determinate"
            value={consolidatedProgress.total > 0 ? (consolidatedProgress.current / consolidatedProgress.total) * 100 : 0}
          />
        </div>
      )}

      <Row>
        <Col>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                <CardTitle className="h4 mb-0">
                  All Batches
                  {filterState && <span className="ms-2 fs-6 text-muted">(State: {filterState})</span>}
                  {filterDepot && <span className="ms-2 fs-6 text-muted">(Depot: {filterDepot})</span>}
                  {filterPeriod !== "ALL" && (
                    <span className="ms-2 fs-6 text-muted">(Period: {filterPeriod})</span>
                  )}
                  {isCustomDateRangeActive && customStartDate && customEndDate && (
                    <span className="ms-2 fs-6 text-muted">
                      (Custom Range: {formatDateForDisplay(customStartDate)} - {formatDateForDisplay(customEndDate)})
                    </span>
                  )}
                  {isCustomDateRangeActive && allBatchesForReportCount > 0 && (
                    <span className="ms-2 fs-6 text-info">
                      (Total: {allBatchesForReportCount} batches for download)
                    </span>
                  )}
                </CardTitle>
                <div className="d-flex flex-wrap gap-2">
                  <Button color="secondary" size="sm" onClick={handleFilterClick}>
                    <FilterListIcon style={{ fontSize: "16px", marginRight: "4px" }} />
                    Filters
                  </Button>
                  <Menu
                    anchorEl={filterAnchorEl}
                    open={Boolean(filterAnchorEl)}
                    onClose={handleFilterClose}
                  >
                    <div style={{ padding: "16px", minWidth: "250px" }}>
                      <Typography variant="subtitle2" className="mb-2">State</Typography>
                      <Select
                        options={availableStates.map(s => ({ value: s, label: s }))}
                        value={filterState ? { value: filterState, label: filterState } : null}
                        onChange={(option) => setFilterState(option?.value || "")}
                        placeholder="All States"
                        isClearable
                        className="mb-3"
                      />
                      <Typography variant="subtitle2" className="mb-2">Depot</Typography>
                      <Select
                        options={availableDepots.map(d => ({ value: d, label: d }))}
                        value={filterDepot ? { value: filterDepot, label: filterDepot } : null}
                        onChange={(option) => setFilterDepot(option?.value || "")}
                        placeholder="All Depots"
                        isClearable
                        className="mb-3"
                      />
                      <Typography variant="subtitle2" className="mb-2">Period</Typography>
                      <Select
                        options={periodOptions}
                        value={periodOptions.find(p => p.value === filterPeriod)}
                        onChange={(option) => {
                          setFilterPeriod(option?.value || "ALL");
                          if (option?.value !== "CUSTOM") {
                            setIsCustomDateRangeActive(false);
                          }
                        }}
                        className="mb-3"
                      />
                      <Button 
                        size="small" 
                        variant="outlined" 
                        onClick={openCustomDateRangeModal}
                        fullWidth
                        style={{ marginBottom: "8px" }}
                      >
                        Custom Date Range
                      </Button>
                      {isCustomDateRangeActive && (
                        <Button 
                          size="small" 
                          variant="outlined" 
                          onClick={clearCustomDateRange}
                          fullWidth
                          style={{ marginBottom: "8px", backgroundColor: "#ffebee" }}
                        >
                          Clear Date Range
                        </Button>
                      )}
                      <Button 
                        size="small" 
                        variant="outlined" 
                        onClick={() => setSerialRangeModalShow(true)}
                        fullWidth
                        style={{ marginBottom: "8px" }}
                      >
                        Serial Range
                      </Button>
                      <Button 
                        size="small" 
                        variant="outlined" 
                        onClick={resetFilters}
                        fullWidth
                      >
                        Reset All Filters
                      </Button>
                    </div>
                  </Menu>
                  <Button color="secondary" size="sm" onClick={() => setSerialRangeModalShow(true)}>
                    <i className="fas fa-sort-numeric-up-alt me-1"></i>Serial Range
                  </Button>
                  {(filterState || filterDepot || filterPeriod !== "ALL" || isCustomDateRangeActive || fromSerial || toSerial || searchText) && (
                    <Button color="danger" size="sm" onClick={clearAllFilters}>
                      <i className="fas fa-times me-1"></i>Clear All
                    </Button>
                  )}
                  <Button color="info" size="sm" onClick={downloadExcel}>
                    <i className="fas fa-download me-1"></i>Excel
                  </Button>
                  <Button color="success" size="sm" onClick={() => setZipDownloadModalShow(true)}>
                    <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
                    Download ZIP
                  </Button>
                  <Button color="success" size="sm" onClick={() => setZipSimulatorDownloadModalShow(true)}>
                    <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
                    Simulator ZIP
                  </Button>
                  <Button color="warning" size="sm" onClick={() => setConsolidatedModalShow(true)}>
                    <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
                    Consolidated Report
                  </Button>
                  <Button color="warning" size="sm" onClick={() => setConsolidatedSimulatorModalShow(true)}>
                    <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
                    Combined Consolidated
                  </Button>
                  <Button color="primary" size="sm" onClick={refreshData}>
                    <RefreshIcon style={{ fontSize: "16px", marginRight: "4px" }} />
                    Refresh
                  </Button>
                </div>
              </div>

              <Row className="mb-3">
                <Col md={6}>
                  <TextField
                    fullWidth
                    label="Search..."
                    placeholder="Batch name, department, depot, state, trainer, date"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      startAdornment: <i className="fas fa-search" style={{ marginRight: 8, color: "#6c757d" }}></i>,
                    }}
                  />
                </Col>
                <Col md={6} className="d-flex align-items-center">
                  <small className="text-muted">
                    <span className="me-2">Batches: <strong>{filteredBatches.length}</strong></span>
                    <span className="me-2">| Students: <strong>{filteredStats.totalStudents}</strong></span>
                    <span className="me-2 text-success">| Passed: <strong>{filteredStats.totalPassed}</strong></span>
                    <span className="me-2 text-danger">| Failed: <strong>{filteredStats.totalFailed}</strong></span>
                    <span className="me-2 text-warning">| Not Attempted: <strong>{filteredStats.totalNotAttempted}</strong></span>
                    <span>| Pass Rate: <strong>{filteredStats.passRate}%</strong></span>
                    <span className="ms-2" style={{ color: "#ffb400" }}>
                      | Avg Rating: <strong>{filteredStats.avgRating > 0 ? filteredStats.avgRating + " ★" : "No Ratings"}</strong>
                    </span>
                    <span className="ms-2 text-success">
                      | Feedback Given: <strong>{filteredStats.totalFeedbackGiven}</strong>
                    </span>
                    <span className="ms-2 text-danger">
                      | Not Given: <strong>{filteredStats.totalNotFeedbackGiven}</strong>
                    </span>
                  </small>
                </Col>
              </Row>

              <Paper elevation={0} style={{ border: "1px solid #e0e0e0" }}>
                <DataGrid
                  autoHeight
                  rows={filteredBatches.map((r, i) => ({
                    ...r,
                    serialNo: page * pageSize + i + 1,
                    id: r.id,
                  }))}
                  columns={columns}
                  pageSizeOptions={[5, 10, 25, 50]}
                  initialState={{
                    pagination: { paginationModel: { pageSize: pageSize, page: 0 } },
                  }}
                  disableRowSelectionOnClick
                  sx={{
                    "& .MuiDataGrid-cell:focus": { outline: "none" },
                    "& .MuiDataGrid-columnHeaders": { backgroundColor: "#f8f9fa", fontWeight: "bold" },
                  }}
                />
              </Paper>

              {renderPagination()}
            </CardBody>
          </Card>
        </Col>
      </Row>

      {/* ============================ */}
      {/* MODALS */}
      {/* ============================ */}

      {/* Custom Date Range Modal */}
      <Modal show={dateRangeModalShow} centered onHide={() => setDateRangeModalShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Select Custom Date Range</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">Start Date</label>
              <DatePicker
                selected={customStartDate}
                onChange={(date) => setCustomStartDate(date)}
                selectsStart
                startDate={customStartDate}
                endDate={customEndDate}
                className="form-control"
                dateFormat="dd-MM-yyyy"
                placeholderText="Select start date"
                maxDate={customEndDate || undefined}
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label fw-bold">End Date</label>
              <DatePicker
                selected={customEndDate}
                onChange={(date) => setCustomEndDate(date)}
                selectsEnd
                startDate={customStartDate}
                endDate={customEndDate}
                minDate={customStartDate}
                className="form-control"
                dateFormat="dd-MM-yyyy"
                placeholderText="Select end date"
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
              />
            </div>
          </div>
          <div className="mt-2 p-2 bg-light rounded">
            <small className="text-muted">
              <i className="fas fa-info-circle me-1"></i>
              Select a date range to show batches that started within this period.
              <br />
              <strong className="text-info">
                <i className="fas fa-info-circle me-1"></i>
                When you download reports (ZIP, Consolidated), ALL batches within this date range will be included — not just the current page.
              </strong>
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setDateRangeModalShow(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={applyCustomDateRange}>
            Apply Filter
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Serial Range Modal */}
      <Modal show={serialRangeModalShow} centered onHide={() => setSerialRangeModalShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Serial Number Range</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label fw-bold">From</label>
            <input
              type="number"
              className="form-control"
              min="1"
              max={allBatch.length}
              value={fromSerial}
              onChange={(e) => setFromSerial(e.target.value)}
              placeholder={`1 to ${allBatch.length}`}
            />
          </div>
          <div className="mb-3">
            <label className="form-label fw-bold">To</label>
            <input
              type="number"
              className="form-control"
              min="1"
              max={allBatch.length}
              value={toSerial}
              onChange={(e) => setToSerial(e.target.value)}
              placeholder={`1 to ${allBatch.length}`}
            />
          </div>
          <div className="mt-2 p-2 bg-light rounded">
            <small className="text-muted">
              <i className="fas fa-info-circle me-1"></i>
              Enter serial number range to filter batches by their position in the list.
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setSerialRangeModalShow(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={applySerialRangeFilter}>
            Apply
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Batch Modal */}
      <Modal show={modalShow} size="lg" centered onHide={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Batch</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="mb-3">
            <label htmlFor="batch-name-input" className="col-md-2 col-form-label">
              Batch Name
            </label>
            <div className="col-md-10">
              <input
                id="batch-name-input"
                type="text"
                className="form-control"
                placeholder="Enter new batch name"
                maxLength="50"
                value={name}
                onChange={(e) => { setName(e.target.value); setSpanDisplay("none"); }}
              />
              <span style={{ color: "red", display: spanDisplay, fontSize: "12px", marginTop: "5px" }}>
                Batch name is required
              </span>
            </div>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button color="secondary" onClick={() => { setModalShow(false); setName(""); setSpanDisplay("none"); }}>
            Close
          </Button>
          <Button color="success" onClick={handleUpdate}>
            Update
          </Button>
          <Button color="danger" onClick={() => { setDeleteModalShow(true); setModalShow(false); }}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Modal */}
      <Modal show={deleteModalShow} centered onHide={() => setDeleteModalShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center py-3">
            <i className="fas fa-exclamation-triangle text-warning" style={{ fontSize: "48px" }}></i>
            <h5 className="mt-3">Delete this batch?</h5>
            <p className="text-muted">This action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button color="secondary" onClick={() => { setDeleteModalShow(false); setModalShow(true); }}>
            Cancel
          </Button>
          <Button color="danger" onClick={handleDelete}>
            Yes, Delete
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Individual Batch Report Modal */}
      <Modal show={batchReportModalShow} centered onHide={() => setBatchReportModalShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Download Batch Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
            <DownloadIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
            <div>
              <strong>Download Report for {selectedBatchForReport?.batchName || "Batch"}</strong>
              <small className="d-block text-muted">
                Select report type to download with images
              </small>
            </div>
          </div>

          <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
            <div>
              <small className="text-muted">Batch</small>
              <div className="fw-bold fs-6">{selectedBatchForReport?.batchName || "N/A"}</div>
            </div>
            <div>
              <small className="text-muted">Department</small>
              <div className="fw-bold fs-6">{selectedBatchForReport?.department || "N/A"}</div>
            </div>
            <div>
              <small className="text-muted">Total Students</small>
              <div className="fw-bold fs-6">{selectedBatchForReport?.totalStudents || 0}</div>
            </div>
            <div>
              <small className="text-muted">Depot</small>
              <div className="fw-bold fs-6">{selectedBatchForReport?.depot || "N/A"}</div>
            </div>
            <div>
              <small className="text-muted">State</small>
              <div className="fw-bold fs-6">{selectedBatchForReport?.state || "N/A"}</div>
            </div>
          </div>

          <label className="mb-2 fw-bold">Select Report Type:</label>
          <Select
            options={reportTypeOptions}
            value={reportTypeOptions.find((opt) => opt.value === selectedReportType)}
            onChange={(option) => setSelectedReportType(option?.value || "Other")}
            placeholder="Choose report type..."
            isSearchable={false}
          />

          <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
            <small className="text-info">
              <i className="fas fa-info-circle me-1"></i>
              The downloaded file will be a ZIP containing:
              <ul className="mt-2 mb-0">
                <li>Excel report with all student data</li>
                <li>Images folder with all uploaded images</li>
                <li>Complete with all fields including Pre Test, Post Test, Practical Grade, etc.</li>
              </ul>
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setBatchReportModalShow(false)}>
            Cancel
          </Button>
          <Button color="success" onClick={downloadSingleBatchReport}>
            <DownloadIcon style={{ fontSize: "16px", marginRight: "4px" }} />
            Download {selectedReportType} Report
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Individual Batch Simulator Report Modal */}
      <Modal show={batchSimulatorReportModalShow} centered onHide={() => setBatchSimulatorReportModalShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Download Simulator Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
            <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
            <div>
              <strong>Download Simulator Report for {selectedBatchForSimulatorReport?.batchName || "Batch"}</strong>
              <small className="d-block text-muted">
                Download complete simulator report with all scenarios (PASS/FAIL/NOT_ATTEMPTED)
              </small>
            </div>
          </div>

          <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
            <div>
              <small className="text-muted">Batch</small>
              <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.batchName || "N/A"}</div>
            </div>
            <div>
              <small className="text-muted">Department</small>
              <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.department || "N/A"}</div>
            </div>
            <div>
              <small className="text-muted">Total Students</small>
              <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.totalStudents || 0}</div>
            </div>
            <div>
              <small className="text-muted">Depot</small>
              <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.depot || "N/A"}</div>
            </div>
            <div>
              <small className="text-muted">State</small>
              <div className="fw-bold fs-6">{selectedBatchForSimulatorReport?.state || "N/A"}</div>
            </div>
          </div>

          <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
            <small className="text-info">
              <i className="fas fa-info-circle me-1"></i>
              The simulator report includes:
              <ul className="mt-2 mb-0">
                <li>All student details with all fields from the backend</li>
                <li>Post Test Start Date & Post Test End Date</li>
                <li>Pre Test & Post Test scores</li>
                <li>Student Rating with star ratings</li>
                <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
                <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
                <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
              </ul>
            </small>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setBatchSimulatorReportModalShow(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={downloadSingleBatchSimulatorReport}>
            <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
            Download Simulator Report
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Consolidated Report Modal */}
      <Modal show={consolidatedModalShow} centered onHide={() => setConsolidatedModalShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Generate Consolidated Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center mb-3 p-3 bg-success bg-opacity-10 rounded">
            <MergeTypeIcon style={{ fontSize: "2rem", color: "#28a745", marginRight: "12px" }} />
            <div>
              <strong>Single Sheet Consolidated Report</strong>
              <small className="d-block text-muted">
                Combines all student data from <strong>{allBatchesForReportCount || filteredBatches.length}</strong> batches into a single Excel sheet
              </small>
            </div>
          </div>

          <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
            <div>
              <small className="text-muted">Batches to Process</small>
              <div className="fw-bold fs-5">{isFetchingAllBatches ? <Spinner size="sm" /> : (allBatchesForReportCount || filteredBatches.length)}</div>
            </div>
            <div>
              <small className="text-muted">Total Students</small>
              <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
            </div>
            <div>
              <small className="text-muted">Pass Rate</small>
              <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
            </div>
            <div>
              <small className="text-muted">Avg Rating</small>
              <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
            </div>
          </div>

          <label className="mb-2 fw-bold">Report Type:</label>
          <Select
            options={consolidatedOptions}
            value={consolidatedOptions.find((opt) => opt.value === selectedConsolidatedType)}
            onChange={(option) => setSelectedConsolidatedType(option.value)}
            placeholder="Choose..."
            isSearchable={false}
          />

          <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
            <small className="text-info">
              <i className="fas fa-info-circle me-1"></i>
              This will generate a single Excel file containing:
              <ul className="mt-2 mb-0">
                <li>Main Sheet: All student data from ALL batches (not just current page) with 30+ fields including Attendance Days, Student Rating (with stars), Practical Grade, etc.</li>
                <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
              </ul>
            </small>
          </div>

          {(allBatchesForReportCount || filteredBatches.length) > 10 && (
            <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
              <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
                Processing <strong>{allBatchesForReportCount || filteredBatches.length}</strong> batches may take several minutes. Each batch report is fetched and merged.
              </small>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConsolidatedModalShow(false)}>
            Cancel
          </Button>
          <Button color="success" onClick={generateConsolidatedReport}>
            <MergeTypeIcon style={{ fontSize: "16px", marginRight: "4px" }} />
            Generate Single Sheet Report ({allBatchesForReportCount || filteredBatches.length} Batches)
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Consolidated Simulator Report Modal */}
      <Modal show={consolidatedSimulatorModalShow} centered onHide={() => setConsolidatedSimulatorModalShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Generate Consolidated Simulator Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
            <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
            <div>
              <strong>Single Sheet Consolidated Simulator Report</strong>
              <small className="d-block text-muted">
                Combines all simulator data from <strong>{allBatchesForReportCount || filteredBatches.length}</strong> batches into a single Excel sheet
              </small>
            </div>
          </div>

          <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
            <div>
              <small className="text-muted">Batches to Process</small>
              <div className="fw-bold fs-5">{isFetchingAllBatches ? <Spinner size="sm" /> : (allBatchesForReportCount || filteredBatches.length)}</div>
            </div>
            <div>
              <small className="text-muted">Total Students</small>
              <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
            </div>
            <div>
              <small className="text-muted">Pass Rate</small>
              <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
            </div>
            <div>
              <small className="text-muted">Avg Rating</small>
              <div className="fw-bold fs-5" style={{ color: "#ffb400" }}>{filteredStats.avgRating > 0 ? filteredStats.avgRating + "★" : "N/A"}</div>
            </div>
          </div>

          <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
            <small className="text-info">
              <i className="fas fa-info-circle me-1"></i>
              This will generate a single Excel file containing simulator data:
              <ul className="mt-2 mb-0">
                <li>All student details from ALL batches (not just current page)</li>
                <li>Post Test Start Date & Post Test End Date</li>
                <li>Pre Test & Post Test scores</li>
                <li>Student Rating with star ratings</li>
                <li>Scenario-wise results: Simulator(City_Driving), Simulator(Highway_Driving), Simulator(Practice_Area), Simulator(Country_Driving), Simulator(Hill_Driving)</li>
                <li>Each scenario shows PASS/FAIL/NOT_ATTEMPTED</li>
                <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
                <li>Summary Sheet: Statistics including pass/fail counts, batch-wise distribution</li>
              </ul>
            </small>
          </div>

          {(allBatchesForReportCount || filteredBatches.length) > 10 && (
            <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
              <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
                Processing <strong>{allBatchesForReportCount || filteredBatches.length}</strong> batches may take several minutes. Each batch report is fetched and merged.
              </small>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConsolidatedSimulatorModalShow(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={generateConsolidatedSimulatorReport}>
            <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
            Generate Simulator Report ({allBatchesForReportCount || filteredBatches.length} Batches)
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ZIP Download Modal */}
      <Modal show={zipDownloadModalShow} centered onHide={() => setZipDownloadModalShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Download All Batches as ZIP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
            <ArchiveIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
            <div>
              <strong>Batch-wise ZIP Download with Images</strong>
              <small className="d-block text-muted">
                Downloads each batch's report as a separate folder in a single ZIP file
              </small>
            </div>
          </div>

          <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
            <div>
              <small className="text-muted">Batches to Download</small>
              <div className="fw-bold fs-5">{isFetchingAllBatches ? <Spinner size="sm" /> : (allBatchesForReportCount || filteredBatches.length)}</div>
            </div>
            <div>
              <small className="text-muted">Total Students</small>
              <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
            </div>
            <div>
              <small className="text-muted">Pass Rate</small>
              <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
            </div>
          </div>

          <label className="mb-2 fw-bold">Report Type:</label>
          <Select
            options={zipDownloadOptions}
            value={zipDownloadOptions.find((opt) => opt.value === selectedZipType)}
            onChange={(option) => setSelectedZipType(option?.value || "Other")}
            placeholder="Choose report type..."
            isSearchable={false}
          />

          <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
            <small className="text-info">
              <i className="fas fa-info-circle me-1"></i>
              The ZIP file will contain:
              <ul className="mt-2 mb-0">
                <li>Each batch in a separate folder with original report ZIP</li>
                <li>Batch_Info.json with complete batch details</li>
                <li>Images folder with all uploaded images</li>
                <li>Download_Summary.txt with overall statistics</li>
              </ul>
              <strong className="d-block mt-2">
                <i className="fas fa-check-circle me-1"></i>
                Includes ALL batches in the selected date range (not just current page)
              </strong>
            </small>
          </div>

          {(allBatchesForReportCount || filteredBatches.length) > 10 && (
            <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
              <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
                Downloading {allBatchesForReportCount || filteredBatches.length} batches may take several minutes. Please be patient.
              </small>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setZipDownloadModalShow(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={downloadAllBatchesAsZip}>
            <ArchiveIcon style={{ fontSize: "16px", marginRight: "4px" }} />
            Download All as ZIP ({allBatchesForReportCount || filteredBatches.length} Batches)
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ZIP Simulator Download Modal */}
      <Modal show={zipSimulatorDownloadModalShow} centered onHide={() => setZipSimulatorDownloadModalShow(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Download All Simulator Reports as ZIP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center mb-3 p-3 bg-primary bg-opacity-10 rounded">
            <ScienceIcon style={{ fontSize: "2rem", color: "#0d6efd", marginRight: "12px" }} />
            <div>
              <strong>Batch-wise Simulator Reports ZIP Download</strong>
              <small className="d-block text-muted">
                Downloads each batch's simulator report as a separate folder in a single ZIP file
              </small>
            </div>
          </div>

          <div className="d-flex gap-3 mb-3 p-2 bg-light rounded flex-wrap">
            <div>
              <small className="text-muted">Batches to Download</small>
              <div className="fw-bold fs-5">{isFetchingAllBatches ? <Spinner size="sm" /> : (allBatchesForReportCount || filteredBatches.length)}</div>
            </div>
            <div>
              <small className="text-muted">Total Students</small>
              <div className="fw-bold fs-5">{filteredStats.totalStudents}</div>
            </div>
            <div>
              <small className="text-muted">Pass Rate</small>
              <div className="fw-bold fs-5">{filteredStats.passRate}%</div>
            </div>
          </div>

          <div className="mt-3 p-2 bg-info bg-opacity-10 rounded">
            <small className="text-info">
              <i className="fas fa-info-circle me-1"></i>
              The ZIP file will contain:
              <ul className="mt-2 mb-0">
                <li>Each batch in a separate folder with Simulator_Report.xlsx</li>
                <li>Batch_Info.json with complete batch details</li>
                <li>Download_Summary.txt with overall statistics</li>
                <li>Complete simulator data with all fields from the backend</li>
                <li>Post Test Start Date & Post Test End Date</li>
                <li>Pre Test & Post Test scores</li>
                <li>Student Rating with star ratings</li>
                <li>All scenarios (PASS/FAIL/NOT_ATTEMPTED)</li>
                <li>Total Sim Duration (min) - cumulative duration across all scenarios</li>
              </ul>
              <strong className="d-block mt-2">
                <i className="fas fa-check-circle me-1"></i>
                Includes ALL batches in the selected date range (not just current page)
              </strong>
            </small>
          </div>

          {(allBatchesForReportCount || filteredBatches.length) > 10 && (
            <div className="mt-3 p-2 bg-warning bg-opacity-10 rounded">
              <small><i className="fas fa-exclamation-triangle text-warning me-1"></i>
                Downloading {allBatchesForReportCount || filteredBatches.length} batches may take several minutes. Please be patient.
              </small>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setZipSimulatorDownloadModalShow(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={downloadAllBatchesSimulatorAsZip}>
            <ScienceIcon style={{ fontSize: "16px", marginRight: "4px" }} />
            Download All Simulator Reports ({allBatchesForReportCount || filteredBatches.length} Batches)
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default connect(null, { setBreadcrumbItems })(AllGroup);